/*! jQuery v3.4.0 | (c) JS Foundation and other contributors | jquery.org/license */
!function(e,t){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return t(e)}:t(e)}("undefined"!=typeof window?window:this,function(C,e){"use strict";var t=[],E=C.document,r=Object.getPrototypeOf,s=t.slice,g=t.concat,u=t.push,i=t.indexOf,n={},o=n.toString,v=n.hasOwnProperty,a=v.toString,l=a.call(Object),y={},m=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType},x=function(e){return null!=e&&e===e.window},c={type:!0,src:!0,nonce:!0,noModule:!0};function b(e,t,n){var r,i,o=(n=n||E).createElement("script");if(o.text=e,t)for(r in c)(i=t[r]||t.getAttribute&&t.getAttribute(r))&&o.setAttribute(r,i);n.head.appendChild(o).parentNode.removeChild(o)}function w(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?n[o.call(e)]||"object":typeof e}var f="3.4.0",k=function(e,t){return new k.fn.init(e,t)},p=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;function d(e){var t=!!e&&"length"in e&&e.length,n=w(e);return!m(e)&&!x(e)&&("array"===n||0===t||"number"==typeof t&&0<t&&t-1 in e)}k.fn=k.prototype={jquery:f,constructor:k,length:0,toArray:function(){return s.call(this)},get:function(e){return null==e?s.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=k.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return k.each(this,e)},map:function(n){return this.pushStack(k.map(this,function(e,t){return n.call(e,t,e)}))},slice:function(){return this.pushStack(s.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(0<=n&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:u,sort:t.sort,splice:t.splice},k.extend=k.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"==typeof a||m(a)||(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)r=e[t],"__proto__"!==t&&a!==r&&(l&&r&&(k.isPlainObject(r)||(i=Array.isArray(r)))?(n=a[t],o=i&&!Array.isArray(n)?[]:i||k.isPlainObject(n)?n:{},i=!1,a[t]=k.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},k.extend({expando:"jQuery"+(f+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==o.call(e))&&(!(t=r(e))||"function"==typeof(n=v.call(t,"constructor")&&t.constructor)&&a.call(n)===l)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t){b(e,{nonce:t&&t.nonce})},each:function(e,t){var n,r=0;if(d(e)){for(n=e.length;r<n;r++)if(!1===t.call(e[r],r,e[r]))break}else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},trim:function(e){return null==e?"":(e+"").replace(p,"")},makeArray:function(e,t){var n=t||[];return null!=e&&(d(Object(e))?k.merge(n,"string"==typeof e?[e]:e):u.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:i.call(t,e,n)},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r=[],i=0,o=e.length,a=!n;i<o;i++)!t(e[i],i)!==a&&r.push(e[i]);return r},map:function(e,t,n){var r,i,o=0,a=[];if(d(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&a.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&a.push(i);return g.apply([],a)},guid:1,support:y}),"function"==typeof Symbol&&(k.fn[Symbol.iterator]=t[Symbol.iterator]),k.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){n["[object "+t+"]"]=t.toLowerCase()});var h=function(n){var e,d,b,o,i,h,f,g,w,u,l,T,C,a,E,v,s,c,y,k="sizzle"+1*new Date,m=n.document,S=0,r=0,p=ue(),x=ue(),A=ue(),N=ue(),D=function(e,t){return e===t&&(l=!0),0},j={}.hasOwnProperty,t=[],q=t.pop,L=t.push,H=t.push,O=t.slice,P=function(e,t){for(var n=0,r=e.length;n<r;n++)if(e[n]===t)return n;return-1},R="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",M="[\\x20\\t\\r\\n\\f]",I="(?:\\\\.|[\\w-]|[^\0-\\xa0])+",W="\\["+M+"*("+I+")(?:"+M+"*([*^$|!~]?=)"+M+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+I+"))|)"+M+"*\\]",$=":("+I+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+W+")*)|.*)\\)|)",F=new RegExp(M+"+","g"),B=new RegExp("^"+M+"+|((?:^|[^\\\\])(?:\\\\.)*)"+M+"+$","g"),_=new RegExp("^"+M+"*,"+M+"*"),z=new RegExp("^"+M+"*([>+~]|"+M+")"+M+"*"),U=new RegExp(M+"|>"),X=new RegExp($),V=new RegExp("^"+I+"$"),G={ID:new RegExp("^#("+I+")"),CLASS:new RegExp("^\\.("+I+")"),TAG:new RegExp("^("+I+"|[*])"),ATTR:new RegExp("^"+W),PSEUDO:new RegExp("^"+$),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+M+"*(even|odd|(([+-]|)(\\d*)n|)"+M+"*(?:([+-]|)"+M+"*(\\d+)|))"+M+"*\\)|)","i"),bool:new RegExp("^(?:"+R+")$","i"),needsContext:new RegExp("^"+M+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+M+"*((?:-\\d)?\\d*)"+M+"*\\)|)(?=[^-]|$)","i")},Y=/HTML$/i,Q=/^(?:input|select|textarea|button)$/i,J=/^h\d$/i,K=/^[^{]+\{\s*\[native \w/,Z=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,ee=/[+~]/,te=new RegExp("\\\\([\\da-f]{1,6}"+M+"?|("+M+")|.)","ig"),ne=function(e,t,n){var r="0x"+t-65536;return r!=r||n?t:r<0?String.fromCharCode(r+65536):String.fromCharCode(r>>10|55296,1023&r|56320)},re=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,ie=function(e,t){return t?"\0"===e?"\ufffd":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e},oe=function(){T()},ae=be(function(e){return!0===e.disabled&&"fieldset"===e.nodeName.toLowerCase()},{dir:"parentNode",next:"legend"});try{H.apply(t=O.call(m.childNodes),m.childNodes),t[m.childNodes.length].nodeType}catch(e){H={apply:t.length?function(e,t){L.apply(e,O.call(t))}:function(e,t){var n=e.length,r=0;while(e[n++]=t[r++]);e.length=n-1}}}function se(t,e,n,r){var i,o,a,s,u,l,c,f=e&&e.ownerDocument,p=e?e.nodeType:9;if(n=n||[],"string"!=typeof t||!t||1!==p&&9!==p&&11!==p)return n;if(!r&&((e?e.ownerDocument||e:m)!==C&&T(e),e=e||C,E)){if(11!==p&&(u=Z.exec(t)))if(i=u[1]){if(9===p){if(!(a=e.getElementById(i)))return n;if(a.id===i)return n.push(a),n}else if(f&&(a=f.getElementById(i))&&y(e,a)&&a.id===i)return n.push(a),n}else{if(u[2])return H.apply(n,e.getElementsByTagName(t)),n;if((i=u[3])&&d.getElementsByClassName&&e.getElementsByClassName)return H.apply(n,e.getElementsByClassName(i)),n}if(d.qsa&&!N[t+" "]&&(!v||!v.test(t))&&(1!==p||"object"!==e.nodeName.toLowerCase())){if(c=t,f=e,1===p&&U.test(t)){(s=e.getAttribute("id"))?s=s.replace(re,ie):e.setAttribute("id",s=k),o=(l=h(t)).length;while(o--)l[o]="#"+s+" "+xe(l[o]);c=l.join(","),f=ee.test(t)&&ye(e.parentNode)||e}try{return H.apply(n,f.querySelectorAll(c)),n}catch(e){N(t,!0)}finally{s===k&&e.removeAttribute("id")}}}return g(t.replace(B,"$1"),e,n,r)}function ue(){var r=[];return function e(t,n){return r.push(t+" ")>b.cacheLength&&delete e[r.shift()],e[t+" "]=n}}function le(e){return e[k]=!0,e}function ce(e){var t=C.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function fe(e,t){var n=e.split("|"),r=n.length;while(r--)b.attrHandle[n[r]]=t}function pe(e,t){var n=t&&e,r=n&&1===e.nodeType&&1===t.nodeType&&e.sourceIndex-t.sourceIndex;if(r)return r;if(n)while(n=n.nextSibling)if(n===t)return-1;return e?1:-1}function de(t){return function(e){return"input"===e.nodeName.toLowerCase()&&e.type===t}}function he(n){return function(e){var t=e.nodeName.toLowerCase();return("input"===t||"button"===t)&&e.type===n}}function ge(t){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===t:e.disabled===t:e.isDisabled===t||e.isDisabled!==!t&&ae(e)===t:e.disabled===t:"label"in e&&e.disabled===t}}function ve(a){return le(function(o){return o=+o,le(function(e,t){var n,r=a([],e.length,o),i=r.length;while(i--)e[n=r[i]]&&(e[n]=!(t[n]=e[n]))})})}function ye(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}for(e in d=se.support={},i=se.isXML=function(e){var t=e.namespaceURI,n=(e.ownerDocument||e).documentElement;return!Y.test(t||n&&n.nodeName||"HTML")},T=se.setDocument=function(e){var t,n,r=e?e.ownerDocument||e:m;return r!==C&&9===r.nodeType&&r.documentElement&&(a=(C=r).documentElement,E=!i(C),m!==C&&(n=C.defaultView)&&n.top!==n&&(n.addEventListener?n.addEventListener("unload",oe,!1):n.attachEvent&&n.attachEvent("onunload",oe)),d.attributes=ce(function(e){return e.className="i",!e.getAttribute("className")}),d.getElementsByTagName=ce(function(e){return e.appendChild(C.createComment("")),!e.getElementsByTagName("*").length}),d.getElementsByClassName=K.test(C.getElementsByClassName),d.getById=ce(function(e){return a.appendChild(e).id=k,!C.getElementsByName||!C.getElementsByName(k).length}),d.getById?(b.filter.ID=function(e){var t=e.replace(te,ne);return function(e){return e.getAttribute("id")===t}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&E){var n=t.getElementById(e);return n?[n]:[]}}):(b.filter.ID=function(e){var n=e.replace(te,ne);return function(e){var t="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return t&&t.value===n}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&E){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];i=t.getElementsByName(e),r=0;while(o=i[r++])if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),b.find.TAG=d.getElementsByTagName?function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):d.qsa?t.querySelectorAll(e):void 0}:function(e,t){var n,r=[],i=0,o=t.getElementsByTagName(e);if("*"===e){while(n=o[i++])1===n.nodeType&&r.push(n);return r}return o},b.find.CLASS=d.getElementsByClassName&&function(e,t){if("undefined"!=typeof t.getElementsByClassName&&E)return t.getElementsByClassName(e)},s=[],v=[],(d.qsa=K.test(C.querySelectorAll))&&(ce(function(e){a.appendChild(e).innerHTML="<a id='"+k+"'></a><select id='"+k+"-\r\\' msallowcapture=''><option selected=''></option></select>",e.querySelectorAll("[msallowcapture^='']").length&&v.push("[*^$]="+M+"*(?:''|\"\")"),e.querySelectorAll("[selected]").length||v.push("\\["+M+"*(?:value|"+R+")"),e.querySelectorAll("[id~="+k+"-]").length||v.push("~="),e.querySelectorAll(":checked").length||v.push(":checked"),e.querySelectorAll("a#"+k+"+*").length||v.push(".#.+[+~]")}),ce(function(e){e.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var t=C.createElement("input");t.setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),e.querySelectorAll("[name=d]").length&&v.push("name"+M+"*[*^$|!~]?="),2!==e.querySelectorAll(":enabled").length&&v.push(":enabled",":disabled"),a.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&v.push(":enabled",":disabled"),e.querySelectorAll("*,:x"),v.push(",.*:")})),(d.matchesSelector=K.test(c=a.matches||a.webkitMatchesSelector||a.mozMatchesSelector||a.oMatchesSelector||a.msMatchesSelector))&&ce(function(e){d.disconnectedMatch=c.call(e,"*"),c.call(e,"[s!='']:x"),s.push("!=",$)}),v=v.length&&new RegExp(v.join("|")),s=s.length&&new RegExp(s.join("|")),t=K.test(a.compareDocumentPosition),y=t||K.test(a.contains)?function(e,t){var n=9===e.nodeType?e.documentElement:e,r=t&&t.parentNode;return e===r||!(!r||1!==r.nodeType||!(n.contains?n.contains(r):e.compareDocumentPosition&&16&e.compareDocumentPosition(r)))}:function(e,t){if(t)while(t=t.parentNode)if(t===e)return!0;return!1},D=t?function(e,t){if(e===t)return l=!0,0;var n=!e.compareDocumentPosition-!t.compareDocumentPosition;return n||(1&(n=(e.ownerDocument||e)===(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!d.sortDetached&&t.compareDocumentPosition(e)===n?e===C||e.ownerDocument===m&&y(m,e)?-1:t===C||t.ownerDocument===m&&y(m,t)?1:u?P(u,e)-P(u,t):0:4&n?-1:1)}:function(e,t){if(e===t)return l=!0,0;var n,r=0,i=e.parentNode,o=t.parentNode,a=[e],s=[t];if(!i||!o)return e===C?-1:t===C?1:i?-1:o?1:u?P(u,e)-P(u,t):0;if(i===o)return pe(e,t);n=e;while(n=n.parentNode)a.unshift(n);n=t;while(n=n.parentNode)s.unshift(n);while(a[r]===s[r])r++;return r?pe(a[r],s[r]):a[r]===m?-1:s[r]===m?1:0}),C},se.matches=function(e,t){return se(e,null,null,t)},se.matchesSelector=function(e,t){if((e.ownerDocument||e)!==C&&T(e),d.matchesSelector&&E&&!N[t+" "]&&(!s||!s.test(t))&&(!v||!v.test(t)))try{var n=c.call(e,t);if(n||d.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(e){N(t,!0)}return 0<se(t,C,null,[e]).length},se.contains=function(e,t){return(e.ownerDocument||e)!==C&&T(e),y(e,t)},se.attr=function(e,t){(e.ownerDocument||e)!==C&&T(e);var n=b.attrHandle[t.toLowerCase()],r=n&&j.call(b.attrHandle,t.toLowerCase())?n(e,t,!E):void 0;return void 0!==r?r:d.attributes||!E?e.getAttribute(t):(r=e.getAttributeNode(t))&&r.specified?r.value:null},se.escape=function(e){return(e+"").replace(re,ie)},se.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},se.uniqueSort=function(e){var t,n=[],r=0,i=0;if(l=!d.detectDuplicates,u=!d.sortStable&&e.slice(0),e.sort(D),l){while(t=e[i++])t===e[i]&&(r=n.push(i));while(r--)e.splice(n[r],1)}return u=null,e},o=se.getText=function(e){var t,n="",r=0,i=e.nodeType;if(i){if(1===i||9===i||11===i){if("string"==typeof e.textContent)return e.textContent;for(e=e.firstChild;e;e=e.nextSibling)n+=o(e)}else if(3===i||4===i)return e.nodeValue}else while(t=e[r++])n+=o(t);return n},(b=se.selectors={cacheLength:50,createPseudo:le,match:G,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(te,ne),e[3]=(e[3]||e[4]||e[5]||"").replace(te,ne),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||se.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&se.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return G.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&X.test(n)&&(t=h(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(te,ne).toLowerCase();return"*"===e?function(){return!0}:function(e){return e.nodeName&&e.nodeName.toLowerCase()===t}},CLASS:function(e){var t=p[e+" "];return t||(t=new RegExp("(^|"+M+")"+e+"("+M+"|$)"))&&p(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(n,r,i){return function(e){var t=se.attr(e,n);return null==t?"!="===r:!r||(t+="","="===r?t===i:"!="===r?t!==i:"^="===r?i&&0===t.indexOf(i):"*="===r?i&&-1<t.indexOf(i):"$="===r?i&&t.slice(-i.length)===i:"~="===r?-1<(" "+t.replace(F," ")+" ").indexOf(i):"|="===r&&(t===i||t.slice(0,i.length+1)===i+"-"))}},CHILD:function(h,e,t,g,v){var y="nth"!==h.slice(0,3),m="last"!==h.slice(-4),x="of-type"===e;return 1===g&&0===v?function(e){return!!e.parentNode}:function(e,t,n){var r,i,o,a,s,u,l=y!==m?"nextSibling":"previousSibling",c=e.parentNode,f=x&&e.nodeName.toLowerCase(),p=!n&&!x,d=!1;if(c){if(y){while(l){a=e;while(a=a[l])if(x?a.nodeName.toLowerCase()===f:1===a.nodeType)return!1;u=l="only"===h&&!u&&"nextSibling"}return!0}if(u=[m?c.firstChild:c.lastChild],m&&p){d=(s=(r=(i=(o=(a=c)[k]||(a[k]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]||[])[0]===S&&r[1])&&r[2],a=s&&c.childNodes[s];while(a=++s&&a&&a[l]||(d=s=0)||u.pop())if(1===a.nodeType&&++d&&a===e){i[h]=[S,s,d];break}}else if(p&&(d=s=(r=(i=(o=(a=e)[k]||(a[k]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]||[])[0]===S&&r[1]),!1===d)while(a=++s&&a&&a[l]||(d=s=0)||u.pop())if((x?a.nodeName.toLowerCase()===f:1===a.nodeType)&&++d&&(p&&((i=(o=a[k]||(a[k]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]=[S,d]),a===e))break;return(d-=v)===g||d%g==0&&0<=d/g}}},PSEUDO:function(e,o){var t,a=b.pseudos[e]||b.setFilters[e.toLowerCase()]||se.error("unsupported pseudo: "+e);return a[k]?a(o):1<a.length?(t=[e,e,"",o],b.setFilters.hasOwnProperty(e.toLowerCase())?le(function(e,t){var n,r=a(e,o),i=r.length;while(i--)e[n=P(e,r[i])]=!(t[n]=r[i])}):function(e){return a(e,0,t)}):a}},pseudos:{not:le(function(e){var r=[],i=[],s=f(e.replace(B,"$1"));return s[k]?le(function(e,t,n,r){var i,o=s(e,null,r,[]),a=e.length;while(a--)(i=o[a])&&(e[a]=!(t[a]=i))}):function(e,t,n){return r[0]=e,s(r,null,n,i),r[0]=null,!i.pop()}}),has:le(function(t){return function(e){return 0<se(t,e).length}}),contains:le(function(t){return t=t.replace(te,ne),function(e){return-1<(e.textContent||o(e)).indexOf(t)}}),lang:le(function(n){return V.test(n||"")||se.error("unsupported lang: "+n),n=n.replace(te,ne).toLowerCase(),function(e){var t;do{if(t=E?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(t=t.toLowerCase())===n||0===t.indexOf(n+"-")}while((e=e.parentNode)&&1===e.nodeType);return!1}}),target:function(e){var t=n.location&&n.location.hash;return t&&t.slice(1)===e.id},root:function(e){return e===a},focus:function(e){return e===C.activeElement&&(!C.hasFocus||C.hasFocus())&&!!(e.type||e.href||~e.tabIndex)},enabled:ge(!1),disabled:ge(!0),checked:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&!!e.checked||"option"===t&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!b.pseudos.empty(e)},header:function(e){return J.test(e.nodeName)},input:function(e){return Q.test(e.nodeName)},button:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&"button"===e.type||"button"===t},text:function(e){var t;return"input"===e.nodeName.toLowerCase()&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:ve(function(){return[0]}),last:ve(function(e,t){return[t-1]}),eq:ve(function(e,t,n){return[n<0?n+t:n]}),even:ve(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:ve(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:ve(function(e,t,n){for(var r=n<0?n+t:t<n?t:n;0<=--r;)e.push(r);return e}),gt:ve(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=b.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})b.pseudos[e]=de(e);for(e in{submit:!0,reset:!0})b.pseudos[e]=he(e);function me(){}function xe(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function be(s,e,t){var u=e.dir,l=e.next,c=l||u,f=t&&"parentNode"===c,p=r++;return e.first?function(e,t,n){while(e=e[u])if(1===e.nodeType||f)return s(e,t,n);return!1}:function(e,t,n){var r,i,o,a=[S,p];if(n){while(e=e[u])if((1===e.nodeType||f)&&s(e,t,n))return!0}else while(e=e[u])if(1===e.nodeType||f)if(i=(o=e[k]||(e[k]={}))[e.uniqueID]||(o[e.uniqueID]={}),l&&l===e.nodeName.toLowerCase())e=e[u]||e;else{if((r=i[c])&&r[0]===S&&r[1]===p)return a[2]=r[2];if((i[c]=a)[2]=s(e,t,n))return!0}return!1}}function we(i){return 1<i.length?function(e,t,n){var r=i.length;while(r--)if(!i[r](e,t,n))return!1;return!0}:i[0]}function Te(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),l&&t.push(s)));return a}function Ce(d,h,g,v,y,e){return v&&!v[k]&&(v=Ce(v)),y&&!y[k]&&(y=Ce(y,e)),le(function(e,t,n,r){var i,o,a,s=[],u=[],l=t.length,c=e||function(e,t,n){for(var r=0,i=t.length;r<i;r++)se(e,t[r],n);return n}(h||"*",n.nodeType?[n]:n,[]),f=!d||!e&&h?c:Te(c,s,d,n,r),p=g?y||(e?d:l||v)?[]:t:f;if(g&&g(f,p,n,r),v){i=Te(p,u),v(i,[],n,r),o=i.length;while(o--)(a=i[o])&&(p[u[o]]=!(f[u[o]]=a))}if(e){if(y||d){if(y){i=[],o=p.length;while(o--)(a=p[o])&&i.push(f[o]=a);y(null,p=[],i,r)}o=p.length;while(o--)(a=p[o])&&-1<(i=y?P(e,a):s[o])&&(e[i]=!(t[i]=a))}}else p=Te(p===t?p.splice(l,p.length):p),y?y(null,t,p,r):H.apply(t,p)})}function Ee(e){for(var i,t,n,r=e.length,o=b.relative[e[0].type],a=o||b.relative[" "],s=o?1:0,u=be(function(e){return e===i},a,!0),l=be(function(e){return-1<P(i,e)},a,!0),c=[function(e,t,n){var r=!o&&(n||t!==w)||((i=t).nodeType?u(e,t,n):l(e,t,n));return i=null,r}];s<r;s++)if(t=b.relative[e[s].type])c=[be(we(c),t)];else{if((t=b.filter[e[s].type].apply(null,e[s].matches))[k]){for(n=++s;n<r;n++)if(b.relative[e[n].type])break;return Ce(1<s&&we(c),1<s&&xe(e.slice(0,s-1).concat({value:" "===e[s-2].type?"*":""})).replace(B,"$1"),t,s<n&&Ee(e.slice(s,n)),n<r&&Ee(e=e.slice(n)),n<r&&xe(e))}c.push(t)}return we(c)}return me.prototype=b.filters=b.pseudos,b.setFilters=new me,h=se.tokenize=function(e,t){var n,r,i,o,a,s,u,l=x[e+" "];if(l)return t?0:l.slice(0);a=e,s=[],u=b.preFilter;while(a){for(o in n&&!(r=_.exec(a))||(r&&(a=a.slice(r[0].length)||a),s.push(i=[])),n=!1,(r=z.exec(a))&&(n=r.shift(),i.push({value:n,type:r[0].replace(B," ")}),a=a.slice(n.length)),b.filter)!(r=G[o].exec(a))||u[o]&&!(r=u[o](r))||(n=r.shift(),i.push({value:n,type:o,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?se.error(e):x(e,s).slice(0)},f=se.compile=function(e,t){var n,v,y,m,x,r,i=[],o=[],a=A[e+" "];if(!a){t||(t=h(e)),n=t.length;while(n--)(a=Ee(t[n]))[k]?i.push(a):o.push(a);(a=A(e,(v=o,m=0<(y=i).length,x=0<v.length,r=function(e,t,n,r,i){var o,a,s,u=0,l="0",c=e&&[],f=[],p=w,d=e||x&&b.find.TAG("*",i),h=S+=null==p?1:Math.random()||.1,g=d.length;for(i&&(w=t===C||t||i);l!==g&&null!=(o=d[l]);l++){if(x&&o){a=0,t||o.ownerDocument===C||(T(o),n=!E);while(s=v[a++])if(s(o,t||C,n)){r.push(o);break}i&&(S=h)}m&&((o=!s&&o)&&u--,e&&c.push(o))}if(u+=l,m&&l!==u){a=0;while(s=y[a++])s(c,f,t,n);if(e){if(0<u)while(l--)c[l]||f[l]||(f[l]=q.call(r));f=Te(f)}H.apply(r,f),i&&!e&&0<f.length&&1<u+y.length&&se.uniqueSort(r)}return i&&(S=h,w=p),c},m?le(r):r))).selector=e}return a},g=se.select=function(e,t,n,r){var i,o,a,s,u,l="function"==typeof e&&e,c=!r&&h(e=l.selector||e);if(n=n||[],1===c.length){if(2<(o=c[0]=c[0].slice(0)).length&&"ID"===(a=o[0]).type&&9===t.nodeType&&E&&b.relative[o[1].type]){if(!(t=(b.find.ID(a.matches[0].replace(te,ne),t)||[])[0]))return n;l&&(t=t.parentNode),e=e.slice(o.shift().value.length)}i=G.needsContext.test(e)?0:o.length;while(i--){if(a=o[i],b.relative[s=a.type])break;if((u=b.find[s])&&(r=u(a.matches[0].replace(te,ne),ee.test(o[0].type)&&ye(t.parentNode)||t))){if(o.splice(i,1),!(e=r.length&&xe(o)))return H.apply(n,r),n;break}}}return(l||f(e,c))(r,t,!E,n,!t||ee.test(e)&&ye(t.parentNode)||t),n},d.sortStable=k.split("").sort(D).join("")===k,d.detectDuplicates=!!l,T(),d.sortDetached=ce(function(e){return 1&e.compareDocumentPosition(C.createElement("fieldset"))}),ce(function(e){return e.innerHTML="<a href='#'></a>","#"===e.firstChild.getAttribute("href")})||fe("type|href|height|width",function(e,t,n){if(!n)return e.getAttribute(t,"type"===t.toLowerCase()?1:2)}),d.attributes&&ce(function(e){return e.innerHTML="<input/>",e.firstChild.setAttribute("value",""),""===e.firstChild.getAttribute("value")})||fe("value",function(e,t,n){if(!n&&"input"===e.nodeName.toLowerCase())return e.defaultValue}),ce(function(e){return null==e.getAttribute("disabled")})||fe(R,function(e,t,n){var r;if(!n)return!0===e[t]?t.toLowerCase():(r=e.getAttributeNode(t))&&r.specified?r.value:null}),se}(C);k.find=h,k.expr=h.selectors,k.expr[":"]=k.expr.pseudos,k.uniqueSort=k.unique=h.uniqueSort,k.text=h.getText,k.isXMLDoc=h.isXML,k.contains=h.contains,k.escapeSelector=h.escape;var T=function(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&k(e).is(n))break;r.push(e)}return r},S=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},A=k.expr.match.needsContext;function N(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}var D=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function j(e,n,r){return m(n)?k.grep(e,function(e,t){return!!n.call(e,t,e)!==r}):n.nodeType?k.grep(e,function(e){return e===n!==r}):"string"!=typeof n?k.grep(e,function(e){return-1<i.call(n,e)!==r}):k.filter(n,e,r)}k.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?k.find.matchesSelector(r,e)?[r]:[]:k.find.matches(e,k.grep(t,function(e){return 1===e.nodeType}))},k.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(k(e).filter(function(){for(t=0;t<r;t++)if(k.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)k.find(e,i[t],n);return 1<r?k.uniqueSort(n):n},filter:function(e){return this.pushStack(j(this,e||[],!1))},not:function(e){return this.pushStack(j(this,e||[],!0))},is:function(e){return!!j(this,"string"==typeof e&&A.test(e)?k(e):e||[],!1).length}});var q,L=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(k.fn.init=function(e,t,n){var r,i;if(!e)return this;if(n=n||q,"string"==typeof e){if(!(r="<"===e[0]&&">"===e[e.length-1]&&3<=e.length?[null,e,null]:L.exec(e))||!r[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(r[1]){if(t=t instanceof k?t[0]:t,k.merge(this,k.parseHTML(r[1],t&&t.nodeType?t.ownerDocument||t:E,!0)),D.test(r[1])&&k.isPlainObject(t))for(r in t)m(this[r])?this[r](t[r]):this.attr(r,t[r]);return this}return(i=E.getElementById(r[2]))&&(this[0]=i,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):m(e)?void 0!==n.ready?n.ready(e):e(k):k.makeArray(e,this)}).prototype=k.fn,q=k(E);var H=/^(?:parents|prev(?:Until|All))/,O={children:!0,contents:!0,next:!0,prev:!0};function P(e,t){while((e=e[t])&&1!==e.nodeType);return e}k.fn.extend({has:function(e){var t=k(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(k.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&k(e);if(!A.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?-1<a.index(n):1===n.nodeType&&k.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(1<o.length?k.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?i.call(k(e),this[0]):i.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(k.uniqueSort(k.merge(this.get(),k(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),k.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return T(e,"parentNode")},parentsUntil:function(e,t,n){return T(e,"parentNode",n)},next:function(e){return P(e,"nextSibling")},prev:function(e){return P(e,"previousSibling")},nextAll:function(e){return T(e,"nextSibling")},prevAll:function(e){return T(e,"previousSibling")},nextUntil:function(e,t,n){return T(e,"nextSibling",n)},prevUntil:function(e,t,n){return T(e,"previousSibling",n)},siblings:function(e){return S((e.parentNode||{}).firstChild,e)},children:function(e){return S(e.firstChild)},contents:function(e){return"undefined"!=typeof e.contentDocument?e.contentDocument:(N(e,"template")&&(e=e.content||e),k.merge([],e.childNodes))}},function(r,i){k.fn[r]=function(e,t){var n=k.map(this,i,e);return"Until"!==r.slice(-5)&&(t=e),t&&"string"==typeof t&&(n=k.filter(t,n)),1<this.length&&(O[r]||k.uniqueSort(n),H.test(r)&&n.reverse()),this.pushStack(n)}});var R=/[^\x20\t\r\n\f]+/g;function M(e){return e}function I(e){throw e}function W(e,t,n,r){var i;try{e&&m(i=e.promise)?i.call(e).done(t).fail(n):e&&m(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}k.Callbacks=function(r){var e,n;r="string"==typeof r?(e=r,n={},k.each(e.match(R)||[],function(e,t){n[t]=!0}),n):k.extend({},r);var i,t,o,a,s=[],u=[],l=-1,c=function(){for(a=a||r.once,o=i=!0;u.length;l=-1){t=u.shift();while(++l<s.length)!1===s[l].apply(t[0],t[1])&&r.stopOnFalse&&(l=s.length,t=!1)}r.memory||(t=!1),i=!1,a&&(s=t?[]:"")},f={add:function(){return s&&(t&&!i&&(l=s.length-1,u.push(t)),function n(e){k.each(e,function(e,t){m(t)?r.unique&&f.has(t)||s.push(t):t&&t.length&&"string"!==w(t)&&n(t)})}(arguments),t&&!i&&c()),this},remove:function(){return k.each(arguments,function(e,t){var n;while(-1<(n=k.inArray(t,s,n)))s.splice(n,1),n<=l&&l--}),this},has:function(e){return e?-1<k.inArray(e,s):0<s.length},empty:function(){return s&&(s=[]),this},disable:function(){return a=u=[],s=t="",this},disabled:function(){return!s},lock:function(){return a=u=[],t||i||(s=t=""),this},locked:function(){return!!a},fireWith:function(e,t){return a||(t=[e,(t=t||[]).slice?t.slice():t],u.push(t),i||c()),this},fire:function(){return f.fireWith(this,arguments),this},fired:function(){return!!o}};return f},k.extend({Deferred:function(e){var o=[["notify","progress",k.Callbacks("memory"),k.Callbacks("memory"),2],["resolve","done",k.Callbacks("once memory"),k.Callbacks("once memory"),0,"resolved"],["reject","fail",k.Callbacks("once memory"),k.Callbacks("once memory"),1,"rejected"]],i="pending",a={state:function(){return i},always:function(){return s.done(arguments).fail(arguments),this},"catch":function(e){return a.then(null,e)},pipe:function(){var i=arguments;return k.Deferred(function(r){k.each(o,function(e,t){var n=m(i[t[4]])&&i[t[4]];s[t[1]](function(){var e=n&&n.apply(this,arguments);e&&m(e.promise)?e.promise().progress(r.notify).done(r.resolve).fail(r.reject):r[t[0]+"With"](this,n?[e]:arguments)})}),i=null}).promise()},then:function(t,n,r){var u=0;function l(i,o,a,s){return function(){var n=this,r=arguments,e=function(){var e,t;if(!(i<u)){if((e=a.apply(n,r))===o.promise())throw new TypeError("Thenable self-resolution");t=e&&("object"==typeof e||"function"==typeof e)&&e.then,m(t)?s?t.call(e,l(u,o,M,s),l(u,o,I,s)):(u++,t.call(e,l(u,o,M,s),l(u,o,I,s),l(u,o,M,o.notifyWith))):(a!==M&&(n=void 0,r=[e]),(s||o.resolveWith)(n,r))}},t=s?e:function(){try{e()}catch(e){k.Deferred.exceptionHook&&k.Deferred.exceptionHook(e,t.stackTrace),u<=i+1&&(a!==I&&(n=void 0,r=[e]),o.rejectWith(n,r))}};i?t():(k.Deferred.getStackHook&&(t.stackTrace=k.Deferred.getStackHook()),C.setTimeout(t))}}return k.Deferred(function(e){o[0][3].add(l(0,e,m(r)?r:M,e.notifyWith)),o[1][3].add(l(0,e,m(t)?t:M)),o[2][3].add(l(0,e,m(n)?n:I))}).promise()},promise:function(e){return null!=e?k.extend(e,a):a}},s={};return k.each(o,function(e,t){var n=t[2],r=t[5];a[t[1]]=n.add,r&&n.add(function(){i=r},o[3-e][2].disable,o[3-e][3].disable,o[0][2].lock,o[0][3].lock),n.add(t[3].fire),s[t[0]]=function(){return s[t[0]+"With"](this===s?void 0:this,arguments),this},s[t[0]+"With"]=n.fireWith}),a.promise(s),e&&e.call(s,s),s},when:function(e){var n=arguments.length,t=n,r=Array(t),i=s.call(arguments),o=k.Deferred(),a=function(t){return function(e){r[t]=this,i[t]=1<arguments.length?s.call(arguments):e,--n||o.resolveWith(r,i)}};if(n<=1&&(W(e,o.done(a(t)).resolve,o.reject,!n),"pending"===o.state()||m(i[t]&&i[t].then)))return o.then();while(t--)W(i[t],a(t),o.reject);return o.promise()}});var $=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;k.Deferred.exceptionHook=function(e,t){C.console&&C.console.warn&&e&&$.test(e.name)&&C.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},k.readyException=function(e){C.setTimeout(function(){throw e})};var F=k.Deferred();function B(){E.removeEventListener("DOMContentLoaded",B),C.removeEventListener("load",B),k.ready()}k.fn.ready=function(e){return F.then(e)["catch"](function(e){k.readyException(e)}),this},k.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--k.readyWait:k.isReady)||(k.isReady=!0)!==e&&0<--k.readyWait||F.resolveWith(E,[k])}}),k.ready.then=F.then,"complete"===E.readyState||"loading"!==E.readyState&&!E.documentElement.doScroll?C.setTimeout(k.ready):(E.addEventListener("DOMContentLoaded",B),C.addEventListener("load",B));var _=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===w(n))for(s in i=!0,n)_(e,t,s,n[s],!0,o,a);else if(void 0!==r&&(i=!0,m(r)||(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(k(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},z=/^-ms-/,U=/-([a-z])/g;function X(e,t){return t.toUpperCase()}function V(e){return e.replace(z,"ms-").replace(U,X)}var G=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function Y(){this.expando=k.expando+Y.uid++}Y.uid=1,Y.prototype={cache:function(e){var t=e[this.expando];return t||(t={},G(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[V(t)]=n;else for(r in t)i[V(r)]=t[r];return i},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][V(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(V):(t=V(t))in r?[t]:t.match(R)||[]).length;while(n--)delete r[t[n]]}(void 0===t||k.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!k.isEmptyObject(t)}};var Q=new Y,J=new Y,K=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,Z=/[A-Z]/g;function ee(e,t,n){var r,i;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(Z,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n="true"===(i=n)||"false"!==i&&("null"===i?null:i===+i+""?+i:K.test(i)?JSON.parse(i):i)}catch(e){}J.set(e,t,n)}else n=void 0;return n}k.extend({hasData:function(e){return J.hasData(e)||Q.hasData(e)},data:function(e,t,n){return J.access(e,t,n)},removeData:function(e,t){J.remove(e,t)},_data:function(e,t,n){return Q.access(e,t,n)},_removeData:function(e,t){Q.remove(e,t)}}),k.fn.extend({data:function(n,e){var t,r,i,o=this[0],a=o&&o.attributes;if(void 0===n){if(this.length&&(i=J.get(o),1===o.nodeType&&!Q.get(o,"hasDataAttrs"))){t=a.length;while(t--)a[t]&&0===(r=a[t].name).indexOf("data-")&&(r=V(r.slice(5)),ee(o,r,i[r]));Q.set(o,"hasDataAttrs",!0)}return i}return"object"==typeof n?this.each(function(){J.set(this,n)}):_(this,function(e){var t;if(o&&void 0===e)return void 0!==(t=J.get(o,n))?t:void 0!==(t=ee(o,n))?t:void 0;this.each(function(){J.set(this,n,e)})},null,e,1<arguments.length,null,!0)},removeData:function(e){return this.each(function(){J.remove(this,e)})}}),k.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=Q.get(e,t),n&&(!r||Array.isArray(n)?r=Q.access(e,t,k.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=k.queue(e,t),r=n.length,i=n.shift(),o=k._queueHooks(e,t);"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,function(){k.dequeue(e,t)},o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return Q.get(e,n)||Q.access(e,n,{empty:k.Callbacks("once memory").add(function(){Q.remove(e,[t+"queue",n])})})}}),k.fn.extend({queue:function(t,n){var e=2;return"string"!=typeof t&&(n=t,t="fx",e--),arguments.length<e?k.queue(this[0],t):void 0===n?this:this.each(function(){var e=k.queue(this,t,n);k._queueHooks(this,t),"fx"===t&&"inprogress"!==e[0]&&k.dequeue(this,t)})},dequeue:function(e){return this.each(function(){k.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=k.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};"string"!=typeof e&&(t=e,e=void 0),e=e||"fx";while(a--)(n=Q.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var te=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,ne=new RegExp("^(?:([+-])=|)("+te+")([a-z%]*)$","i"),re=["Top","Right","Bottom","Left"],ie=E.documentElement,oe=function(e){return k.contains(e.ownerDocument,e)},ae={composed:!0};ie.attachShadow&&(oe=function(e){return k.contains(e.ownerDocument,e)||e.getRootNode(ae)===e.ownerDocument});var se=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&oe(e)&&"none"===k.css(e,"display")},ue=function(e,t,n,r){var i,o,a={};for(o in t)a[o]=e.style[o],e.style[o]=t[o];for(o in i=n.apply(e,r||[]),t)e.style[o]=a[o];return i};function le(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return k.css(e,t,"")},u=s(),l=n&&n[3]||(k.cssNumber[t]?"":"px"),c=e.nodeType&&(k.cssNumber[t]||"px"!==l&&+u)&&ne.exec(k.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)k.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,k.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var ce={};function fe(e,t){for(var n,r,i,o,a,s,u,l=[],c=0,f=e.length;c<f;c++)(r=e[c]).style&&(n=r.style.display,t?("none"===n&&(l[c]=Q.get(r,"display")||null,l[c]||(r.style.display="")),""===r.style.display&&se(r)&&(l[c]=(u=a=o=void 0,a=(i=r).ownerDocument,s=i.nodeName,(u=ce[s])||(o=a.body.appendChild(a.createElement(s)),u=k.css(o,"display"),o.parentNode.removeChild(o),"none"===u&&(u="block"),ce[s]=u)))):"none"!==n&&(l[c]="none",Q.set(r,"display",n)));for(c=0;c<f;c++)null!=l[c]&&(e[c].style.display=l[c]);return e}k.fn.extend({show:function(){return fe(this,!0)},hide:function(){return fe(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){se(this)?k(this).show():k(this).hide()})}});var pe=/^(?:checkbox|radio)$/i,de=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,he=/^$|^module$|\/(?:java|ecma)script/i,ge={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function ve(e,t){var n;return n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&N(e,t)?k.merge([e],n):n}function ye(e,t){for(var n=0,r=e.length;n<r;n++)Q.set(e[n],"globalEval",!t||Q.get(t[n],"globalEval"))}ge.optgroup=ge.option,ge.tbody=ge.tfoot=ge.colgroup=ge.caption=ge.thead,ge.th=ge.td;var me,xe,be=/<|&#?\w+;/;function we(e,t,n,r,i){for(var o,a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,h=e.length;d<h;d++)if((o=e[d])||0===o)if("object"===w(o))k.merge(p,o.nodeType?[o]:o);else if(be.test(o)){a=a||f.appendChild(t.createElement("div")),s=(de.exec(o)||["",""])[1].toLowerCase(),u=ge[s]||ge._default,a.innerHTML=u[1]+k.htmlPrefilter(o)+u[2],c=u[0];while(c--)a=a.lastChild;k.merge(p,a.childNodes),(a=f.firstChild).textContent=""}else p.push(t.createTextNode(o));f.textContent="",d=0;while(o=p[d++])if(r&&-1<k.inArray(o,r))i&&i.push(o);else if(l=oe(o),a=ve(f.appendChild(o),"script"),l&&ye(a),n){c=0;while(o=a[c++])he.test(o.type||"")&&n.push(o)}return f}me=E.createDocumentFragment().appendChild(E.createElement("div")),(xe=E.createElement("input")).setAttribute("type","radio"),xe.setAttribute("checked","checked"),xe.setAttribute("name","t"),me.appendChild(xe),y.checkClone=me.cloneNode(!0).cloneNode(!0).lastChild.checked,me.innerHTML="<textarea>x</textarea>",y.noCloneChecked=!!me.cloneNode(!0).lastChild.defaultValue;var Te=/^key/,Ce=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,Ee=/^([^.]*)(?:\.(.+)|)/;function ke(){return!0}function Se(){return!1}function Ae(e,t){return e===function(){try{return E.activeElement}catch(e){}}()==("focus"===t)}function Ne(e,t,n,r,i,o){var a,s;if("object"==typeof t){for(s in"string"!=typeof n&&(r=r||n,n=void 0),t)Ne(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=Se;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return k().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=k.guid++)),e.each(function(){k.event.add(this,t,i,r,n)})}function De(e,i,o){o?(Q.set(e,i,!1),k.event.add(e,i,{namespace:!1,handler:function(e){var t,n,r=Q.get(this,i);if(1&e.isTrigger&&this[i]){if(r)(k.event.special[i]||{}).delegateType&&e.stopPropagation();else if(r=s.call(arguments),Q.set(this,i,r),t=o(this,i),this[i](),r!==(n=Q.get(this,i))||t?Q.set(this,i,!1):n=void 0,r!==n)return e.stopImmediatePropagation(),e.preventDefault(),n}else r&&(Q.set(this,i,k.event.trigger(k.extend(r.shift(),k.Event.prototype),r,this)),e.stopImmediatePropagation())}})):k.event.add(e,i,ke)}k.event={global:{},add:function(t,e,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=Q.get(t);if(v){n.handler&&(n=(o=n).handler,i=o.selector),i&&k.find.matchesSelector(ie,i),n.guid||(n.guid=k.guid++),(u=v.events)||(u=v.events={}),(a=v.handle)||(a=v.handle=function(e){return"undefined"!=typeof k&&k.event.triggered!==e.type?k.event.dispatch.apply(t,arguments):void 0}),l=(e=(e||"").match(R)||[""]).length;while(l--)d=g=(s=Ee.exec(e[l])||[])[1],h=(s[2]||"").split(".").sort(),d&&(f=k.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=k.event.special[d]||{},c=k.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&k.expr.match.needsContext.test(i),namespace:h.join(".")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(t,r,h,a)||t.addEventListener&&t.addEventListener(d,a)),f.add&&(f.add.call(t,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c),k.event.global[d]=!0)}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=Q.hasData(e)&&Q.get(e);if(v&&(u=v.events)){l=(t=(t||"").match(R)||[""]).length;while(l--)if(d=g=(s=Ee.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),d){f=k.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=p.length;while(o--)c=p[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,v.handle)||k.removeEvent(e,d,v.handle),delete u[d])}else for(d in u)k.event.remove(e,d+t[l],n,r,!0);k.isEmptyObject(u)&&Q.remove(e,"handle events")}},dispatch:function(e){var t,n,r,i,o,a,s=k.event.fix(e),u=new Array(arguments.length),l=(Q.get(this,"events")||{})[s.type]||[],c=k.event.special[s.type]||{};for(u[0]=s,t=1;t<arguments.length;t++)u[t]=arguments[t];if(s.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,s)){a=k.event.handlers.call(this,s,l),t=0;while((i=a[t++])&&!s.isPropagationStopped()){s.currentTarget=i.elem,n=0;while((o=i.handlers[n++])&&!s.isImmediatePropagationStopped())s.rnamespace&&!1!==o.namespace&&!s.rnamespace.test(o.namespace)||(s.handleObj=o,s.data=o.data,void 0!==(r=((k.event.special[o.origType]||{}).handle||o.handler).apply(i.elem,u))&&!1===(s.result=r)&&(s.preventDefault(),s.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,s),s.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!("click"===e.type&&1<=e.button))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)void 0===a[i=(r=t[n]).selector+" "]&&(a[i]=r.needsContext?-1<k(i,this).index(l):k.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(t,e){Object.defineProperty(k.Event.prototype,t,{enumerable:!0,configurable:!0,get:m(e)?function(){if(this.originalEvent)return e(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[t]},set:function(e){Object.defineProperty(this,t,{enumerable:!0,configurable:!0,writable:!0,value:e})}})},fix:function(e){return e[k.expando]?e:new k.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return pe.test(t.type)&&t.click&&N(t,"input")&&void 0===Q.get(t,"click")&&De(t,"click",ke),!1},trigger:function(e){var t=this||e;return pe.test(t.type)&&t.click&&N(t,"input")&&void 0===Q.get(t,"click")&&De(t,"click"),!0},_default:function(e){var t=e.target;return pe.test(t.type)&&t.click&&N(t,"input")&&Q.get(t,"click")||N(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},k.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},k.Event=function(e,t){if(!(this instanceof k.Event))return new k.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?ke:Se,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&k.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[k.expando]=!0},k.Event.prototype={constructor:k.Event,isDefaultPrevented:Se,isPropagationStopped:Se,isImmediatePropagationStopped:Se,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=ke,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=ke,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=ke,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},k.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:function(e){var t=e.button;return null==e.which&&Te.test(e.type)?null!=e.charCode?e.charCode:e.keyCode:!e.which&&void 0!==t&&Ce.test(e.type)?1&t?1:2&t?3:4&t?2:0:e.which}},k.event.addProp),k.each({focus:"focusin",blur:"focusout"},function(e,t){k.event.special[e]={setup:function(){return De(this,e,Ae),!1},trigger:function(){return De(this,e),!0},delegateType:t}}),k.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,i){k.event.special[e]={delegateType:i,bindType:i,handle:function(e){var t,n=e.relatedTarget,r=e.handleObj;return n&&(n===this||k.contains(this,n))||(e.type=r.origType,t=r.handler.apply(this,arguments),e.type=i),t}}}),k.fn.extend({on:function(e,t,n,r){return Ne(this,e,t,n,r)},one:function(e,t,n,r){return Ne(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,k(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=Se),this.each(function(){k.event.remove(this,e,n,t)})}});var je=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,qe=/<script|<style|<link/i,Le=/checked\s*(?:[^=]|=\s*.checked.)/i,He=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function Oe(e,t){return N(e,"table")&&N(11!==t.nodeType?t:t.firstChild,"tr")&&k(e).children("tbody")[0]||e}function Pe(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function Re(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Me(e,t){var n,r,i,o,a,s,u,l;if(1===t.nodeType){if(Q.hasData(e)&&(o=Q.access(e),a=Q.set(t,o),l=o.events))for(i in delete a.handle,a.events={},l)for(n=0,r=l[i].length;n<r;n++)k.event.add(t,i,l[i][n]);J.hasData(e)&&(s=J.access(e),u=k.extend({},s),J.set(t,u))}}function Ie(n,r,i,o){r=g.apply([],r);var e,t,a,s,u,l,c=0,f=n.length,p=f-1,d=r[0],h=m(d);if(h||1<f&&"string"==typeof d&&!y.checkClone&&Le.test(d))return n.each(function(e){var t=n.eq(e);h&&(r[0]=d.call(this,e,t.html())),Ie(t,r,i,o)});if(f&&(t=(e=we(r,n[0].ownerDocument,!1,n,o)).firstChild,1===e.childNodes.length&&(e=t),t||o)){for(s=(a=k.map(ve(e,"script"),Pe)).length;c<f;c++)u=e,c!==p&&(u=k.clone(u,!0,!0),s&&k.merge(a,ve(u,"script"))),i.call(n[c],u,c);if(s)for(l=a[a.length-1].ownerDocument,k.map(a,Re),c=0;c<s;c++)u=a[c],he.test(u.type||"")&&!Q.access(u,"globalEval")&&k.contains(l,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?k._evalUrl&&!u.noModule&&k._evalUrl(u.src,{nonce:u.nonce||u.getAttribute("nonce")}):b(u.textContent.replace(He,""),u,l))}return n}function We(e,t,n){for(var r,i=t?k.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||k.cleanData(ve(r)),r.parentNode&&(n&&oe(r)&&ye(ve(r,"script")),r.parentNode.removeChild(r));return e}k.extend({htmlPrefilter:function(e){return e.replace(je,"<$1></$2>")},clone:function(e,t,n){var r,i,o,a,s,u,l,c=e.cloneNode(!0),f=oe(e);if(!(y.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||k.isXMLDoc(e)))for(a=ve(c),r=0,i=(o=ve(e)).length;r<i;r++)s=o[r],u=a[r],void 0,"input"===(l=u.nodeName.toLowerCase())&&pe.test(s.type)?u.checked=s.checked:"input"!==l&&"textarea"!==l||(u.defaultValue=s.defaultValue);if(t)if(n)for(o=o||ve(e),a=a||ve(c),r=0,i=o.length;r<i;r++)Me(o[r],a[r]);else Me(e,c);return 0<(a=ve(c,"script")).length&&ye(a,!f&&ve(e,"script")),c},cleanData:function(e){for(var t,n,r,i=k.event.special,o=0;void 0!==(n=e[o]);o++)if(G(n)){if(t=n[Q.expando]){if(t.events)for(r in t.events)i[r]?k.event.remove(n,r):k.removeEvent(n,r,t.handle);n[Q.expando]=void 0}n[J.expando]&&(n[J.expando]=void 0)}}}),k.fn.extend({detach:function(e){return We(this,e,!0)},remove:function(e){return We(this,e)},text:function(e){return _(this,function(e){return void 0===e?k.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return Ie(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||Oe(this,e).appendChild(e)})},prepend:function(){return Ie(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=Oe(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return Ie(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return Ie(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(k.cleanData(ve(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return k.clone(this,e,t)})},html:function(e){return _(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!qe.test(e)&&!ge[(de.exec(e)||["",""])[1].toLowerCase()]){e=k.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(k.cleanData(ve(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var n=[];return Ie(this,arguments,function(e){var t=this.parentNode;k.inArray(this,n)<0&&(k.cleanData(ve(this)),t&&t.replaceChild(e,this))},n)}}),k.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,a){k.fn[e]=function(e){for(var t,n=[],r=k(e),i=r.length-1,o=0;o<=i;o++)t=o===i?this:this.clone(!0),k(r[o])[a](t),u.apply(n,t.get());return this.pushStack(n)}});var $e=new RegExp("^("+te+")(?!px)[a-z%]+$","i"),Fe=function(e){var t=e.ownerDocument.defaultView;return t&&t.opener||(t=C),t.getComputedStyle(e)},Be=new RegExp(re.join("|"),"i");function _e(e,t,n){var r,i,o,a,s=e.style;return(n=n||Fe(e))&&(""!==(a=n.getPropertyValue(t)||n[t])||oe(e)||(a=k.style(e,t)),!y.pixelBoxStyles()&&$e.test(a)&&Be.test(t)&&(r=s.width,i=s.minWidth,o=s.maxWidth,s.minWidth=s.maxWidth=s.width=a,a=n.width,s.width=r,s.minWidth=i,s.maxWidth=o)),void 0!==a?a+"":a}function ze(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}!function(){function e(){if(u){s.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",u.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",ie.appendChild(s).appendChild(u);var e=C.getComputedStyle(u);n="1%"!==e.top,a=12===t(e.marginLeft),u.style.right="60%",o=36===t(e.right),r=36===t(e.width),u.style.position="absolute",i=12===t(u.offsetWidth/3),ie.removeChild(s),u=null}}function t(e){return Math.round(parseFloat(e))}var n,r,i,o,a,s=E.createElement("div"),u=E.createElement("div");u.style&&(u.style.backgroundClip="content-box",u.cloneNode(!0).style.backgroundClip="",y.clearCloneStyle="content-box"===u.style.backgroundClip,k.extend(y,{boxSizingReliable:function(){return e(),r},pixelBoxStyles:function(){return e(),o},pixelPosition:function(){return e(),n},reliableMarginLeft:function(){return e(),a},scrollboxSize:function(){return e(),i}}))}();var Ue=["Webkit","Moz","ms"],Xe=E.createElement("div").style,Ve={};function Ge(e){var t=k.cssProps[e]||Ve[e];return t||(e in Xe?e:Ve[e]=function(e){var t=e[0].toUpperCase()+e.slice(1),n=Ue.length;while(n--)if((e=Ue[n]+t)in Xe)return e}(e)||e)}var Ye=/^(none|table(?!-c[ea]).+)/,Qe=/^--/,Je={position:"absolute",visibility:"hidden",display:"block"},Ke={letterSpacing:"0",fontWeight:"400"};function Ze(e,t,n){var r=ne.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function et(e,t,n,r,i,o){var a="width"===t?1:0,s=0,u=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(u+=k.css(e,n+re[a],!0,i)),r?("content"===n&&(u-=k.css(e,"padding"+re[a],!0,i)),"margin"!==n&&(u-=k.css(e,"border"+re[a]+"Width",!0,i))):(u+=k.css(e,"padding"+re[a],!0,i),"padding"!==n?u+=k.css(e,"border"+re[a]+"Width",!0,i):s+=k.css(e,"border"+re[a]+"Width",!0,i));return!r&&0<=o&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))||0),u}function tt(e,t,n){var r=Fe(e),i=(!y.boxSizingReliable()||n)&&"border-box"===k.css(e,"boxSizing",!1,r),o=i,a=_e(e,t,r),s="offset"+t[0].toUpperCase()+t.slice(1);if($e.test(a)){if(!n)return a;a="auto"}return(!y.boxSizingReliable()&&i||"auto"===a||!parseFloat(a)&&"inline"===k.css(e,"display",!1,r))&&e.getClientRects().length&&(i="border-box"===k.css(e,"boxSizing",!1,r),(o=s in e)&&(a=e[s])),(a=parseFloat(a)||0)+et(e,t,n||(i?"border":"content"),o,r,a)+"px"}function nt(e,t,n,r,i){return new nt.prototype.init(e,t,n,r,i)}k.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=_e(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=V(t),u=Qe.test(t),l=e.style;if(u||(t=Ge(s)),a=k.cssHooks[t]||k.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];"string"===(o=typeof n)&&(i=ne.exec(n))&&i[1]&&(n=le(e,t,i),o="number"),null!=n&&n==n&&("number"!==o||u||(n+=i&&i[3]||(k.cssNumber[s]?"":"px")),y.clearCloneStyle||""!==n||0!==t.indexOf("background")||(l[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n))}},css:function(e,t,n,r){var i,o,a,s=V(t);return Qe.test(t)||(t=Ge(s)),(a=k.cssHooks[t]||k.cssHooks[s])&&"get"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=_e(e,t,r)),"normal"===i&&t in Ke&&(i=Ke[t]),""===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),k.each(["height","width"],function(e,u){k.cssHooks[u]={get:function(e,t,n){if(t)return!Ye.test(k.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?tt(e,u,n):ue(e,Je,function(){return tt(e,u,n)})},set:function(e,t,n){var r,i=Fe(e),o=!y.scrollboxSize()&&"absolute"===i.position,a=(o||n)&&"border-box"===k.css(e,"boxSizing",!1,i),s=n?et(e,u,n,a,i):0;return a&&o&&(s-=Math.ceil(e["offset"+u[0].toUpperCase()+u.slice(1)]-parseFloat(i[u])-et(e,u,"border",!1,i)-.5)),s&&(r=ne.exec(t))&&"px"!==(r[3]||"px")&&(e.style[u]=t,t=k.css(e,u)),Ze(0,t,s)}}}),k.cssHooks.marginLeft=ze(y.reliableMarginLeft,function(e,t){if(t)return(parseFloat(_e(e,"marginLeft"))||e.getBoundingClientRect().left-ue(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),k.each({margin:"",padding:"",border:"Width"},function(i,o){k.cssHooks[i+o]={expand:function(e){for(var t=0,n={},r="string"==typeof e?e.split(" "):[e];t<4;t++)n[i+re[t]+o]=r[t]||r[t-2]||r[0];return n}},"margin"!==i&&(k.cssHooks[i+o].set=Ze)}),k.fn.extend({css:function(e,t){return _(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=Fe(e),i=t.length;a<i;a++)o[t[a]]=k.css(e,t[a],!1,r);return o}return void 0!==n?k.style(e,t,n):k.css(e,t)},e,t,1<arguments.length)}}),((k.Tween=nt).prototype={constructor:nt,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||k.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(k.cssNumber[n]?"":"px")},cur:function(){var e=nt.propHooks[this.prop];return e&&e.get?e.get(this):nt.propHooks._default.get(this)},run:function(e){var t,n=nt.propHooks[this.prop];return this.options.duration?this.pos=t=k.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):nt.propHooks._default.set(this),this}}).init.prototype=nt.prototype,(nt.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=k.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){k.fx.step[e.prop]?k.fx.step[e.prop](e):1!==e.elem.nodeType||!k.cssHooks[e.prop]&&null==e.elem.style[Ge(e.prop)]?e.elem[e.prop]=e.now:k.style(e.elem,e.prop,e.now+e.unit)}}}).scrollTop=nt.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},k.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},k.fx=nt.prototype.init,k.fx.step={};var rt,it,ot,at,st=/^(?:toggle|show|hide)$/,ut=/queueHooks$/;function lt(){it&&(!1===E.hidden&&C.requestAnimationFrame?C.requestAnimationFrame(lt):C.setTimeout(lt,k.fx.interval),k.fx.tick())}function ct(){return C.setTimeout(function(){rt=void 0}),rt=Date.now()}function ft(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i["margin"+(n=re[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function pt(e,t,n){for(var r,i=(dt.tweeners[t]||[]).concat(dt.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function dt(o,e,t){var n,a,r=0,i=dt.prefilters.length,s=k.Deferred().always(function(){delete u.elem}),u=function(){if(a)return!1;for(var e=rt||ct(),t=Math.max(0,l.startTime+l.duration-e),n=1-(t/l.duration||0),r=0,i=l.tweens.length;r<i;r++)l.tweens[r].run(n);return s.notifyWith(o,[l,n,t]),n<1&&i?t:(i||s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l]),!1)},l=s.promise({elem:o,props:k.extend({},e),opts:k.extend(!0,{specialEasing:{},easing:k.easing._default},t),originalProperties:e,originalOptions:t,startTime:rt||ct(),duration:t.duration,tweens:[],createTween:function(e,t){var n=k.Tween(o,l.opts,e,t,l.opts.specialEasing[e]||l.opts.easing);return l.tweens.push(n),n},stop:function(e){var t=0,n=e?l.tweens.length:0;if(a)return this;for(a=!0;t<n;t++)l.tweens[t].run(1);return e?(s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l,e])):s.rejectWith(o,[l,e]),this}}),c=l.props;for(!function(e,t){var n,r,i,o,a;for(n in e)if(i=t[r=V(n)],o=e[n],Array.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=k.cssHooks[r])&&"expand"in a)for(n in o=a.expand(o),delete e[r],o)n in e||(e[n]=o[n],t[n]=i);else t[r]=i}(c,l.opts.specialEasing);r<i;r++)if(n=dt.prefilters[r].call(l,o,c,l.opts))return m(n.stop)&&(k._queueHooks(l.elem,l.opts.queue).stop=n.stop.bind(n)),n;return k.map(c,pt,l),m(l.opts.start)&&l.opts.start.call(o,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),k.fx.timer(k.extend(u,{elem:o,anim:l,queue:l.opts.queue})),l}k.Animation=k.extend(dt,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return le(n.elem,e,ne.exec(t),n),n}]},tweener:function(e,t){m(e)?(t=e,e=["*"]):e=e.match(R);for(var n,r=0,i=e.length;r<i;r++)n=e[r],dt.tweeners[n]=dt.tweeners[n]||[],dt.tweeners[n].unshift(t)},prefilters:[function(e,t,n){var r,i,o,a,s,u,l,c,f="width"in t||"height"in t,p=this,d={},h=e.style,g=e.nodeType&&se(e),v=Q.get(e,"fxshow");for(r in n.queue||(null==(a=k._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,k.queue(e,"fx").length||a.empty.fire()})})),t)if(i=t[r],st.test(i)){if(delete t[r],o=o||"toggle"===i,i===(g?"hide":"show")){if("show"!==i||!v||void 0===v[r])continue;g=!0}d[r]=v&&v[r]||k.style(e,r)}if((u=!k.isEmptyObject(t))||!k.isEmptyObject(d))for(r in f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=v&&v.display)&&(l=Q.get(e,"display")),"none"===(c=k.css(e,"display"))&&(l?c=l:(fe([e],!0),l=e.style.display||l,c=k.css(e,"display"),fe([e]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===k.css(e,"float")&&(u||(p.done(function(){h.display=l}),null==l&&(c=h.display,l="none"===c?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1,d)u||(v?"hidden"in v&&(g=v.hidden):v=Q.access(e,"fxshow",{display:l}),o&&(v.hidden=!g),g&&fe([e],!0),p.done(function(){for(r in g||fe([e]),Q.remove(e,"fxshow"),d)k.style(e,r,d[r])})),u=pt(g?v[r]:0,r,p),r in v||(v[r]=u.start,g&&(u.end=u.start,u.start=0))}],prefilter:function(e,t){t?dt.prefilters.unshift(e):dt.prefilters.push(e)}}),k.speed=function(e,t,n){var r=e&&"object"==typeof e?k.extend({},e):{complete:n||!n&&t||m(e)&&e,duration:e,easing:n&&t||t&&!m(t)&&t};return k.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in k.fx.speeds?r.duration=k.fx.speeds[r.duration]:r.duration=k.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){m(r.old)&&r.old.call(this),r.queue&&k.dequeue(this,r.queue)},r},k.fn.extend({fadeTo:function(e,t,n,r){return this.filter(se).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(t,e,n,r){var i=k.isEmptyObject(t),o=k.speed(e,n,r),a=function(){var e=dt(this,k.extend({},t),o);(i||Q.get(this,"finish"))&&e.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(i,e,o){var a=function(e){var t=e.stop;delete e.stop,t(o)};return"string"!=typeof i&&(o=e,e=i,i=void 0),e&&!1!==i&&this.queue(i||"fx",[]),this.each(function(){var e=!0,t=null!=i&&i+"queueHooks",n=k.timers,r=Q.get(this);if(t)r[t]&&r[t].stop&&a(r[t]);else for(t in r)r[t]&&r[t].stop&&ut.test(t)&&a(r[t]);for(t=n.length;t--;)n[t].elem!==this||null!=i&&n[t].queue!==i||(n[t].anim.stop(o),e=!1,n.splice(t,1));!e&&o||k.dequeue(this,i)})},finish:function(a){return!1!==a&&(a=a||"fx"),this.each(function(){var e,t=Q.get(this),n=t[a+"queue"],r=t[a+"queueHooks"],i=k.timers,o=n?n.length:0;for(t.finish=!0,k.queue(this,a,[]),r&&r.stop&&r.stop.call(this,!0),e=i.length;e--;)i[e].elem===this&&i[e].queue===a&&(i[e].anim.stop(!0),i.splice(e,1));for(e=0;e<o;e++)n[e]&&n[e].finish&&n[e].finish.call(this);delete t.finish})}}),k.each(["toggle","show","hide"],function(e,r){var i=k.fn[r];k.fn[r]=function(e,t,n){return null==e||"boolean"==typeof e?i.apply(this,arguments):this.animate(ft(r,!0),e,t,n)}}),k.each({slideDown:ft("show"),slideUp:ft("hide"),slideToggle:ft("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,r){k.fn[e]=function(e,t,n){return this.animate(r,e,t,n)}}),k.timers=[],k.fx.tick=function(){var e,t=0,n=k.timers;for(rt=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||k.fx.stop(),rt=void 0},k.fx.timer=function(e){k.timers.push(e),k.fx.start()},k.fx.interval=13,k.fx.start=function(){it||(it=!0,lt())},k.fx.stop=function(){it=null},k.fx.speeds={slow:600,fast:200,_default:400},k.fn.delay=function(r,e){return r=k.fx&&k.fx.speeds[r]||r,e=e||"fx",this.queue(e,function(e,t){var n=C.setTimeout(e,r);t.stop=function(){C.clearTimeout(n)}})},ot=E.createElement("input"),at=E.createElement("select").appendChild(E.createElement("option")),ot.type="checkbox",y.checkOn=""!==ot.value,y.optSelected=at.selected,(ot=E.createElement("input")).value="t",ot.type="radio",y.radioValue="t"===ot.value;var ht,gt=k.expr.attrHandle;k.fn.extend({attr:function(e,t){return _(this,k.attr,e,t,1<arguments.length)},removeAttr:function(e){return this.each(function(){k.removeAttr(this,e)})}}),k.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?k.prop(e,t,n):(1===o&&k.isXMLDoc(e)||(i=k.attrHooks[t.toLowerCase()]||(k.expr.match.bool.test(t)?ht:void 0)),void 0!==n?null===n?void k.removeAttr(e,t):i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n+""),n):i&&"get"in i&&null!==(r=i.get(e,t))?r:null==(r=k.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!y.radioValue&&"radio"===t&&N(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(R);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),ht={set:function(e,t,n){return!1===t?k.removeAttr(e,n):e.setAttribute(n,n),n}},k.each(k.expr.match.bool.source.match(/\w+/g),function(e,t){var a=gt[t]||k.find.attr;gt[t]=function(e,t,n){var r,i,o=t.toLowerCase();return n||(i=gt[o],gt[o]=r,r=null!=a(e,t,n)?o:null,gt[o]=i),r}});var vt=/^(?:input|select|textarea|button)$/i,yt=/^(?:a|area)$/i;function mt(e){return(e.match(R)||[]).join(" ")}function xt(e){return e.getAttribute&&e.getAttribute("class")||""}function bt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(R)||[]}k.fn.extend({prop:function(e,t){return _(this,k.prop,e,t,1<arguments.length)},removeProp:function(e){return this.each(function(){delete this[k.propFix[e]||e]})}}),k.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&k.isXMLDoc(e)||(t=k.propFix[t]||t,i=k.propHooks[t]),void 0!==n?i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=k.find.attr(e,"tabindex");return t?parseInt(t,10):vt.test(e.nodeName)||yt.test(e.nodeName)&&e.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),y.optSelected||(k.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),k.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){k.propFix[this.toLowerCase()]=this}),k.fn.extend({addClass:function(t){var e,n,r,i,o,a,s,u=0;if(m(t))return this.each(function(e){k(this).addClass(t.call(this,e,xt(this)))});if((e=bt(t)).length)while(n=this[u++])if(i=xt(n),r=1===n.nodeType&&" "+mt(i)+" "){a=0;while(o=e[a++])r.indexOf(" "+o+" ")<0&&(r+=o+" ");i!==(s=mt(r))&&n.setAttribute("class",s)}return this},removeClass:function(t){var e,n,r,i,o,a,s,u=0;if(m(t))return this.each(function(e){k(this).removeClass(t.call(this,e,xt(this)))});if(!arguments.length)return this.attr("class","");if((e=bt(t)).length)while(n=this[u++])if(i=xt(n),r=1===n.nodeType&&" "+mt(i)+" "){a=0;while(o=e[a++])while(-1<r.indexOf(" "+o+" "))r=r.replace(" "+o+" "," ");i!==(s=mt(r))&&n.setAttribute("class",s)}return this},toggleClass:function(i,t){var o=typeof i,a="string"===o||Array.isArray(i);return"boolean"==typeof t&&a?t?this.addClass(i):this.removeClass(i):m(i)?this.each(function(e){k(this).toggleClass(i.call(this,e,xt(this),t),t)}):this.each(function(){var e,t,n,r;if(a){t=0,n=k(this),r=bt(i);while(e=r[t++])n.hasClass(e)?n.removeClass(e):n.addClass(e)}else void 0!==i&&"boolean"!==o||((e=xt(this))&&Q.set(this,"__className__",e),this.setAttribute&&this.setAttribute("class",e||!1===i?"":Q.get(this,"__className__")||""))})},hasClass:function(e){var t,n,r=0;t=" "+e+" ";while(n=this[r++])if(1===n.nodeType&&-1<(" "+mt(xt(n))+" ").indexOf(t))return!0;return!1}});var wt=/\r/g;k.fn.extend({val:function(n){var r,e,i,t=this[0];return arguments.length?(i=m(n),this.each(function(e){var t;1===this.nodeType&&(null==(t=i?n.call(this,e,k(this).val()):n)?t="":"number"==typeof t?t+="":Array.isArray(t)&&(t=k.map(t,function(e){return null==e?"":e+""})),(r=k.valHooks[this.type]||k.valHooks[this.nodeName.toLowerCase()])&&"set"in r&&void 0!==r.set(this,t,"value")||(this.value=t))})):t?(r=k.valHooks[t.type]||k.valHooks[t.nodeName.toLowerCase()])&&"get"in r&&void 0!==(e=r.get(t,"value"))?e:"string"==typeof(e=t.value)?e.replace(wt,""):null==e?"":e:void 0}}),k.extend({valHooks:{option:{get:function(e){var t=k.find.attr(e,"value");return null!=t?t:mt(k.text(e))}},select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a="select-one"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!N(n.parentNode,"optgroup"))){if(t=k(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=k.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=-1<k.inArray(k.valHooks.option.get(r),o))&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),k.each(["radio","checkbox"],function(){k.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=-1<k.inArray(k(e).val(),t)}},y.checkOn||(k.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})}),y.focusin="onfocusin"in C;var Tt=/^(?:focusinfocus|focusoutblur)$/,Ct=function(e){e.stopPropagation()};k.extend(k.event,{trigger:function(e,t,n,r){var i,o,a,s,u,l,c,f,p=[n||E],d=v.call(e,"type")?e.type:e,h=v.call(e,"namespace")?e.namespace.split("."):[];if(o=f=a=n=n||E,3!==n.nodeType&&8!==n.nodeType&&!Tt.test(d+k.event.triggered)&&(-1<d.indexOf(".")&&(d=(h=d.split(".")).shift(),h.sort()),u=d.indexOf(":")<0&&"on"+d,(e=e[k.expando]?e:new k.Event(d,"object"==typeof e&&e)).isTrigger=r?2:3,e.namespace=h.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,e.result=void 0,e.target||(e.target=n),t=null==t?[e]:k.makeArray(t,[e]),c=k.event.special[d]||{},r||!c.trigger||!1!==c.trigger.apply(n,t))){if(!r&&!c.noBubble&&!x(n)){for(s=c.delegateType||d,Tt.test(s+d)||(o=o.parentNode);o;o=o.parentNode)p.push(o),a=o;a===(n.ownerDocument||E)&&p.push(a.defaultView||a.parentWindow||C)}i=0;while((o=p[i++])&&!e.isPropagationStopped())f=o,e.type=1<i?s:c.bindType||d,(l=(Q.get(o,"events")||{})[e.type]&&Q.get(o,"handle"))&&l.apply(o,t),(l=u&&o[u])&&l.apply&&G(o)&&(e.result=l.apply(o,t),!1===e.result&&e.preventDefault());return e.type=d,r||e.isDefaultPrevented()||c._default&&!1!==c._default.apply(p.pop(),t)||!G(n)||u&&m(n[d])&&!x(n)&&((a=n[u])&&(n[u]=null),k.event.triggered=d,e.isPropagationStopped()&&f.addEventListener(d,Ct),n[d](),e.isPropagationStopped()&&f.removeEventListener(d,Ct),k.event.triggered=void 0,a&&(n[u]=a)),e.result}},simulate:function(e,t,n){var r=k.extend(new k.Event,n,{type:e,isSimulated:!0});k.event.trigger(r,null,t)}}),k.fn.extend({trigger:function(e,t){return this.each(function(){k.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return k.event.trigger(e,t,n,!0)}}),y.focusin||k.each({focus:"focusin",blur:"focusout"},function(n,r){var i=function(e){k.event.simulate(r,e.target,k.event.fix(e))};k.event.special[r]={setup:function(){var e=this.ownerDocument||this,t=Q.access(e,r);t||e.addEventListener(n,i,!0),Q.access(e,r,(t||0)+1)},teardown:function(){var e=this.ownerDocument||this,t=Q.access(e,r)-1;t?Q.access(e,r,t):(e.removeEventListener(n,i,!0),Q.remove(e,r))}}});var Et=C.location,kt=Date.now(),St=/\?/;k.parseXML=function(e){var t;if(!e||"string"!=typeof e)return null;try{t=(new C.DOMParser).parseFromString(e,"text/xml")}catch(e){t=void 0}return t&&!t.getElementsByTagName("parsererror").length||k.error("Invalid XML: "+e),t};var At=/\[\]$/,Nt=/\r?\n/g,Dt=/^(?:submit|button|image|reset|file)$/i,jt=/^(?:input|select|textarea|keygen)/i;function qt(n,e,r,i){var t;if(Array.isArray(e))k.each(e,function(e,t){r||At.test(n)?i(n,t):qt(n+"["+("object"==typeof t&&null!=t?e:"")+"]",t,r,i)});else if(r||"object"!==w(e))i(n,e);else for(t in e)qt(n+"["+t+"]",e[t],r,i)}k.param=function(e,t){var n,r=[],i=function(e,t){var n=m(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!k.isPlainObject(e))k.each(e,function(){i(this.name,this.value)});else for(n in e)qt(n,e[n],t,i);return r.join("&")},k.fn.extend({serialize:function(){return k.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=k.prop(this,"elements");return e?k.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!k(this).is(":disabled")&&jt.test(this.nodeName)&&!Dt.test(e)&&(this.checked||!pe.test(e))}).map(function(e,t){var n=k(this).val();return null==n?null:Array.isArray(n)?k.map(n,function(e){return{name:t.name,value:e.replace(Nt,"\r\n")}}):{name:t.name,value:n.replace(Nt,"\r\n")}}).get()}});var Lt=/%20/g,Ht=/#.*$/,Ot=/([?&])_=[^&]*/,Pt=/^(.*?):[ \t]*([^\r\n]*)$/gm,Rt=/^(?:GET|HEAD)$/,Mt=/^\/\//,It={},Wt={},$t="*/".concat("*"),Ft=E.createElement("a");function Bt(o){return function(e,t){"string"!=typeof e&&(t=e,e="*");var n,r=0,i=e.toLowerCase().match(R)||[];if(m(t))while(n=i[r++])"+"===n[0]?(n=n.slice(1)||"*",(o[n]=o[n]||[]).unshift(t)):(o[n]=o[n]||[]).push(t)}}function _t(t,i,o,a){var s={},u=t===Wt;function l(e){var r;return s[e]=!0,k.each(t[e]||[],function(e,t){var n=t(i,o,a);return"string"!=typeof n||u||s[n]?u?!(r=n):void 0:(i.dataTypes.unshift(n),l(n),!1)}),r}return l(i.dataTypes[0])||!s["*"]&&l("*")}function zt(e,t){var n,r,i=k.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&k.extend(!0,e,r),e}Ft.href=Et.href,k.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:Et.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Et.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":$t,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":k.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?zt(zt(e,k.ajaxSettings),t):zt(k.ajaxSettings,e)},ajaxPrefilter:Bt(It),ajaxTransport:Bt(Wt),ajax:function(e,t){"object"==typeof e&&(t=e,e=void 0),t=t||{};var c,f,p,n,d,r,h,g,i,o,v=k.ajaxSetup({},t),y=v.context||v,m=v.context&&(y.nodeType||y.jquery)?k(y):k.event,x=k.Deferred(),b=k.Callbacks("once memory"),w=v.statusCode||{},a={},s={},u="canceled",T={readyState:0,getResponseHeader:function(e){var t;if(h){if(!n){n={};while(t=Pt.exec(p))n[t[1].toLowerCase()+" "]=(n[t[1].toLowerCase()+" "]||[]).concat(t[2])}t=n[e.toLowerCase()+" "]}return null==t?null:t.join(", ")},getAllResponseHeaders:function(){return h?p:null},setRequestHeader:function(e,t){return null==h&&(e=s[e.toLowerCase()]=s[e.toLowerCase()]||e,a[e]=t),this},overrideMimeType:function(e){return null==h&&(v.mimeType=e),this},statusCode:function(e){var t;if(e)if(h)T.always(e[T.status]);else for(t in e)w[t]=[w[t],e[t]];return this},abort:function(e){var t=e||u;return c&&c.abort(t),l(0,t),this}};if(x.promise(T),v.url=((e||v.url||Et.href)+"").replace(Mt,Et.protocol+"//"),v.type=t.method||t.type||v.method||v.type,v.dataTypes=(v.dataType||"*").toLowerCase().match(R)||[""],null==v.crossDomain){r=E.createElement("a");try{r.href=v.url,r.href=r.href,v.crossDomain=Ft.protocol+"//"+Ft.host!=r.protocol+"//"+r.host}catch(e){v.crossDomain=!0}}if(v.data&&v.processData&&"string"!=typeof v.data&&(v.data=k.param(v.data,v.traditional)),_t(It,v,t,T),h)return T;for(i in(g=k.event&&v.global)&&0==k.active++&&k.event.trigger("ajaxStart"),v.type=v.type.toUpperCase(),v.hasContent=!Rt.test(v.type),f=v.url.replace(Ht,""),v.hasContent?v.data&&v.processData&&0===(v.contentType||"").indexOf("application/x-www-form-urlencoded")&&(v.data=v.data.replace(Lt,"+")):(o=v.url.slice(f.length),v.data&&(v.processData||"string"==typeof v.data)&&(f+=(St.test(f)?"&":"?")+v.data,delete v.data),!1===v.cache&&(f=f.replace(Ot,"$1"),o=(St.test(f)?"&":"?")+"_="+kt+++o),v.url=f+o),v.ifModified&&(k.lastModified[f]&&T.setRequestHeader("If-Modified-Since",k.lastModified[f]),k.etag[f]&&T.setRequestHeader("If-None-Match",k.etag[f])),(v.data&&v.hasContent&&!1!==v.contentType||t.contentType)&&T.setRequestHeader("Content-Type",v.contentType),T.setRequestHeader("Accept",v.dataTypes[0]&&v.accepts[v.dataTypes[0]]?v.accepts[v.dataTypes[0]]+("*"!==v.dataTypes[0]?", "+$t+"; q=0.01":""):v.accepts["*"]),v.headers)T.setRequestHeader(i,v.headers[i]);if(v.beforeSend&&(!1===v.beforeSend.call(y,T,v)||h))return T.abort();if(u="abort",b.add(v.complete),T.done(v.success),T.fail(v.error),c=_t(Wt,v,t,T)){if(T.readyState=1,g&&m.trigger("ajaxSend",[T,v]),h)return T;v.async&&0<v.timeout&&(d=C.setTimeout(function(){T.abort("timeout")},v.timeout));try{h=!1,c.send(a,l)}catch(e){if(h)throw e;l(-1,e)}}else l(-1,"No Transport");function l(e,t,n,r){var i,o,a,s,u,l=t;h||(h=!0,d&&C.clearTimeout(d),c=void 0,p=r||"",T.readyState=0<e?4:0,i=200<=e&&e<300||304===e,n&&(s=function(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}(v,T,n)),s=function(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+u+" to "+o}}}return{state:"success",data:t}}(v,s,T,i),i?(v.ifModified&&((u=T.getResponseHeader("Last-Modified"))&&(k.lastModified[f]=u),(u=T.getResponseHeader("etag"))&&(k.etag[f]=u)),204===e||"HEAD"===v.type?l="nocontent":304===e?l="notmodified":(l=s.state,o=s.data,i=!(a=s.error))):(a=l,!e&&l||(l="error",e<0&&(e=0))),T.status=e,T.statusText=(t||l)+"",i?x.resolveWith(y,[o,l,T]):x.rejectWith(y,[T,l,a]),T.statusCode(w),w=void 0,g&&m.trigger(i?"ajaxSuccess":"ajaxError",[T,v,i?o:a]),b.fireWith(y,[T,l]),g&&(m.trigger("ajaxComplete",[T,v]),--k.active||k.event.trigger("ajaxStop")))}return T},getJSON:function(e,t,n){return k.get(e,t,n,"json")},getScript:function(e,t){return k.get(e,void 0,t,"script")}}),k.each(["get","post"],function(e,i){k[i]=function(e,t,n,r){return m(t)&&(r=r||n,n=t,t=void 0),k.ajax(k.extend({url:e,type:i,dataType:r,data:t,success:n},k.isPlainObject(e)&&e))}}),k._evalUrl=function(e,t){return k.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(e){k.globalEval(e,t)}})},k.fn.extend({wrapAll:function(e){var t;return this[0]&&(m(e)&&(e=e.call(this[0])),t=k(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(n){return m(n)?this.each(function(e){k(this).wrapInner(n.call(this,e))}):this.each(function(){var e=k(this),t=e.contents();t.length?t.wrapAll(n):e.append(n)})},wrap:function(t){var n=m(t);return this.each(function(e){k(this).wrapAll(n?t.call(this,e):t)})},unwrap:function(e){return this.parent(e).not("body").each(function(){k(this).replaceWith(this.childNodes)}),this}}),k.expr.pseudos.hidden=function(e){return!k.expr.pseudos.visible(e)},k.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},k.ajaxSettings.xhr=function(){try{return new C.XMLHttpRequest}catch(e){}};var Ut={0:200,1223:204},Xt=k.ajaxSettings.xhr();y.cors=!!Xt&&"withCredentials"in Xt,y.ajax=Xt=!!Xt,k.ajaxTransport(function(i){var o,a;if(y.cors||Xt&&!i.crossDomain)return{send:function(e,t){var n,r=i.xhr();if(r.open(i.type,i.url,i.async,i.username,i.password),i.xhrFields)for(n in i.xhrFields)r[n]=i.xhrFields[n];for(n in i.mimeType&&r.overrideMimeType&&r.overrideMimeType(i.mimeType),i.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest"),e)r.setRequestHeader(n,e[n]);o=function(e){return function(){o&&(o=a=r.onload=r.onerror=r.onabort=r.ontimeout=r.onreadystatechange=null,"abort"===e?r.abort():"error"===e?"number"!=typeof r.status?t(0,"error"):t(r.status,r.statusText):t(Ut[r.status]||r.status,r.statusText,"text"!==(r.responseType||"text")||"string"!=typeof r.responseText?{binary:r.response}:{text:r.responseText},r.getAllResponseHeaders()))}},r.onload=o(),a=r.onerror=r.ontimeout=o("error"),void 0!==r.onabort?r.onabort=a:r.onreadystatechange=function(){4===r.readyState&&C.setTimeout(function(){o&&a()})},o=o("abort");try{r.send(i.hasContent&&i.data||null)}catch(e){if(o)throw e}},abort:function(){o&&o()}}}),k.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),k.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return k.globalEval(e),e}}}),k.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),k.ajaxTransport("script",function(n){var r,i;if(n.crossDomain||n.scriptAttrs)return{send:function(e,t){r=k("<script>").attr(n.scriptAttrs||{}).prop({charset:n.scriptCharset,src:n.url}).on("load error",i=function(e){r.remove(),i=null,e&&t("error"===e.type?404:200,e.type)}),E.head.appendChild(r[0])},abort:function(){i&&i()}}});var Vt,Gt=[],Yt=/(=)\?(?=&|$)|\?\?/;k.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=Gt.pop()||k.expando+"_"+kt++;return this[e]=!0,e}}),k.ajaxPrefilter("json jsonp",function(e,t,n){var r,i,o,a=!1!==e.jsonp&&(Yt.test(e.url)?"url":"string"==typeof e.data&&0===(e.contentType||"").indexOf("application/x-www-form-urlencoded")&&Yt.test(e.data)&&"data");if(a||"jsonp"===e.dataTypes[0])return r=e.jsonpCallback=m(e.jsonpCallback)?e.jsonpCallback():e.jsonpCallback,a?e[a]=e[a].replace(Yt,"$1"+r):!1!==e.jsonp&&(e.url+=(St.test(e.url)?"&":"?")+e.jsonp+"="+r),e.converters["script json"]=function(){return o||k.error(r+" was not called"),o[0]},e.dataTypes[0]="json",i=C[r],C[r]=function(){o=arguments},n.always(function(){void 0===i?k(C).removeProp(r):C[r]=i,e[r]&&(e.jsonpCallback=t.jsonpCallback,Gt.push(r)),o&&m(i)&&i(o[0]),o=i=void 0}),"script"}),y.createHTMLDocument=((Vt=E.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===Vt.childNodes.length),k.parseHTML=function(e,t,n){return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(y.createHTMLDocument?((r=(t=E.implementation.createHTMLDocument("")).createElement("base")).href=E.location.href,t.head.appendChild(r)):t=E),o=!n&&[],(i=D.exec(e))?[t.createElement(i[1])]:(i=we([e],t,o),o&&o.length&&k(o).remove(),k.merge([],i.childNodes)));var r,i,o},k.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return-1<s&&(r=mt(e.slice(s)),e=e.slice(0,s)),m(t)?(n=t,t=void 0):t&&"object"==typeof t&&(i="POST"),0<a.length&&k.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?k("<div>").append(k.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},k.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){k.fn[t]=function(e){return this.on(t,e)}}),k.expr.pseudos.animated=function(t){return k.grep(k.timers,function(e){return t===e.elem}).length},k.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l=k.css(e,"position"),c=k(e),f={};"static"===l&&(e.style.position="relative"),s=c.offset(),o=k.css(e,"top"),u=k.css(e,"left"),("absolute"===l||"fixed"===l)&&-1<(o+u).indexOf("auto")?(a=(r=c.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),m(t)&&(t=t.call(e,n,k.extend({},s))),null!=t.top&&(f.top=t.top-s.top+a),null!=t.left&&(f.left=t.left-s.left+i),"using"in t?t.using.call(e,f):c.css(f)}},k.fn.extend({offset:function(t){if(arguments.length)return void 0===t?this:this.each(function(e){k.offset.setOffset(this,t,e)});var e,n,r=this[0];return r?r.getClientRects().length?(e=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:e.top+n.pageYOffset,left:e.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===k.css(r,"position"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&(e===n.body||e===n.documentElement)&&"static"===k.css(e,"position"))e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=k(e).offset()).top+=k.css(e,"borderTopWidth",!0),i.left+=k.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-k.css(r,"marginTop",!0),left:t.left-i.left-k.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&"static"===k.css(e,"position"))e=e.offsetParent;return e||ie})}}),k.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(t,i){var o="pageYOffset"===i;k.fn[t]=function(e){return _(this,function(e,t,n){var r;if(x(e)?r=e:9===e.nodeType&&(r=e.defaultView),void 0===n)return r?r[i]:e[t];r?r.scrollTo(o?r.pageXOffset:n,o?n:r.pageYOffset):e[t]=n},t,e,arguments.length)}}),k.each(["top","left"],function(e,n){k.cssHooks[n]=ze(y.pixelPosition,function(e,t){if(t)return t=_e(e,n),$e.test(t)?k(e).position()[n]+"px":t})}),k.each({Height:"height",Width:"width"},function(a,s){k.each({padding:"inner"+a,content:s,"":"outer"+a},function(r,o){k.fn[o]=function(e,t){var n=arguments.length&&(r||"boolean"!=typeof e),i=r||(!0===e||!0===t?"margin":"border");return _(this,function(e,t,n){var r;return x(e)?0===o.indexOf("outer")?e["inner"+a]:e.document.documentElement["client"+a]:9===e.nodeType?(r=e.documentElement,Math.max(e.body["scroll"+a],r["scroll"+a],e.body["offset"+a],r["offset"+a],r["client"+a])):void 0===n?k.css(e,t,i):k.style(e,t,n,i)},s,n?e:void 0,n)}})}),k.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,n){k.fn[n]=function(e,t){return 0<arguments.length?this.on(n,null,e,t):this.trigger(n)}}),k.fn.extend({hover:function(e,t){return this.mouseenter(e).mouseleave(t||e)}}),k.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)}}),k.proxy=function(e,t){var n,r,i;if("string"==typeof t&&(n=e[t],t=e,e=n),m(e))return r=s.call(arguments,2),(i=function(){return e.apply(t||this,r.concat(s.call(arguments)))}).guid=e.guid=e.guid||k.guid++,i},k.holdReady=function(e){e?k.readyWait++:k.ready(!0)},k.isArray=Array.isArray,k.parseJSON=JSON.parse,k.nodeName=N,k.isFunction=m,k.isWindow=x,k.camelCase=V,k.type=w,k.now=Date.now,k.isNumeric=function(e){var t=k.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},"function"==typeof define&&define.amd&&define("jquery",[],function(){return k});var Qt=C.jQuery,Jt=C.$;return k.noConflict=function(e){return C.$===k&&(C.$=Jt),e&&C.jQuery===k&&(C.jQuery=Qt),k},e||(C.jQuery=C.$=k),k});

/*!
 * Flickity PACKAGED v2.3.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2021 Metafizzy
 */

/**
 * Bridget makes jQuery widgets
 * v2.0.1
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /* globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'jquery-bridget/jquery-bridget',[ 'jquery' ], function( jQuery ) {
      return factory( window, jQuery );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('jquery')
    );
  } else {
    // browser global
    window.jQueryBridget = factory(
      window,
      window.jQuery
    );
  }

}( window, function factory( window, jQuery ) {
'use strict';

// ----- utils ----- //

var arraySlice = Array.prototype.slice;

// helper function for logging errors
// $.error breaks jQuery chaining
var console = window.console;
var logError = typeof console == 'undefined' ? function() {} :
  function( message ) {
    console.error( message );
  };

// ----- jQueryBridget ----- //

function jQueryBridget( namespace, PluginClass, $ ) {
  $ = $ || jQuery || window.jQuery;
  if ( !$ ) {
    return;
  }

  // add option method -> $().plugin('option', {...})
  if ( !PluginClass.prototype.option ) {
    // option setter
    PluginClass.prototype.option = function( opts ) {
      // bail out if not an object
      if ( !$.isPlainObject( opts ) ){
        return;
      }
      this.options = $.extend( true, this.options, opts );
    };
  }

  // make jQuery plugin
  $.fn[ namespace ] = function( arg0 /*, arg1 */ ) {
    if ( typeof arg0 == 'string' ) {
      // method call $().plugin( 'methodName', { options } )
      // shift arguments by 1
      var args = arraySlice.call( arguments, 1 );
      return methodCall( this, arg0, args );
    }
    // just $().plugin({ options })
    plainCall( this, arg0 );
    return this;
  };

  // $().plugin('methodName')
  function methodCall( $elems, methodName, args ) {
    var returnValue;
    var pluginMethodStr = '$().' + namespace + '("' + methodName + '")';

    $elems.each( function( i, elem ) {
      // get instance
      var instance = $.data( elem, namespace );
      if ( !instance ) {
        logError( namespace + ' not initialized. Cannot call methods, i.e. ' +
          pluginMethodStr );
        return;
      }

      var method = instance[ methodName ];
      if ( !method || methodName.charAt(0) == '_' ) {
        logError( pluginMethodStr + ' is not a valid method' );
        return;
      }

      // apply method, get return value
      var value = method.apply( instance, args );
      // set return value if value is returned, use only first value
      returnValue = returnValue === undefined ? value : returnValue;
    });

    return returnValue !== undefined ? returnValue : $elems;
  }

  function plainCall( $elems, options ) {
    $elems.each( function( i, elem ) {
      var instance = $.data( elem, namespace );
      if ( instance ) {
        // set options & init
        instance.option( options );
        instance._init();
      } else {
        // initialize new instance
        instance = new PluginClass( elem, options );
        $.data( elem, namespace, instance );
      }
    });
  }

  updateJQuery( $ );

}

// ----- updateJQuery ----- //

// set $.bridget for v1 backwards compatibility
function updateJQuery( $ ) {
  if ( !$ || ( $ && $.bridget ) ) {
    return;
  }
  $.bridget = jQueryBridget;
}

updateJQuery( jQuery || window.jQuery );

// -----  ----- //

return jQueryBridget;

}));

/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if ( typeof define == 'function' && define.amd ) {
    // AMD - RequireJS
    define( 'ev-emitter/ev-emitter',factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }

}( typeof window != 'undefined' ? window : this, function() {



function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  // copy over to avoid interference if .off() in listener
  listeners = listeners.slice(0);
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  for ( var i=0; i < listeners.length; i++ ) {
    var listener = listeners[i]
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
  }

  return this;
};

proto.allOff = function() {
  delete this._events;
  delete this._onceEvents;
};

return EvEmitter;

}));

/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */
/* globals console: false */

( function( window, factory ) {
  /* jshint strict: false */ /* globals define, module */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'get-size/get-size',factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.getSize = factory();
  }

})( window, function factory() {
'use strict';

// -------------------------- helpers -------------------------- //

// get a number from a string, not a percentage
function getStyleSize( value ) {
  var num = parseFloat( value );
  // not a percent like '100%', and a number
  var isValid = value.indexOf('%') == -1 && !isNaN( num );
  return isValid && num;
}

function noop() {}

var logError = typeof console == 'undefined' ? noop :
  function( message ) {
    console.error( message );
  };

// -------------------------- measurements -------------------------- //

var measurements = [
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
  'borderLeftWidth',
  'borderRightWidth',
  'borderTopWidth',
  'borderBottomWidth'
];

var measurementsLength = measurements.length;

function getZeroSize() {
  var size = {
    width: 0,
    height: 0,
    innerWidth: 0,
    innerHeight: 0,
    outerWidth: 0,
    outerHeight: 0
  };
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    size[ measurement ] = 0;
  }
  return size;
}

// -------------------------- getStyle -------------------------- //

/**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */
function getStyle( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    logError( 'Style returned ' + style +
      '. Are you running this code in a hidden iframe on Firefox? ' +
      'See https://bit.ly/getsizebug1' );
  }
  return style;
}

// -------------------------- setup -------------------------- //

var isSetup = false;

var isBoxSizeOuter;

/**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */
function setup() {
  // setup once
  if ( isSetup ) {
    return;
  }
  isSetup = true;

  // -------------------------- box sizing -------------------------- //

  /**
   * Chrome & Safari measure the outer-width on style.width on border-box elems
   * IE11 & Firefox<29 measures the inner-width
   */
  var div = document.createElement('div');
  div.style.width = '200px';
  div.style.padding = '1px 2px 3px 4px';
  div.style.borderStyle = 'solid';
  div.style.borderWidth = '1px 2px 3px 4px';
  div.style.boxSizing = 'border-box';

  var body = document.body || document.documentElement;
  body.appendChild( div );
  var style = getStyle( div );
  // round value for browser zoom. desandro/masonry#928
  isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;
  getSize.isBoxSizeOuter = isBoxSizeOuter;

  body.removeChild( div );
}

// -------------------------- getSize -------------------------- //

function getSize( elem ) {
  setup();

  // use querySeletor if elem is string
  if ( typeof elem == 'string' ) {
    elem = document.querySelector( elem );
  }

  // do not proceed on non-objects
  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
    return;
  }

  var style = getStyle( elem );

  // if hidden, everything is 0
  if ( style.display == 'none' ) {
    return getZeroSize();
  }

  var size = {};
  size.width = elem.offsetWidth;
  size.height = elem.offsetHeight;

  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

  // get all measurements
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    var value = style[ measurement ];
    var num = parseFloat( value );
    // any 'auto', 'medium' value will be 0
    size[ measurement ] = !isNaN( num ) ? num : 0;
  }

  var paddingWidth = size.paddingLeft + size.paddingRight;
  var paddingHeight = size.paddingTop + size.paddingBottom;
  var marginWidth = size.marginLeft + size.marginRight;
  var marginHeight = size.marginTop + size.marginBottom;
  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
  var borderHeight = size.borderTopWidth + size.borderBottomWidth;

  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

  // overwrite width and height if we can get it from style
  var styleWidth = getStyleSize( style.width );
  if ( styleWidth !== false ) {
    size.width = styleWidth +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
  }

  var styleHeight = getStyleSize( style.height );
  if ( styleHeight !== false ) {
    size.height = styleHeight +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
  }

  size.innerWidth = size.width - ( paddingWidth + borderWidth );
  size.innerHeight = size.height - ( paddingHeight + borderHeight );

  size.outerWidth = size.width + marginWidth;
  size.outerHeight = size.height + marginHeight;

  return size;
}

return getSize;

});

/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  /*global define: false, module: false */
  'use strict';
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'desandro-matches-selector/matches-selector',factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.matchesSelector = factory();
  }

}( window, function factory() {
  'use strict';

  var matchesMethod = ( function() {
    var ElemProto = window.Element.prototype;
    // check for the standard method name first
    if ( ElemProto.matches ) {
      return 'matches';
    }
    // check un-prefixed
    if ( ElemProto.matchesSelector ) {
      return 'matchesSelector';
    }
    // check vendor prefixes
    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];

    for ( var i=0; i < prefixes.length; i++ ) {
      var prefix = prefixes[i];
      var method = prefix + 'MatchesSelector';
      if ( ElemProto[ method ] ) {
        return method;
      }
    }
  })();

  return function matchesSelector( elem, selector ) {
    return elem[ matchesMethod ]( selector );
  };

}));

/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'fizzy-ui-utils/utils',[
      'desandro-matches-selector/matches-selector'
    ], function( matchesSelector ) {
      return factory( window, matchesSelector );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('desandro-matches-selector')
    );
  } else {
    // browser global
    window.fizzyUIUtils = factory(
      window,
      window.matchesSelector
    );
  }

}( window, function factory( window, matchesSelector ) {



var utils = {};

// ----- extend ----- //

// extends objects
utils.extend = function( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
};

// ----- modulo ----- //

utils.modulo = function( num, div ) {
  return ( ( num % div ) + div ) % div;
};

// ----- makeArray ----- //

var arraySlice = Array.prototype.slice;

// turn element or nodeList into an array
utils.makeArray = function( obj ) {
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    return obj;
  }
  // return empty array if undefined or null. #6
  if ( obj === null || obj === undefined ) {
    return [];
  }

  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
  if ( isArrayLike ) {
    // convert nodeList to array
    return arraySlice.call( obj );
  }

  // array of single index
  return [ obj ];
};

// ----- removeFrom ----- //

utils.removeFrom = function( ary, obj ) {
  var index = ary.indexOf( obj );
  if ( index != -1 ) {
    ary.splice( index, 1 );
  }
};

// ----- getParent ----- //

utils.getParent = function( elem, selector ) {
  while ( elem.parentNode && elem != document.body ) {
    elem = elem.parentNode;
    if ( matchesSelector( elem, selector ) ) {
      return elem;
    }
  }
};

// ----- getQueryElement ----- //

// use element as selector string
utils.getQueryElement = function( elem ) {
  if ( typeof elem == 'string' ) {
    return document.querySelector( elem );
  }
  return elem;
};

// ----- handleEvent ----- //

// enable .ontype to trigger from .addEventListener( elem, 'type' )
utils.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// ----- filterFindElements ----- //

utils.filterFindElements = function( elems, selector ) {
  // make array of elems
  elems = utils.makeArray( elems );
  var ffElems = [];

  elems.forEach( function( elem ) {
    // check that elem is an actual element
    if ( !( elem instanceof HTMLElement ) ) {
      return;
    }
    // add elem if no selector
    if ( !selector ) {
      ffElems.push( elem );
      return;
    }
    // filter & find items if we have a selector
    // filter
    if ( matchesSelector( elem, selector ) ) {
      ffElems.push( elem );
    }
    // find children
    var childElems = elem.querySelectorAll( selector );
    // concat childElems to filterFound array
    for ( var i=0; i < childElems.length; i++ ) {
      ffElems.push( childElems[i] );
    }
  });

  return ffElems;
};

// ----- debounceMethod ----- //

utils.debounceMethod = function( _class, methodName, threshold ) {
  threshold = threshold || 100;
  // original method
  var method = _class.prototype[ methodName ];
  var timeoutName = methodName + 'Timeout';

  _class.prototype[ methodName ] = function() {
    var timeout = this[ timeoutName ];
    clearTimeout( timeout );

    var args = arguments;
    var _this = this;
    this[ timeoutName ] = setTimeout( function() {
      method.apply( _this, args );
      delete _this[ timeoutName ];
    }, threshold );
  };
};

// ----- docReady ----- //

utils.docReady = function( callback ) {
  var readyState = document.readyState;
  if ( readyState == 'complete' || readyState == 'interactive' ) {
    // do async to allow for other scripts to run. metafizzy/flickity#441
    setTimeout( callback );
  } else {
    document.addEventListener( 'DOMContentLoaded', callback );
  }
};

// ----- htmlInit ----- //

// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
utils.toDashed = function( str ) {
  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
    return $1 + '-' + $2;
  }).toLowerCase();
};

var console = window.console;
/**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */
utils.htmlInit = function( WidgetClass, namespace ) {
  utils.docReady( function() {
    var dashedNamespace = utils.toDashed( namespace );
    var dataAttr = 'data-' + dashedNamespace;
    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
    var elems = utils.makeArray( dataAttrElems )
      .concat( utils.makeArray( jsDashElems ) );
    var dataOptionsAttr = dataAttr + '-options';
    var jQuery = window.jQuery;

    elems.forEach( function( elem ) {
      var attr = elem.getAttribute( dataAttr ) ||
        elem.getAttribute( dataOptionsAttr );
      var options;
      try {
        options = attr && JSON.parse( attr );
      } catch ( error ) {
        // log error, do not initialize
        if ( console ) {
          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
          ': ' + error );
        }
        return;
      }
      // initialize
      var instance = new WidgetClass( elem, options );
      // make available via $().data('namespace')
      if ( jQuery ) {
        jQuery.data( elem, namespace, instance );
      }
    });

  });
};

// -----  ----- //

return utils;

}));

// Flickity.Cell
( function( window, factory ) {
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity/js/cell',[
      'get-size/get-size',
    ], function( getSize ) {
      return factory( window, getSize );
    } );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('get-size')
    );
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Cell = factory(
        window,
        window.getSize
    );
  }

}( window, function factory( window, getSize ) {



function Cell( elem, parent ) {
  this.element = elem;
  this.parent = parent;

  this.create();
}

var proto = Cell.prototype;

proto.create = function() {
  this.element.style.position = 'absolute';
  this.element.setAttribute( 'aria-hidden', 'true' );
  this.x = 0;
  this.shift = 0;
  this.element.style[ this.parent.originSide ] = 0;
};

proto.destroy = function() {
  // reset style
  this.unselect();
  this.element.style.position = '';
  var side = this.parent.originSide;
  this.element.style[ side ] = '';
  this.element.style.transform = '';
  this.element.removeAttribute('aria-hidden');
};

proto.getSize = function() {
  this.size = getSize( this.element );
};

proto.setPosition = function( x ) {
  this.x = x;
  this.updateTarget();
  this.renderPosition( x );
};

// setDefaultTarget v1 method, backwards compatibility, remove in v3
proto.updateTarget = proto.setDefaultTarget = function() {
  var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
  this.target = this.x + this.size[ marginProperty ] +
    this.size.width * this.parent.cellAlign;
};

proto.renderPosition = function( x ) {
  // render position of cell with in slider
  var sideOffset = this.parent.originSide === 'left' ? 1 : -1;

  var adjustedX = this.parent.options.percentPosition ?
    x * sideOffset * ( this.parent.size.innerWidth / this.size.width ) :
    x * sideOffset;

  this.element.style.transform = 'translateX(' +
    this.parent.getPositionValue( adjustedX ) + ')';
};

proto.select = function() {
  this.element.classList.add('is-selected');
  this.element.removeAttribute('aria-hidden');
};

proto.unselect = function() {
  this.element.classList.remove('is-selected');
  this.element.setAttribute( 'aria-hidden', 'true' );
};

/**
 * @param {Integer} shift - 0, 1, or -1
 */
proto.wrapShift = function( shift ) {
  this.shift = shift;
  this.renderPosition( this.x + this.parent.slideableWidth * shift );
};

proto.remove = function() {
  this.element.parentNode.removeChild( this.element );
};

return Cell;

} ) );

// slide
( function( window, factory ) {
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity/js/slide',factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.Slide = factory();
  }

}( window, function factory() {
'use strict';

function Slide( parent ) {
  this.parent = parent;
  this.isOriginLeft = parent.originSide == 'left';
  this.cells = [];
  this.outerWidth = 0;
  this.height = 0;
}

var proto = Slide.prototype;

proto.addCell = function( cell ) {
  this.cells.push( cell );
  this.outerWidth += cell.size.outerWidth;
  this.height = Math.max( cell.size.outerHeight, this.height );
  // first cell stuff
  if ( this.cells.length == 1 ) {
    this.x = cell.x; // x comes from first cell
    var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
    this.firstMargin = cell.size[ beginMargin ];
  }
};

proto.updateTarget = function() {
  var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
  var lastCell = this.getLastCell();
  var lastMargin = lastCell ? lastCell.size[ endMargin ] : 0;
  var slideWidth = this.outerWidth - ( this.firstMargin + lastMargin );
  this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
};

proto.getLastCell = function() {
  return this.cells[ this.cells.length - 1 ];
};

proto.select = function() {
  this.cells.forEach( function( cell ) {
    cell.select();
  } );
};

proto.unselect = function() {
  this.cells.forEach( function( cell ) {
    cell.unselect();
  } );
};

proto.getCellElements = function() {
  return this.cells.map( function( cell ) {
    return cell.element;
  } );
};

return Slide;

} ) );

// animate
( function( window, factory ) {
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity/js/animate',[
      'fizzy-ui-utils/utils',
    ], function( utils ) {
      return factory( window, utils );
    } );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    window.Flickity = window.Flickity || {};
    window.Flickity.animatePrototype = factory(
        window,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, utils ) {



// -------------------------- animate -------------------------- //

var proto = {};

proto.startAnimation = function() {
  if ( this.isAnimating ) {
    return;
  }

  this.isAnimating = true;
  this.restingFrames = 0;
  this.animate();
};

proto.animate = function() {
  this.applyDragForce();
  this.applySelectedAttraction();

  var previousX = this.x;

  this.integratePhysics();
  this.positionSlider();
  this.settle( previousX );
  // animate next frame
  if ( this.isAnimating ) {
    var _this = this;
    requestAnimationFrame( function animateFrame() {
      _this.animate();
    } );
  }
};

proto.positionSlider = function() {
  var x = this.x;
  // wrap position around
  if ( this.options.wrapAround && this.cells.length > 1 ) {
    x = utils.modulo( x, this.slideableWidth );
    x -= this.slideableWidth;
    this.shiftWrapCells( x );
  }

  this.setTranslateX( x, this.isAnimating );
  this.dispatchScrollEvent();
};

proto.setTranslateX = function( x, is3d ) {
  x += this.cursorPosition;
  // reverse if right-to-left and using transform
  x = this.options.rightToLeft ? -x : x;
  var translateX = this.getPositionValue( x );
  // use 3D transforms for hardware acceleration on iOS
  // but use 2D when settled, for better font-rendering
  this.slider.style.transform = is3d ?
    'translate3d(' + translateX + ',0,0)' : 'translateX(' + translateX + ')';
};

proto.dispatchScrollEvent = function() {
  var firstSlide = this.slides[0];
  if ( !firstSlide ) {
    return;
  }
  var positionX = -this.x - firstSlide.target;
  var progress = positionX / this.slidesWidth;
  this.dispatchEvent( 'scroll', null, [ progress, positionX ] );
};

proto.positionSliderAtSelected = function() {
  if ( !this.cells.length ) {
    return;
  }
  this.x = -this.selectedSlide.target;
  this.velocity = 0; // stop wobble
  this.positionSlider();
};

proto.getPositionValue = function( position ) {
  if ( this.options.percentPosition ) {
    // percent position, round to 2 digits, like 12.34%
    return ( Math.round( ( position / this.size.innerWidth ) * 10000 ) * 0.01 ) + '%';
  } else {
    // pixel positioning
    return Math.round( position ) + 'px';
  }
};

proto.settle = function( previousX ) {
  // keep track of frames where x hasn't moved
  var isResting = !this.isPointerDown &&
      Math.round( this.x * 100 ) == Math.round( previousX * 100 );
  if ( isResting ) {
    this.restingFrames++;
  }
  // stop animating if resting for 3 or more frames
  if ( this.restingFrames > 2 ) {
    this.isAnimating = false;
    delete this.isFreeScrolling;
    // render position with translateX when settled
    this.positionSlider();
    this.dispatchEvent( 'settle', null, [ this.selectedIndex ] );
  }
};

proto.shiftWrapCells = function( x ) {
  // shift before cells
  var beforeGap = this.cursorPosition + x;
  this._shiftCells( this.beforeShiftCells, beforeGap, -1 );
  // shift after cells
  var afterGap = this.size.innerWidth - ( x + this.slideableWidth + this.cursorPosition );
  this._shiftCells( this.afterShiftCells, afterGap, 1 );
};

proto._shiftCells = function( cells, gap, shift ) {
  for ( var i = 0; i < cells.length; i++ ) {
    var cell = cells[i];
    var cellShift = gap > 0 ? shift : 0;
    cell.wrapShift( cellShift );
    gap -= cell.size.outerWidth;
  }
};

proto._unshiftCells = function( cells ) {
  if ( !cells || !cells.length ) {
    return;
  }
  for ( var i = 0; i < cells.length; i++ ) {
    cells[i].wrapShift( 0 );
  }
};

// -------------------------- physics -------------------------- //

proto.integratePhysics = function() {
  this.x += this.velocity;
  this.velocity *= this.getFrictionFactor();
};

proto.applyForce = function( force ) {
  this.velocity += force;
};

proto.getFrictionFactor = function() {
  return 1 - this.options[ this.isFreeScrolling ? 'freeScrollFriction' : 'friction' ];
};

proto.getRestingPosition = function() {
  // my thanks to Steven Wittens, who simplified this math greatly
  return this.x + this.velocity / ( 1 - this.getFrictionFactor() );
};

proto.applyDragForce = function() {
  if ( !this.isDraggable || !this.isPointerDown ) {
    return;
  }
  // change the position to drag position by applying force
  var dragVelocity = this.dragX - this.x;
  var dragForce = dragVelocity - this.velocity;
  this.applyForce( dragForce );
};

proto.applySelectedAttraction = function() {
  // do not attract if pointer down or no slides
  var dragDown = this.isDraggable && this.isPointerDown;
  if ( dragDown || this.isFreeScrolling || !this.slides.length ) {
    return;
  }
  var distance = this.selectedSlide.target * -1 - this.x;
  var force = distance * this.options.selectedAttraction;
  this.applyForce( force );
};

return proto;

} ) );

// Flickity main
/* eslint-disable max-params */
( function( window, factory ) {
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity/js/flickity',[
      'ev-emitter/ev-emitter',
      'get-size/get-size',
      'fizzy-ui-utils/utils',
      './cell',
      './slide',
      './animate',
    ], function( EvEmitter, getSize, utils, Cell, Slide, animatePrototype ) {
      return factory( window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype );
    } );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('ev-emitter'),
        require('get-size'),
        require('fizzy-ui-utils'),
        require('./cell'),
        require('./slide'),
        require('./animate')
    );
  } else {
    // browser global
    var _Flickity = window.Flickity;

    window.Flickity = factory(
        window,
        window.EvEmitter,
        window.getSize,
        window.fizzyUIUtils,
        _Flickity.Cell,
        _Flickity.Slide,
        _Flickity.animatePrototype
    );
  }

}( window, function factory( window, EvEmitter, getSize,
    utils, Cell, Slide, animatePrototype ) {

/* eslint-enable max-params */


// vars
var jQuery = window.jQuery;
var getComputedStyle = window.getComputedStyle;
var console = window.console;

function moveElements( elems, toElem ) {
  elems = utils.makeArray( elems );
  while ( elems.length ) {
    toElem.appendChild( elems.shift() );
  }
}

// -------------------------- Flickity -------------------------- //

// globally unique identifiers
var GUID = 0;
// internal store of all Flickity intances
var instances = {};

function Flickity( element, options ) {
  var queryElement = utils.getQueryElement( element );
  if ( !queryElement ) {
    if ( console ) {
      console.error( 'Bad element for Flickity: ' + ( queryElement || element ) );
    }
    return;
  }
  this.element = queryElement;
  // do not initialize twice on same element
  if ( this.element.flickityGUID ) {
    var instance = instances[ this.element.flickityGUID ];
    if ( instance ) instance.option( options );
    return instance;
  }

  // add jQuery
  if ( jQuery ) {
    this.$element = jQuery( this.element );
  }
  // options
  this.options = utils.extend( {}, this.constructor.defaults );
  this.option( options );

  // kick things off
  this._create();
}

Flickity.defaults = {
  accessibility: true,
  // adaptiveHeight: false,
  cellAlign: 'center',
  // cellSelector: undefined,
  // contain: false,
  freeScrollFriction: 0.075, // friction when free-scrolling
  friction: 0.28, // friction when selecting
  namespaceJQueryEvents: true,
  // initialIndex: 0,
  percentPosition: true,
  resize: true,
  selectedAttraction: 0.025,
  setGallerySize: true,
  // watchCSS: false,
  // wrapAround: false
};

// hash of methods triggered on _create()
Flickity.createMethods = [];

var proto = Flickity.prototype;
// inherit EventEmitter
utils.extend( proto, EvEmitter.prototype );

proto._create = function() {
  // add id for Flickity.data
  var id = this.guid = ++GUID;
  this.element.flickityGUID = id; // expando
  instances[ id ] = this; // associate via id
  // initial properties
  this.selectedIndex = 0;
  // how many frames slider has been in same position
  this.restingFrames = 0;
  // initial physics properties
  this.x = 0;
  this.velocity = 0;
  this.originSide = this.options.rightToLeft ? 'right' : 'left';
  // create viewport & slider
  this.viewport = document.createElement('div');
  this.viewport.className = 'flickity-viewport';
  this._createSlider();

  if ( this.options.resize || this.options.watchCSS ) {
    window.addEventListener( 'resize', this );
  }

  // add listeners from on option
  for ( var eventName in this.options.on ) {
    var listener = this.options.on[ eventName ];
    this.on( eventName, listener );
  }

  Flickity.createMethods.forEach( function( method ) {
    this[ method ]();
  }, this );

  if ( this.options.watchCSS ) {
    this.watchCSS();
  } else {
    this.activate();
  }

};

/**
 * set options
 * @param {Object} opts - options to extend
 */
proto.option = function( opts ) {
  utils.extend( this.options, opts );
};

proto.activate = function() {
  if ( this.isActive ) {
    return;
  }
  this.isActive = true;
  this.element.classList.add('flickity-enabled');
  if ( this.options.rightToLeft ) {
    this.element.classList.add('flickity-rtl');
  }

  this.getSize();
  // move initial cell elements so they can be loaded as cells
  var cellElems = this._filterFindCellElements( this.element.children );
  moveElements( cellElems, this.slider );
  this.viewport.appendChild( this.slider );
  this.element.appendChild( this.viewport );
  // get cells from children
  this.reloadCells();

  if ( this.options.accessibility ) {
    // allow element to focusable
    this.element.tabIndex = 0;
    // listen for key presses
    this.element.addEventListener( 'keydown', this );
  }

  this.emitEvent('activate');
  this.selectInitialIndex();
  // flag for initial activation, for using initialIndex
  this.isInitActivated = true;
  // ready event. #493
  this.dispatchEvent('ready');
};

// slider positions the cells
proto._createSlider = function() {
  // slider element does all the positioning
  var slider = document.createElement('div');
  slider.className = 'flickity-slider';
  slider.style[ this.originSide ] = 0;
  this.slider = slider;
};

proto._filterFindCellElements = function( elems ) {
  return utils.filterFindElements( elems, this.options.cellSelector );
};

// goes through all children
proto.reloadCells = function() {
  // collection of item elements
  this.cells = this._makeCells( this.slider.children );
  this.positionCells();
  this._getWrapShiftCells();
  this.setGallerySize();
};

/**
 * turn elements into Flickity.Cells
 * @param {[Array, NodeList, HTMLElement]} elems - elements to make into cells
 * @returns {Array} items - collection of new Flickity Cells
 */
proto._makeCells = function( elems ) {
  var cellElems = this._filterFindCellElements( elems );

  // create new Flickity for collection
  var cells = cellElems.map( function( cellElem ) {
    return new Cell( cellElem, this );
  }, this );

  return cells;
};

proto.getLastCell = function() {
  return this.cells[ this.cells.length - 1 ];
};

proto.getLastSlide = function() {
  return this.slides[ this.slides.length - 1 ];
};

// positions all cells
proto.positionCells = function() {
  // size all cells
  this._sizeCells( this.cells );
  // position all cells
  this._positionCells( 0 );
};

/**
 * position certain cells
 * @param {Integer} index - which cell to start with
 */
proto._positionCells = function( index ) {
  index = index || 0;
  // also measure maxCellHeight
  // start 0 if positioning all cells
  this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
  var cellX = 0;
  // get cellX
  if ( index > 0 ) {
    var startCell = this.cells[ index - 1 ];
    cellX = startCell.x + startCell.size.outerWidth;
  }
  var len = this.cells.length;
  for ( var i = index; i < len; i++ ) {
    var cell = this.cells[i];
    cell.setPosition( cellX );
    cellX += cell.size.outerWidth;
    this.maxCellHeight = Math.max( cell.size.outerHeight, this.maxCellHeight );
  }
  // keep track of cellX for wrap-around
  this.slideableWidth = cellX;
  // slides
  this.updateSlides();
  // contain slides target
  this._containSlides();
  // update slidesWidth
  this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
};

/**
 * cell.getSize() on multiple cells
 * @param {Array} cells - cells to size
 */
proto._sizeCells = function( cells ) {
  cells.forEach( function( cell ) {
    cell.getSize();
  } );
};

// --------------------------  -------------------------- //

proto.updateSlides = function() {
  this.slides = [];
  if ( !this.cells.length ) {
    return;
  }

  var slide = new Slide( this );
  this.slides.push( slide );
  var isOriginLeft = this.originSide == 'left';
  var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';

  var canCellFit = this._getCanCellFit();

  this.cells.forEach( function( cell, i ) {
    // just add cell if first cell in slide
    if ( !slide.cells.length ) {
      slide.addCell( cell );
      return;
    }

    var slideWidth = ( slide.outerWidth - slide.firstMargin ) +
      ( cell.size.outerWidth - cell.size[ nextMargin ] );

    if ( canCellFit.call( this, i, slideWidth ) ) {
      slide.addCell( cell );
    } else {
      // doesn't fit, new slide
      slide.updateTarget();

      slide = new Slide( this );
      this.slides.push( slide );
      slide.addCell( cell );
    }
  }, this );
  // last slide
  slide.updateTarget();
  // update .selectedSlide
  this.updateSelectedSlide();
};

proto._getCanCellFit = function() {
  var groupCells = this.options.groupCells;
  if ( !groupCells ) {
    return function() {
      return false;
    };
  } else if ( typeof groupCells == 'number' ) {
    // group by number. 3 -> [0,1,2], [3,4,5], ...
    var number = parseInt( groupCells, 10 );
    return function( i ) {
      return ( i % number ) !== 0;
    };
  }
  // default, group by width of slide
  // parse '75%
  var percentMatch = typeof groupCells == 'string' &&
    groupCells.match( /^(\d+)%$/ );
  var percent = percentMatch ? parseInt( percentMatch[1], 10 ) / 100 : 1;
  return function( i, slideWidth ) {
    /* eslint-disable-next-line no-invalid-this */
    return slideWidth <= ( this.size.innerWidth + 1 ) * percent;
  };
};

// alias _init for jQuery plugin .flickity()
proto._init =
proto.reposition = function() {
  this.positionCells();
  this.positionSliderAtSelected();
};

proto.getSize = function() {
  this.size = getSize( this.element );
  this.setCellAlign();
  this.cursorPosition = this.size.innerWidth * this.cellAlign;
};

var cellAlignShorthands = {
  // cell align, then based on origin side
  center: {
    left: 0.5,
    right: 0.5,
  },
  left: {
    left: 0,
    right: 1,
  },
  right: {
    right: 0,
    left: 1,
  },
};

proto.setCellAlign = function() {
  var shorthand = cellAlignShorthands[ this.options.cellAlign ];
  this.cellAlign = shorthand ? shorthand[ this.originSide ] : this.options.cellAlign;
};

proto.setGallerySize = function() {
  if ( this.options.setGallerySize ) {
    var height = this.options.adaptiveHeight && this.selectedSlide ?
      this.selectedSlide.height : this.maxCellHeight;
    this.viewport.style.height = height + 'px';
  }
};

proto._getWrapShiftCells = function() {
  // only for wrap-around
  if ( !this.options.wrapAround ) {
    return;
  }
  // unshift previous cells
  this._unshiftCells( this.beforeShiftCells );
  this._unshiftCells( this.afterShiftCells );
  // get before cells
  // initial gap
  var gapX = this.cursorPosition;
  var cellIndex = this.cells.length - 1;
  this.beforeShiftCells = this._getGapCells( gapX, cellIndex, -1 );
  // get after cells
  // ending gap between last cell and end of gallery viewport
  gapX = this.size.innerWidth - this.cursorPosition;
  // start cloning at first cell, working forwards
  this.afterShiftCells = this._getGapCells( gapX, 0, 1 );
};

proto._getGapCells = function( gapX, cellIndex, increment ) {
  // keep adding cells until the cover the initial gap
  var cells = [];
  while ( gapX > 0 ) {
    var cell = this.cells[ cellIndex ];
    if ( !cell ) {
      break;
    }
    cells.push( cell );
    cellIndex += increment;
    gapX -= cell.size.outerWidth;
  }
  return cells;
};

// ----- contain ----- //

// contain cell targets so no excess sliding
proto._containSlides = function() {
  if ( !this.options.contain || this.options.wrapAround || !this.cells.length ) {
    return;
  }
  var isRightToLeft = this.options.rightToLeft;
  var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
  var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
  var contentWidth = this.slideableWidth - this.getLastCell().size[ endMargin ];
  // content is less than gallery size
  var isContentSmaller = contentWidth < this.size.innerWidth;
  // bounds
  var beginBound = this.cursorPosition + this.cells[0].size[ beginMargin ];
  var endBound = contentWidth - this.size.innerWidth * ( 1 - this.cellAlign );
  // contain each cell target
  this.slides.forEach( function( slide ) {
    if ( isContentSmaller ) {
      // all cells fit inside gallery
      slide.target = contentWidth * this.cellAlign;
    } else {
      // contain to bounds
      slide.target = Math.max( slide.target, beginBound );
      slide.target = Math.min( slide.target, endBound );
    }
  }, this );
};

// -----  ----- //

/**
 * emits events via eventEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */
proto.dispatchEvent = function( type, event, args ) {
  var emitArgs = event ? [ event ].concat( args ) : args;
  this.emitEvent( type, emitArgs );

  if ( jQuery && this.$element ) {
    // default trigger with type if no event
    type += this.options.namespaceJQueryEvents ? '.flickity' : '';
    var $event = type;
    if ( event ) {
      // create jQuery event
      var jQEvent = new jQuery.Event( event );
      jQEvent.type = type;
      $event = jQEvent;
    }
    this.$element.trigger( $event, args );
  }
};

// -------------------------- select -------------------------- //

/**
 * @param {Integer} index - index of the slide
 * @param {Boolean} isWrap - will wrap-around to last/first if at the end
 * @param {Boolean} isInstant - will immediately set position at selected cell
 */
proto.select = function( index, isWrap, isInstant ) {
  if ( !this.isActive ) {
    return;
  }
  index = parseInt( index, 10 );
  this._wrapSelect( index );

  if ( this.options.wrapAround || isWrap ) {
    index = utils.modulo( index, this.slides.length );
  }
  // bail if invalid index
  if ( !this.slides[ index ] ) {
    return;
  }
  var prevIndex = this.selectedIndex;
  this.selectedIndex = index;
  this.updateSelectedSlide();
  if ( isInstant ) {
    this.positionSliderAtSelected();
  } else {
    this.startAnimation();
  }
  if ( this.options.adaptiveHeight ) {
    this.setGallerySize();
  }
  // events
  this.dispatchEvent( 'select', null, [ index ] );
  // change event if new index
  if ( index != prevIndex ) {
    this.dispatchEvent( 'change', null, [ index ] );
  }
  // old v1 event name, remove in v3
  this.dispatchEvent('cellSelect');
};

// wraps position for wrapAround, to move to closest slide. #113
proto._wrapSelect = function( index ) {
  var len = this.slides.length;
  var isWrapping = this.options.wrapAround && len > 1;
  if ( !isWrapping ) {
    return index;
  }
  var wrapIndex = utils.modulo( index, len );
  // go to shortest
  var delta = Math.abs( wrapIndex - this.selectedIndex );
  var backWrapDelta = Math.abs( ( wrapIndex + len ) - this.selectedIndex );
  var forewardWrapDelta = Math.abs( ( wrapIndex - len ) - this.selectedIndex );
  if ( !this.isDragSelect && backWrapDelta < delta ) {
    index += len;
  } else if ( !this.isDragSelect && forewardWrapDelta < delta ) {
    index -= len;
  }
  // wrap position so slider is within normal area
  if ( index < 0 ) {
    this.x -= this.slideableWidth;
  } else if ( index >= len ) {
    this.x += this.slideableWidth;
  }
};

proto.previous = function( isWrap, isInstant ) {
  this.select( this.selectedIndex - 1, isWrap, isInstant );
};

proto.next = function( isWrap, isInstant ) {
  this.select( this.selectedIndex + 1, isWrap, isInstant );
};

proto.updateSelectedSlide = function() {
  var slide = this.slides[ this.selectedIndex ];
  // selectedIndex could be outside of slides, if triggered before resize()
  if ( !slide ) {
    return;
  }
  // unselect previous selected slide
  this.unselectSelectedSlide();
  // update new selected slide
  this.selectedSlide = slide;
  slide.select();
  this.selectedCells = slide.cells;
  this.selectedElements = slide.getCellElements();
  // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
  // Remove in v3?
  this.selectedCell = slide.cells[0];
  this.selectedElement = this.selectedElements[0];
};

proto.unselectSelectedSlide = function() {
  if ( this.selectedSlide ) {
    this.selectedSlide.unselect();
  }
};

proto.selectInitialIndex = function() {
  var initialIndex = this.options.initialIndex;
  // already activated, select previous selectedIndex
  if ( this.isInitActivated ) {
    this.select( this.selectedIndex, false, true );
    return;
  }
  // select with selector string
  if ( initialIndex && typeof initialIndex == 'string' ) {
    var cell = this.queryCell( initialIndex );
    if ( cell ) {
      this.selectCell( initialIndex, false, true );
      return;
    }
  }

  var index = 0;
  // select with number
  if ( initialIndex && this.slides[ initialIndex ] ) {
    index = initialIndex;
  }
  // select instantly
  this.select( index, false, true );
};

/**
 * select slide from number or cell element
 * @param {[Element, Number]} value - zero-based index or element to select
 * @param {Boolean} isWrap - enables wrapping around for extra index
 * @param {Boolean} isInstant - disables slide animation
 */
proto.selectCell = function( value, isWrap, isInstant ) {
  // get cell
  var cell = this.queryCell( value );
  if ( !cell ) {
    return;
  }

  var index = this.getCellSlideIndex( cell );
  this.select( index, isWrap, isInstant );
};

proto.getCellSlideIndex = function( cell ) {
  // get index of slides that has cell
  for ( var i = 0; i < this.slides.length; i++ ) {
    var slide = this.slides[i];
    var index = slide.cells.indexOf( cell );
    if ( index != -1 ) {
      return i;
    }
  }
};

// -------------------------- get cells -------------------------- //

/**
 * get Flickity.Cell, given an Element
 * @param {Element} elem - matching cell element
 * @returns {Flickity.Cell} cell - matching cell
 */
proto.getCell = function( elem ) {
  // loop through cells to get the one that matches
  for ( var i = 0; i < this.cells.length; i++ ) {
    var cell = this.cells[i];
    if ( cell.element == elem ) {
      return cell;
    }
  }
};

/**
 * get collection of Flickity.Cells, given Elements
 * @param {[Element, Array, NodeList]} elems - multiple elements
 * @returns {Array} cells - Flickity.Cells
 */
proto.getCells = function( elems ) {
  elems = utils.makeArray( elems );
  var cells = [];
  elems.forEach( function( elem ) {
    var cell = this.getCell( elem );
    if ( cell ) {
      cells.push( cell );
    }
  }, this );
  return cells;
};

/**
 * get cell elements
 * @returns {Array} cellElems
 */
proto.getCellElements = function() {
  return this.cells.map( function( cell ) {
    return cell.element;
  } );
};

/**
 * get parent cell from an element
 * @param {Element} elem - child element
 * @returns {Flickit.Cell} cell - parent cell
 */
proto.getParentCell = function( elem ) {
  // first check if elem is cell
  var cell = this.getCell( elem );
  if ( cell ) {
    return cell;
  }
  // try to get parent cell elem
  elem = utils.getParent( elem, '.flickity-slider > *' );
  return this.getCell( elem );
};

/**
 * get cells adjacent to a slide
 * @param {Integer} adjCount - number of adjacent slides
 * @param {Integer} index - index of slide to start
 * @returns {Array} cells - array of Flickity.Cells
 */
proto.getAdjacentCellElements = function( adjCount, index ) {
  if ( !adjCount ) {
    return this.selectedSlide.getCellElements();
  }
  index = index === undefined ? this.selectedIndex : index;

  var len = this.slides.length;
  if ( 1 + ( adjCount * 2 ) >= len ) {
    return this.getCellElements();
  }

  var cellElems = [];
  for ( var i = index - adjCount; i <= index + adjCount; i++ ) {
    var slideIndex = this.options.wrapAround ? utils.modulo( i, len ) : i;
    var slide = this.slides[ slideIndex ];
    if ( slide ) {
      cellElems = cellElems.concat( slide.getCellElements() );
    }
  }
  return cellElems;
};

/**
 * select slide from number or cell element
 * @param {[Element, String, Number]} selector - element, selector string, or index
 * @returns {Flickity.Cell} - matching cell
 */
proto.queryCell = function( selector ) {
  if ( typeof selector == 'number' ) {
    // use number as index
    return this.cells[ selector ];
  }
  if ( typeof selector == 'string' ) {
    // do not select invalid selectors from hash: #123, #/. #791
    if ( selector.match( /^[#.]?[\d/]/ ) ) {
      return;
    }
    // use string as selector, get element
    selector = this.element.querySelector( selector );
  }
  // get cell from element
  return this.getCell( selector );
};

// -------------------------- events -------------------------- //

proto.uiChange = function() {
  this.emitEvent('uiChange');
};

// keep focus on element when child UI elements are clicked
proto.childUIPointerDown = function( event ) {
  // HACK iOS does not allow touch events to bubble up?!
  if ( event.type != 'touchstart' ) {
    event.preventDefault();
  }
  this.focus();
};

// ----- resize ----- //

proto.onresize = function() {
  this.watchCSS();
  this.resize();
};

utils.debounceMethod( Flickity, 'onresize', 150 );

proto.resize = function() {
  // #1177 disable resize behavior when animating or dragging for iOS 15
  if ( !this.isActive || this.isAnimating || this.isDragging ) {
    return;
  }
  this.getSize();
  // wrap values
  if ( this.options.wrapAround ) {
    this.x = utils.modulo( this.x, this.slideableWidth );
  }
  this.positionCells();
  this._getWrapShiftCells();
  this.setGallerySize();
  this.emitEvent('resize');
  // update selected index for group slides, instant
  // TODO: position can be lost between groups of various numbers
  var selectedElement = this.selectedElements && this.selectedElements[0];
  this.selectCell( selectedElement, false, true );
};

// watches the :after property, activates/deactivates
proto.watchCSS = function() {
  var watchOption = this.options.watchCSS;
  if ( !watchOption ) {
    return;
  }

  var afterContent = getComputedStyle( this.element, ':after' ).content;
  // activate if :after { content: 'flickity' }
  if ( afterContent.indexOf('flickity') != -1 ) {
    this.activate();
  } else {
    this.deactivate();
  }
};

// ----- keydown ----- //

// go previous/next if left/right keys pressed
proto.onkeydown = function( event ) {
  // only work if element is in focus
  var isNotFocused = document.activeElement && document.activeElement != this.element;
  if ( !this.options.accessibility || isNotFocused ) {
    return;
  }

  var handler = Flickity.keyboardHandlers[ event.keyCode ];
  if ( handler ) {
    handler.call( this );
  }
};

Flickity.keyboardHandlers = {
  // left arrow
  37: function() {
    var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
    this.uiChange();
    this[ leftMethod ]();
  },
  // right arrow
  39: function() {
    var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
    this.uiChange();
    this[ rightMethod ]();
  },
};

// ----- focus ----- //

proto.focus = function() {
  // TODO remove scrollTo once focus options gets more support
  // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus ...
  //    #Browser_compatibility
  var prevScrollY = window.pageYOffset;
  this.element.focus({ preventScroll: true });
  // hack to fix scroll jump after focus, #76
  if ( window.pageYOffset != prevScrollY ) {
    window.scrollTo( window.pageXOffset, prevScrollY );
  }
};

// -------------------------- destroy -------------------------- //

// deactivate all Flickity functionality, but keep stuff available
proto.deactivate = function() {
  if ( !this.isActive ) {
    return;
  }
  this.element.classList.remove('flickity-enabled');
  this.element.classList.remove('flickity-rtl');
  this.unselectSelectedSlide();
  // destroy cells
  this.cells.forEach( function( cell ) {
    cell.destroy();
  } );
  this.element.removeChild( this.viewport );
  // move child elements back into element
  moveElements( this.slider.children, this.element );
  if ( this.options.accessibility ) {
    this.element.removeAttribute('tabIndex');
    this.element.removeEventListener( 'keydown', this );
  }
  // set flags
  this.isActive = false;
  this.emitEvent('deactivate');
};

proto.destroy = function() {
  this.deactivate();
  window.removeEventListener( 'resize', this );
  this.allOff();
  this.emitEvent('destroy');
  if ( jQuery && this.$element ) {
    jQuery.removeData( this.element, 'flickity' );
  }
  delete this.element.flickityGUID;
  delete instances[ this.guid ];
};

// -------------------------- prototype -------------------------- //

utils.extend( proto, animatePrototype );

// -------------------------- extras -------------------------- //

/**
 * get Flickity instance from element
 * @param {[Element, String]} elem - element or selector string
 * @returns {Flickity} - Flickity instance
 */
Flickity.data = function( elem ) {
  elem = utils.getQueryElement( elem );
  var id = elem && elem.flickityGUID;
  return id && instances[ id ];
};

utils.htmlInit( Flickity, 'flickity' );

if ( jQuery && jQuery.bridget ) {
  jQuery.bridget( 'flickity', Flickity );
}

// set internal jQuery, for Webpack + jQuery v3, #478
Flickity.setJQuery = function( jq ) {
  jQuery = jq;
};

Flickity.Cell = Cell;
Flickity.Slide = Slide;

return Flickity;

} ) );

/*!
 * Unipointer v2.4.0
 * base class for doing one thing with pointer event
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*global define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'unipointer/unipointer',[
      'ev-emitter/ev-emitter'
    ], function( EvEmitter ) {
      return factory( window, EvEmitter );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('ev-emitter')
    );
  } else {
    // browser global
    window.Unipointer = factory(
      window,
      window.EvEmitter
    );
  }

}( window, function factory( window, EvEmitter ) {



function noop() {}

function Unipointer() {}

// inherit EvEmitter
var proto = Unipointer.prototype = Object.create( EvEmitter.prototype );

proto.bindStartEvent = function( elem ) {
  this._bindStartEvent( elem, true );
};

proto.unbindStartEvent = function( elem ) {
  this._bindStartEvent( elem, false );
};

/**
 * Add or remove start event
 * @param {Boolean} isAdd - remove if falsey
 */
proto._bindStartEvent = function( elem, isAdd ) {
  // munge isAdd, default to true
  isAdd = isAdd === undefined ? true : isAdd;
  var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';

  // default to mouse events
  var startEvent = 'mousedown';
  if ( 'ontouchstart' in window ) {
    // HACK prefer Touch Events as you can preventDefault on touchstart to
    // disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
    startEvent = 'touchstart';
  } else if ( window.PointerEvent ) {
    // Pointer Events
    startEvent = 'pointerdown';
  }
  elem[ bindMethod ]( startEvent, this );
};

// trigger handler methods for events
proto.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// returns the touch that we're keeping track of
proto.getTouch = function( touches ) {
  for ( var i=0; i < touches.length; i++ ) {
    var touch = touches[i];
    if ( touch.identifier == this.pointerIdentifier ) {
      return touch;
    }
  }
};

// ----- start event ----- //

proto.onmousedown = function( event ) {
  // dismiss clicks from right or middle buttons
  var button = event.button;
  if ( button && ( button !== 0 && button !== 1 ) ) {
    return;
  }
  this._pointerDown( event, event );
};

proto.ontouchstart = function( event ) {
  this._pointerDown( event, event.changedTouches[0] );
};

proto.onpointerdown = function( event ) {
  this._pointerDown( event, event );
};

/**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto._pointerDown = function( event, pointer ) {
  // dismiss right click and other pointers
  // button = 0 is okay, 1-4 not
  if ( event.button || this.isPointerDown ) {
    return;
  }

  this.isPointerDown = true;
  // save pointer identifier to match up touch events
  this.pointerIdentifier = pointer.pointerId !== undefined ?
    // pointerId for pointer events, touch.indentifier for touch events
    pointer.pointerId : pointer.identifier;

  this.pointerDown( event, pointer );
};

proto.pointerDown = function( event, pointer ) {
  this._bindPostStartEvents( event );
  this.emitEvent( 'pointerDown', [ event, pointer ] );
};

// hash of events to be bound after start event
var postStartEvents = {
  mousedown: [ 'mousemove', 'mouseup' ],
  touchstart: [ 'touchmove', 'touchend', 'touchcancel' ],
  pointerdown: [ 'pointermove', 'pointerup', 'pointercancel' ],
};

proto._bindPostStartEvents = function( event ) {
  if ( !event ) {
    return;
  }
  // get proper events to match start event
  var events = postStartEvents[ event.type ];
  // bind events to node
  events.forEach( function( eventName ) {
    window.addEventListener( eventName, this );
  }, this );
  // save these arguments
  this._boundPointerEvents = events;
};

proto._unbindPostStartEvents = function() {
  // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
  if ( !this._boundPointerEvents ) {
    return;
  }
  this._boundPointerEvents.forEach( function( eventName ) {
    window.removeEventListener( eventName, this );
  }, this );

  delete this._boundPointerEvents;
};

// ----- move event ----- //

proto.onmousemove = function( event ) {
  this._pointerMove( event, event );
};

proto.onpointermove = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerMove( event, event );
  }
};

proto.ontouchmove = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerMove( event, touch );
  }
};

/**
 * pointer move
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerMove = function( event, pointer ) {
  this.pointerMove( event, pointer );
};

// public
proto.pointerMove = function( event, pointer ) {
  this.emitEvent( 'pointerMove', [ event, pointer ] );
};

// ----- end event ----- //


proto.onmouseup = function( event ) {
  this._pointerUp( event, event );
};

proto.onpointerup = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerUp( event, event );
  }
};

proto.ontouchend = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerUp( event, touch );
  }
};

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerUp = function( event, pointer ) {
  this._pointerDone();
  this.pointerUp( event, pointer );
};

// public
proto.pointerUp = function( event, pointer ) {
  this.emitEvent( 'pointerUp', [ event, pointer ] );
};

// ----- pointer done ----- //

// triggered on pointer up & pointer cancel
proto._pointerDone = function() {
  this._pointerReset();
  this._unbindPostStartEvents();
  this.pointerDone();
};

proto._pointerReset = function() {
  // reset properties
  this.isPointerDown = false;
  delete this.pointerIdentifier;
};

proto.pointerDone = noop;

// ----- pointer cancel ----- //

proto.onpointercancel = function( event ) {
  if ( event.pointerId == this.pointerIdentifier ) {
    this._pointerCancel( event, event );
  }
};

proto.ontouchcancel = function( event ) {
  var touch = this.getTouch( event.changedTouches );
  if ( touch ) {
    this._pointerCancel( event, touch );
  }
};

/**
 * pointer cancel
 * @param {Event} event
 * @param {Event or Touch} pointer
 * @private
 */
proto._pointerCancel = function( event, pointer ) {
  this._pointerDone();
  this.pointerCancel( event, pointer );
};

// public
proto.pointerCancel = function( event, pointer ) {
  this.emitEvent( 'pointerCancel', [ event, pointer ] );
};

// -----  ----- //

// utility function for getting x/y coords from event
Unipointer.getPointerPoint = function( pointer ) {
  return {
    x: pointer.pageX,
    y: pointer.pageY
  };
};

// -----  ----- //

return Unipointer;

}));

/*!
 * Unidragger v2.4.0
 * Draggable base class
 * MIT license
 */

/*jshint browser: true, unused: true, undef: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'unidragger/unidragger',[
      'unipointer/unipointer'
    ], function( Unipointer ) {
      return factory( window, Unipointer );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('unipointer')
    );
  } else {
    // browser global
    window.Unidragger = factory(
      window,
      window.Unipointer
    );
  }

}( window, function factory( window, Unipointer ) {



// -------------------------- Unidragger -------------------------- //

function Unidragger() {}

// inherit Unipointer & EvEmitter
var proto = Unidragger.prototype = Object.create( Unipointer.prototype );

// ----- bind start ----- //

proto.bindHandles = function() {
  this._bindHandles( true );
};

proto.unbindHandles = function() {
  this._bindHandles( false );
};

/**
 * Add or remove start event
 * @param {Boolean} isAdd
 */
proto._bindHandles = function( isAdd ) {
  // munge isAdd, default to true
  isAdd = isAdd === undefined ? true : isAdd;
  // bind each handle
  var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
  var touchAction = isAdd ? this._touchActionValue : '';
  for ( var i=0; i < this.handles.length; i++ ) {
    var handle = this.handles[i];
    this._bindStartEvent( handle, isAdd );
    handle[ bindMethod ]( 'click', this );
    // touch-action: none to override browser touch gestures. metafizzy/flickity#540
    if ( window.PointerEvent ) {
      handle.style.touchAction = touchAction;
    }
  }
};

// prototype so it can be overwriteable by Flickity
proto._touchActionValue = 'none';

// ----- start event ----- //

/**
 * pointer start
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerDown = function( event, pointer ) {
  var isOkay = this.okayPointerDown( event );
  if ( !isOkay ) {
    return;
  }
  // track start event position
  // Safari 9 overrides pageX and pageY. These values needs to be copied. flickity#842
  this.pointerDownPointer = {
    pageX: pointer.pageX,
    pageY: pointer.pageY,
  };

  event.preventDefault();
  this.pointerDownBlur();
  // bind move and end events
  this._bindPostStartEvents( event );
  this.emitEvent( 'pointerDown', [ event, pointer ] );
};

// nodes that have text fields
var cursorNodes = {
  TEXTAREA: true,
  INPUT: true,
  SELECT: true,
  OPTION: true,
};

// input types that do not have text fields
var clickTypes = {
  radio: true,
  checkbox: true,
  button: true,
  submit: true,
  image: true,
  file: true,
};

// dismiss inputs with text fields. flickity#403, flickity#404
proto.okayPointerDown = function( event ) {
  var isCursorNode = cursorNodes[ event.target.nodeName ];
  var isClickType = clickTypes[ event.target.type ];
  var isOkay = !isCursorNode || isClickType;
  if ( !isOkay ) {
    this._pointerReset();
  }
  return isOkay;
};

// kludge to blur previously focused input
proto.pointerDownBlur = function() {
  var focused = document.activeElement;
  // do not blur body for IE10, metafizzy/flickity#117
  var canBlur = focused && focused.blur && focused != document.body;
  if ( canBlur ) {
    focused.blur();
  }
};

// ----- move event ----- //

/**
 * drag move
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerMove = function( event, pointer ) {
  var moveVector = this._dragPointerMove( event, pointer );
  this.emitEvent( 'pointerMove', [ event, pointer, moveVector ] );
  this._dragMove( event, pointer, moveVector );
};

// base pointer move logic
proto._dragPointerMove = function( event, pointer ) {
  var moveVector = {
    x: pointer.pageX - this.pointerDownPointer.pageX,
    y: pointer.pageY - this.pointerDownPointer.pageY
  };
  // start drag if pointer has moved far enough to start drag
  if ( !this.isDragging && this.hasDragStarted( moveVector ) ) {
    this._dragStart( event, pointer );
  }
  return moveVector;
};

// condition if pointer has moved far enough to start drag
proto.hasDragStarted = function( moveVector ) {
  return Math.abs( moveVector.x ) > 3 || Math.abs( moveVector.y ) > 3;
};

// ----- end event ----- //

/**
 * pointer up
 * @param {Event} event
 * @param {Event or Touch} pointer
 */
proto.pointerUp = function( event, pointer ) {
  this.emitEvent( 'pointerUp', [ event, pointer ] );
  this._dragPointerUp( event, pointer );
};

proto._dragPointerUp = function( event, pointer ) {
  if ( this.isDragging ) {
    this._dragEnd( event, pointer );
  } else {
    // pointer didn't move enough for drag to start
    this._staticClick( event, pointer );
  }
};

// -------------------------- drag -------------------------- //

// dragStart
proto._dragStart = function( event, pointer ) {
  this.isDragging = true;
  // prevent clicks
  this.isPreventingClicks = true;
  this.dragStart( event, pointer );
};

proto.dragStart = function( event, pointer ) {
  this.emitEvent( 'dragStart', [ event, pointer ] );
};

// dragMove
proto._dragMove = function( event, pointer, moveVector ) {
  // do not drag if not dragging yet
  if ( !this.isDragging ) {
    return;
  }

  this.dragMove( event, pointer, moveVector );
};

proto.dragMove = function( event, pointer, moveVector ) {
  event.preventDefault();
  this.emitEvent( 'dragMove', [ event, pointer, moveVector ] );
};

// dragEnd
proto._dragEnd = function( event, pointer ) {
  // set flags
  this.isDragging = false;
  // re-enable clicking async
  setTimeout( function() {
    delete this.isPreventingClicks;
  }.bind( this ) );

  this.dragEnd( event, pointer );
};

proto.dragEnd = function( event, pointer ) {
  this.emitEvent( 'dragEnd', [ event, pointer ] );
};

// ----- onclick ----- //

// handle all clicks and prevent clicks when dragging
proto.onclick = function( event ) {
  if ( this.isPreventingClicks ) {
    event.preventDefault();
  }
};

// ----- staticClick ----- //

// triggered after pointer down & up with no/tiny movement
proto._staticClick = function( event, pointer ) {
  // ignore emulated mouse up clicks
  if ( this.isIgnoringMouseUp && event.type == 'mouseup' ) {
    return;
  }

  this.staticClick( event, pointer );

  // set flag for emulated clicks 300ms after touchend
  if ( event.type != 'mouseup' ) {
    this.isIgnoringMouseUp = true;
    // reset flag after 300ms
    setTimeout( function() {
      delete this.isIgnoringMouseUp;
    }.bind( this ), 400 );
  }
};

proto.staticClick = function( event, pointer ) {
  this.emitEvent( 'staticClick', [ event, pointer ] );
};

// ----- utils ----- //

Unidragger.getPointerPoint = Unipointer.getPointerPoint;

// -----  ----- //

return Unidragger;

}));

// drag
( function( window, factory ) {
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity/js/drag',[
      './flickity',
      'unidragger/unidragger',
      'fizzy-ui-utils/utils',
    ], function( Flickity, Unidragger, utils ) {
      return factory( window, Flickity, Unidragger, utils );
    } );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('./flickity'),
        require('unidragger'),
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    window.Flickity = factory(
        window,
        window.Flickity,
        window.Unidragger,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, Unidragger, utils ) {



// ----- defaults ----- //

utils.extend( Flickity.defaults, {
  draggable: '>1',
  dragThreshold: 3,
} );

// ----- create ----- //

Flickity.createMethods.push('_createDrag');

// -------------------------- drag prototype -------------------------- //

var proto = Flickity.prototype;
utils.extend( proto, Unidragger.prototype );
proto._touchActionValue = 'pan-y';

// --------------------------  -------------------------- //

proto._createDrag = function() {
  this.on( 'activate', this.onActivateDrag );
  this.on( 'uiChange', this._uiChangeDrag );
  this.on( 'deactivate', this.onDeactivateDrag );
  this.on( 'cellChange', this.updateDraggable );
  // TODO updateDraggable on resize? if groupCells & slides change
};

proto.onActivateDrag = function() {
  this.handles = [ this.viewport ];
  this.bindHandles();
  this.updateDraggable();
};

proto.onDeactivateDrag = function() {
  this.unbindHandles();
  this.element.classList.remove('is-draggable');
};

proto.updateDraggable = function() {
  // disable dragging if less than 2 slides. #278
  if ( this.options.draggable == '>1' ) {
    this.isDraggable = this.slides.length > 1;
  } else {
    this.isDraggable = this.options.draggable;
  }
  if ( this.isDraggable ) {
    this.element.classList.add('is-draggable');
  } else {
    this.element.classList.remove('is-draggable');
  }
};

// backwards compatibility
proto.bindDrag = function() {
  this.options.draggable = true;
  this.updateDraggable();
};

proto.unbindDrag = function() {
  this.options.draggable = false;
  this.updateDraggable();
};

proto._uiChangeDrag = function() {
  delete this.isFreeScrolling;
};

// -------------------------- pointer events -------------------------- //

proto.pointerDown = function( event, pointer ) {
  if ( !this.isDraggable ) {
    this._pointerDownDefault( event, pointer );
    return;
  }
  var isOkay = this.okayPointerDown( event );
  if ( !isOkay ) {
    return;
  }

  this._pointerDownPreventDefault( event );
  this.pointerDownFocus( event );
  // blur
  if ( document.activeElement != this.element ) {
    // do not blur if already focused
    this.pointerDownBlur();
  }

  // stop if it was moving
  this.dragX = this.x;
  this.viewport.classList.add('is-pointer-down');
  // track scrolling
  this.pointerDownScroll = getScrollPosition();
  window.addEventListener( 'scroll', this );

  this._pointerDownDefault( event, pointer );
};

// default pointerDown logic, used for staticClick
proto._pointerDownDefault = function( event, pointer ) {
  // track start event position
  // Safari 9 overrides pageX and pageY. These values needs to be copied. #779
  this.pointerDownPointer = {
    pageX: pointer.pageX,
    pageY: pointer.pageY,
  };
  // bind move and end events
  this._bindPostStartEvents( event );
  this.dispatchEvent( 'pointerDown', event, [ pointer ] );
};

var focusNodes = {
  INPUT: true,
  TEXTAREA: true,
  SELECT: true,
};

proto.pointerDownFocus = function( event ) {
  var isFocusNode = focusNodes[ event.target.nodeName ];
  if ( !isFocusNode ) {
    this.focus();
  }
};

proto._pointerDownPreventDefault = function( event ) {
  var isTouchStart = event.type == 'touchstart';
  var isTouchPointer = event.pointerType == 'touch';
  var isFocusNode = focusNodes[ event.target.nodeName ];
  if ( !isTouchStart && !isTouchPointer && !isFocusNode ) {
    event.preventDefault();
  }
};

// ----- move ----- //

proto.hasDragStarted = function( moveVector ) {
  return Math.abs( moveVector.x ) > this.options.dragThreshold;
};

// ----- up ----- //

proto.pointerUp = function( event, pointer ) {
  delete this.isTouchScrolling;
  this.viewport.classList.remove('is-pointer-down');
  this.dispatchEvent( 'pointerUp', event, [ pointer ] );
  this._dragPointerUp( event, pointer );
};

proto.pointerDone = function() {
  window.removeEventListener( 'scroll', this );
  delete this.pointerDownScroll;
};

// -------------------------- dragging -------------------------- //

proto.dragStart = function( event, pointer ) {
  if ( !this.isDraggable ) {
    return;
  }
  this.dragStartPosition = this.x;
  this.startAnimation();
  window.removeEventListener( 'scroll', this );
  this.dispatchEvent( 'dragStart', event, [ pointer ] );
};

proto.pointerMove = function( event, pointer ) {
  var moveVector = this._dragPointerMove( event, pointer );
  this.dispatchEvent( 'pointerMove', event, [ pointer, moveVector ] );
  this._dragMove( event, pointer, moveVector );
};

proto.dragMove = function( event, pointer, moveVector ) {
  if ( !this.isDraggable ) {
    return;
  }
  event.preventDefault();

  this.previousDragX = this.dragX;
  // reverse if right-to-left
  var direction = this.options.rightToLeft ? -1 : 1;
  if ( this.options.wrapAround ) {
    // wrap around move. #589
    moveVector.x %= this.slideableWidth;
  }
  var dragX = this.dragStartPosition + moveVector.x * direction;

  if ( !this.options.wrapAround && this.slides.length ) {
    // slow drag
    var originBound = Math.max( -this.slides[0].target, this.dragStartPosition );
    dragX = dragX > originBound ? ( dragX + originBound ) * 0.5 : dragX;
    var endBound = Math.min( -this.getLastSlide().target, this.dragStartPosition );
    dragX = dragX < endBound ? ( dragX + endBound ) * 0.5 : dragX;
  }

  this.dragX = dragX;

  this.dragMoveTime = new Date();
  this.dispatchEvent( 'dragMove', event, [ pointer, moveVector ] );
};

proto.dragEnd = function( event, pointer ) {
  if ( !this.isDraggable ) {
    return;
  }
  if ( this.options.freeScroll ) {
    this.isFreeScrolling = true;
  }
  // set selectedIndex based on where flick will end up
  var index = this.dragEndRestingSelect();

  if ( this.options.freeScroll && !this.options.wrapAround ) {
    // if free-scroll & not wrap around
    // do not free-scroll if going outside of bounding slides
    // so bounding slides can attract slider, and keep it in bounds
    var restingX = this.getRestingPosition();
    this.isFreeScrolling = -restingX > this.slides[0].target &&
      -restingX < this.getLastSlide().target;
  } else if ( !this.options.freeScroll && index == this.selectedIndex ) {
    // boost selection if selected index has not changed
    index += this.dragEndBoostSelect();
  }
  delete this.previousDragX;
  // apply selection
  // TODO refactor this, selecting here feels weird
  // HACK, set flag so dragging stays in correct direction
  this.isDragSelect = this.options.wrapAround;
  this.select( index );
  delete this.isDragSelect;
  this.dispatchEvent( 'dragEnd', event, [ pointer ] );
};

proto.dragEndRestingSelect = function() {
  var restingX = this.getRestingPosition();
  // how far away from selected slide
  var distance = Math.abs( this.getSlideDistance( -restingX, this.selectedIndex ) );
  // get closet resting going up and going down
  var positiveResting = this._getClosestResting( restingX, distance, 1 );
  var negativeResting = this._getClosestResting( restingX, distance, -1 );
  // use closer resting for wrap-around
  var index = positiveResting.distance < negativeResting.distance ?
    positiveResting.index : negativeResting.index;
  return index;
};

/**
 * given resting X and distance to selected cell
 * get the distance and index of the closest cell
 * @param {Number} restingX - estimated post-flick resting position
 * @param {Number} distance - distance to selected cell
 * @param {Integer} increment - +1 or -1, going up or down
 * @returns {Object} - { distance: {Number}, index: {Integer} }
 */
proto._getClosestResting = function( restingX, distance, increment ) {
  var index = this.selectedIndex;
  var minDistance = Infinity;
  var condition = this.options.contain && !this.options.wrapAround ?
    // if contain, keep going if distance is equal to minDistance
    function( dist, minDist ) {
      return dist <= minDist;
    } : function( dist, minDist ) {
      return dist < minDist;
    };
  while ( condition( distance, minDistance ) ) {
    // measure distance to next cell
    index += increment;
    minDistance = distance;
    distance = this.getSlideDistance( -restingX, index );
    if ( distance === null ) {
      break;
    }
    distance = Math.abs( distance );
  }
  return {
    distance: minDistance,
    // selected was previous index
    index: index - increment,
  };
};

/**
 * measure distance between x and a slide target
 * @param {Number} x - horizontal position
 * @param {Integer} index - slide index
 * @returns {Number} - slide distance
 */
proto.getSlideDistance = function( x, index ) {
  var len = this.slides.length;
  // wrap around if at least 2 slides
  var isWrapAround = this.options.wrapAround && len > 1;
  var slideIndex = isWrapAround ? utils.modulo( index, len ) : index;
  var slide = this.slides[ slideIndex ];
  if ( !slide ) {
    return null;
  }
  // add distance for wrap-around slides
  var wrap = isWrapAround ? this.slideableWidth * Math.floor( index/len ) : 0;
  return x - ( slide.target + wrap );
};

proto.dragEndBoostSelect = function() {
  // do not boost if no previousDragX or dragMoveTime
  if ( this.previousDragX === undefined || !this.dragMoveTime ||
    // or if drag was held for 100 ms
    new Date() - this.dragMoveTime > 100 ) {
    return 0;
  }

  var distance = this.getSlideDistance( -this.dragX, this.selectedIndex );
  var delta = this.previousDragX - this.dragX;
  if ( distance > 0 && delta > 0 ) {
    // boost to next if moving towards the right, and positive velocity
    return 1;
  } else if ( distance < 0 && delta < 0 ) {
    // boost to previous if moving towards the left, and negative velocity
    return -1;
  }
  return 0;
};

// ----- staticClick ----- //

proto.staticClick = function( event, pointer ) {
  // get clickedCell, if cell was clicked
  var clickedCell = this.getParentCell( event.target );
  var cellElem = clickedCell && clickedCell.element;
  var cellIndex = clickedCell && this.cells.indexOf( clickedCell );
  this.dispatchEvent( 'staticClick', event, [ pointer, cellElem, cellIndex ] );
};

// ----- scroll ----- //

proto.onscroll = function() {
  var scroll = getScrollPosition();
  var scrollMoveX = this.pointerDownScroll.x - scroll.x;
  var scrollMoveY = this.pointerDownScroll.y - scroll.y;
  // cancel click/tap if scroll is too much
  if ( Math.abs( scrollMoveX ) > 3 || Math.abs( scrollMoveY ) > 3 ) {
    this._pointerDone();
  }
};

// ----- utils ----- //

function getScrollPosition() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset,
  };
}

// -----  ----- //

return Flickity;

} ) );

// prev/next buttons
( function( window, factory ) {
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity/js/prev-next-button',[
      './flickity',
      'unipointer/unipointer',
      'fizzy-ui-utils/utils',
    ], function( Flickity, Unipointer, utils ) {
      return factory( window, Flickity, Unipointer, utils );
    } );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('./flickity'),
        require('unipointer'),
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
        window,
        window.Flickity,
        window.Unipointer,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, Unipointer, utils ) {
'use strict';

var svgURI = 'http://www.w3.org/2000/svg';

// -------------------------- PrevNextButton -------------------------- //

function PrevNextButton( direction, parent ) {
  this.direction = direction;
  this.parent = parent;
  this._create();
}

PrevNextButton.prototype = Object.create( Unipointer.prototype );

PrevNextButton.prototype._create = function() {
  // properties
  this.isEnabled = true;
  this.isPrevious = this.direction == -1;
  var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
  this.isLeft = this.direction == leftDirection;

  var element = this.element = document.createElement('button');
  element.className = 'flickity-button flickity-prev-next-button';
  element.className += this.isPrevious ? ' previous' : ' next';
  // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
  element.setAttribute( 'type', 'button' );
  // init as disabled
  this.disable();

  element.setAttribute( 'aria-label', this.isPrevious ? 'Previous' : 'Next' );

  // create arrow
  var svg = this.createSVG();
  element.appendChild( svg );
  // events
  this.parent.on( 'select', this.update.bind( this ) );
  this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
};

PrevNextButton.prototype.activate = function() {
  this.bindStartEvent( this.element );
  this.element.addEventListener( 'click', this );
  // add to DOM
  this.parent.element.appendChild( this.element );
};

PrevNextButton.prototype.deactivate = function() {
  // remove from DOM
  this.parent.element.removeChild( this.element );
  // click events
  this.unbindStartEvent( this.element );
  this.element.removeEventListener( 'click', this );
};

PrevNextButton.prototype.createSVG = function() {
  var svg = document.createElementNS( svgURI, 'svg' );
  svg.setAttribute( 'class', 'flickity-button-icon' );
  svg.setAttribute( 'viewBox', '0 0 100 100' );
  var path = document.createElementNS( svgURI, 'path' );
  var pathMovements = getArrowMovements( this.parent.options.arrowShape );
  path.setAttribute( 'd', pathMovements );
  path.setAttribute( 'class', 'arrow' );
  // rotate arrow
  if ( !this.isLeft ) {
    path.setAttribute( 'transform', 'translate(100, 100) rotate(180) ' );
  }
  svg.appendChild( path );
  return svg;
};

// get SVG path movmement
function getArrowMovements( shape ) {
  // use shape as movement if string
  if ( typeof shape == 'string' ) {
    return shape;
  }
  // create movement string
  return 'M ' + shape.x0 + ',50' +
    ' L ' + shape.x1 + ',' + ( shape.y1 + 50 ) +
    ' L ' + shape.x2 + ',' + ( shape.y2 + 50 ) +
    ' L ' + shape.x3 + ',50 ' +
    ' L ' + shape.x2 + ',' + ( 50 - shape.y2 ) +
    ' L ' + shape.x1 + ',' + ( 50 - shape.y1 ) +
    ' Z';
}

PrevNextButton.prototype.handleEvent = utils.handleEvent;

PrevNextButton.prototype.onclick = function() {
  if ( !this.isEnabled ) {
    return;
  }
  this.parent.uiChange();
  var method = this.isPrevious ? 'previous' : 'next';
  this.parent[ method ]();
};

// -----  ----- //

PrevNextButton.prototype.enable = function() {
  if ( this.isEnabled ) {
    return;
  }
  this.element.disabled = false;
  this.isEnabled = true;
};

PrevNextButton.prototype.disable = function() {
  if ( !this.isEnabled ) {
    return;
  }
  this.element.disabled = true;
  this.isEnabled = false;
};

PrevNextButton.prototype.update = function() {
  // index of first or last slide, if previous or next
  var slides = this.parent.slides;
  // enable is wrapAround and at least 2 slides
  if ( this.parent.options.wrapAround && slides.length > 1 ) {
    this.enable();
    return;
  }
  var lastIndex = slides.length ? slides.length - 1 : 0;
  var boundIndex = this.isPrevious ? 0 : lastIndex;
  var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
  this[ method ]();
};

PrevNextButton.prototype.destroy = function() {
  this.deactivate();
  this.allOff();
};

// -------------------------- Flickity prototype -------------------------- //

utils.extend( Flickity.defaults, {
  prevNextButtons: true,
  arrowShape: {
    x0: 10,
    x1: 60, y1: 50,
    x2: 70, y2: 40,
    x3: 30,
  },
} );

Flickity.createMethods.push('_createPrevNextButtons');
var proto = Flickity.prototype;

proto._createPrevNextButtons = function() {
  if ( !this.options.prevNextButtons ) {
    return;
  }

  this.prevButton = new PrevNextButton( -1, this );
  this.nextButton = new PrevNextButton( 1, this );

  this.on( 'activate', this.activatePrevNextButtons );
};

proto.activatePrevNextButtons = function() {
  this.prevButton.activate();
  this.nextButton.activate();
  this.on( 'deactivate', this.deactivatePrevNextButtons );
};

proto.deactivatePrevNextButtons = function() {
  this.prevButton.deactivate();
  this.nextButton.deactivate();
  this.off( 'deactivate', this.deactivatePrevNextButtons );
};

// --------------------------  -------------------------- //

Flickity.PrevNextButton = PrevNextButton;

return Flickity;

} ) );

// page dots
( function( window, factory ) {
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity/js/page-dots',[
      './flickity',
      'unipointer/unipointer',
      'fizzy-ui-utils/utils',
    ], function( Flickity, Unipointer, utils ) {
      return factory( window, Flickity, Unipointer, utils );
    } );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('./flickity'),
        require('unipointer'),
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
        window,
        window.Flickity,
        window.Unipointer,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, Unipointer, utils ) {

// -------------------------- PageDots -------------------------- //



function PageDots( parent ) {
  this.parent = parent;
  this._create();
}

PageDots.prototype = Object.create( Unipointer.prototype );

PageDots.prototype._create = function() {
  // create holder element
  this.holder = document.createElement('ol');
  this.holder.className = 'flickity-page-dots';
  this.holder.tabIndex = 0;
  // create dots, array of elements
  this.dots = [];
  // events
  this.handleClick = this.onClick.bind( this );
  this.on( 'pointerDown', this.parent.childUIPointerDown.bind( this.parent ) );
};

PageDots.prototype.activate = function() {
  this.setDots();
  this.holder.addEventListener( 'click', this.handleClick );
  this.bindStartEvent( this.holder );
  // add to DOM
  this.parent.element.appendChild( this.holder );
};

PageDots.prototype.deactivate = function() {
  this.holder.removeEventListener( 'click', this.handleClick );
  this.unbindStartEvent( this.holder );
  // remove from DOM
  this.parent.element.removeChild( this.holder );
};

PageDots.prototype.setDots = function() {
  // get difference between number of slides and number of dots
  var delta = this.parent.slides.length - this.dots.length;
  if ( delta > 0 ) {
    this.addDots( delta );
  } else if ( delta < 0 ) {
    this.removeDots( -delta );
  }
};

PageDots.prototype.addDots = function( count ) {
  var fragment = document.createDocumentFragment();
  var newDots = [];
  var length = this.dots.length;
  var max = length + count;

  for ( var i = length; i < max; i++ ) {
    var dot = document.createElement('li');
    dot.className = 'dot';
    dot.setAttribute( 'aria-label', 'Page dot ' + ( i + 1 ) );
    dot.tabIndex = 0;
    fragment.appendChild( dot );
    newDots.push( dot );
  }

  this.holder.appendChild( fragment );
  this.dots = this.dots.concat( newDots );
};

PageDots.prototype.removeDots = function( count ) {
  // remove from this.dots collection
  var removeDots = this.dots.splice( this.dots.length - count, count );
  // remove from DOM
  removeDots.forEach( function( dot ) {
    this.holder.removeChild( dot );
  }, this );
};

PageDots.prototype.updateSelected = function() {
  // remove selected class on previous
  if ( this.selectedDot ) {
    this.selectedDot.className = 'dot';
    this.selectedDot.removeAttribute('aria-current');
  }
  // don't proceed if no dots
  if ( !this.dots.length ) {
    return;
  }
  this.selectedDot = this.dots[ this.parent.selectedIndex ];
  this.selectedDot.className = 'dot is-selected';
  this.selectedDot.setAttribute( 'aria-current', 'step' );
};

PageDots.prototype.onTap = // old method name, backwards-compatible
PageDots.prototype.onClick = function( event ) {
  var target = event.target;
  // only care about dot clicks
  if ( target.nodeName != 'LI' ) {
    return;
  }

  this.parent.uiChange();
  var index = this.dots.indexOf( target );
  this.parent.select( index );
};

PageDots.prototype.destroy = function() {
  this.deactivate();
  this.allOff();
};

Flickity.PageDots = PageDots;

// -------------------------- Flickity -------------------------- //

utils.extend( Flickity.defaults, {
  pageDots: true,
} );

Flickity.createMethods.push('_createPageDots');

var proto = Flickity.prototype;

proto._createPageDots = function() {
  if ( !this.options.pageDots ) {
    return;
  }
  this.pageDots = new PageDots( this );
  // events
  this.on( 'activate', this.activatePageDots );
  this.on( 'select', this.updateSelectedPageDots );
  this.on( 'cellChange', this.updatePageDots );
  this.on( 'resize', this.updatePageDots );
  this.on( 'deactivate', this.deactivatePageDots );
};

proto.activatePageDots = function() {
  this.pageDots.activate();
};

proto.updateSelectedPageDots = function() {
  this.pageDots.updateSelected();
};

proto.updatePageDots = function() {
  this.pageDots.setDots();
};

proto.deactivatePageDots = function() {
  this.pageDots.deactivate();
};

// -----  ----- //

Flickity.PageDots = PageDots;

return Flickity;

} ) );

// player & autoPlay
( function( window, factory ) {
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity/js/player',[
      'ev-emitter/ev-emitter',
      'fizzy-ui-utils/utils',
      './flickity',
    ], function( EvEmitter, utils, Flickity ) {
      return factory( EvEmitter, utils, Flickity );
    } );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        require('ev-emitter'),
        require('fizzy-ui-utils'),
        require('./flickity')
    );
  } else {
    // browser global
    factory(
        window.EvEmitter,
        window.fizzyUIUtils,
        window.Flickity
    );
  }

}( window, function factory( EvEmitter, utils, Flickity ) {



// -------------------------- Player -------------------------- //

function Player( parent ) {
  this.parent = parent;
  this.state = 'stopped';
  // visibility change event handler
  this.onVisibilityChange = this.visibilityChange.bind( this );
  this.onVisibilityPlay = this.visibilityPlay.bind( this );
}

Player.prototype = Object.create( EvEmitter.prototype );

// start play
Player.prototype.play = function() {
  if ( this.state == 'playing' ) {
    return;
  }
  // do not play if page is hidden, start playing when page is visible
  var isPageHidden = document.hidden;
  if ( isPageHidden ) {
    document.addEventListener( 'visibilitychange', this.onVisibilityPlay );
    return;
  }

  this.state = 'playing';
  // listen to visibility change
  document.addEventListener( 'visibilitychange', this.onVisibilityChange );
  // start ticking
  this.tick();
};

Player.prototype.tick = function() {
  // do not tick if not playing
  if ( this.state != 'playing' ) {
    return;
  }

  var time = this.parent.options.autoPlay;
  // default to 3 seconds
  time = typeof time == 'number' ? time : 3000;
  var _this = this;
  // HACK: reset ticks if stopped and started within interval
  this.clear();
  this.timeout = setTimeout( function() {
    _this.parent.next( true );
    _this.tick();
  }, time );
};

Player.prototype.stop = function() {
  this.state = 'stopped';
  this.clear();
  // remove visibility change event
  document.removeEventListener( 'visibilitychange', this.onVisibilityChange );
};

Player.prototype.clear = function() {
  clearTimeout( this.timeout );
};

Player.prototype.pause = function() {
  if ( this.state == 'playing' ) {
    this.state = 'paused';
    this.clear();
  }
};

Player.prototype.unpause = function() {
  // re-start play if paused
  if ( this.state == 'paused' ) {
    this.play();
  }
};

// pause if page visibility is hidden, unpause if visible
Player.prototype.visibilityChange = function() {
  var isPageHidden = document.hidden;
  this[ isPageHidden ? 'pause' : 'unpause' ]();
};

Player.prototype.visibilityPlay = function() {
  this.play();
  document.removeEventListener( 'visibilitychange', this.onVisibilityPlay );
};

// -------------------------- Flickity -------------------------- //

utils.extend( Flickity.defaults, {
  pauseAutoPlayOnHover: true,
} );

Flickity.createMethods.push('_createPlayer');
var proto = Flickity.prototype;

proto._createPlayer = function() {
  this.player = new Player( this );

  this.on( 'activate', this.activatePlayer );
  this.on( 'uiChange', this.stopPlayer );
  this.on( 'pointerDown', this.stopPlayer );
  this.on( 'deactivate', this.deactivatePlayer );
};

proto.activatePlayer = function() {
  if ( !this.options.autoPlay ) {
    return;
  }
  this.player.play();
  this.element.addEventListener( 'mouseenter', this );
};

// Player API, don't hate the ... thanks I know where the door is

proto.playPlayer = function() {
  this.player.play();
};

proto.stopPlayer = function() {
  this.player.stop();
};

proto.pausePlayer = function() {
  this.player.pause();
};

proto.unpausePlayer = function() {
  this.player.unpause();
};

proto.deactivatePlayer = function() {
  this.player.stop();
  this.element.removeEventListener( 'mouseenter', this );
};

// ----- mouseenter/leave ----- //

// pause auto-play on hover
proto.onmouseenter = function() {
  if ( !this.options.pauseAutoPlayOnHover ) {
    return;
  }
  this.player.pause();
  this.element.addEventListener( 'mouseleave', this );
};

// resume auto-play on hover off
proto.onmouseleave = function() {
  this.player.unpause();
  this.element.removeEventListener( 'mouseleave', this );
};

// -----  ----- //

Flickity.Player = Player;

return Flickity;

} ) );

// add, remove cell
( function( window, factory ) {
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity/js/add-remove-cell',[
      './flickity',
      'fizzy-ui-utils/utils',
    ], function( Flickity, utils ) {
      return factory( window, Flickity, utils );
    } );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('./flickity'),
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
        window,
        window.Flickity,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, utils ) {



// append cells to a document fragment
function getCellsFragment( cells ) {
  var fragment = document.createDocumentFragment();
  cells.forEach( function( cell ) {
    fragment.appendChild( cell.element );
  } );
  return fragment;
}

// -------------------------- add/remove cell prototype -------------------------- //

var proto = Flickity.prototype;

/**
 * Insert, prepend, or append cells
 * @param {[Element, Array, NodeList]} elems - Elements to insert
 * @param {Integer} index - Zero-based number to insert
 */
proto.insert = function( elems, index ) {
  var cells = this._makeCells( elems );
  if ( !cells || !cells.length ) {
    return;
  }
  var len = this.cells.length;
  // default to append
  index = index === undefined ? len : index;
  // add cells with document fragment
  var fragment = getCellsFragment( cells );
  // append to slider
  var isAppend = index == len;
  if ( isAppend ) {
    this.slider.appendChild( fragment );
  } else {
    var insertCellElement = this.cells[ index ].element;
    this.slider.insertBefore( fragment, insertCellElement );
  }
  // add to this.cells
  if ( index === 0 ) {
    // prepend, add to start
    this.cells = cells.concat( this.cells );
  } else if ( isAppend ) {
    // append, add to end
    this.cells = this.cells.concat( cells );
  } else {
    // insert in this.cells
    var endCells = this.cells.splice( index, len - index );
    this.cells = this.cells.concat( cells ).concat( endCells );
  }

  this._sizeCells( cells );
  this.cellChange( index, true );
};

proto.append = function( elems ) {
  this.insert( elems, this.cells.length );
};

proto.prepend = function( elems ) {
  this.insert( elems, 0 );
};

/**
 * Remove cells
 * @param {[Element, Array, NodeList]} elems - ELements to remove
 */
proto.remove = function( elems ) {
  var cells = this.getCells( elems );
  if ( !cells || !cells.length ) {
    return;
  }

  var minCellIndex = this.cells.length - 1;
  // remove cells from collection & DOM
  cells.forEach( function( cell ) {
    cell.remove();
    var index = this.cells.indexOf( cell );
    minCellIndex = Math.min( index, minCellIndex );
    utils.removeFrom( this.cells, cell );
  }, this );

  this.cellChange( minCellIndex, true );
};

/**
 * logic to be run after a cell's size changes
 * @param {Element} elem - cell's element
 */
proto.cellSizeChange = function( elem ) {
  var cell = this.getCell( elem );
  if ( !cell ) {
    return;
  }
  cell.getSize();

  var index = this.cells.indexOf( cell );
  this.cellChange( index );
};

/**
 * logic any time a cell is changed: added, removed, or size changed
 * @param {Integer} changedCellIndex - index of the changed cell, optional
 * @param {Boolean} isPositioningSlider - Positions slider after selection
 */
proto.cellChange = function( changedCellIndex, isPositioningSlider ) {
  var prevSelectedElem = this.selectedElement;
  this._positionCells( changedCellIndex );
  this._getWrapShiftCells();
  this.setGallerySize();
  // update selectedIndex
  // try to maintain position & select previous selected element
  var cell = this.getCell( prevSelectedElem );
  if ( cell ) {
    this.selectedIndex = this.getCellSlideIndex( cell );
  }
  this.selectedIndex = Math.min( this.slides.length - 1, this.selectedIndex );

  this.emitEvent( 'cellChange', [ changedCellIndex ] );
  // position slider
  this.select( this.selectedIndex );
  // do not position slider after lazy load
  if ( isPositioningSlider ) {
    this.positionSliderAtSelected();
  }
};

// -----  ----- //

return Flickity;

} ) );

// lazyload
( function( window, factory ) {
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity/js/lazyload',[
      './flickity',
      'fizzy-ui-utils/utils',
    ], function( Flickity, utils ) {
      return factory( window, Flickity, utils );
    } );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        window,
        require('./flickity'),
        require('fizzy-ui-utils')
    );
  } else {
    // browser global
    factory(
        window,
        window.Flickity,
        window.fizzyUIUtils
    );
  }

}( window, function factory( window, Flickity, utils ) {
'use strict';

Flickity.createMethods.push('_createLazyload');
var proto = Flickity.prototype;

proto._createLazyload = function() {
  this.on( 'select', this.lazyLoad );
};

proto.lazyLoad = function() {
  var lazyLoad = this.options.lazyLoad;
  if ( !lazyLoad ) {
    return;
  }
  // get adjacent cells, use lazyLoad option for adjacent count
  var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
  var cellElems = this.getAdjacentCellElements( adjCount );
  // get lazy images in those cells
  var lazyImages = [];
  cellElems.forEach( function( cellElem ) {
    var lazyCellImages = getCellLazyImages( cellElem );
    lazyImages = lazyImages.concat( lazyCellImages );
  } );
  // load lazy images
  lazyImages.forEach( function( img ) {
    new LazyLoader( img, this );
  }, this );
};

function getCellLazyImages( cellElem ) {
  // check if cell element is lazy image
  if ( cellElem.nodeName == 'IMG' ) {
    var lazyloadAttr = cellElem.getAttribute('data-flickity-lazyload');
    var srcAttr = cellElem.getAttribute('data-flickity-lazyload-src');
    var srcsetAttr = cellElem.getAttribute('data-flickity-lazyload-srcset');
    if ( lazyloadAttr || srcAttr || srcsetAttr ) {
      return [ cellElem ];
    }
  }
  // select lazy images in cell
  var lazySelector = 'img[data-flickity-lazyload], ' +
    'img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]';
  var imgs = cellElem.querySelectorAll( lazySelector );
  return utils.makeArray( imgs );
}

// -------------------------- LazyLoader -------------------------- //

/**
 * class to handle loading images
 * @param {Image} img - Image element
 * @param {Flickity} flickity - Flickity instance
 */
function LazyLoader( img, flickity ) {
  this.img = img;
  this.flickity = flickity;
  this.load();
}

LazyLoader.prototype.handleEvent = utils.handleEvent;

LazyLoader.prototype.load = function() {
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  // get src & srcset
  var src = this.img.getAttribute('data-flickity-lazyload') ||
    this.img.getAttribute('data-flickity-lazyload-src');
  var srcset = this.img.getAttribute('data-flickity-lazyload-srcset');
  // set src & serset
  this.img.src = src;
  if ( srcset ) {
    this.img.setAttribute( 'srcset', srcset );
  }
  // remove attr
  this.img.removeAttribute('data-flickity-lazyload');
  this.img.removeAttribute('data-flickity-lazyload-src');
  this.img.removeAttribute('data-flickity-lazyload-srcset');
};

LazyLoader.prototype.onload = function( event ) {
  this.complete( event, 'flickity-lazyloaded' );
};

LazyLoader.prototype.onerror = function( event ) {
  this.complete( event, 'flickity-lazyerror' );
};

LazyLoader.prototype.complete = function( event, className ) {
  // unbind events
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );

  var cell = this.flickity.getParentCell( this.img );
  var cellElem = cell && cell.element;
  this.flickity.cellSizeChange( cellElem );

  this.img.classList.add( className );
  this.flickity.dispatchEvent( 'lazyLoad', event, cellElem );
};

// -----  ----- //

Flickity.LazyLoader = LazyLoader;

return Flickity;

} ) );

/*!
 * Flickity v2.3.0
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2021 Metafizzy
 */

( function( window, factory ) {
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity/js/index',[
      './flickity',
      './drag',
      './prev-next-button',
      './page-dots',
      './player',
      './add-remove-cell',
      './lazyload',
    ], factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
        require('./flickity'),
        require('./drag'),
        require('./prev-next-button'),
        require('./page-dots'),
        require('./player'),
        require('./add-remove-cell'),
        require('./lazyload')
    );
  }

} )( window, function factory( Flickity ) {
  return Flickity;
} );

/*!
 * Flickity asNavFor v2.0.2
 * enable asNavFor for Flickity
 */

/*jshint browser: true, undef: true, unused: true, strict: true*/

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'flickity-as-nav-for/as-nav-for',[
      'flickity/js/index',
      'fizzy-ui-utils/utils'
    ], factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      require('flickity'),
      require('fizzy-ui-utils')
    );
  } else {
    // browser global
    window.Flickity = factory(
      window.Flickity,
      window.fizzyUIUtils
    );
  }

}( window, function factory( Flickity, utils ) {



// -------------------------- asNavFor prototype -------------------------- //

// Flickity.defaults.asNavFor = null;

Flickity.createMethods.push('_createAsNavFor');

var proto = Flickity.prototype;

proto._createAsNavFor = function() {
  this.on( 'activate', this.activateAsNavFor );
  this.on( 'deactivate', this.deactivateAsNavFor );
  this.on( 'destroy', this.destroyAsNavFor );

  var asNavForOption = this.options.asNavFor;
  if ( !asNavForOption ) {
    return;
  }
  // HACK do async, give time for other flickity to be initalized
  var _this = this;
  setTimeout( function initNavCompanion() {
    _this.setNavCompanion( asNavForOption );
  });
};

proto.setNavCompanion = function( elem ) {
  elem = utils.getQueryElement( elem );
  var companion = Flickity.data( elem );
  // stop if no companion or companion is self
  if ( !companion || companion == this ) {
    return;
  }

  this.navCompanion = companion;
  // companion select
  var _this = this;
  this.onNavCompanionSelect = function() {
    _this.navCompanionSelect();
  };
  companion.on( 'select', this.onNavCompanionSelect );
  // click
  this.on( 'staticClick', this.onNavStaticClick );

  this.navCompanionSelect( true );
};

proto.navCompanionSelect = function( isInstant ) {
  // wait for companion & selectedCells first. #8
  var companionCells = this.navCompanion && this.navCompanion.selectedCells;
  if ( !companionCells ) {
    return;
  }
  // select slide that matches first cell of slide
  var selectedCell = companionCells[0];
  var firstIndex = this.navCompanion.cells.indexOf( selectedCell );
  var lastIndex = firstIndex + companionCells.length - 1;
  var selectIndex = Math.floor( lerp( firstIndex, lastIndex,
    this.navCompanion.cellAlign ) );
  this.selectCell( selectIndex, false, isInstant );
  // set nav selected class
  this.removeNavSelectedElements();
  // stop if companion has more cells than this one
  if ( selectIndex >= this.cells.length ) {
    return;
  }

  var selectedCells = this.cells.slice( firstIndex, lastIndex + 1 );
  this.navSelectedElements = selectedCells.map( function( cell ) {
    return cell.element;
  });
  this.changeNavSelectedClass('add');
};

function lerp( a, b, t ) {
  return ( b - a ) * t + a;
}

proto.changeNavSelectedClass = function( method ) {
  this.navSelectedElements.forEach( function( navElem ) {
    navElem.classList[ method ]('is-nav-selected');
  });
};

proto.activateAsNavFor = function() {
  this.navCompanionSelect( true );
};

proto.removeNavSelectedElements = function() {
  if ( !this.navSelectedElements ) {
    return;
  }
  this.changeNavSelectedClass('remove');
  delete this.navSelectedElements;
};

proto.onNavStaticClick = function( event, pointer, cellElement, cellIndex ) {
  if ( typeof cellIndex == 'number' ) {
    this.navCompanion.selectCell( cellIndex );
  }
};

proto.deactivateAsNavFor = function() {
  this.removeNavSelectedElements();
};

proto.destroyAsNavFor = function() {
  if ( !this.navCompanion ) {
    return;
  }
  this.navCompanion.off( 'select', this.onNavCompanionSelect );
  this.off( 'staticClick', this.onNavStaticClick );
  delete this.navCompanion;
};

// -----  ----- //

return Flickity;

}));

/*!
 * imagesLoaded v4.1.4
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

( function( window, factory ) { 'use strict';
  // universal module definition

  /*global define: false, module: false, require: false */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'imagesloaded/imagesloaded',[
      'ev-emitter/ev-emitter'
    ], function( EvEmitter ) {
      return factory( window, EvEmitter );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('ev-emitter')
    );
  } else {
    // browser global
    window.imagesLoaded = factory(
      window,
      window.EvEmitter
    );
  }

})( typeof window !== 'undefined' ? window : this,

// --------------------------  factory -------------------------- //

function factory( window, EvEmitter ) {



var $ = window.jQuery;
var console = window.console;

// -------------------------- helpers -------------------------- //

// extend objects
function extend( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
}

var arraySlice = Array.prototype.slice;

// turn element or nodeList into an array
function makeArray( obj ) {
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    return obj;
  }

  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
  if ( isArrayLike ) {
    // convert nodeList to array
    return arraySlice.call( obj );
  }

  // array of single index
  return [ obj ];
}

// -------------------------- imagesLoaded -------------------------- //

/**
 * @param {Array, Element, NodeList, String} elem
 * @param {Object or Function} options - if function, use as callback
 * @param {Function} onAlways - callback function
 */
function ImagesLoaded( elem, options, onAlways ) {
  // coerce ImagesLoaded() without new, to be new ImagesLoaded()
  if ( !( this instanceof ImagesLoaded ) ) {
    return new ImagesLoaded( elem, options, onAlways );
  }
  // use elem as selector string
  var queryElem = elem;
  if ( typeof elem == 'string' ) {
    queryElem = document.querySelectorAll( elem );
  }
  // bail if bad element
  if ( !queryElem ) {
    console.error( 'Bad element for imagesLoaded ' + ( queryElem || elem ) );
    return;
  }

  this.elements = makeArray( queryElem );
  this.options = extend( {}, this.options );
  // shift arguments if no options set
  if ( typeof options == 'function' ) {
    onAlways = options;
  } else {
    extend( this.options, options );
  }

  if ( onAlways ) {
    this.on( 'always', onAlways );
  }

  this.getImages();

  if ( $ ) {
    // add jQuery Deferred object
    this.jqDeferred = new $.Deferred();
  }

  // HACK check async to allow time to bind listeners
  setTimeout( this.check.bind( this ) );
}

ImagesLoaded.prototype = Object.create( EvEmitter.prototype );

ImagesLoaded.prototype.options = {};

ImagesLoaded.prototype.getImages = function() {
  this.images = [];

  // filter & find items if we have an item selector
  this.elements.forEach( this.addElementImages, this );
};

/**
 * @param {Node} element
 */
ImagesLoaded.prototype.addElementImages = function( elem ) {
  // filter siblings
  if ( elem.nodeName == 'IMG' ) {
    this.addImage( elem );
  }
  // get background image on element
  if ( this.options.background === true ) {
    this.addElementBackgroundImages( elem );
  }

  // find children
  // no non-element nodes, #143
  var nodeType = elem.nodeType;
  if ( !nodeType || !elementNodeTypes[ nodeType ] ) {
    return;
  }
  var childImgs = elem.querySelectorAll('img');
  // concat childElems to filterFound array
  for ( var i=0; i < childImgs.length; i++ ) {
    var img = childImgs[i];
    this.addImage( img );
  }

  // get child background images
  if ( typeof this.options.background == 'string' ) {
    var children = elem.querySelectorAll( this.options.background );
    for ( i=0; i < children.length; i++ ) {
      var child = children[i];
      this.addElementBackgroundImages( child );
    }
  }
};

var elementNodeTypes = {
  1: true,
  9: true,
  11: true
};

ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    // Firefox returns null if in a hidden iframe https://bugzil.la/548397
    return;
  }
  // get url inside url("...")
  var reURL = /url\((['"])?(.*?)\1\)/gi;
  var matches = reURL.exec( style.backgroundImage );
  while ( matches !== null ) {
    var url = matches && matches[2];
    if ( url ) {
      this.addBackground( url, elem );
    }
    matches = reURL.exec( style.backgroundImage );
  }
};

/**
 * @param {Image} img
 */
ImagesLoaded.prototype.addImage = function( img ) {
  var loadingImage = new LoadingImage( img );
  this.images.push( loadingImage );
};

ImagesLoaded.prototype.addBackground = function( url, elem ) {
  var background = new Background( url, elem );
  this.images.push( background );
};

ImagesLoaded.prototype.check = function() {
  var _this = this;
  this.progressedCount = 0;
  this.hasAnyBroken = false;
  // complete if no images
  if ( !this.images.length ) {
    this.complete();
    return;
  }

  function onProgress( image, elem, message ) {
    // HACK - Chrome triggers event before object properties have changed. #83
    setTimeout( function() {
      _this.progress( image, elem, message );
    });
  }

  this.images.forEach( function( loadingImage ) {
    loadingImage.once( 'progress', onProgress );
    loadingImage.check();
  });
};

ImagesLoaded.prototype.progress = function( image, elem, message ) {
  this.progressedCount++;
  this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
  // progress event
  this.emitEvent( 'progress', [ this, image, elem ] );
  if ( this.jqDeferred && this.jqDeferred.notify ) {
    this.jqDeferred.notify( this, image );
  }
  // check if completed
  if ( this.progressedCount == this.images.length ) {
    this.complete();
  }

  if ( this.options.debug && console ) {
    console.log( 'progress: ' + message, image, elem );
  }
};

ImagesLoaded.prototype.complete = function() {
  var eventName = this.hasAnyBroken ? 'fail' : 'done';
  this.isComplete = true;
  this.emitEvent( eventName, [ this ] );
  this.emitEvent( 'always', [ this ] );
  if ( this.jqDeferred ) {
    var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
    this.jqDeferred[ jqMethod ]( this );
  }
};

// --------------------------  -------------------------- //

function LoadingImage( img ) {
  this.img = img;
}

LoadingImage.prototype = Object.create( EvEmitter.prototype );

LoadingImage.prototype.check = function() {
  // If complete is true and browser supports natural sizes,
  // try to check for image status manually.
  var isComplete = this.getIsImageComplete();
  if ( isComplete ) {
    // report based on naturalWidth
    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
    return;
  }

  // If none of the checks above matched, simulate loading on detached element.
  this.proxyImage = new Image();
  this.proxyImage.addEventListener( 'load', this );
  this.proxyImage.addEventListener( 'error', this );
  // bind to image as well for Firefox. #191
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  this.proxyImage.src = this.img.src;
};

LoadingImage.prototype.getIsImageComplete = function() {
  // check for non-zero, non-undefined naturalWidth
  // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
  return this.img.complete && this.img.naturalWidth;
};

LoadingImage.prototype.confirm = function( isLoaded, message ) {
  this.isLoaded = isLoaded;
  this.emitEvent( 'progress', [ this, this.img, message ] );
};

// ----- events ----- //

// trigger specified handler for event type
LoadingImage.prototype.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

LoadingImage.prototype.onload = function() {
  this.confirm( true, 'onload' );
  this.unbindEvents();
};

LoadingImage.prototype.onerror = function() {
  this.confirm( false, 'onerror' );
  this.unbindEvents();
};

LoadingImage.prototype.unbindEvents = function() {
  this.proxyImage.removeEventListener( 'load', this );
  this.proxyImage.removeEventListener( 'error', this );
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );
};

// -------------------------- Background -------------------------- //

function Background( url, element ) {
  this.url = url;
  this.element = element;
  this.img = new Image();
}

// inherit LoadingImage prototype
Background.prototype = Object.create( LoadingImage.prototype );

Background.prototype.check = function() {
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  this.img.src = this.url;
  // check if image is already complete
  var isComplete = this.getIsImageComplete();
  if ( isComplete ) {
    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
    this.unbindEvents();
  }
};

Background.prototype.unbindEvents = function() {
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );
};

Background.prototype.confirm = function( isLoaded, message ) {
  this.isLoaded = isLoaded;
  this.emitEvent( 'progress', [ this, this.element, message ] );
};

// -------------------------- jQuery -------------------------- //

ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
  jQuery = jQuery || window.jQuery;
  if ( !jQuery ) {
    return;
  }
  // set local variable
  $ = jQuery;
  // $().imagesLoaded()
  $.fn.imagesLoaded = function( options, callback ) {
    var instance = new ImagesLoaded( this, options, callback );
    return instance.jqDeferred.promise( $(this) );
  };
};
// try making plugin
ImagesLoaded.makeJQueryPlugin();

// --------------------------  -------------------------- //

return ImagesLoaded;

});

/*!
 * Flickity imagesLoaded v2.0.0
 * enables imagesLoaded option for Flickity
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'flickity/js/index',
      'imagesloaded/imagesloaded'
    ], function( Flickity, imagesLoaded ) {
      return factory( window, Flickity, imagesLoaded );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('flickity'),
      require('imagesloaded')
    );
  } else {
    // browser global
    window.Flickity = factory(
      window,
      window.Flickity,
      window.imagesLoaded
    );
  }

}( window, function factory( window, Flickity, imagesLoaded ) {
'use strict';

Flickity.createMethods.push('_createImagesLoaded');

var proto = Flickity.prototype;

proto._createImagesLoaded = function() {
  this.on( 'activate', this.imagesLoaded );
};

proto.imagesLoaded = function() {
  if ( !this.options.imagesLoaded ) {
    return;
  }
  var _this = this;
  function onImagesLoadedProgress( instance, image ) {
    var cell = _this.getParentCell( image.img );
    _this.cellSizeChange( cell && cell.element );
    if ( !_this.options.freeScroll ) {
      _this.positionSliderAtSelected();
    }
  }
  imagesLoaded( this.slider ).on( 'progress', onImagesLoadedProgress );
};

return Flickity;

}));

/**
 * Flickity fade v1.0.0
 * Fade between Flickity slides
 */

/* jshint browser: true, undef: true, unused: true */

( function( window, factory ) {
    // universal module definition
    /*globals define, module, require */
    if ( typeof define == 'function' && define.amd ) {
      // AMD
      define( [
        'flickity/js/index',
        'fizzy-ui-utils/utils',
      ], factory );
    } else if ( typeof module == 'object' && module.exports ) {
      // CommonJS
      module.exports = factory(
        require('flickity'),
        require('fizzy-ui-utils')
      );
    } else {
      // browser global
      factory(
        window.Flickity,
        window.fizzyUIUtils
      );
    }
  
  }( this, function factory( Flickity, utils ) {
  
  // ---- Slide ---- //
  
  var Slide = Flickity.Slide;
  
  var slideUpdateTarget = Slide.prototype.updateTarget;
  Slide.prototype.updateTarget = function() {
    slideUpdateTarget.apply( this, arguments );
    if ( !this.parent.options.fade ) {
      return;
    }
    // position cells at selected target
    var slideTargetX = this.target - this.x;
    var firstCellX = this.cells[0].x;
    this.cells.forEach( function( cell ) {
      var targetX = cell.x - firstCellX - slideTargetX;
      cell.renderPosition( targetX );
    });
  };
  
  Slide.prototype.setOpacity = function( alpha ) {
    this.cells.forEach( function( cell ) {
      cell.element.style.opacity = alpha;
    });
  };
  
  // ---- Flickity ---- //
  
  var proto = Flickity.prototype;
  
  Flickity.createMethods.push('_createFade');
  
  proto._createFade = function() {
    this.fadeIndex = this.selectedIndex;
    this.prevSelectedIndex = this.selectedIndex;
    this.on( 'select', this.onSelectFade );
    this.on( 'dragEnd', this.onDragEndFade );
    this.on( 'settle', this.onSettleFade );
    this.on( 'activate', this.onActivateFade );
    this.on( 'deactivate', this.onDeactivateFade );
  };
  
  var updateSlides = proto.updateSlides;
  proto.updateSlides = function() {
    updateSlides.apply( this, arguments );
    if ( !this.options.fade ) {
      return;
    }
    // set initial opacity
    this.slides.forEach( function( slide, i ) {
      var alpha = i == this.selectedIndex ? 1 : 0;
      slide.setOpacity( alpha );
    }, this );
  };
  
  /* ---- events ---- */
  
  proto.onSelectFade = function() {
    // in case of resize, keep fadeIndex within current count
    this.fadeIndex = Math.min( this.prevSelectedIndex, this.slides.length - 1 );
    this.prevSelectedIndex = this.selectedIndex;
  };
  
  proto.onSettleFade = function() {
    delete this.didDragEnd;
    if ( !this.options.fade ) {
      return;
    }
    // set full and 0 opacity on selected & faded slides
    this.selectedSlide.setOpacity( 1 );
    var fadedSlide = this.slides[ this.fadeIndex ];
    if ( fadedSlide && this.fadeIndex != this.selectedIndex ) {
      this.slides[ this.fadeIndex ].setOpacity( 0 );
    }
  };
  
  proto.onDragEndFade = function() {
    // set flag
    this.didDragEnd = true;
  };
  
  proto.onActivateFade = function() {
    if ( this.options.fade ) {
      this.element.classList.add('is-fade');
    }
  };
  
  proto.onDeactivateFade = function() {
    if ( !this.options.fade ) {
      return;
    }
    this.element.classList.remove('is-fade');
    // reset opacity
    this.slides.forEach( function( slide ) {
      slide.setOpacity('');
    });
  };
  
  /* ---- position & fading ---- */
  
  var positionSlider = proto.positionSlider;
  proto.positionSlider = function() {
    if ( !this.options.fade ) {
      positionSlider.apply( this, arguments );
      return;
    }
  
    this.fadeSlides();
    this.dispatchScrollEvent();
  };
  
  var positionSliderAtSelected = proto.positionSliderAtSelected;
  proto.positionSliderAtSelected = function() {
    if ( this.options.fade ) {
      // position fade slider at origin
      this.setTranslateX( 0 );
    }
    positionSliderAtSelected.apply( this, arguments );
  };
  
  proto.fadeSlides = function() {
    if ( this.slides.length < 2 ) {
      return;
    }
    // get slides to fade-in & fade-out
    var indexes = this.getFadeIndexes();
    var fadeSlideA = this.slides[ indexes.a ];
    var fadeSlideB = this.slides[ indexes.b ];
    var distance = this.wrapDifference( fadeSlideA.target, fadeSlideB.target );
    var progress = this.wrapDifference( fadeSlideA.target, -this.x );
    progress = progress / distance;
  
    fadeSlideA.setOpacity( 1 - progress );
    fadeSlideB.setOpacity( progress );
  
    // hide previous slide
    var fadeHideIndex = indexes.a;
    if ( this.isDragging ) {
      fadeHideIndex = progress > 0.5 ? indexes.a : indexes.b;
    }
    var isNewHideIndex = this.fadeHideIndex != undefined &&
      this.fadeHideIndex != fadeHideIndex &&
      this.fadeHideIndex != indexes.a &&
      this.fadeHideIndex != indexes.b;
    if ( isNewHideIndex ) {
      // new fadeHideSlide set, hide previous
      this.slides[ this.fadeHideIndex ].setOpacity( 0 );
    }
    this.fadeHideIndex = fadeHideIndex;
  };
  
  proto.getFadeIndexes = function() {
    if ( !this.isDragging && !this.didDragEnd ) {
      return {
        a: this.fadeIndex,
        b: this.selectedIndex,
      };
    }
    if ( this.options.wrapAround ) {
      return this.getFadeDragWrapIndexes();
    } else {
      return this.getFadeDragLimitIndexes();
    }
  };
  
  proto.getFadeDragWrapIndexes = function() {
    var distances = this.slides.map( function( slide, i ) {
      return this.getSlideDistance( -this.x, i );
    }, this );
    var absDistances = distances.map( function( distance ) {
      return Math.abs( distance );
    });
    var minDistance = Math.min.apply( Math, absDistances );
    var closestIndex = absDistances.indexOf( minDistance );
    var distance = distances[ closestIndex ];
    var len = this.slides.length;
  
    var delta = distance >= 0 ? 1 : -1;
    return {
      a: closestIndex,
      b: utils.modulo( closestIndex + delta, len ),
    };
  };
  
  proto.getFadeDragLimitIndexes = function() {
    // calculate closest previous slide
    var dragIndex = 0;
    for ( var i=0; i < this.slides.length - 1; i++ ) {
      var slide = this.slides[i];
      if ( -this.x < slide.target ) {
        break;
      }
      dragIndex = i;
    }
    return {
      a: dragIndex,
      b: dragIndex + 1,
    };
  };

  proto.wrapDifference = function( a, b ) {
    var diff = b - a;
  
    if ( !this.options.wrapAround ) {
      return diff;
    }
  
    var diffPlus = diff + this.slideableWidth;
    var diffMinus = diff - this.slideableWidth;
    if ( Math.abs( diffPlus ) < Math.abs( diff ) ) {
      diff = diffPlus;
    }
    if ( Math.abs( diffMinus ) < Math.abs( diff ) ) {
      diff = diffMinus;
    }
    return diff;
  };
  
  // ---- wrapAround ---- //
  
  var _getWrapShiftCells = proto._getWrapShiftCells;
  proto._getWrapShiftCells = function() {
    if ( !this.options.fade ) {
      _getWrapShiftCells.apply( this, arguments );
    }
  };
  
  var shiftWrapCells = proto.shiftWrapCells;
  proto.shiftWrapCells = function() {
    if ( !this.options.fade ) {
      shiftWrapCells.apply( this, arguments );
    }
  };
  
  return Flickity;
  
  }));
!function(e,o){if("function"==typeof define&&define.amd)define(["exports"],o);else if("undefined"!=typeof exports)o(exports);else{var t={};o(t),e.bodyScrollLock=t}}(this,function(exports){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var t=!1;if("undefined"!=typeof window){var e={get passive(){t=!0}};window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e)}function l(o){return c.some(function(e){return!(!e.options.allowTouchMove||!e.options.allowTouchMove(o))})}function d(e){var o=e||window.event;return!!l(o.target)||(1<o.touches.length||(o.preventDefault&&o.preventDefault(),!1))}function n(){void 0!==v&&(document.body.style.paddingRight=v,v=void 0),void 0!==s&&(document.body.style.overflow=s,s=void 0)}var i="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&(/iP(ad|hone|od)/.test(window.navigator.platform)||"MacIntel"===window.navigator.platform&&1<window.navigator.maxTouchPoints),c=[],a=!1,u=-1,s=void 0,v=void 0;exports.disableBodyScroll=function(r,e){if(r){if(!c.some(function(e){return e.targetElement===r})){var o={targetElement:r,options:e||{}};c=[].concat(function(e){if(Array.isArray(e)){for(var o=0,t=Array(e.length);o<e.length;o++)t[o]=e[o];return t}return Array.from(e)}(c),[o]),i?(r.ontouchstart=function(e){1===e.targetTouches.length&&(u=e.targetTouches[0].clientY)},r.ontouchmove=function(e){var o,t,n,i;1===e.targetTouches.length&&(t=r,i=(o=e).targetTouches[0].clientY-u,l(o.target)||(t&&0===t.scrollTop&&0<i||(n=t)&&n?.scrollHeight-n.scrollTop<=n.clientHeight&&i<0?d(o):o.stopPropagation()))},a||(document.addEventListener("touchmove",d,t?{passive:!1}:void 0),a=!0)):function(e){if(void 0===v){var o=!!e&&!0===e.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;o&&0<t&&(v=document.body.style.paddingRight,document.body.style.paddingRight=t+"px")}void 0===s&&(s=document.body.style.overflow,document.body.style.overflow="hidden")}(e)}}else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.")},exports.clearAllBodyScrollLocks=function(){i?(c.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),a&&(document.removeEventListener("touchmove",d,t?{passive:!1}:void 0),a=!1),u=-1):n(),c=[]},exports.enableBodyScroll=function(o){o?(c=c.filter(function(e){return e.targetElement!==o}),i?(o.ontouchstart=null,o.ontouchmove=null,a&&0===c.length&&(document.removeEventListener("touchmove",d,t?{passive:!1}:void 0),a=!1)):c.length||n()):console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.")}});
/*! lazysizes - v5.2.2 */
!function(t,e){var r=function(){e(t.lazySizes),t.removeEventListener("lazyunveilread",r,!0)};e=e.bind(null,t,t.document),"object"==typeof module&&module.exports?e(require("lazysizes")):"function"==typeof define&&define.amd?define(["lazysizes"],e):t.lazySizes?r():t.addEventListener("lazyunveilread",r,!0)}(window,function(l,u,g){"use strict";var b,m,i=g.cfg,d={string:1,number:1},o=/^\-*\+*\d+\.*\d*$/,c=/^picture$/i,v=/\s*\{\s*width\s*\}\s*/i,f=/\s*\{\s*height\s*\}\s*/i,p=/\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,y=/^\[.*\]|\{.*\}$/,z=/^(?:auto|\d+(px)?)$/,h=u.createElement("a"),t=u.createElement("img"),A="srcset"in t&&!("sizes"in t),w=!!l.HTMLPictureElement&&!A;function P(a,t){function r(t,e){var r,i=a.getAttribute("data-"+t);if(i||(r=s.getPropertyValue("--ls-"+t))&&(i=r.trim()),i){if("true"==i)i=!0;else if("false"==i)i=!1;else if(o.test(i))i=parseFloat(i);else if("function"==typeof m[t])i=m[t](a,i);else if(y.test(i))try{i=JSON.parse(i)}catch(t){}n[t]=i}else t in m&&"function"!=typeof m[t]?n[t]=m[t]:e&&"function"==typeof m[t]&&(n[t]=m[t](a,i))}var e,s=l.getComputedStyle(a),i=a.parentNode,n={isPicture:!(!i||!c.test(i.nodeName||""))};for(e in m)r(e);return t.replace(p,function(t,e){e in n||r(e,!0)}),n}function E(t,e,r){var s,n,o,i=0,a=0,c=r;if(t){if("container"===e.ratio){for(i=c.scrollWidth,a=c?.scrollHeight;!(i&&a||c===u);)i=(c=c.parentNode).scrollWidth,a=c?.scrollHeight;i&&a&&(e.ratio=e.traditionalRatio?a/i:i/a)}s=t,n=e,(o=[]).srcset=[],n.absUrl&&(h.setAttribute("href",s),s=h.href),s=((n.prefix||"")+s+(n.postfix||"")).replace(p,function(t,e){return d[typeof n[e]]?n[e]:t}),n.widths.forEach(function(t){var e=n.widthmap[t]||t,r=n.aspectratio||n.ratio,i=!n.aspectratio&&m.traditionalRatio,a={u:s.replace(v,e).replace(f,r?i?Math.round(t*r):Math.round(t/r):""),w:t};o.push(a),o.srcset.push(a.c=a.u+" "+t+"w")}),(t=o).isPicture=e.isPicture,A&&"IMG"==r.nodeName.toUpperCase()?r.removeAttribute(b.srcsetAttr):r.setAttribute(b.srcsetAttr,t.srcset.join(", ")),Object.defineProperty(r,"_lazyrias",{value:t,writable:!0})}}function N(t){return t.getAttribute(t.getAttribute("data-srcattr")||m.srcAttr)||t.getAttribute(b.srcsetAttr)||t.getAttribute(b.srcAttr)||t.getAttribute("data-pfsrcset")||""}!function(){var t,e={prefix:"",postfix:"",srcAttr:"data-src",absUrl:!1,modifyOptions:function(){},widthmap:{},ratio:!1,traditionalRatio:!1,aspectratio:!1};for(t in(b=g&&g.cfg).supportsType||(b.supportsType=function(t){return!t}),b.rias||(b.rias={}),"widths"in(m=b.rias)||(m.widths=[],function(t){for(var e,r=0;!e||e<3e3;)30<(r+=5)&&(r+=1),e=36*r,t.push(e)}(m.widths)),e)t in m||(m[t]=e[t])}(),addEventListener("lazybeforesizes",function(t){if(t.detail.instance==g){var e,r,i,a,s,n,o,c,u,d,l,f=t.target;if(t.detail.dataAttr&&!t.defaultPrevented&&!m.disabled&&(o=f.getAttribute(b.sizesAttr)||f.getAttribute("sizes"))&&z.test(o)){var p,y,h=N(f);if(y=P(p=f,h),m.modifyOptions.call(p,{target:p,details:y,detail:y}),g.fire(p,"lazyriasmodifyoptions",y),e=y,u=v.test(e.prefix)||v.test(e.postfix),e.isPicture&&(r=f.parentNode))for(a=0,s=(i=r.getElementsByTagName("source")).length;a<s;a++)(u||v.test(n=N(i[a])))&&(E(n,e,i[a]),d=!0);u||v.test(h)?(E(h,e,f),d=!0):d&&((l=[]).srcset=[],l.isPicture=!0,Object.defineProperty(f,"_lazyrias",{value:l,writable:!0})),d&&(w?f.removeAttribute(b.srcAttr):"auto"!=o&&(c={width:parseInt(o,10)},_({target:f,detail:c})))}}},!0);var a,_=(a=function(t){var e,r;t.detail.instance==g&&(r=t.target,A||!(l.respimage||l.picturefill||i.pf)?("_lazyrias"in r||t.detail.dataAttr&&M(r,!0))&&(e=s(r,t.detail.width))&&e.u&&r._lazyrias.cur!=e.u&&(r._lazyrias.cur=e.u,e.cached=!0,g.rAF(function(){r.setAttribute(b.srcAttr,e.u),r.setAttribute("src",e.u)})):u.removeEventListener("lazybeforesizes",a))},w?a=function(){}:addEventListener("lazybeforesizes",a),a);function x(t,e){return t.w-e.w}function M(t,e){var r;return!t._lazyrias&&g.pWS&&(r=g.pWS(t.getAttribute(b.srcsetAttr||""))).length&&(Object.defineProperty(t,"_lazyrias",{value:r,writable:!0}),e&&t.parentNode&&(r.isPicture="PICTURE"==t.parentNode.nodeName.toUpperCase())),t._lazyrias}function s(t,e){var r,i,a,s,n,o,c,u,d=t._lazyrias;if(d.isPicture&&l.matchMedia)for(i=0,a=(r=t.parentNode.getElementsByTagName("source")).length;i<a;i++)if(M(r[i])&&!r[i].getAttribute("type")&&(!(s=r[i].getAttribute("media"))||(matchMedia(s)||{}).matches)){d=r[i]._lazyrias;break}return(!d.w||d.w<e)&&(d.w=e,d.d=(o=t,c=l.devicePixelRatio||1,u=g.getX&&g.getX(o),Math.min(u||c,2.4,c)),n=function(t){for(var e,r,i=t.length,a=t[i-1],s=0;s<i;s++)if((a=t[s]).d=a.w/t.w,a.d>=t.d){!a.cached&&(e=t[s-1])&&e.d>t.d-.13*Math.pow(t.d,2.2)&&(r=Math.pow(e.d-.6,1.6),e.cached&&(e.d+=.15*r),e.d+(a.d-t.d)*r>t.d&&(a=e));break}return a}(d.sort(x))),n}});
/*! lazysizes - v5.2.2 */

!function(e){var t=function(u,D,f){"use strict";var k,H;if(function(){var e;var t={lazyClass:"lazyload",loadedClass:"lazyloaded",loadingClass:"lazyloading",preloadClass:"lazypreload",errorClass:"lazyerror",autosizesClass:"lazyautosizes",srcAttr:"data-src",srcsetAttr:"data-srcset",sizesAttr:"data-sizes",minSize:40,customMedia:{},init:true,expFactor:1.5,hFac:.8,loadMode:2,loadHidden:true,ricTimeout:0,throttleDelay:125};H=u.lazySizesConfig||u.lazysizesConfig||{};for(e in t){if(!(e in H)){H[e]=t[e]}}}(),!D||!D.getElementsByClassName){return{init:function(){},cfg:H,noSupport:true}}var O=D.documentElement,a=u.HTMLPictureElement,P="addEventListener",$="getAttribute",q=u[P].bind(u),I=u.setTimeout,U=u.requestAnimationFrame||I,l=u.requestIdleCallback,j=/^picture$/i,r=["load","error","lazyincluded","_lazyloaded"],i={},G=Array.prototype.forEach,J=function(e,t){if(!i[t]){i[t]=new RegExp("(\\s|^)"+t+"(\\s|$)")}return i[t].test(e[$]("class")||"")&&i[t]},K=function(e,t){if(!J(e,t)){e.setAttribute("class",(e[$]("class")||"").trim()+" "+t)}},Q=function(e,t){var i;if(i=J(e,t)){e.setAttribute("class",(e[$]("class")||"").replace(i," "))}},V=function(t,i,e){var a=e?P:"removeEventListener";if(e){V(t,i)}r.forEach(function(e){t[a](e,i)})},X=function(e,t,i,a,r){var n=D.createEvent("Event");if(!i){i={}}i.instance=k;n.initEvent(t,!a,!r);n.detail=i;e.dispatchEvent(n);return n},Y=function(e,t){var i;if(!a&&(i=u.picturefill||H.pf)){if(t&&t.src&&!e[$]("srcset")){e.setAttribute("srcset",t.src)}i({reevaluate:true,elements:[e]})}else if(t&&t.src){e.src=t.src}},Z=function(e,t){return(getComputedStyle(e,null)||{})[t]},s=function(e,t,i){i=i||e.offsetWidth;while(i<H.minSize&&t&&!e._lazysizesWidth){i=t.offsetWidth;t=t.parentNode}return i},ee=function(){var i,a;var t=[];var r=[];var n=t;var s=function(){var e=n;n=t.length?r:t;i=true;a=false;while(e.length){e.shift()()}i=false};var e=function(e,t){if(i&&!t){e.apply(this,arguments)}else{n.push(e);if(!a){a=true;(D.hidden?I:U)(s)}}};e._lsFlush=s;return e}(),te=function(i,e){return e?function(){ee(i)}:function(){var e=this;var t=arguments;ee(function(){i.apply(e,t)})}},ie=function(e){var i;var a=0;var r=H.throttleDelay;var n=H.ricTimeout;var t=function(){i=false;a=f.now();e()};var s=l&&n>49?function(){l(t,{timeout:n});if(n!==H.ricTimeout){n=H.ricTimeout}}:te(function(){I(t)},true);return function(e){var t;if(e=e===true){n=33}if(i){return}i=true;t=r-(f.now()-a);if(t<0){t=0}if(e||t<9){s()}else{I(s,t)}}},ae=function(e){var t,i;var a=99;var r=function(){t=null;e()};var n=function(){var e=f.now()-i;if(e<a){I(n,a-e)}else{(l||r)(r)}};return function(){i=f.now();if(!t){t=I(n,a)}}},e=function(){var v,m,c,h,e;var y,z,g,p,C,b,A;var n=/^img$/i;var d=/^iframe$/i;var E="onscroll"in u&&!/(gle|ing)bot/.test(navigator.userAgent);var _=0;var w=0;var N=0;var M=-1;var x=function(e){N--;if(!e||N<0||!e.target){N=0}};var W=function(e){if(A==null){A=Z(D.body,"visibility")=="hidden"}return A||!(Z(e.parentNode,"visibility")=="hidden"&&Z(e,"visibility")=="hidden")};var S=function(e,t){var i;var a=e;var r=W(e);g-=t;b+=t;p-=t;C+=t;while(r&&(a=a.offsetParent)&&a!=D.body&&a!=O){r=(Z(a,"opacity")||1)>0;if(r&&Z(a,"overflow")!="visible"){i=a.getBoundingClientRect();r=C>i.left&&p<i.right&&b>i.top-1&&g<i.bottom+1}}return r};var t=function(){var e,t,i,a,r,n,s,l,o,u,f,c;var d=k.elements;if((h=H.loadMode)&&N<8&&(e=d.length)){t=0;M++;for(;t<e;t++){if(!d[t]||d[t]._lazyRace){continue}if(!E||k.prematureUnveil&&k.prematureUnveil(d[t])){R(d[t]);continue}if(!(l=d[t][$]("data-expand"))||!(n=l*1)){n=w}if(!u){u=!H.expand||H.expand<1?O.clientHeight>500&&O.clientWidth>500?500:370:H.expand;k._defEx=u;f=u*H.expFactor;c=H.hFac;A=null;if(w<f&&N<1&&M>2&&h>2&&!D.hidden){w=f;M=0}else if(h>1&&M>1&&N<6){w=u}else{w=_}}if(o!==n){y=innerWidth+n*c;z=innerHeight+n;s=n*-1;o=n}i=d[t].getBoundingClientRect();if((b=i.bottom)>=s&&(g=i.top)<=z&&(C=i.right)>=s*c&&(p=i.left)<=y&&(b||C||p||g)&&(H.loadHidden||W(d[t]))&&(m&&N<3&&!l&&(h<3||M<4)||S(d[t],n))){R(d[t]);r=true;if(N>9){break}}else if(!r&&m&&!a&&N<4&&M<4&&h>2&&(v[0]||H.preloadAfterLoad)&&(v[0]||!l&&(b||C||p||g||d[t][$](H.sizesAttr)!="auto"))){a=v[0]||d[t]}}if(a&&!r){R(a)}}};var i=ie(t);var B=function(e){var t=e.target;if(t._lazyCache){delete t._lazyCache;return}x(e);K(t,H.loadedClass);Q(t,H.loadingClass);V(t,L);X(t,"lazyloaded")};var a=te(B);var L=function(e){a({target:e.target})};var T=function(t,i){try{t.contentWindow.location.replace(i)}catch(e){t.src=i}};var F=function(e){var t;var i=e[$](H.srcsetAttr);if(t=H.customMedia[e[$]("data-media")||e[$]("media")]){e.setAttribute("media",t)}if(i){e.setAttribute("srcset",i)}};var s=te(function(t,e,i,a,r){var n,s,l,o,u,f;if(!(u=X(t,"lazybeforeunveil",e)).defaultPrevented){if(a){if(i){K(t,H.autosizesClass)}else{t.setAttribute("sizes",a)}}s=t[$](H.srcsetAttr);n=t[$](H.srcAttr);if(r){l=t.parentNode;o=l&&j.test(l.nodeName||"")}f=e.firesLoad||"src"in t&&(s||n||o);u={target:t};K(t,H.loadingClass);if(f){clearTimeout(c);c=I(x,2500);V(t,L,true)}if(o){G.call(l.getElementsByTagName("source"),F)}if(s){t.setAttribute("srcset",s)}else if(n&&!o){if(d.test(t.nodeName)){T(t,n)}else{t.src=n}}if(r&&(s||o)){Y(t,{src:n})}}if(t._lazyRace){delete t._lazyRace}Q(t,H.lazyClass);ee(function(){var e=t.complete&&t.naturalWidth>1;if(!f||e){if(e){K(t,"ls-is-cached")}B(u);t._lazyCache=true;I(function(){if("_lazyCache"in t){delete t._lazyCache}},9)}if(t.loading=="lazy"){N--}},true)});var R=function(e){if(e._lazyRace){return}var t;var i=n.test(e.nodeName);var a=i&&(e[$](H.sizesAttr)||e[$]("sizes"));var r=a=="auto";if((r||!m)&&i&&(e[$]("src")||e.srcset)&&!e.complete&&!J(e,H.errorClass)&&J(e,H.lazyClass)){return}t=X(e,"lazyunveilread").detail;if(r){re.updateElem(e,true,e.offsetWidth)}e._lazyRace=true;N++;s(e,t,r,a,i)};var r=ae(function(){H.loadMode=3;i()});var l=function(){if(H.loadMode==3){H.loadMode=2}r()};var o=function(){if(m){return}if(f.now()-e<999){I(o,999);return}m=true;H.loadMode=3;i();q("scroll",l,true)};return{_:function(){e=f.now();k.elements=D.getElementsByClassName(H.lazyClass);v=D.getElementsByClassName(H.lazyClass+" "+H.preloadClass);q("scroll",i,true);q("resize",i,true);q("pageshow",function(e){if(e.persisted){var t=D.querySelectorAll("."+H.loadingClass);if(t.length&&t.forEach){U(function(){t.forEach(function(e){if(e.complete){R(e)}})})}}});if(u.MutationObserver){new MutationObserver(i).observe(O,{childList:true,subtree:true,attributes:true})}else{O[P]("DOMNodeInserted",i,true);O[P]("DOMAttrModified",i,true);setInterval(i,999)}q("hashchange",i,true);["focus","mouseover","click","load","transitionend","animationend"].forEach(function(e){D[P](e,i,true)});if(/d$|^c/.test(D.readyState)){o()}else{q("load",o);D[P]("DOMContentLoaded",i);I(o,2e4)}if(k.elements.length){t();ee._lsFlush()}else{i()}},checkElems:i,unveil:R,_aLSL:l}}(),re=function(){var i;var n=te(function(e,t,i,a){var r,n,s;e._lazysizesWidth=a;a+="px";e.setAttribute("sizes",a);if(j.test(t.nodeName||"")){r=t.getElementsByTagName("source");for(n=0,s=r.length;n<s;n++){r[n].setAttribute("sizes",a)}}if(!i.detail.dataAttr){Y(e,i.detail)}});var a=function(e,t,i){var a;var r=e.parentNode;if(r){i=s(e,r,i);a=X(e,"lazybeforesizes",{width:i,dataAttr:!!t});if(!a.defaultPrevented){i=a.detail.width;if(i&&i!==e._lazysizesWidth){n(e,r,a,i)}}}};var e=function(){var e;var t=i.length;if(t){e=0;for(;e<t;e++){a(i[e])}}};var t=ae(e);return{_:function(){i=D.getElementsByClassName(H.autosizesClass);q("resize",t)},checkElems:t,updateElem:a}}(),t=function(){if(!t.i&&D.getElementsByClassName){t.i=true;re._();e._()}};return I(function(){H.init&&t()}),k={cfg:H,autoSizer:re,loader:e,init:t,uP:Y,aC:K,rC:Q,hC:J,fire:X,gW:s,rAF:ee}}(e,e.document,Date);e.lazySizes=t,"object"==typeof module&&module.exports&&(module.exports=t)}("undefined"!=typeof window?window:{});
/*!
 * in-view 0.6.1 - Get notified when a DOM element enters or exits the viewport.
 * Copyright (c) 2016 Cam Wiegert <cam@camwiegert.com> - https://camwiegert.github.io/in-view
 * License: MIT
 */
!function(t,e){"object"==typeof exports&&"object"==typeof module?module.exports=e():"function"==typeof define&&define.amd?define([],e):"object"==typeof exports?exports.inView=e():t.inView=e()}(this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var i=n[r]={exports:{},id:r,loaded:!1};return t[r].call(i.exports,i,i.exports,e),i.loaded=!0,i.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}var i=n(2),o=r(i);t.exports=o["default"]},function(t,e){function n(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}t.exports=n},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var i=n(9),o=r(i),u=n(3),f=r(u),s=n(4),c=function(){if("undefined"!=typeof window){var t=100,e=["scroll","resize","load"],n={history:[]},r={offset:{},threshold:0,test:s.inViewport},i=(0,o["default"])(function(){n.history.forEach(function(t){n[t].check()})},t);e.forEach(function(t){return addEventListener(t,i)}),window.MutationObserver&&addEventListener("DOMContentLoaded",function(){new MutationObserver(i).observe(document.body,{attributes:!0,childList:!0,subtree:!0})});var u=function(t){if("string"==typeof t){var e=[].slice.call(document.querySelectorAll(t));return n.history.indexOf(t)>-1?n[t].elements=e:(n[t]=(0,f["default"])(e,r),n.history.push(t)),n[t]}};return u.offset=function(t){if(void 0===t)return r.offset;var e=function(t){return"number"==typeof t};return["top","right","bottom","left"].forEach(e(t)?function(e){return r.offset[e]=t}:function(n){return e(t[n])?r.offset[n]=t[n]:null}),r.offset},u.threshold=function(t){return"number"==typeof t&&t>=0&&t<=1?r.threshold=t:r.threshold},u.test=function(t){return"function"==typeof t?r.test=t:r.test},u.is=function(t){return r.test(t,r)},u.offset(0),u}};e["default"]=c()},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var r=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}(),i=function(){function t(e,r){n(this,t),this.options=r,this.elements=e,this.current=[],this.handlers={enter:[],exit:[]},this.singles={enter:[],exit:[]}}return r(t,[{key:"check",value:function(){var t=this;return this.elements.forEach(function(e){var n=t.options.test(e,t.options),r=t.current.indexOf(e),i=r>-1,o=n&&!i,u=!n&&i;o&&(t.current.push(e),t.emit("enter",e)),u&&(t.current.splice(r,1),t.emit("exit",e))}),this}},{key:"on",value:function(t,e){return this.handlers[t].push(e),this}},{key:"once",value:function(t,e){return this.singles[t].unshift(e),this}},{key:"emit",value:function(t,e){for(;this.singles[t].length;)this.singles[t].pop()(e);for(var n=this.handlers[t].length;--n>-1;)this.handlers[t][n](e);return this}}]),t}();e["default"]=function(t,e){return new i(t,e)}},function(t,e){"use strict";function n(t,e){var n=t.getBoundingClientRect(),r=n.top,i=n.right,o=n.bottom,u=n.left,f=n.width,s=n.height,c={t:o,r:window.innerWidth-u,b:window.innerHeight-r,l:i},a={x:e.threshold*f,y:e.threshold*s};return c.t>e.offset.top+a.y&&c.r>e.offset.right+a.x&&c.b>e.offset.bottom+a.y&&c.l>e.offset.left+a.x}Object.defineProperty(e,"__esModule",{value:!0}),e.inViewport=n},function(t,e){(function(e){var n="object"==typeof e&&e&&e.Object===Object&&e;t.exports=n}).call(e,function(){return this}())},function(t,e,n){var r=n(5),i="object"==typeof self&&self&&self.Object===Object&&self,o=r||i||Function("return this")();t.exports=o},function(t,e,n){function r(t,e,n){function r(e){var n=x,r=m;return x=m=void 0,E=e,w=t.apply(r,n)}function a(t){return E=t,j=setTimeout(h,e),M?r(t):w}function l(t){var n=t-O,r=t-E,i=e-n;return _?c(i,g-r):i}function d(t){var n=t-O,r=t-E;return void 0===O||n>=e||n<0||_&&r>=g}function h(){var t=o();return d(t)?p(t):void(j=setTimeout(h,l(t)))}function p(t){return j=void 0,T&&x?r(t):(x=m=void 0,w)}function v(){void 0!==j&&clearTimeout(j),E=0,x=O=m=j=void 0}function y(){return void 0===j?w:p(o())}function b(){var t=o(),n=d(t);if(x=arguments,m=this,O=t,n){if(void 0===j)return a(O);if(_)return j=setTimeout(h,e),r(O)}return void 0===j&&(j=setTimeout(h,e)),w}var x,m,g,w,j,O,E=0,M=!1,_=!1,T=!0;if("function"!=typeof t)throw new TypeError(f);return e=u(e)||0,i(n)&&(M=!!n.leading,_="maxWait"in n,g=_?s(u(n.maxWait)||0,e):g,T="trailing"in n?!!n.trailing:T),b.cancel=v,b.flush=y,b}var i=n(1),o=n(8),u=n(10),f="Expected a function",s=Math.max,c=Math.min;t.exports=r},function(t,e,n){var r=n(6),i=function(){return r.Date.now()};t.exports=i},function(t,e,n){function r(t,e,n){var r=!0,f=!0;if("function"!=typeof t)throw new TypeError(u);return o(n)&&(r="leading"in n?!!n.leading:r,f="trailing"in n?!!n.trailing:f),i(t,e,{leading:r,maxWait:e,trailing:f})}var i=n(7),o=n(1),u="Expected a function";t.exports=r},function(t,e){function n(t){return t}t.exports=n}])});
/**
 * format price
 * @param  {number} price e.g. "1200"
 * @return {string}       e.g. "12.00"
 */
 _.formatPrice = function(price) {
  return (price / 100).toFixed(2);
};
/**
 * format price display
 * @param  {number} price e.g. "1200"
 * @return {string}       e.g. "$12"
 */
 _.formatPriceDisplay = function(price) {
  const getSymbol = (code) => ({AED:'د.إ',AFN:'؋',ALL:'L',AMD:'֏',ANG:'ƒ',AOA:'Kz',ARS:'$',AUD:'$',AWG:'ƒ',AZN:'₼',BAM:'KM',BBD:'$',BDT:'৳',BGN:'лв.',BHD:'.د.ب',BIF:'FBu',BMD:'$',BND:'$',BOB:'$b',BRL:'R$',BSD:'$',BTC:'₿',BTN:'Nu.',BWP:'P',BYR:'Br',BYN:'Br',BZD:'BZ$',CAD:'$',CDF:'FC',CHF:'Fr.',CLP:'$',CNY:'¥',COP:'$',CRC:'₡',CUC:'$',CUP:'₱',CVE:'$',CZK:'Kč',DJF:'Fdj',DKK:'kr',DOP:'RD$',DZD:'دج',EGP:'£',ERN:'Nfk',ETB:'Br',ETH:'Ξ',EUR:'€',FJD:'$',FKP:'£',GBP:'£',GEL:'₾',GGP:'£',GHS:'GH₵',GIP:'£',GMD:'D',GNF:'FG',GTQ:'Q',GYD:'$',HKD:'$',HNL:'L',HRK:'kn',HTG:'G',HUF:'Ft',IDR:'Rp',ILS:'₪',IMP:'£',INR:'₹',IQD:'ع.د',IRR:'﷼',ISK:'kr',JEP:'£',JMD:'J$',JOD:'JD',JPY:'¥',KES:'KSh',KGS:'лв',KHR:'៛',KMF:'CF',KPW:'₩',KRW:'₩',KWD:'KD',KYD:'$',KZT:'₸',LAK:'₭',LBP:'£',LKR:'₨',LRD:'$',LSL:'M',LTC:'Ł',LYD:'LD',MAD:'MAD',MDL:'lei',MGA:'Ar',MKD:'ден',MMK:'K',MNT:'₮',MOP:'MOP$',MRO:'UM',MRU:'UM',MUR:'₨',MVR:'Rf',MWK:'MK',MXN:'$',MYR:'RM',MZN:'MT',NAD:'$',NGN:'₦',NIO:'C$',NOK:'kr',NPR:'₨',NZD:'$',OMR:'﷼',PAB:'B/.',PEN:'S/',PGK:'K',PHP:'₱',PKR:'₨',PLN:'zł',PYG:'Gs',QAR:'﷼',RMB:'￥',RON:'L',RSD:'Дин.',RUB:'₽',RWF:'R₣',SAR:'﷼',SBD:'$',SCR:'₨',SDG:'ج.س.',SEK:'kr',SGD:'$',SHP:'£',SLL:'Le',SOS:'S',SRD:'$',SSP:'£',STD:'Db',STN:'Db',SVC:'$',SYP:'£',SZL:'E',THB:'฿',TJS:'SM',TMT:'T',TND:'د.ت',TOP:'T$',TRL:'₤',TRY:'₺',TTD:'TT$',TVD:'$',TWD:'NT$',TZS:'TSh',UAH:'₴',UGX:'USh',USD:'$',UYU:'$',UZS:'soʻm',VEF:'Bs',VND:'₫',VUV:'VT',WST:'WS$',XAF:'FCFA',XBT:'₿',XCD:'$',XOF:'CFA',XPF:'₣',YER:'﷼',ZAR:'R',ZMW:'ZK',ZMK:'ZK',ZWL:'Z$'}[code]);

  currency = getSymbol(window.Shopify.currency.active)

  return `${currency} ${_.formatPrice(price).replace(/\.00$/, '')}`;
};
/**
 * Currency Sumbols @type {Object}
 * Iso Countries @type {Object}
 * 
 */

SDG.CurrencySymbols = SDG.CurrencySymbols || {};
SDG.IsoCountries = SDG.IsoCountries || {};

/**
 * currency symbols
 * @type {Object}
 */
SDG.CurrencySymbols = {
  'USD': '$', // US Dollar
  'EUR': '€', // Euro
  'CRC': '₡', // Costa Rican Colón
  'GBP': '£', // British Pound Sterling
  'ILS': '₪', // Israeli New Sheqel
  'INR': '₹', // Indian Rupee
  'JPY': '¥', // Japanese Yen
  'KRW': '₩', // South Korean Won
  'NGN': '₦', // Nigerian Naira
  'PHP': '₱', // Philippine Peso
  'PLN': 'zł', // Polish Zloty
  'PYG': '₲', // Paraguayan Guarani
  'THB': '฿', // Thai Baht
  'UAH': '₴', // Ukrainian Hryvnia
  'VND': '₫', // Vietnamese Dong
};

/**
 * iso countries
 * @type {Object}
 */
SDG.IsoCountries = {
  'AF': 'Afghanistan',
  'AX': 'Aland Islands',
  'AL': 'Albania',
  'DZ': 'Algeria',
  'AS': 'American Samoa',
  'AD': 'Andorra',
  'AO': 'Angola',
  'AI': 'Anguilla',
  'AQ': 'Antarctica',
  'AG': 'Antigua And Barbuda',
  'AR': 'Argentina',
  'AM': 'Armenia',
  'AW': 'Aruba',
  'AU': 'Australia',
  'AT': 'Austria',
  'AZ': 'Azerbaijan',
  'BS': 'Bahamas',
  'BH': 'Bahrain',
  'BD': 'Bangladesh',
  'BB': 'Barbados',
  'BY': 'Belarus',
  'BE': 'Belgium',
  'BZ': 'Belize',
  'BJ': 'Benin',
  'BM': 'Bermuda',
  'BT': 'Bhutan',
  'BO': 'Bolivia',
  'BA': 'Bosnia And Herzegovina',
  'BW': 'Botswana',
  'BV': 'Bouvet Island',
  'BR': 'Brazil',
  'IO': 'British Indian Ocean Territory',
  'BN': 'Brunei Darussalam',
  'BG': 'Bulgaria',
  'BF': 'Burkina Faso',
  'BI': 'Burundi',
  'KH': 'Cambodia',
  'CM': 'Cameroon',
  'CA': 'Canada',
  'CV': 'Cape Verde',
  'KY': 'Cayman Islands',
  'CF': 'Central African Republic',
  'TD': 'Chad',
  'CL': 'Chile',
  'CN': 'China',
  'CX': 'Christmas Island',
  'CC': 'Cocos (Keeling) Islands',
  'CO': 'Colombia',
  'KM': 'Comoros',
  'CG': 'Congo',
  'CD': 'Congo, Democratic Republic',
  'CK': 'Cook Islands',
  'CR': 'Costa Rica',
  'CI': 'Cote D\'Ivoire',
  'HR': 'Croatia',
  'CU': 'Cuba',
  'CY': 'Cyprus',
  'CZ': 'Czech Republic',
  'DK': 'Denmark',
  'DJ': 'Djibouti',
  'DM': 'Dominica',
  'DO': 'Dominican Republic',
  'EC': 'Ecuador',
  'EG': 'Egypt',
  'SV': 'El Salvador',
  'GQ': 'Equatorial Guinea',
  'ER': 'Eritrea',
  'EE': 'Estonia',
  'ET': 'Ethiopia',
  'FK': 'Falkland Islands (Malvinas)',
  'FO': 'Faroe Islands',
  'FJ': 'Fiji',
  'FI': 'Finland',
  'FR': 'France',
  'GF': 'French Guiana',
  'PF': 'French Polynesia',
  'TF': 'French Southern Territories',
  'GA': 'Gabon',
  'GM': 'Gambia',
  'GE': 'Georgia',
  'DE': 'Germany',
  'GH': 'Ghana',
  'GI': 'Gibraltar',
  'GR': 'Greece',
  'GL': 'Greenland',
  'GD': 'Grenada',
  'GP': 'Guadeloupe',
  'GU': 'Guam',
  'GT': 'Guatemala',
  'GG': 'Guernsey',
  'GN': 'Guinea',
  'GW': 'Guinea-Bissau',
  'GY': 'Guyana',
  'HT': 'Haiti',
  'HM': 'Heard Island & Mcdonald Islands',
  'VA': 'Holy See (Vatican City State)',
  'HN': 'Honduras',
  'HK': 'Hong Kong',
  'HU': 'Hungary',
  'IS': 'Iceland',
  'IN': 'India',
  'ID': 'Indonesia',
  'IR': 'Iran, Islamic Republic Of',
  'IQ': 'Iraq',
  'IE': 'Ireland',
  'IM': 'Isle Of Man',
  'IL': 'Israel',
  'IT': 'Italy',
  'JM': 'Jamaica',
  'JP': 'Japan',
  'JE': 'Jersey',
  'JO': 'Jordan',
  'KZ': 'Kazakhstan',
  'KE': 'Kenya',
  'KI': 'Kiribati',
  'KR': 'Korea',
  'KW': 'Kuwait',
  'KG': 'Kyrgyzstan',
  'LA': 'Lao People\'s Democratic Republic',
  'LV': 'Latvia',
  'LB': 'Lebanon',
  'LS': 'Lesotho',
  'LR': 'Liberia',
  'LY': 'Libyan Arab Jamahiriya',
  'LI': 'Liechtenstein',
  'LT': 'Lithuania',
  'LU': 'Luxembourg',
  'MO': 'Macao',
  'MK': 'Macedonia',
  'MG': 'Madagascar',
  'MW': 'Malawi',
  'MY': 'Malaysia',
  'MV': 'Maldives',
  'ML': 'Mali',
  'MT': 'Malta',
  'MH': 'Marshall Islands',
  'MQ': 'Martinique',
  'MR': 'Mauritania',
  'MU': 'Mauritius',
  'YT': 'Mayotte',
  'MX': 'Mexico',
  'FM': 'Micronesia, Federated States Of',
  'MD': 'Moldova',
  'MC': 'Monaco',
  'MN': 'Mongolia',
  'ME': 'Montenegro',
  'MS': 'Montserrat',
  'MA': 'Morocco',
  'MZ': 'Mozambique',
  'MM': 'Myanmar',
  'NA': 'Namibia',
  'NR': 'Nauru',
  'NP': 'Nepal',
  'NL': 'Netherlands',
  'AN': 'Netherlands Antilles',
  'NC': 'New Caledonia',
  'NZ': 'New Zealand',
  'NI': 'Nicaragua',
  'NE': 'Niger',
  'NG': 'Nigeria',
  'NU': 'Niue',
  'NF': 'Norfolk Island',
  'MP': 'Northern Mariana Islands',
  'NO': 'Norway',
  'OM': 'Oman',
  'PK': 'Pakistan',
  'PW': 'Palau',
  'PS': 'Palestinian Territory, Occupied',
  'PA': 'Panama',
  'PG': 'Papua New Guinea',
  'PY': 'Paraguay',
  'PE': 'Peru',
  'PH': 'Philippines',
  'PN': 'Pitcairn',
  'PL': 'Poland',
  'PT': 'Portugal',
  'PR': 'Puerto Rico',
  'QA': 'Qatar',
  'RE': 'Reunion',
  'RO': 'Romania',
  'RU': 'Russian Federation',
  'RW': 'Rwanda',
  'BL': 'Saint Barthelemy',
  'SH': 'Saint Helena',
  'KN': 'Saint Kitts And Nevis',
  'LC': 'Saint Lucia',
  'MF': 'Saint Martin',
  'PM': 'Saint Pierre And Miquelon',
  'VC': 'Saint Vincent And Grenadines',
  'WS': 'Samoa',
  'SM': 'San Marino',
  'ST': 'Sao Tome And Principe',
  'SA': 'Saudi Arabia',
  'SN': 'Senegal',
  'RS': 'Serbia',
  'SC': 'Seychelles',
  'SL': 'Sierra Leone',
  'SG': 'Singapore',
  'SK': 'Slovakia',
  'SI': 'Slovenia',
  'SB': 'Solomon Islands',
  'SO': 'Somalia',
  'ZA': 'South Africa',
  'GS': 'South Georgia And Sandwich Isl.',
  'ES': 'Spain',
  'LK': 'Sri Lanka',
  'SD': 'Sudan',
  'SR': 'Suriname',
  'SJ': 'Svalbard And Jan Mayen',
  'SZ': 'Swaziland',
  'SE': 'Sweden',
  'CH': 'Switzerland',
  'SY': 'Syrian Arab Republic',
  'TW': 'Taiwan',
  'TJ': 'Tajikistan',
  'TZ': 'Tanzania',
  'TH': 'Thailand',
  'TL': 'Timor-Leste',
  'TG': 'Togo',
  'TK': 'Tokelau',
  'TO': 'Tonga',
  'TT': 'Trinidad And Tobago',
  'TN': 'Tunisia',
  'TR': 'Turkey',
  'TM': 'Turkmenistan',
  'TC': 'Turks And Caicos Islands',
  'TV': 'Tuvalu',
  'UG': 'Uganda',
  'UA': 'Ukraine',
  'AE': 'United Arab Emirates',
  'GB': 'United Kingdom',
  'US': 'United States',
  'UM': 'United States Outlying Islands',
  'UY': 'Uruguay',
  'UZ': 'Uzbekistan',
  'VU': 'Vanuatu',
  'VE': 'Venezuela',
  'VN': 'Viet Nam',
  'VG': 'Virgin Islands, British',
  'VI': 'Virgin Islands, U.S.',
  'WF': 'Wallis And Futuna',
  'EH': 'Western Sahara',
  'YE': 'Yemen',
  'ZM': 'Zambia',
  'ZW': 'Zimbabwe'
};
 /**
  * Viewport
  * @type {Object}
  * 
  */

 SDG.Viewport = SDG.Viewport || {};

 /**
  * viewport
  * @type {Function}
  * return init()
  * 
  */

 SDG.viewport = function() {

   const c = {
     mobileBreakpoint: 1024
   }

   /**
    * init
    */
   function init() {
     reportScrollPosition();
     reportWindowSize();
     addEvents();
   };

   /**
    * add events
    */
   function addEvents() {
     window.addEventListener('resize', reportWindowSize);
     window.addEventListener('scroll', reportScrollPosition);
   };

   /**
    * report window size
    */
   function reportWindowSize() {
     SDG.Viewport.windowHeight = window.innerHeight;
     SDG.Viewport.windowWidth = window.innerWidth;

     if (window.innerWidth > c.mobileBreakpoint) {
       SDG.Viewport.currentState = 'desktop';
     } else {
       SDG.Viewport.currentState = 'mobile';
     }
   };

   /**
    * report scroll position
    */
   function reportScrollPosition() {
     SDG.Viewport.scrollPosition = window.pageYOffset;
   };

   /**
    * return
    */
   return init();
 }

 SDG.viewport();
/**
 * Globals
 * @type {Function}
 * @return init()
 *
 */
SDG.globals = function () {
  const c = {
    cls: {
      bagIcon: 'icon--bag',
      bagOverlay: 'js-bag-overlay',
      borderedButton: 'js-cta-bordered',
      collectionWrap: 'js-collection',
      country: 'js-country',
      currency: 'js-currency',
      globalHide: 'js-global-hide',
      globalShow: 'js-global-show',
      headerWrap: 'js-header-wrap',
      heroSlidePictureClass: 'hero-slide__picture',
      isVisible: 'is-visible',
      lazylodedClass: 'image-lazyloaded',
      logo: 'js-logo',
      mainNav: 'main-nav',
      mobileNavTriggerChild: 'js-mobile-nav-trigger-child',
      notificationBannerDisabledClass: 'notification-banner-disabled',
      pictureWithGradient: 'picture-with-gradient',
      pictureWithOverlay: 'picture-with-overlay',
      scrolledClass: 'scrolled',
      scrolledMoreClass: 'scrolled-more',
      scrolledUpClass: 'scrolled-up',
      scrolledNotificationBannerDisabledClass: 'scrolled--notification-banner-disabled',
      searchIcon: 'icon--search',
      utilNav: 'util-nav',
    }
  }

  // cached globals
  const $body = document.body;
  const $header = document.querySelector(`.${c.cls.headerWrap}`);
  const $bagOverlay = document.querySelector(`.${c.cls.bagOverlay}`);
  const $bagPath = $header.querySelector(`.${c.cls.bagIcon} path`);
  const $borderedButtons = document.querySelectorAll(`.${c.cls.borderedButton}`);
  const $collectionWrap = document.querySelector(`.${c.cls.collectionWrap}`);
  const $country = document.querySelectorAll(`.${c.cls.country}`);
  const $currency = document.querySelectorAll(`.${c.cls.currency}`);
  const $globalHides = document.querySelectorAll(`.${c.cls.globalHide}`);
  const $globalShows = document.querySelectorAll(`.${c.cls.globalShow}`);
  const $logo = $header.querySelector(`.${c.cls.logo}`);
  const $mainNav = $header.querySelector(`.${c.cls.mainNav}`);
  const $mobileNavTriggerChilds = document.querySelectorAll(`.${c.cls.mobileNavTriggerChild}`);
  const $searchIconPath = $header.querySelector(`.${c.cls.searchIcon} path`);
  const $utilNav = $header.querySelector(`.${c.cls.utilNav}`);
  const currencySymbols = SDG.CurrencySymbols;
  const isoCountries = SDG.IsoCountries;

  window.SDG.updateNavigationColor = updateNavigationColor;

  // settings and checks
  const offSet = 20 //px
  const hideOffset = 100;

  /**
   * init
   */
  function init() {
    addEvents();
    globaleInterval();
    borderedButtonsHoverState();
    if ($collectionWrap?.dataset.navigationColor) {
      updateNavigationColor($collectionWrap.dataset.navigationColor);
    }

    window.resolveSDGLoaded();
  };

  /**
   * Add Events
   */
  function addEvents() {
    window.addEventListener('scroll', toggleScrolledClass);
    document.addEventListener('lazyloaded', addClassToParentOnLazyLoad);
  };

  /**
   * Global-E Inteval (check)
   */
  function globaleInterval() {
    const intervalLimit = 1200; // 600 x 100ms = 60s
    let invervalCount = 0;

    const interval = setInterval(() => checkForGlobale(), 100);

    function checkForGlobale() {
      invervalCount++;

      if (window.GlobalE) {
        if (window.GlobalE.Country) {
          clearInterval(interval);
          updateCountryAndCurrency();
          globaleShowHide();
        }
      } else if (invervalCount > intervalLimit) {
        clearInterval(interval);
      }
    };
  };

  /**
   * Add Class To Parent on Lazy Load
   */
  function addClassToParentOnLazyLoad(e) {
    if (e.target.parentNode.classList.contains(`${c.cls.pictureWithGradient}`)) {
      e.target.parentNode.parentNode.classList.add(`${c.cls.lazylodedClass}`);
    } else if (e.target.parentNode.classList.contains(`${c.cls.pictureWithOverlay}`)) {
      e.target.parentNode.parentNode.classList.add(`${c.cls.lazylodedClass}`);
    } else if (e.target.parentNode.classList.contains(`${c.cls.heroSlidePictureClass}`)) {
      e.target.parentNode.parentNode.classList.add(`${c.cls.lazylodedClass}`);
    }
  };

  /**
   * Update Navigation Color
   */
  function updateNavigationColor(color) {
    if (color !== undefined) {
      // update main navigation color
      $mainNav.style.color = color;

      // update util navigation color
      $utilNav.style.color = color;

      // update logo color
      $logo.style.color = color;

      // update search icon color
      $searchIconPath.setAttribute('fill', color);

      // update bag icon color
      $bagPath.setAttribute('fill', color);

      // update mobile navigation trigger color
      $mobileNavTriggerChilds.forEach(child => child.style.backgroundColor = color);
    }
  };

  /**
   * Bordered Buttons Hover State
   * (this need to be done by js, can't write inline hover effect)
   */
  function borderedButtonsHoverState() {
    if ($borderedButtons.length > 0) {
      $borderedButtons.forEach((button) => {

        const hoverBackgroundColor = button.dataset.ctaHoverBgColor;
        const hoverColor = button.dataset.ctaHoverColor;
        const color = button.dataset.ctaColor;

        button.addEventListener('mouseover', (e) => {
          const $target = e.target;
          $target.style.background = hoverBackgroundColor;
          $target.style.borderColor = hoverBackgroundColor;
          $target.style.color = hoverColor;
        });

        button.addEventListener('mouseout', (e) => {
          const $target = e.target;
          $target.style.background = 'transparent';
          $target.style.borderColor = color;
          $target.style.color = color;
        });
      });
    }
  }

  /**
   * Global E Hide/Show
   */
  function globaleShowHide() { // update for desktop and mobile

    if ($globalHides.length > 0) {
      $globalHides.forEach(($elem) => {
        if (window.GlobalE.Country === 'US') {
          $elem.style.display = 'none';
        } else {
          $elem.style.display = 'inline-block';
        }

      });
    }

    if ($globalShows.length > 0) {
      $globalShows.forEach(($elem) => {
        if (window.GlobalE.Country === 'US') {
          $elem.style.display = 'block';
        } else {
          $elem.style.display = 'none';
        }
      });
    }
  };

  /**
   * Update Country and Currency
   */
  function updateCountryAndCurrency() { // update for desktop and mobile
    $country.forEach((el) => el.innerHTML = getCountryName(window.GlobalE.Country));
    $currency.forEach((el) => el.innerHTML = getCurrencySymbol(window.GlobalE.Currency));
  };

  /**
   * Get Country Name
   */
  function getCountryName(countryCode) {
    if (isoCountries.hasOwnProperty(countryCode)) {
      return isoCountries[countryCode];
    } else {
      return countryCode;
    }
  };

  /**
   * Get Currency Symbol
   */
  function getCurrencySymbol(currency_name) {
    const currencySymbol = currencySymbols[currency_name]

    if (currencySymbols[currency_name]) {
      return currencySymbol;
    } else {
      return currency_name;
    }
  };

  /**
   * Toggle Scrolled Class
   */
  let startScrollUp = null;
  let lastScroll = 0;
  function toggleScrolledClass() {
    const fromTop = window.pageYOffset;

    if (SDG.NotificationBannerState === true) {
      if (fromTop >= offSet) {
        $body.classList.add(`${c.cls.scrolledClass}`);
      } else {
        $body.classList.remove(`${c.cls.scrolledClass}`);
      }
    } else {
      if (fromTop >= offSet) {
        $body.classList.add(`${c.cls.scrolledNotificationBannerDisabledClass}`);
      } else {
        $body.classList.remove(`${c.cls.scrolledNotificationBannerDisabledClass}`);
      }
    }

    $body.classList.toggle(c.cls.scrolledMoreClass, fromTop > hideOffset);

    if (lastScroll >= fromTop) {
      // scrolling up
      if (startScrollUp === null) {
        startScrollUp = fromTop;
      }
    } else {
      // scrolling down
      startScrollUp = null;
    }

    $body.classList.toggle(c.cls.scrolledUpClass, startScrollUp !== null && startScrollUp - fromTop > 50);
    lastScroll = fromTop;
  };

  /**
   * return
   */
  return init();
};

SDG.globals();


/**
 * Old Mansure Code // NOT WRITTEN BY SDG
 *
 */

document.originalTitle = document.title

String.prototype.parameterize = function () {
  console.trace('parameterize');
  return this.toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '')
}

document.documentElement.classList.remove('no-js');
document.documentElement.dataset.designMode = !!Shopify.designMode;

if (Shopify.theme.role === 'unpublished') {
  document.documentElement.dataset.previewMode = 'true';
}

document.querySelectorAll('form').forEach(form => form.setAttribute('autocomplete', 'off'));

const firstError = document.querySelector('input.error, textarea.error');

if (firstError) {
  firstError.focus();
  firstError.classList.remove('error');
}

const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

class ConditionalDetails extends HTMLElement {
  constructor() {
    super();
    this.summary = this.querySelector("summary");
    this.details = this.querySelector("details");
    this.content = this.querySelector("[data-content]");

    this.summary.addEventListener("click", (e) => {
      e.preventDefault();

      if (this._allowToggle) {
        this.details.open ? this.close() : this.open();
      }
    });

    const toggleOpen = () => {
      if (!this._allowToggle) {
        this.summary.tabIndex = -1;
        this._forceOpen();
      } else if (this.lastAllowToggle === false && this._allowToggle) {
        this.summary.tabIndex = null;
        this._forceClose();
      }

      this.lastAllowToggle = this._allowToggle;
    };

    toggleOpen();

    this.onResize = debounce(toggleOpen, 200);

    window.addEventListener("resize", this.onResize);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.onResize);
  }

  _forceOpen() {
    this.removeEventListener("transitionend", this.handleTransitionEnd);
    this.details.open = true;
    this.content.style.height = null;
    this.content.style.opacity = null;
  }

  _forceClose() {
    this.removeEventListener("transitionend", this.handleTransitionEnd);
    this.details.open = false;
    this.content.style.height = null;
    this.content.style.opacity = null;
  }

  open() {
    if (this.details.open) return;
    this.removeEventListener("transitionend", this.handleTransitionEnd);
    this.details.open = true;
    if (this.content) {
      this.content.style.height = 0;
      this.content.style.opacity = 0;

      window.requestAnimationFrame(() => {
        this.content.style.height = `${this.content.scrollHeight}px`;
        this.content.style.opacity = 1;
      });
    }
  }

  close() {
    if (!this.details.open) return;
    if (this.content) {
      this.removeEventListener("transitionend", this.handleTransitionEnd);

      this.handleTransitionEnd = () => {
        this.removeEventListener("transitionend", this.handleTransitionEnd);
        this.details.open = false;
      };

      this.addEventListener("transitionend", this.handleTransitionEnd);

      this.content.style.height = 0;
      this.content.style.opacity = 0;
    } else {
      this.details.open = false;
    }
  }

  get _allowToggle() {
    return window.matchMedia(this._mediaQuery).matches;
  }

  get _mediaQuery() {
    return this.getAttribute("allow-toggle-when") || "all";
  }
}

if (!customElements.get("conditional-details")) {
  customElements.define("conditional-details", ConditionalDetails);
}

SDG.trapFocus = function trapFocus(element) {
  /**
   * Init
   */
  function init() {
    trap();
  }

  /**
   * Trap
   */
  function trap() {
    const KEYCODE_TAB = 9; // Tab keycode
    const focusableEls = Array.prototype.slice.call(element.querySelectorAll('a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled])'));
    let { length } = Object.keys(focusableEls);

    // Removes all DOM-hidden elements from focusableEls
    if (focusableEls.length > 1) {
      while (focusableEls[length - 1].offsetParent === null) {
        try {
          delete focusableEls[length - 1];
          length -= 1;
        } catch (e) {
          length -= 1;
        }
      }
    }

    const firstFocusableEl = focusableEls[0];
    const lastFocusableEl = focusableEls[length - 1];

    firstFocusableEl.focus();

    function addEvent(e) {
      const isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);

      if (!isTabPressed) return;

      if (e.shiftKey && document.activeElement === firstFocusableEl) /* shift + tab */ {
        lastFocusableEl.focus();
        e.preventDefault();
      } else if (!e.shiftKey && document.activeElement === lastFocusableEl) /* tab */ {
        firstFocusableEl.focus();
        e.preventDefault();
      }
    }

    element.addEventListener('keydown', addEvent);
  }

  return init();
}

/**
 * converts a string to a handle
 */
_.handleize = function(str) {
  return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, '-').replace(/^-+|-+$/g, '');
}


/**
 * Radom String Generator
 * @type {function}
 */
SDG.randomString = function(length) {
  var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var result = '';
  for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
  return result;
}
/**
 * truncate HTML
 */
SDG.truncateHTML = function(text, length) {
  let truncated = text.substring(0, length);

  truncated = truncated.replace(/(\r\n|\n|\r)/gm,"").trim();

  truncated = truncated.replace(/<(\w*)(?:(?:\s\w+(?:={0,1}(["']{0,1})\w*\2{0,1})))*$/g, '');

  let truncatedEndTagExpr = /<\/((?:\w*))$/g;
  let truncatedEndTagMatch = truncatedEndTagExpr.exec(truncated);
  if (truncatedEndTagMatch != null) {
      let truncatedEndTag = truncatedEndTagMatch[1];
      if (truncatedEndTag.length > 0) {
          let startTagExpr = new RegExp(
              "<(" + truncatedEndTag + "\\w?)(?:(?:\\s\\w+(?:=([\"\'])\\w*\\2)))*>");
          let testString = truncated;
          let startTagMatch = startTagExpr.exec(testString);

          let startTag = null;
          while (startTagMatch != null) {
              startTag = startTagMatch[1];
              testString = testString.replace(startTagExpr, '');
              startTagMatch = startTagExpr.exec(testString);
          }
          if (startTag != null) {
              truncated = truncated.replace(truncatedEndTagExpr, '</' + startTag + '>');
          }
      } else {
          truncated = truncated.replace(truncatedEndTagExpr, '');
      }
  }

  let testString = SDG.reverseHtml(truncated);
  let reverseTagOpenExpr = /<(?:(["'])\w*\1=\w+ )*(\w*)>/;
  let tagMatch = reverseTagOpenExpr.exec(testString);
  while (tagMatch != null) {
      let tag = tagMatch[0];
      let tagName = tagMatch[2];
      let startPos = tagMatch.index;
      let endPos = startPos + tag.length;
      let fragment = testString.substring(0, endPos);

      if (!new RegExp("<" + tagName + "\/>").test(fragment)) {
          truncated += '</' + SDG.reverseHtml(tagName) + '>';
      }

      testString = testString.replace(fragment, '');
      tagMatch = reverseTagOpenExpr.exec(testString);
  }
  return truncated;
}

/**
 * reverse HTML
 */
SDG.reverseHtml = function(str) {
  let ph = String.fromCharCode(206);
  let result = str.split('').reverse().join('');
  while (result.indexOf('<') > -1) {
      result = result.replace('<',ph);
  }
  while (result.indexOf('>') > -1) {
      result = result.replace('>', '<');
  }
  while (result.indexOf(ph) > -1) {
      result = result.replace(ph, '>');
  }
  return result;
}
/**
 * Get Sized Image Url
 */
SDG.getSizedImageUrl = function(imgUrl, size) {
  let i;
  let n;
  let r;

  if (! imgUrl) return '//cdn.searchspring.net/ajax_search/img/missing-image-75x75.gif';
  if (! size) return imgUrl;
  if (size === 'master') return _.removeProtocol(imgUrl);

  n = imgUrl.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

  if (n !== null) {
    r = imgUrl.split(n[0]);
    i = n[0];
    return (r[0] + '_' + size + i).replace(/http(s)?:/, '');
  }
};
/**
 * format money
 * edited version of the following script:
 * @see    https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c
 * @param  {Number|String} cents    e.g. "1200"
 * @param  {String}        format   e.g. "amount_with_currency"
 * @param  {String}        currency e.g. "$"
 * @return {String}
 */
SDG.formatMoney = function(cents, format, currency = '$') {

  const getSymbol = (code) => ({AED:'د.إ',AFN:'؋',ALL:'L',AMD:'֏',ANG:'ƒ',AOA:'Kz',ARS:'$',AUD:'$',AWG:'ƒ',AZN:'₼',BAM:'KM',BBD:'$',BDT:'৳',BGN:'лв.',BHD:'.د.ب',BIF:'FBu',BMD:'$',BND:'$',BOB:'$b',BRL:'R$',BSD:'$',BTC:'₿',BTN:'Nu.',BWP:'P',BYR:'Br',BYN:'Br',BZD:'BZ$',CAD:'$',CDF:'FC',CHF:'Fr.',CLP:'$',CNY:'¥',COP:'$',CRC:'₡',CUC:'$',CUP:'₱',CVE:'$',CZK:'Kč',DJF:'Fdj',DKK:'kr',DOP:'RD$',DZD:'دج',EGP:'£',ERN:'Nfk',ETB:'Br',ETH:'Ξ',EUR:'€',FJD:'$',FKP:'£',GBP:'£',GEL:'₾',GGP:'£',GHS:'GH₵',GIP:'£',GMD:'D',GNF:'FG',GTQ:'Q',GYD:'$',HKD:'$',HNL:'L',HRK:'kn',HTG:'G',HUF:'Ft',IDR:'Rp',ILS:'₪',IMP:'£',INR:'₹',IQD:'ع.د',IRR:'﷼',ISK:'kr',JEP:'£',JMD:'J$',JOD:'JD',JPY:'¥',KES:'KSh',KGS:'лв',KHR:'៛',KMF:'CF',KPW:'₩',KRW:'₩',KWD:'KD',KYD:'$',KZT:'₸',LAK:'₭',LBP:'£',LKR:'₨',LRD:'$',LSL:'M',LTC:'Ł',LYD:'LD',MAD:'MAD',MDL:'lei',MGA:'Ar',MKD:'ден',MMK:'K',MNT:'₮',MOP:'MOP$',MRO:'UM',MRU:'UM',MUR:'₨',MVR:'Rf',MWK:'MK',MXN:'$',MYR:'RM',MZN:'MT',NAD:'$',NGN:'₦',NIO:'C$',NOK:'kr',NPR:'₨',NZD:'$',OMR:'﷼',PAB:'B/.',PEN:'S/',PGK:'K',PHP:'₱',PKR:'₨',PLN:'zł',PYG:'Gs',QAR:'﷼',RMB:'￥',RON:'L',RSD:'Дин.',RUB:'₽',RWF:'R₣',SAR:'﷼',SBD:'$',SCR:'₨',SDG:'ج.س.',SEK:'kr',SGD:'$',SHP:'£',SLL:'Le',SOS:'S',SRD:'$',SSP:'£',STD:'Db',STN:'Db',SVC:'$',SYP:'£',SZL:'E',THB:'฿',TJS:'SM',TMT:'T',TND:'د.ت',TOP:'T$',TRL:'₤',TRY:'₺',TTD:'TT$',TVD:'$',TWD:'NT$',TZS:'TSh',UAH:'₴',UGX:'USh',USD:'$',UYU:'$',UZS:'soʻm',VEF:'Bs',VND:'₫',VUV:'VT',WST:'WS$',XAF:'FCFA',XBT:'₿',XCD:'$',XOF:'CFA',XPF:'₣',YER:'﷼',ZAR:'R',ZMW:'ZK',ZMK:'ZK',ZWL:'Z$'}[code]);

  currency = getSymbol(window.Shopify.currency.active)

  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (format) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_with_currency':
      value = currency + formatWithDelimiters(cents, 2);
      break;
    case 'amount_with_currency_without_trailing_zeros':
      value = currency + formatWithDelimiters(cents, 2);
      if (value.indexOf('.00') !== -1) {
        value = value.replace('.00', '');
      }
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return value;
}

/**
 * Back In Stock
 * @type {Function}
 * @return init()
 *
 */

SDG.backInStock = function() {

  const c = {
    cls: {
      backInStockButton: 'js-back-in-stock-button',
      backInStockEmail: 'js-back-in-stock-email',
      backInStockForm: 'js-back-in-stock-form',
      backInStockMarketing: 'js-back-in-stock-marketing',
      backInStockMessage: 'js-back-in-stock-message',
      error_class: 'error',
      valid_class: 'valid',
      added_class: 'added',
      visible_class: 'is-visible',
    },
    wrong_email_message: 'Enter valid email address',
    add_to_waitlist_text: 'Add to waitlist'
  };

  // cached globals
  const $backInStockButton = document.querySelector(`.${c.cls.backInStockButton}`);
  const $backInStockEmail = document.querySelector(`.${c.cls.backInStockEmail}`);
  const $backInStockForm = document.querySelector(`.${c.cls.backInStockForm}`);
  const $backInStockMarketing = document.querySelector(`.${c.cls.backInStockMarketing}`);
  const $backInStockMessage = document.querySelector(`.${c.cls.backInStockMessage}`);

  /**
   * init
   */
  function init() {
    if ($backInStockForm) {
      addEvents();
    }
  };

  /**
   * Add Events
   */
  function addEvents() {
    $backInStockButton.addEventListener('click', submitForm);
  };

  /**
   * Submit Form
   */
  function submitForm() {
    const email = $backInStockEmail.value;
    const marketing = $backInStockMarketing.checked;
    const { productId, variantId } = $backInStockForm.dataset;
    const buttonText = $backInStockButton.dataset.buttonText;

    if (emailIsValid(email) === true) {
      $backInStockMessage.innerHTML = '';
      $backInStockMessage.classList.remove(c.cls.visible_class, c.cls.error_class);
      $backInStockEmail.classList.remove(c.cls.error_class);

      BIS
      .create(email, variantId, productId, { accepts_marketing: marketing })
      .then(function (resp) {
        if (resp.status === 'OK') {
          $backInStockMessage.innerHTML = '';
          $backInStockButton.innerHTML = resp.message;
          $backInStockButton.classList.add(c.cls.added_class);

          setTimeout(() => {
            $backInStockButton.innerHTML = c.add_to_waitlist_text;
            $backInStockButton.classList.remove(c.cls.added_class);
          }, 5000);

          $backInStockMessage.classList.remove(c.cls.visible_class);
          $backInStockEmail.classList.remove(c.cls.error_class);
          $backInStockEmail.value = '';

        } else {
          $backInStockMessage.innerHTML = '';
          if (resp.errors.email) {
            $backInStockButton.innerHTML = resp.errors.email.join(' ');
            $backInStockButton.classList.add(c.cls.added_class);
          }

          if (resp.errors.base) {
            if (resp.errors.base[0] === 'Added to waitlist') {
              $backInStockButton.innerHTML = 'You are already in the waitlist'
              $backInStockButton.classList.add(c.cls.added_class);
            }
          }

          setTimeout(() => {
            $backInStockButton.innerHTML = buttonText;
            $backInStockButton.classList.remove(c.cls.added_class);
          }, 5000);

          $backInStockMessage.classList.remove(c.cls.visible_class);
          $backInStockEmail.classList.remove(c.cls.error_class);
          $backInStockEmail.value = '';
        }
      })

    } else {
      $backInStockMessage.innerHTML = c.wrong_email_message;
      $backInStockMessage.classList.add(c.cls.visible_class, c.cls.error_class);
      $backInStockEmail.classList.add(c.cls.error_class);
    }
  }

  /**
   * Email Validation
   */
  function emailIsValid(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  /**
   * return
   */
  return init();
};

SDG.backInStock();

/**
 * Gift with purchase
 * if cart total is more than $X amount, add free item
 * @type {Object}
 */

SDG.GiftWithPurchase = SDG.GiftWithPurchase || {};
SDG.GiftWithPurchase.config = SDG.GiftWithPurchase.config || {};

SDG.GiftWithPurchase.config = {
  cls: {
    active: 'is-active',
    cart_count: '.minicart__item-count'
  },
  header: '#header-menues',
  form: '#productForm',
  minicart: '#miniCart',
  minicart_list: '#miniCartList',
  close_btn: '#btnCloseCart',
  minicart_btn: '#btnMiniCart',
  productWithSkuInCart: false,
  inCart: false,
  comesFromMiniCart: false
}

/**
 * init
 */
SDG.GiftWithPurchase.init = function (comesFromMiniCart, requestId) {

  function init() {
    if (comesFromMiniCart === true) {
      SDG.GiftWithPurchase.config.comesFromMiniCart = true;
    }

    SDG.GiftWithPurchase.checkItemInCart(requestId);
  };

  /**
   * return
   * @type {Object}
   */
  return init();
};

/**
 * check item in cart
 */
SDG.GiftWithPurchase.checkItemInCart = function (requestId) {
  const c = SDG.GiftWithPurchase.config;
  const GWP = window.SDG.GiftWithPurchase;

  fetch(`${window.SDG.routes.cart_url}?view=gwp`)
    .then(response => response.json())
    .then(items => {
      if (requestId !== SDG.Bag.requestId) return;

      const gift_card_threshold = Currency.convert(GWP.threshold * 100, 'USD', Shopify.currency.active);
      const cart_total = items.reduce((total, item) => item.eligible ? total + item.price : total, 0);
      c.inCart = false;
      items.forEach(function (item) {

        // check if free gift is in cart
        if (item.handle === GWP.free_product.data.handle) {
          if (item.is_gwp) {
            c.inCart = true;
          }
        }
      });

      if (c.inCart === false) {
        // gwp product not in cart
        if (cart_total >= gift_card_threshold) {
          if (window.sessionStorage.getItem('gwpAdded') === null) {
            // cart over the threshold, add gwp item
            SDG.GiftWithPurchase.addItemToCart();
            window.sessionStorage.setItem('gwpAdded', 'true');
          } else {
            // console.log('not adding because already added');
          }
        } else {
          // console.log('not adding because below threshold');
          window.sessionStorage.removeItem('gwpAdded')
        }
      } else if (c.inCart === true) {
        // console.log('already in cart');
        if (cart_total < gift_card_threshold) {

          // gwp item in cart and cart below the limit
          SDG.GiftWithPurchase.removeItemFromCart();
        } else if (cart_total === 0 && items.length > 0) {

          // if there is only free item in the cart remove it;
          SDG.GiftWithPurchase.removeItemFromCart();
        }
      }
    });
};

/**
 * add to cart
 */
SDG.GiftWithPurchase.addItemToCart = function () {
  const GWP = window.SDG.GiftWithPurchase;

  const properties = {
    '_gift_with_purchase': 'true'
  };

  // if (GWP.free_product.is_gift_card && GWP.free_product.gift_card_delay_days) {
  //   send_on = new Date(Date.now() + GWP.free_product.gift_card_delay_days * 86400000);
  //   properties["Send on"] = `${send_on.getFullYear()}-${send_on.getMonth() + 1}-${send_on.getDate()}`;
  // }

  const data = {
    quantity: 1,
    id: GWP.free_product.selected_or_first_available_variant,
    properties: properties
  };

  // init ajax
  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ items: [data] }),
  })
    .then(() => {
      if (SDG.GiftWithPurchase.config.comesFromMiniCart !== true) {
        document.addEventListener('DOMContentLoaded', () => {
          location.reload();
        });
      };

      SDG.Bag.getCartData();
    });
}

/**
 * remove from cart
 */
SDG.GiftWithPurchase.removeItemFromCart = function () {
  const GWP = window.SDG.GiftWithPurchase;
  const data = {};
  const variantID = GWP.free_product.selected_or_first_available_variant;
  window.sessionStorage.removeItem('gwpAdded')

  data[variantID] = 0;
  // init ajax
  fetch(`${window.Shopify.routes.root}cart/update.js`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates: data }),
  })
    .then(() => {
      if (SDG.GiftWithPurchase.config.comesFromMiniCart !== true) {
        document.addEventListener('DOMContentLoaded', () => {
          location.reload();
        });
      };

      SDG.Bag.getCartData();
    });
};

/**
 * Bag Config
 */
SDG.Bag = SDG.Bag || {};
SDG.Data.monogramming = SDG.Data.monogramming || {};

SDG.Bag.config = {
  cls: {
    bag_count: 'js-bag-count',
    bag_count_wrap: 'js-bag-count-wrap',
    cart_form: 'js-cart-form',
    cart_product_monogram: 'js-cart-product-monogram',
    cart_product_monogrammed: 'js-cart-product-monogrammed',
    cart_product: 'js-cart-product',
    cart_template: 'template-cart',
    in_progress: 'in-progress',
    is_updating: 'is-updating',
    is_visible: 'is-visible',
    hidden: 'hidden',
    is_visible_on_mobile: 'is-visible-on-mobile',
    mini_bag: 'js-mini-bag',
    mini_bag_close: 'js-mini-bag-close',
    mini_bag_count: 'js-mini-bag-count',
    mini_bag_empty: 'js-mini-bag-empty',
    mini_bag_form: 'js-mini-bag-form',
    mini_bag_is_open: 'mini-bag-is-open',
    mini_bag_loading_icon: 'js-mini-bag-loading',
    mini_bag_monogramming_text: 'js-mini-bag-monogramming-text',
    mini_bag_overlay: 'js-bag-overlay',
    mini_bag_product: 'js-mini-bag-product',
    mini_bag_products: 'js-mini-bag-products',
    mini_bag_qty_minus: 'js-mini-bag-qty-minus',
    mini_bag_qty_plus: 'js-mini-bag-qty-plus',
    mini_bag_qty_value: 'js-mini-bag-product-qty-value',
    mini_bag_qucik_add: 'js-mini-bag-quick-add',
    mini_bag_remove: 'js-mini-bag-remove',
    mini_bag_subtotal: 'js-mini-bag-subtotal',
    mini_bag_tags: 'js-mini-product-tags',
    mini_bag_trigger: 'js-bag-trigger',
    mini_bag_collection_empty_bag: 'js-collection-empty-bag',
    mini_bag_collection_not_empty_bag: 'js-collection-not-empty-bag',
    mini_bag_international_shipping: 'js-cart-shipping-international',
    quantity_disabled_class: 'quantity-disabled',
    quantity_minus: 'js-qty-minus',
    quantity_plus: 'js-qty-plus',
    quantity: 'js-quantity',
  },
  quick_add_added: 'Added',
  quick_add_adding: 'Adding',
  quick_add_initial: 'Add to bag',
};

SDG.Data.monogramming.monogram_in_cart = false;


/**
 * Mini Bag Additional Checkout Buttons
 */
SDG.Bag.additionalCheckout = function() {
  const $checkoutBtns = document.querySelector('.additional-checkout-buttons');

  const observer = new MutationObserver(((mutations) => {
    mutations.forEach((mt) => {
      if (mt.addedNodes[0]) {
        const $elements = mt.addedNodes[0].querySelectorAll('.shopify-cleanslate');

        if ($elements) {
          // Find ApplePay then hide the element
          $elements.forEach(($el) => {
            if ($el && $el.querySelector('[data-testid="ApplePay-button"]')) {
              $el.querySelector('[data-testid="ApplePay-button"]').parentNode.classList.add('hidden');
            }
          });

          observer.disconnect();
        }
      }
    });
  }));
  observer.observe($checkoutBtns, { attributes: true, childList: true, subtree: true });
}

/**
 * Get product data
 */

SDG.Bag.getProductData = function (array, requestId) {
  const config = {
    dom: {
      mini_bag_product: 'js-mini-bag-product',
      mini_bag_product_low_inventory: 'js-mini-bag-low-inventory',
      mini_bag_compare_at_price: 'js-bag-compare-at-price'
    },
    cls: {
      hidden: 'is-hidden',
      with_price: 'with-price',
    }
  };

  const $miniBagProducts = document.querySelectorAll(`.${config.dom.mini_bag_product}`);
  const items = array;
  let index = 0;
  let isLast = false;

  if (items.length === 0) return;

  ajax(items[index].handle);

  /**
   * ajax
   * @param {String}
   */
  function ajax(handle) {
    const url = `/products/${handle}.json`;

    fetch(url, {
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(res => res.json())
      .then((result) => {
        index += 1;
        if (items.length === index) isLast = true;
        if (!isLast) ajax(items[index].handle);
        storeResponse(result);
      })
      .catch(error => console.warn('ERROR', error));
  }

  /**
   * Store response
   * @param {Object}
   */
  function storeResponse(data) {

    const product = data.product;
    SDG.Bag.data.items.forEach(item => {
      if (item.handle === product.handle) {
        item.product_data = product;
      }
    });

    // Render additional data
    if (isLast) renderAdditionalData();
  }

  /**
   * Render additional data
   */
  function renderAdditionalData() {
    if (requestId !== SDG.Bag.requestId) return;

    $miniBagProducts.forEach(($product) => {
      const variant_id = Number($product.dataset.variantId);
      const $lowInventory = $product.querySelector(`.${config.dom.mini_bag_product_low_inventory}`);
      const $compareAtPrice = $product.querySelector(`.${config.dom.mini_bag_compare_at_price}`);

      SDG.Bag.data.items.forEach(item => {
        let variantInventory;
        let lowInventoryText;
        let compareAtPrice;
        let price;

        item.product_data.variants.forEach((variant) => {
          if (variant.id === variant_id) {
            const priceIsLower = Number(variant.price) < Number(variant.compare_at_price);

            compareAtPrice = variant.compare_at_price.replaceAll('.', '');
            variantInventory = variant.inventory_quantity;

            // show compare at price
            if (priceIsLower) {
              $compareAtPrice.innerHTML = '<span class="screenreader">Original Price: </span>' + _.formatPriceDisplay(compareAtPrice);
              $compareAtPrice.classList.add(config.cls.with_price);
            }
          }
        });

        if (variantInventory < 4 && variantInventory > 0) {
          lowInventoryText = `Only ${variantInventory} left`;
          $lowInventory.innerHTML = lowInventoryText;
          $lowInventory.classList.remove(config.cls.hidden);
        }

      });
    });
  }
};

/**
 * Get cart data
 */
SDG.Bag.requestId = 0;

SDG.Bag.getCartData = function () {
  const c = SDG.Bag.config;
  const $miniBagProducts = document.querySelector(`.${c.cls.mini_bag_products}`);
  const $miniBagLoadingIcon = document.querySelector(`.${c.cls.mini_bag_loading_icon}`);

  // fade out cart
  $miniBagProducts.classList.add(c.cls.is_updating);
  $miniBagLoadingIcon.classList.add(c.cls.is_visible);

  // pull cart data and store in SDG.Bag.data
  SDG.Bag.requestId++;
  const requestId = SDG.Bag.requestId;

  fetch(`${window.Shopify.routes.root}cart.js`, {
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(res => res.json())
    .then((result) => {
      if (requestId !== SDG.Bag.requestId) return;

      document.dispatchEvent(new CustomEvent('cart-updated'));
      SDG.Bag.data = result;
      const bagIsEmpty = SDG.Bag.data.items.length === 0;

      SDG.Bag.checkForMonogram();

      // render bag
      SDG.Bag.renderBag(requestId);

      if (window.SDG.GiftWithPurchase.enabled) {
        SDG.GiftWithPurchase.init(true, requestId);
      }
    })
    .catch(error => {
      console.warn('ERROR, will refresh.', error);
      window.location.reload();
    });
}

/**
 * Add to cart
 * @param {Number} variantId
 */

SDG.Bag.addToCart = function (variantId) {

  const c = SDG.Bag.config;

  if (datafp) {
    properties = {
      '_datafp': `${datafp}`
    };
  }

  const data = {
    items: [
      {
        quantity: 1,
        id: variantId,
        properties
      }
    ]
  }


  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then(() => {
      SDG.Bag.getCartData();
    });
}

/**
 * Quick Add
 * @param {Number} variantId
 * @param {Object} $target - dom element
 */
SDG.Bag.quickAdd = function (variantId, $target) {

  const c = SDG.Bag.config;
  const isFinalSale = $target.dataset.finalSale;
  const datafp = $target.dataset.fp;
  const datacafp = $target.dataset.cafp;

  let properties = {};

  if (isFinalSale) {
    properties['_finalSale'] = 'true';
  }

  if (datafp) {
    properties['_datafp'] = `${datafp}`;
    properties['_datacafp'] = `${datacafp}`;
  }


  const data = {
    items: [
      {
        quantity: 1,
        id: variantId,
        properties,
      }
    ]
  }

  $target.innerHTML = c.quick_add_adding;
  $target.classList.add(c.cls.in_progress);

  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  })
    .then(() => {
      SDG.Bag.getCartData();

      $target.innerHTML = c.quick_add_added;
      SDG.Bag.open();
      setTimeout(() => {
        $target.innerHTML = c.quick_add_initial;
        $target.classList.remove(c.cls.in_progress);
      }, 2000); // reset button text to initial text
    });
};

/**
 * Remove Monogram from bag
 * @type {String} randomKey
 */

SDG.Bag.removeMonogram = function (randomKey) {
  let itemToRemove;
  let itemToUpdate;
  let updateData = {
    id: '',
    properties: {}
  };


  // find monogram product with matching randomKey
  SDG.Bag.data.items.forEach((item) => {
    const isMonogram = item.product_id === SDG.Data.monogramming.product_id;
    if (isMonogram) {
      for (const property in item.properties) {
        if (property === '_randomMatchingKey' && item.properties[property] === randomKey) {
          itemToRemove = item;
        }
      }
    } else {
      for (const property in item.properties) {
        if (property === '_randomMatchingKey' && item.properties[property] === randomKey) {
          itemToUpdate = item;
          updateData.id = itemToUpdate.key;
          // We can't set a totally blank properties object so just set something that does nothing.
          updateData.properties.__null = 'null';
        }
      }
    }
  });

  fetch(`${window.Shopify.routes.root}cart/change.js`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ quantity: 0, id: itemToRemove.key }),
  })
    .then(() => {
      if (itemToUpdate) {
        return fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updateData),
        });
      }
    })
    .then(() => {
      SDG.Bag.getCartData();
    });
};

/**
 * Update Monogram qty
 * @type {String} randomKey
 * @type {String} action
 */

SDG.Bag.updateMonogram = function (randomKey, action) {
  let itemToUpdate;
  let newQuanity;

  // find monogram product with matching randomKey
  SDG.Bag.data.items.forEach((item) => {
    const isMonogram = item.product_id === SDG.Data.monogramming.product_id;
    if (isMonogram) {
      for (const property in item.properties) {
        if (property === '_randomMatchingKey' && item.properties[property] === randomKey) {
          itemToUpdate = item;
        }
      }
    }
  });

  if (action === 'add') {
    newQuanity = itemToUpdate.quantity + parseFloat(itemToUpdate.properties._quantity);
  } else if (action === 'remove') {
    newQuanity = itemToUpdate.quantity - parseFloat(itemToUpdate.properties._quantity);
  }

  fetch(`${window.Shopify.routes.root}cart/change.js`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ quantity: newQuanity, id: itemToUpdate.key }),
  })
    .then(() => {
      SDG.Bag.getCartData();
    });
};

/**
 * Remove from bag
 */

SDG.Bag.removeFromBag = function (e) {

  const c = SDG.Bag.config;
  const $target = e.target;
  const $wrap = $target.closest(`.${c.cls.mini_bag_product}`);
  const { key, randomKey } = $wrap.dataset;

  if (randomKey) {
    if ($wrap.classList.contains('mini-bag-product--monogram')) {
      // Removing a monogram product (so also update the associated product to remove monogram properties)
      SDG.Bag.removeMonogram(randomKey);
    } else {
      // Removing a monogrammed product and the associated monogram product(s)
      const familyItems = document.querySelectorAll(`[data-random-key="${randomKey}"]`);

      const updates = {};
      familyItems.forEach(item => { updates[item.dataset.key] = 0; });

      if (familyItems.length) {
        fetch(`${window.Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates }),
        })
          .then(() => {
            document.dispatchEvent(new CustomEvent('cart-item-removed', { detail: { key } }));
            SDG.Bag.getCartData();
          });
      }
    }
  } else {
    // Removing a normal product
    fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ quantity: 0, id: key }),
    })
      .then(() => {
        document.dispatchEvent(new CustomEvent('cart-item-removed', { detail: { key } }));
        SDG.Bag.getCartData();
      });
  }
};

/**
 * Update item
 */

SDG.Bag.updateItem = function (e) {
  const c = SDG.Bag.config;
  const $target = e.target;
  const $wrap = $target.closest(`.${c.cls.mini_bag_product}`);
  const qty = Number($wrap.querySelector(`.${c.cls.mini_bag_qty_value}`).innerHTML);
  let classList = $target.classList;
  let isIncrease = false;
  if (classList.contains(c.cls.mini_bag_qty_plus) || classList.contains(c.cls.quantity_plus)) {
    isIncrease = true;
  }
  // const isIncrease = $target.classList.contains(c.cls.mini_bag_qty_plus);
  const { key, randomKey } = $wrap.dataset;

  let newQty;

  if (isIncrease) {
    newQty = qty + 1;
  } else if (qty === 0) {
    newQty = 0;
  } else {
    newQty = qty - 1;
  }

  fetch(`${window.Shopify.routes.root}cart/change.js`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ quantity: newQty, id: key }),
  })
    .then(() => {
      if (!isIncrease) {
        document.dispatchEvent(new CustomEvent('cart-item-removed', { detail: { key, quantity: 1 } }));
      } else {
        document.dispatchEvent(new CustomEvent('cart-item-qty-increased', { detail: { key, quantity: 1 } }));
      }

      // if removed item has radom key - is monogrammed - update monogram product
      if (randomKey) {
        if (qty < newQty) {
          SDG.Bag.updateMonogram(randomKey, action = 'add');
        } else {
          SDG.Bag.updateMonogram(randomKey, action = 'remove');
        }

      } else {
        SDG.Bag.getCartData();
      }
    });
};

/**
 * Bag clear
 * @param {Boolean} refresh
 */

SDG.Bag.clear = function (refresh) {
  fetch(`${window.Shopify.routes.root}cart/clear.js`)
    .then(() => {
      if (refresh) location = location;
      else SDG.Bag.getCartData();
    });
};

/**
 * Check for monogram
 */
SDG.Bag.checkForMonogram = function() {
  const c = SDG.Bag.config;
  const itemsInCartCount = SDG.Bag.data.items.length;
  const bagItems = SDG.Bag.data.items;
  let monogramProductsInCart = 0;

  SDG.Data.monogramming.monogram_in_cart = false;

  bagItems.forEach(item => {
    const isMonogramProduct = item.product_id === SDG.Data.monogramming.product_id;
    if (isMonogramProduct) {
      SDG.Data.monogramming.monogram_in_cart = true;
      monogramProductsInCart++;
    }
  });

  if (SDG.Data.monogramming.monogram_in_cart) {

    // check if products in cart are monogram products only
    // if yes clear the cart and refresh the page
    if (itemsInCartCount === monogramProductsInCart) {
      SDG.Bag.clear(refresh = true);
    }
  }
};

/**
 * Render Bag
 */
SDG.Bag.renderBag = function (requestId) {
  const c = SDG.Bag.config;
  const products = SDG.Bag.data.items;
  let html = '';

  // cached globals
  const $bagCount = document.querySelector(`.${c.cls.bag_count}`);
  const $bagCountWrap = document.querySelector(`.${c.cls.bag_count_wrap}`);
  const $miniBagCount = document.querySelector(`.${c.cls.mini_bag_count}`);
  const $miniBagProducts = document.querySelector(`.${c.cls.mini_bag_products}`);
  const $miniBagSubTotal = document.querySelector(`.${c.cls.mini_bag_subtotal}`);
  const $miniBagLoadingIcon = document.querySelector(`.${c.cls.mini_bag_loading_icon}`);
  const $miniBagEmpty = document.querySelector(`.${c.cls.mini_bag_empty}`);
  const $miniBagForm = document.querySelector(`.${c.cls.mini_bag_form}`);
  const $miniBagMonogrammingText = document.querySelector(`.${c.cls.mini_bag_monogramming_text}`);
  const $emptyBagCollections = document.querySelectorAll(`.${c.cls.mini_bag_collection_empty_bag}`);
  const $notEmptyBagCollections = document.querySelectorAll(`.${c.cls.mini_bag_collection_not_empty_bag}`);
  const $internationalShippingMessage = document.querySelector(`.${c.cls.mini_bag_international_shipping}`);
  const bagHasProducts = products.length > 0;
  const monogramIsInCart = SDG.Data.monogramming.monogram_in_cart;

  // update mini-bag count
  if (bagHasProducts) $miniBagCount.innerHTML = `(${SDG.Bag.data.item_count})`;
  else $miniBagCount.innerHTML = '';

  // update header bag count
  if (bagHasProducts) {
    $bagCount.innerHTML = SDG.Bag.data.item_count;
    $bagCountWrap.classList.add(c.cls.is_visible_on_mobile);
  } else {
    $bagCount.innerHTML = SDG.Bag.data.item_count;
    $bagCountWrap.classList.remove(c.cls.is_visible_on_mobile);
  }

  // update subtotal
  const $theCurrency = SDG.Bag.data.currency == "USD" ? "" : SDG.Bag.data.currency;
  $miniBagSubTotal.innerHTML = SDG.formatMoney(SDG.Bag.data.items_subtotal_price, 'amount_with_currency_without_trailing_zeros') + ' ' + $theCurrency;

  // show hide/empty state
  if (bagHasProducts) {
    $miniBagEmpty.classList.remove(c.cls.is_visible);
    $miniBagForm.classList.add(c.cls.is_visible);
    $emptyBagCollections.forEach(($el) => $el.classList.remove(c.cls.is_visible));
    $notEmptyBagCollections.forEach(($el) => $el.classList.add(c.cls.is_visible));
  } else {
    $miniBagEmpty.classList.add(c.cls.is_visible);
    $miniBagForm.classList.remove(c.cls.is_visible);
    $emptyBagCollections.forEach(($el) => $el.classList.add(c.cls.is_visible));
    $notEmptyBagCollections.forEach(($el) => $el.classList.remove(c.cls.is_visible));
  };

  // get html for each product
  products.forEach(product => {
    const itemHtml = getItemHtml(product);
    html += itemHtml;
  });

  // render product list
  $miniBagProducts.innerHTML = html;

  // get product data
  SDG.Bag.getProductData(products, requestId);

  // show/hide international shipping message
  if (bagHasProducts && $internationalShippingMessage) {
    const intlShippingProducts = SDG.Data.shippingInternationalProducts;
    // check if products in cart are included in SDG.Data.shippingInternationalProducts
    const isIntlShippingProducts = products.some((product) => intlShippingProducts.includes(product.handle));
    // check if international shipping message is visible
    const intlShippingIsHidden = [...$internationalShippingMessage.classList].includes(c.cls.hidden);
    if (isIntlShippingProducts) {
      if (intlShippingIsHidden) $internationalShippingMessage.classList.remove(c.cls.hidden);
    } else {
      if (!intlShippingIsHidden) $internationalShippingMessage.classList.add(c.cls.hidden);
    }
  }

  // add events
  addEvents();

  // remove fade out & loading icon
  setTimeout(() => {
    if (requestId !== SDG.Bag.requestId) return;

    $miniBagProducts.classList.remove(c.cls.is_updating);
    $miniBagLoadingIcon.classList.remove(c.cls.is_visible);
  }, 300);// wait until content is loaded

  const klarnaMessage = document.querySelector('.mini-bag #mini-bag-klarna');
  if (klarnaMessage) {
    klarnaMessage.dataset.purchaseAmount = SDG.Bag.data.items_subtotal_price;
    window.Klarna?.OnsiteMessaging?.refresh();
  }

  // show/hide monogramming text

  if (monogramIsInCart) $miniBagMonogrammingText.classList.add(c.cls.is_visible);
  else $miniBagMonogrammingText.classList.remove(c.cls.is_visible);

  /**
   * Get item html
   * @param {Object}
   */
  function getItemHtml(obj) {
    const {
      original_line_price,
      final_line_price,
      handle,
      image,
      key,
      options_with_values,
      product_title,
      product_id,
      quantity,
      url,
      variant_id,
      properties,
      discounts,
      vendor,
    } = obj;
    let item = '';
    let optionsHtml = '';
    let propertiesHtml = '';
    let randomMatchingKeyHtml = '';
    let lowInventoryHtml = '';
    let hasProperties = false;
    let isMonogrammed = false;
    let monogrammedClass = '';
    let monogramClass = '';
    let isFinalSale = false;
    let datafp;
    let datacafp;

    const isMonogramProduct = product_id === SDG.Data.monogramming.product_id;
    const isGWP = properties && '_gift_with_purchase' in properties;
    const productTitle = product_title.split('-')[0];
    const finalSaleVendors = ['Recurate', 'Route']
    let hasPreorderProperty;
    let preorderProperty = '';

    // sort properties alphabetically
    const sortedProperties = {};
    const propertyOrder = ["Initial One", "Initial Two", "Initial Three"];
    if (properties) {
      Object.keys(properties).sort((a, b) => {
        const indexA = propertyOrder.indexOf(a);
        const indexB = propertyOrder.indexOf(b);
        if (indexA === -1 || indexB === -1) {
          return a.localeCompare(b);
        }
        return indexA - indexB;
      }).forEach(function (key) {
        sortedProperties[key] = properties[key];
      });
    } else {
      console.log('no properties');
    }


    // properties html
    for (property in sortedProperties) {
      if (sortedProperties[property] === '') {
        continue;
      }
      const isNotHiddenProperty = !property.includes('_') && !property.includes('Product');
      const isRandomMatchingKey = property.includes('_randomMatchingKey');
      const hasMonogrammingProperty = property.includes('Initial Left') || property.includes('Initial One');
      const datafpProperty = property.includes('_datafp');
      const datacafpProperty = property.includes('_datacafp');

      hasPreorderProperty = property.includes('_preorder');
      isFinalSale = property.includes('_finalSale');

      if (isNotHiddenProperty && !hasPreorderProperty && !isGWP) {
        const propertieHtml = `<span class="option-name option-name--long">${property}</span>${sortedProperties[property]}<br>`;
        propertiesHtml += propertieHtml;
        hasProperties = true;
      }

      if (hasPreorderProperty) {
        preorderProperty = sortedProperties[property]
      }

      if (isRandomMatchingKey) {
        randomMatchingKeyHtml = `data-random-key="${sortedProperties[property]}"`;
      }

      if (hasMonogrammingProperty) {
        isMonogrammed = true;
      }

      if (datafpProperty) {
        datafp = sortedProperties[property];

        if (datafp === undefined) {
          datafp = '';
        }
      }

      if (datacafpProperty) {
        datacafp = sortedProperties[property];

        if (datacafp === undefined) {
          datacafp = '';
        }
      }
    }

    lowInventoryHtml = `<div class="mini-bag-product__details-low-inventory is-hidden js-mini-bag-low-inventory"></div>`;

    // if item has monogramming properties
    if (isMonogrammed) {
      monogrammedClass = ' mini-bag-product--monogrammed';

      // if monogram product
      if (isMonogramProduct) {
        monogramClass = ' mini-bag-product--monogram';
      }
    }

    // options html updated
    options_with_values.forEach(option => {
      let optionHtml = '';
      if (Shopify.country != "US") {
        optionHtml = `<span class="option-name${hasProperties === true ? ' option-name--long' : ''}">${option.name}</span>`
        if (option.name === 'Amount') {
          optionHtml += `${SDG.formatMoney(final_line_price, 'amount_with_currency_without_trailing_zeros')} ${SDG.Bag.data.currency == "USD" ? "" : SDG.Bag.data.currency}`;
        } else {
          optionHtml = `<span class="option-name${hasProperties === true ? ' option-name--long' : ''}">${option.name}</span>${option.value}<br>`;
        }
        optionsHtml += optionHtml;
      } else {
        optionHtml = `<span class="option-name${hasProperties === true ? ' option-name--long' : ''}">${option.name}</span>${option.value}<br>`;
        optionsHtml += optionHtml;
      }
    });

    // image html
    const productImageHtml = `
      <a
        class="mini-bag-product__image"
        href="${isMonogramProduct ? 'javascript:void(0)' : url}"
      >
        <img data-src="${SDG.getSizedImageUrl(image, '140x')}" class="lazyload" alt="${productTitle}" width="70" height="70">
      </a>
    `;

    // details html
    const productDetailsHtml = `
      <div class="mini-bag-product__details">
        <div class="flex items-center justify-between">
          <a class="mini-bag-product__details-title${isMonogrammed ? ' monomono' : ' nomono'}" href="${isMonogramProduct ? 'javascript:void(0)' : url}">
            <h2>${productTitle}</h2>
          </a>
          <button
            class="mini-bag-product__details-remove js-mini-bag-remove"
            type="button"
          >
            remove
          </button>
        </div>

        <div class="mini-bag-product__details-properties">
          ${optionsHtml}
          ${propertiesHtml}
          ${!isGWP ? '' : discounts.map(discount => `
            <div class="mini-bag-product__details-discount-message">
              ${discount.title}
            </div>
          `).join('')}
        </div>


        <div
          class="mini-bag-product__details-tags${hasPreorderProperty ? ' mini-bag-product__details-tags--preorder' : ''} js-mini-product-tags"
          ${hasPreorderProperty ? 'style="color: ' + SDG.Data.preorderCopyColor + ';"' : ''}
        >
          ${isMonogrammed || isMonogramProduct || isFinalSale || finalSaleVendors.includes(vendor) ? 'This item is final sale' : ''}
          ${hasPreorderProperty ? preorderProperty : ''}
        </div>

        ${lowInventoryHtml}
        <div class="quantity-and-price">
          ${isMonogramProduct || isGWP ? '' : `
            <div class="mini-bag-product__details-quantity">
              <button
                class="quantity-minus${!isMonogramProduct ? ' js-mini-bag-qty-minus' : ''}"
                aria-label="Decrease quantity"
                type="button"
              >
              </button>
              <span class="quantity-value js-mini-bag-product-qty-value">${quantity}</span>
              <button
                class="quantity-plus${!isMonogramProduct ? ' js-mini-bag-qty-plus' : ''}"
                aria-label="Increase quantity"
                type="button"
              >
              </button>
            </div>`}

          <p class="mini-bag-product__details-price">
            <s class="compare-at-price js-bag-compare-at-price ${original_line_price > final_line_price ? 'with-price' : ''}" data-fp="${datacafp}">
              <span class="screenreader">Original Price: </span>
              ${SDG.formatMoney(original_line_price, 'amount_with_currency_without_trailing_zeros')} ${SDG.Bag.data.currency == "USD" ? "" : SDG.Bag.data.currency}
            </s>
            <span
              class="price product__price"
              data-price-minor-units="${final_line_price}"
              data-fp="${datafp}"
            >
              <span class="screenreader">Current Price: </span>
              ${SDG.formatMoney(final_line_price, 'amount_with_currency_without_trailing_zeros')} ${SDG.Bag.data.currency == "USD" ? "" : SDG.Bag.data.currency}
            </span>
          </p>
        </div>
      </div>
    `;

    item = `
      <div
        class="mini-bag-product js-mini-bag-product${monogrammedClass}${monogramClass}"
        data-variant-id="${variant_id}"
        data-handle="${handle}"
        data-key="${key}"
        role="group"
        aria-label="product"
        ${randomMatchingKeyHtml}
      >
        ${productImageHtml}
        ${productDetailsHtml}
      </div>
    `;

    return item;
  }

  /**
   * Add events
   */
  function addEvents() {

    const $removeButtons = document.querySelectorAll(`.${c.cls.mini_bag_remove}`);
    const $qtyPlusButtons = document.querySelectorAll(`.${c.cls.mini_bag_qty_plus}`);
    const $qtyMinusButtons = document.querySelectorAll(`.${c.cls.mini_bag_qty_minus}`);

    // remove events
    $removeButtons.forEach(($button) => $button.addEventListener('click', SDG.Bag.removeFromBag));

    // Update quantity
    $qtyPlusButtons.forEach(($button) => $button.addEventListener('click', SDG.Bag.updateItem));
    $qtyMinusButtons.forEach(($button) => $button.addEventListener('click', SDG.Bag.updateItem));

    $miniBagForm.addEventListener('submit', (e) => {
      // Check Monogram status in cart, and remove if wrong monograms exist in cart.
      e.preventDefault();

      fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(res => res.json())
      .then((result) => {
        let wrongMonograms = [];
        result.items.forEach((item) => {
          const isMonogram = item.product_id === SDG.Data.monogramming.product_id;
          if (isMonogram && typeof item.properties._randomMatchingKey === 'undefined') {
            wrongMonograms.push(item);
          }
        });

        if (wrongMonograms.length > 0) {
          async function recursiveFetch(monograms) {
            const key = monograms[0].key;
            const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
              method: 'POST',
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ quantity: 0, id: key }),
            })
            .then(() => {
              document.dispatchEvent(new CustomEvent('cart-item-removed', { detail: { key } }));
            });

            let removedItem = wrongMonograms.shift();

            if (wrongMonograms.length > 0) {
              return recursiveFetch(wrongMonograms);
            } else {
              return true;
            }
          }

          recursiveFetch(wrongMonograms).then(allRemoved => {
            console.log(`Wrong monograms are removed: ${allRemoved}`);
            if(allRemoved) {
              location.href = '/checkout'
            }
          })
        } else {
          location.href = '/checkout'
        }
      });
    })
  }
};

/**
 * Bag open & bag close
 * @param {Boolean} refresh - refresh bag data
 */
SDG.Bag.open = function(refresh) {

  const c = SDG.Bag.config;
  const $body = document.body;
  const $miniBag = document.querySelector(`.${c.cls.mini_bag}`);
  const isCartPage = window.location.pathname === `${window.Shopify.routes.root}cart`;
  const $close = document.querySelector(`.${c.cls.mini_bag_close}`);

  /**
   * init
   */
  function init() {
    if (isCartPage) return;
    if (refresh) SDG.Bag.getCartData();

    bodyScrollLock.disableBodyScroll($miniBag);
    openMiniBag();
    $close.focus();
    SDG.trapFocus($miniBag);
  };

  /**
   * open mini bag
   */
  function openMiniBag() {
    document.dispatchEvent(new CustomEvent('cart-viewed'));
    $body.classList.add(c.cls.mini_bag_is_open);
    $miniBag.setAttribute('aria-hidden', false);
    $miniBag.style.display = null;
  }

  /**
   * return
   */
  return init();

};

/**
 * Bag close
\ */
SDG.Bag.close = function() {

  const c = SDG.Bag.config;
  const $body = document.body;
  const $bagTrigger = document.querySelector(`.${c.cls.mini_bag_trigger}`);
  const $miniBag = document.querySelector(`.${c.cls.mini_bag}`);
  /**
   * init
   */
  function init() {
    closeMiniBag();
    bodyScrollLock.clearAllBodyScrollLocks();
    $bagTrigger.focus();
  };

  /**
   * close mini bag
   */
  function closeMiniBag() {
    $body.classList.remove(c.cls.mini_bag_is_open);
    $miniBag.setAttribute('aria-hidden', true);

    const onEnd = () => {
      $miniBag.removeEventListener('transitionend', onEnd);
      $miniBag.style.display = 'none';
    }
    $miniBag.addEventListener('transitionend', onEnd);
  }


  /**
   * return
   */
  return init();

};

/**
 * Bag Init
 *
 */
SDG.Bag.init = function() {

  const c = SDG.Bag.config;

  // globals
  const $bagTrigger = document.querySelector(`.${c.cls.mini_bag_trigger}`);
  const $bagClose = document.querySelectorAll(`.${c.cls.mini_bag_close}`);
  const $bagOverlay = document.querySelector(`.${c.cls.mini_bag_overlay}`);
  const $quickAdds = document.querySelectorAll(`.${c.cls.mini_bag_qucik_add}`);

  /**
   * init
   */
  function init() {
    SDG.Bag.getCartData();
    SDG.Bag.additionalCheckout();
    addEvents();
  };

  /**
   * Add Events
   */
  function addEvents() {
    $bagTrigger.addEventListener('click', () => {
      SDG.Bag.open();
      Klarna.ExpressButton.refreshButtons();
    });
    $bagOverlay.addEventListener('click', () => SDG.Bag.close());
    $bagClose.forEach(($trigger) => $trigger.addEventListener('click', () => SDG.Bag.close()));
    $quickAdds.forEach(($quickAdd) => $quickAdd.addEventListener('click', (e) => quickAdd(e)));
  };

  /**
   * Quick Add
   */
  function quickAdd(e) {
    const $target = e.target;
    const variantId = Number($target.dataset.variantId);

    SDG.Bag.quickAdd(variantId, $target);
  };


  /**
   * return
   * @type {Object}
   */
  return init();

};

SDG.Bag.init();

/**
 * Carousel Buttons
 * Append Buttons into the dots
 */

 SDG.appendButtons = function appendButtons(gallery) {
  const c = {
    dom: {
      dot: 'dot',
    },
    cls: {
      selected: 'is-selected',
    },
  };

  const items = gallery.element;
  const $dots = items ? items.querySelectorAll(`.${c.dom.dot}`) : null;

  /**
   * Init
   */
  function init() {
    if (!$dots) return;
    listButtons();
  }

  function listButtons() {
    $dots.forEach((dot, index) => {
      const selected = dot.classList.contains(c.cls.selected);
      const number = index + 1;
      const label = `aria-label="${selected ? `Current slide ${number}` : `Go to slide ${number}`}"`;
      const innerHtml = `
        <button tabindex="0" class="screenreader" ${label}></button>
      `;

      dot.innerHTML = innerHtml.trim();
      dot.childNodes[0].addEventListener('click', () => {
        dot.click();
      });

      dot.removeAttribute('aria-label');
      dot.removeAttribute('aria-current');
    });
  }

  return init();
}

/**
 * Carousel selected
 * For ADA, updates aria-hidden on slides and tabindexes on focusable elements according to which slides are selected
 */
SDG.carouselSelect = function carouselSelect(carousel) {
  /**
   * Init
   */
  function init() {
    updateHiddenSlides();
  }

  function updateHiddenSlides() {
    const $slideEls = carousel.cells.map((cell) => cell.element);

    $slideEls.forEach(($el) => {
      const selected = $el.classList.contains('is-selected');
      const focusableEl = $el.querySelectorAll('textarea:not([disabled]), input:not([disabled]), select:not([disabled])');
      if (selected) {
        $el.setAttribute('aria-hidden', false);
        focusableEl.forEach((item) => {
          item.removeAttribute('tabindex');
        });
      } else {
        $el.setAttribute('aria-hidden', true);
        focusableEl.forEach((item) => {
          item.setAttribute('tabindex', -1);
        });
      }
    });
  }

  return init();
}

/**
 * Collection
 * @type {Function}
 * @return init()
 *
 */
SDG.collection = function () {
  const c = {
    cls: {
      collection_image_wrap: 'js-collection-image-wrap',
      collection_product: 'js-collection-product',
      collection_products: 'js-collection-products',
      collection_swatch: 'js-collection-swatch',
      show_size_button: 'js-show-size-button',
      collection: 'js-collection',
      is_hidden_class: 'hidden',
      image_hover: 'image-hover',
      next_page_button: 'js-next-page',
      pagination: 'js-pagination',
      seo_block_content: 'js-seo-block-content',
      seo_block_mobile: 'js-seo-block-mobile',
      seo_block: 'js-seo-block',
      seo_read_more_button: 'js-seo-read-more',
      collection_block: 'collection-block',
    }
  }

  // cached globals
  const $nextPageButton = document.querySelector(`.${c.cls.next_page_button}`);
  const $collection = document.querySelector(`.${c.cls.collection}`);
  const $collectionProducts = document.querySelector(`.${c.cls.collection_products}`);
  const $seoBlock = document.querySelector(`.${c.cls.seo_block}`);
  const $seoBlockMobile = document.querySelector(`.${c.cls.seo_block_mobile}`);
  const $seoBlockContent = document.querySelector(`.${c.cls.seo_block_content}`);
  const $collectionImageWraps = document.querySelectorAll(`.${c.cls.collection_image_wrap}`);
  const $showSizeButtons = document.querySelectorAll(`.${c.cls.show_size_button}`);
  const $collectionBlocks = $collection?.querySelectorAll(`.${c.cls.collection_block}`);
  let loadCount = 0;

  /**
   * init
   */
  function init() {
    adjustBlocks();
    addEvents();
    seoBlock();
    setTimeout(() => {
      trackCollectionView();
    }, 1000);
  };

  /* Move collection blocks to their position */
  function adjustBlocks() {
    $collectionBlocks?.forEach(block => {
      let pos = block.dataset.position;
      let target = $collectionProducts.children[pos];
      $collectionProducts.insertBefore(block, target);
    });
  }

  /** Track page view */
  function trackCollectionView() {
    setTimeout(() => {
      if (window.location.href.includes('search')) {
        const query = window.location.href.substring(window.location.href.indexOf("q=") + 2);
        const queryWithoutView = query.replace("&view=spring", "");
        klaviyo.push(['track', 'Searched for item', {
          PageName: `Search - ${queryWithoutView}`
        }
        ]);
      } else if (document.body.classList.contains('template-collection')) {
        klaviyo.push(['track', 'Viewed Collection Page', {
          PageName: `Collection Page - ${window.location.href}`
        }
        ]);
      }
    }, 1000);
  }

  /**
   * Seo block
   */
  function seoBlock() {
    if ($seoBlock) {
      $seoBlockMobile.innerHTML = `${SDG.truncateHTML($seoBlock.innerHTML, 350)}... <button type="button" class="collection-seo-block__read-more js-seo-read-more">Read more</button>`;
      const $seoBlockButton = document.querySelector(`.${c.cls.seo_read_more_button}`);
      if ($seoBlockButton != null) {
        $seoBlockButton.addEventListener('click', showFullSeoText);
      }
    }
  }

  /**
   * Show Full Seo Text
   */
  function showFullSeoText() {
    $seoBlockMobile.style.opacity = '0';
    $seoBlock.style.maxHeight = `${$seoBlockContent.offsetHeight + 75}px`;
  }

  /**
   * Add Events
   */
  function addEvents() {
    if ($nextPageButton) $nextPageButton.addEventListener('click', pullMoreProducts);
    if ($collectionImageWraps.length > 0) {
      $collectionImageWraps.forEach($wrap => $wrap.addEventListener('touchstart', addClassParent));
      $collectionImageWraps.forEach($wrap => $wrap.addEventListener('touchend', removeClassParent))
    }

    const paginationEl = document.querySelector(`.${c.cls.pagination}`);
    if ($collection && paginationEl) {
      const paginationObserver = new IntersectionObserver(([target]) => {
        if (!target.isIntersecting) return;

        const paginationOn = document.getElementById('pagination-toggle').checked;

        if (loadCount === 0 && !paginationOn) {
          pullMoreProducts();
          loadCount++;
        }
      });

      paginationObserver.observe(paginationEl);

      document.querySelector('#pagination-toggle').addEventListener('change', (e) => {
        const paginationNext = document.querySelector('.pagination__next');
        paginationNext?.classList.toggle('hidden', !e.target.checked);
      });

      paginationEl.addEventListener('click', (e) => {
        e.preventDefault();
        pullMoreProducts();
        loadCount++;
      });
    }

    $collectionBlocks?.forEach(block => {
      if (block.classList.contains('collection-block--video')) {
        let btn = block.querySelector('.collection-block__video-btn');
        let video = block.querySelector('.collection-block__video');
        if (!btn || !video) return;
        btn.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();
          btn.classList.toggle('paused');
          if (video.paused) {
            video.play();
            btn.setAttribute('aria-label', 'Pause Video');
          } else {
            video.pause();
            btn.setAttribute('aria-label', 'Play Video');
          }
        });
      }
    });
  };

  /**
   * Pull More Products
   */
  function pullMoreProducts(e) {
    const $nextPageButton = document.querySelector(`.${c.cls.next_page_button}`);
    const $pagination = document.querySelector(`.${c.cls.pagination}`);

    let href;

    if (typeof e !== 'undefined') {
      e.preventDefault();
    }

    if ($nextPageButton) {
      href = $nextPageButton.getAttribute('href');
    }

    if ($collection && href) {
      $pagination.innerHTML = `
        <span class="pagination__loading">
          <svg class="pagination__loading-icon" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg">
            <defs><linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a">
              <stop stop-color="#000000" stop-opacity="0" offset="0%"/>
              <stop stop-color="#000000" stop-opacity=".631" offset="63.146%"/>
              <stop stop-color="#000000" offset="100%"/></linearGradient>
            </defs>
            <g fill="none" fill-rule="evenodd"><g transform="translate(1 1)">
            <path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#a)" stroke-width="2"></path>
            <circle fill="#000000" cx="36" cy="18" r="1"></circle>
            </g></g>
          </svg>

          Loading more products...
        </span>`;

      fetch(href)
        .then(res => res.text())
        .then((data) => {
          const parser = new DOMParser();
          const responseHtml = parser.parseFromString(data, 'text/html');
          const $responseCollection = responseHtml.querySelector(`.${c.cls.collection}`);
          const $responseCollectionProducts = $responseCollection.querySelectorAll(`.${c.cls.collection_product}`);
          const $responsePagination = responseHtml.querySelector(`.${c.cls.pagination}`);

          if ($responseCollectionProducts.length > 0) {
            // Remove the "newfocus" class from all elements

            const elements = document.querySelectorAll('.newfocus');
            elements.forEach((element) => {
              element.classList.remove('newfocus');
            });

            $responseCollectionProducts.forEach(($newProduct, index) => {
              if (index === 0) {
                $newProduct.classList.add('newfocus'); // Add the class to the first element
              }
              $collectionProducts.appendChild($newProduct);
            });

            // Set focus on the element with the "newfocus" class
            const newFocusElement = document.querySelector('.newfocus');
            if (newFocusElement) {
              newFocusElement.tabIndex = '-1';
              newFocusElement.focus();
            }
          }

          if ($responsePagination) {
            $pagination.innerHTML = $responsePagination.innerHTML;

            if (document.getElementById('pagination-toggle').checked) {
              $pagination.querySelector('.pagination__next').classList.remove('hidden');
            }

            $collection.appendChild($pagination);
          } else {
            $pagination.remove();
          }

          loadCount = 0;
          resetSwatchesEvents();
        })
        .catch(error => console.warn('ERROR', error));
    }

  };

  function resetSwatchesEvents() {
    const $collectionSwatches = document.querySelectorAll(`.${c.cls.collection_swatch}`);
    $collectionSwatches.forEach(($swatch) => {
      $swatch.parentElement.querySelector('input').removeEventListener('change', SDG.collectionSwatchesUpdateContent);
    });

    $collectionSwatches.forEach(($swatch) => {
      $swatch.parentElement.querySelector('input').addEventListener('change', (e) => SDG.collectionSwatchesUpdateContent(e.target.parentElement.querySelector('label')));
    });

    SDG.collectionSwatchesCarouselsInit();
    SDG.collectionSwatchesSizeCarouselInit();
    SDG.collectionATCReInit();
  }

  /**
   * Add Class to parent
   */
  function addClassParent(e) {
    let $parent;
    const isImage = e.target.nodeName == 'IMG';

    if (isImage) $parent = e.target.parentNode.parentNode;
    else $parent = e.target.parentNode;

    removeClassParent();
    $parent.classList.add(c.cls.image_hover);
  }

  /**
   * Remove class from parent
   */
  function removeClassParent() {
    $collectionImageWraps.forEach(($wrap) => $wrap.parentNode.classList.remove(c.cls.image_hover));
  }

  /**
   * return
   */
  return init();
};

SDG.collection();

/**
 * Collection Filters
 * @type {Function}
 * @return init()
 *
 */

SDG.collectionFilters = function () {

  const c = {
    id: {
      sort_content: 'sortContent',
      collection_products: 'collectionProductItems',
    },
    cls: {
      button: 'js-filter-button',
      close_button: 'js-filter-close',
      collection_filter: 'js-collection-filter',
      content: 'js-filter-contnet',
      filters_close_button: 'js-filter-close',
      filters_wrap: 'js-filters-wrap',
      filters_body: 'js-filters-body',
      filters_action: 'js-filters-actions',
      is_active_class: 'is-active',
      is_expanded_class: 'is-expanded',
      is_open_class: 'is-open',
      is_visible_class: 'is-visible',
      filter_is_open_class: 'filter-is-open',
      mobile_filter_button: 'js-mobile-filter-button',
      overlay: 'js-overlay',
      sort_option: 'js-sort-option',
      results_count: 'js-results-count',
      tag_link: 'js-tag-link',
    },
  }

  // cached globals
  const $body = document.body;
  const $buttons = document.querySelectorAll(`.${c.cls.button}`);
  const $contents = document.querySelectorAll(`.${c.cls.content}`);
  const $collectionFilters = document.querySelectorAll(`.${c.cls.collection_filter}`);
  const $sortOptions = document.querySelectorAll(`.${c.cls.sort_option}`);
  const $filtersWrap = document.querySelector(`.${c.cls.filters_wrap}`);
  const $filtersBody = document.querySelector(`.${c.cls.filters_body}`);
  const $filtersActions = document.querySelector(`.${c.cls.filters_action}`);
  const $closeButton = document.querySelector(`.${c.cls.close_button}`);
  const $mobileCloseButton = document.querySelectorAll(`.${c.cls.filters_close_button}`);
  const $mobileFilterButtons = document.querySelectorAll(`.${c.cls.mobile_filter_button}`);
  const $overlay = document.querySelector(`.${c.cls.overlay}`);
  const $sortContent = document.getElementById(c.id.sort_content);
  const keyboardFilter = localStorage.getItem('keyboardSelectedFilter');
  const $tagLinks = document.querySelectorAll(`.${c.cls.tag_link}`);
  const view = SDG.Viewport.currentState;

  /**
   * init
   */
  function init() {
    addEvents();

    if ($sortOptions.length > 0) {
      selectActiveSort();
    }

    if ($collectionFilters.length > 0) {
      checkSelectedFilters();
    }

    if (keyboardFilter && keyboardFilter !== '') {
      keyboardFilterFocus();
    }
  };

  /**
   * Add Events
   */
  function addEvents() {

    if ($buttons.length > 0) {
      $buttons.forEach(($trigger) => {
        $trigger.addEventListener('click', toggleContent);
      });
    }

    // Close Filters/Sort Content
    if ($filtersWrap) {
      window.addEventListener('click', (e) => {
        if (!$filtersWrap.contains(e.target)) {
          closeContent();
        }
      });
    }

    $sortOptions.forEach((link) => {
      link.addEventListener('keydown', (e) => {
        if (e.keyCode === 13) {
          localStorage.setItem('keyboardSelectedFilter', e.target.id);
        }
      });

      link.addEventListener('click', (e) => {
        e.preventDefault();

        const url = new URL(window.location);

        const targetURL = new URL(link.href);

        url.searchParams.set('sort_by', targetURL.searchParams.get('sort_by'));

        window.location = url;
      })
    });

    if ($closeButton) {
      $closeButton.addEventListener('click', closeContent);
    }

    if ($mobileCloseButton) {
      $mobileCloseButton.forEach(($button) => $button.addEventListener('click', closeContent))
    }

    if ($mobileFilterButtons) {
      $mobileFilterButtons.forEach(($button) => $button.addEventListener('click', toggleMobileContent))
    }
  };

  /**
   * Returns focus on sort filter select via keyboard after page refresh
   */
  function keyboardFilterFocus() {
    const filterItem = document.getElementById(keyboardFilter);
    $sortContent.classList.add(c.cls.is_open_class);
    $sortContent.previousElementSibling.classList.add(c.cls.is_open_class);
    $sortContent.previousElementSibling.setAttribute('aria-expanded', true);
    $overlay.classList.add(c.cls.is_visible_class);
    localStorage.setItem('keyboardSelectedFilter', '');

    setTimeout(() => {
      filterItem.focus();
    }, 200); // Waits for animation
  }

  /**
   * Select Active Sort
   */
  function selectActiveSort() {
    const typeFromUrl = getParameterByName('sort_by');
    $sortOptions.forEach(($option) => {
      const type = $option.dataset.type;
      if (type === typeFromUrl) {
        $option.classList.add(c.cls.is_active_class);
      }
    });
  }

  /**
   * Toggle Content
   */
  function toggleContent(e) {
    let $target = e.target;
    let content = $target.dataset.type;

    $body.classList.toggle(c.cls.filter_is_open_class);

    if (content === undefined) {
      $target = $target.parentNode;
      content = $target.dataset.type;
    }

    $buttons.forEach(($button) => {
      const contentAttribute = $button.dataset.type;

      if (content === contentAttribute && !$button.classList.contains(c.cls.is_open_class)) {
        $button.classList.add(c.cls.is_open_class);
        $button.setAttribute('aria-expanded', true);
        $overlay.classList.add(c.cls.is_visible_class);
      } else if ($button.classList.contains(c.cls.is_open_class)) {
        $button.classList.remove(c.cls.is_open_class);
        $button.setAttribute('aria-expanded', false);
        $overlay.classList.remove(c.cls.is_visible_class);
      }

    });

    $contents.forEach(($content, key) => {

      const contentAttribute = $content.dataset.type;
      let contentHeight;

      if (content === contentAttribute && !$content.classList.contains(c.cls.is_open_class)) {
        $content.classList.add(c.cls.is_open_class);

        if (view === 'mobile') {
          contentHeight = $content.offsetHeight;

          if (contentAttribute === 'filter' && !$mobileFilterButtons[0].classList.contains(c.cls.is_expanded_class)) {
            $mobileFilterButtons[0].click();
          }

          setTimeout(() => {
            if (contentHeight === 0) {
              $content.style.height = `${$content?.scrollHeight}px`;
            } else {
              $content.style.height = `${contentHeight}px`;
            }
          }, 300)

        }
      } else if ($content.classList.contains(c.cls.is_open_class)) {
        $content.classList.remove(c.cls.is_open_class);

        if (view === 'mobile') {
          $content.style.height = `0px`
        }
      }

    });
  }

  /**
   * Toggle Mobile Content
   */
  function toggleMobileContent(e) {
    if (window.innerWidth > 1024) return;
    const $target = e.target;
    let $nextElement = $target.nextSibling;
    let contentHeight;

    if ($nextElement.classList === undefined) {
      $nextElement = $nextElement.nextSibling;
    }

    // close siblings
    $mobileFilterButtons.forEach(($button) => {
      if ($button !== $target) {
        let $nextElement = $button.nextSibling;

        if ($nextElement.classList === undefined) {
          $nextElement = $nextElement.nextSibling;
        }

        $button.classList.remove(c.cls.is_expanded_class);
        $nextElement.classList.remove(c.cls.is_expanded_class);
        $nextElement.style.height = '0px';
      }
    });

    if ($nextElement.classList.contains(c.cls.is_expanded_class)) {
      $target.classList.remove(c.cls.is_expanded_class);
      $nextElement.classList.remove(c.cls.is_expanded_class);
      $nextElement.style.height = '0px';
      $overlay.classList.remove(c.cls.is_visible_class);
    } else {
      contentHeight = $nextElement.offsetHeight;
      $target.classList.add(c.cls.is_expanded_class);
      $nextElement.classList.add(c.cls.is_expanded_class);

      if (contentHeight === 0) {
        $nextElement.style.height = `${$nextElement?.scrollHeight + 40}px`;
      } else {
        $nextElement.style.height = `${contentHeight}px`;
      }
    }

    // update parent height
    $contents.forEach(($content) => {
      const type = $content.dataset.type;
      const actionsHeight = $filtersActions.offsetHeight;

      if (type === 'filter') {
        setTimeout(() => {
          $content.style.height = `${$filtersBody.offsetHeight + actionsHeight + 50}px`
        }, 200)
      }
    })
  }

  /**
   * Close Content
   */
  function closeContent(e) {

    $buttons.forEach(($button) => {
      $button.classList.remove(c.cls.is_open_class);
    });

    $contents.forEach(($content) => {
      $content.classList.remove(c.cls.is_open_class);

      if (view === 'mobile') {
        $content.style.height = `0px`;
      }

    });

    $overlay.classList.remove(c.cls.is_visible_class);
    $body.classList.toggle(c.cls.filter_is_open_class);
  }

  /**
   * Get The Parameter By Name
   */
  function getParameterByName(name) {
    const url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  /**
   * return
   */
  return init();
};

SDG.collectionFilters();

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.requestId = 0;
    this.form = this.querySelector('form');
    this.resultsCount = this.querySelector('[data-filter-results-count]');
    this.apply = this.querySelector('[data-filter-apply]');

    this.addEventListener('change', (e) => {
      if ('selectOne' in e.target.dataset) {
        this.querySelectorAll(`[name="${e.target.name}"]`).forEach(input => {
          if (input === e.target) return;

          input.checked = false;
        });
      }

      this.requestId++;
      const requestId = this.requestId;
      this._fetchProductCount()
        .then(({ result_count }) => {
          if (requestId !== this.requestId) return;

          this.resultsCount.innerHTML = `(${result_count})`;
          this.apply.disabled = result_count === 0;
        });
    });
  }

  disconnectedCallback() {

  }

  _fetchProductCount() {
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData).toString();
    const url = `${window.location.pathname}?view=json&${searchParams}`;
    return fetch(url)
      .then(res => res.json())
  }
}

if (!customElements.get("facet-filters-form")) {
  customElements.define("facet-filters-form", FacetFiltersForm);
}

$(document).ready(function () {
  var $collection_menu = $('#collection-menu')
    .on('cm:close', 'li', function () {
      $(this).removeClass('active')
    })
    .on('cm:open', 'li', function () {
      $(this).siblings().trigger('cm:close')
      $(this).addClass('active')
    })
    .on('click', 'a[href^=\'#\']', function (e) {
      e.preventDefault()
      $(this).trigger('cm:open')
    })

  $collection_menu
    .each(function () {
      var $collections = $('.collections')
      var $active_links = $('li.active > a:not(.is-proxy)').clone()

      if ($active_links.length > 0) {
        $collections.before($('<nav id="breadcrumbs" />').append($active_links))
      }
    })
})

/**
 * Collection Swatches
 * @type {Function}
 * @return init()
 *
 */

SDG.collectionSwatches = function() {

  const c = {
    cls: {
      collection_additional_flag: 'js-additional-flag',
      collection_flag_class: 'collection-product__flags-flag',
      collection_main_image_cover_class: 'collection-image--cover',
      collection_image_cover_class: 'collection-image--hover-cover',
      collection_product_color: 'js-collection-product-color',
      collection_product_compare_at_price: 'js-collection-product-compare-at-price',
      collection_product_flag_coming_coon: 'js-collection-product-flag-coming-soon',
      collection_product_flag_low_stock: 'js-collection-product-flag-low-stock',
      collection_product_flag_other: 'js-collection-product-flag-other',
      collection_product_flag_sale: 'js-collection-product-flag-sale',
      collection_product_flag_sold_out: 'js-collection-product-flag-sold-out',
      collection_product_flag_waitlist: 'js-collection-product-flag-waitlist',
      collection_product_flags_wrap: 'js-collection-product-flags-wrap',
      collection_product_image_hover: 'js-collection-image-hover',
      collection_product_image: 'js-collection-image',
      collection_product_link: 'js-collection-product-title-link',
      collection_product_low_inventory: 'js-collection-product-low-inventory',
      collection_product_price: 'js-collection-product-price',
      collection_product_sizes: 'js-collection-product-sizes',
      collection_product: 'js-collection-product',
      collection_swatch_wrapper: 'collection-product-swatches__swatch',
      collection_swatch: 'js-collection-swatch',
      collection_swatches_carousel: 'js-swatches-carousel',
      collection_swatches_carousel_arrow: 'js-collection-swatches-arrow',
      collection_swatches_carousel_slide: 'js-carousel-slide',
      collection_no_hover_class: 'collection-image-wrap--no-hover-image',
      flickity_enabled: 'flickity-enabled',
      is_hidden_class: 'is-hidden',
      is_loading_class: 'is-loading',
      is_selected_class: 'is-selected',
      is_visible_class: 'is-visible',
      with_price_class: 'with-price',
    }
  }

  // cached globals
  const $products = [...document.querySelectorAll(`.${c.cls.collection_product}`)];
  const $collectionSwatches = document.querySelectorAll(`.${c.cls.collection_swatch}`);
  const view = SDG.Viewport.currentState;
  SDG.collectionSwatchesUpdateContent = updateContent;
  SDG.collectionSwatchesCarouselsInit = initCarousels;
  SDG.collectionSwatchesSizeCarouselInit = initSizeCarouesls;
  SDG.collectionATCReInit = reInitAddToCartButtons;

  /**
   * init
   */
  function init() {

    if ($collectionSwatches.length > 0) {
      addEvents();
    }

    initCarousels();

  };

  /**
   * Add Events
   */
  function addEvents() {
    $collectionSwatches.forEach(($swatch) => {
      $swatch.parentElement.querySelector('input').addEventListener('change', (e) => {
        e.preventDefault();
        e.stopPropagation();
        updateContent(e.target.parentElement.querySelector('label'));
      });
    });

    $products.forEach((product) => {
      let variantsData = null;
      const $variantsDataEl = product.querySelector(".is-selected [data-swatch-variant-data]");
      const $sizes = product.querySelector(`.${c.cls.collection_product_sizes}`);
      if ($variantsDataEl) {
        variantsData = JSON.parse($variantsDataEl.textContent);
      }
      buildSizeHtml($sizes, variantsData);

      product.addEventListener('click', e => {
        if (e.target.closest('.collection-product-swatches')) return;
        if (e.target.closest('.js-collection-product-title-link')) return;
        const $link = product.querySelector(`.${c.cls.collection_product_link}`);
        $link.click();
      });
    });
  };

  /**
   * Init carousels
   */
  function initCarousels() {
    const $collectionSwatchesCarousels = document.querySelectorAll(`.${c.cls.collection_swatches_carousel}`);
    const settings = {
      cellSelector: `.${c.cls.collection_swatches_carousel_slide}`,
      cellAlign: 'left',
      wrapAround: false,
      pageDots: false,
      groupCells: 3,
      prevNextButtons: true,
      watchCSS: true,
      contain: true
    };

    if ($collectionSwatchesCarousels.length === 0) return;

    $collectionSwatchesCarousels.forEach(($wrap) => {
      const flickityEnabled = $wrap.classList.contains(c.cls.flickity_enabled);
      const $selectedSwatch = $wrap.querySelector(`.${c.cls.collection_swatches_carousel_slide}.${c.cls.is_selected_class}`);

      if (!flickityEnabled) {
        const initCarousel = $wrap.dataset.initCarousel;
        let flickity;

        if (initCarousel === 'true') {

          // move swatch to the first position
          if ($selectedSwatch && view === 'mobile') $wrap.insertBefore($selectedSwatch, $wrap.childNodes[0]);

          // init flickity
          flickity = new Flickity($wrap, settings);

          // add arrow event
          const $arrowButton = $wrap.querySelector(`.${c.cls.collection_swatches_carousel_arrow}`);
          const slidesLength = $wrap.querySelectorAll(`.${c.cls.collection_swatches_carousel_slide}`).length;
          $arrowButton.addEventListener('click', () => {
            const currentIndex = flickity.selectedIndex;

            if (currentIndex + 5 !== slidesLength) flickity.selectCell(currentIndex + (slidesLength - 5));
          });
        }
      }
    });
  };

  /**
   * Update Content
   */
  function updateContent($target) {
    if ($target.classList.contains(c.cls.is_selected_class)) {
      return;
    }

    const $product = $target.closest(`.${c.cls.collection_product}`);
    const $swatchWrapper = $target.closest(`.${c.cls.collection_swatch_wrapper}`);
    const $image = $product.querySelector(`.${c.cls.collection_product_image}`);
    const $imageHover = $product.querySelector(`.${c.cls.collection_product_image_hover}`);
    const $link = $product.querySelector(`.${c.cls.collection_product_link}`);
    const $color = $product.querySelector(`.${c.cls.collection_product_color}`);
    const $swatches = $product.querySelectorAll(`.${c.cls.collection_swatch}`);
    const $price = $product.querySelector(`.${c.cls.collection_product_price}`);
    const $compareAtPrice = $product.querySelector(`.${c.cls.collection_product_compare_at_price}`);
    const $sizes = $product.querySelector(`.${c.cls.collection_product_sizes}`);
    const $inventory = $product.querySelector(`.${c.cls.collection_product_low_inventory}`);
    const $flagSale = $product.querySelector(`.${c.cls.collection_product_flag_sale}`);
    const $flagLowStock = $product.querySelector(`.${c.cls.collection_product_flag_low_stock}`);
    const $flagSoldOut = $product.querySelector(`.${c.cls.collection_product_flag_sold_out}`);
    const $flagsWrap = $product.querySelector(`.${c.cls.collection_product_flags_wrap}`);
    const $flagComingSoon = $product.querySelector(`.${c.cls.collection_product_flag_coming_coon}`);
    const $flagWaitlist = $product.querySelector(`.${c.cls.collection_product_flag_waitlist}`);
    const $additionalFlags = $product.querySelectorAll(`.${c.cls.collection_additional_flag}`);
    const { price, compareAtPrice, image, imageHover, availableSizes, variantId,
            soldout, backInStock, comingSoon, humanColor, url, imageHoverIsCover, mainImageIsCover,
            finalSale, globaleFp, globaleFpCompareAt, inventory, flags } = $target.dataset;
    const flagsArray = flags.split(',');

    let variantsData = null;
    const $variantsDataEl = $swatchWrapper.querySelector("[data-swatch-variant-data]");
    if ($variantsDataEl) {
      variantsData = JSON.parse($variantsDataEl.textContent);
    }

    if ($image) {
      $image.setAttribute('data-srcset', image);
      $image.setAttribute('srcset', image);
      $image.classList.remove('lazyloaded');
      $image.classList.add('lazyload');
    }

    if ($imageHover) {
      if (imageHover) {
        $imageHover.parentNode.classList.remove(c.cls.collection_no_hover_class);
        $imageHover.setAttribute('data-srcset', imageHover);
        $imageHover.setAttribute('srcset', imageHover);
        $imageHover.classList.remove('lazyloaded');
        $imageHover.classList.add('lazyload');
      } else {
        $imageHover.setAttribute('data-srcset', '');
        $imageHover.setAttribute('srcset', '');
        $imageHover.parentNode.classList.add(c.cls.collection_no_hover_class);
      }
    }

    // if main image is a cover
      $image && $image.classList.add(c.cls.collection_main_image_cover_class);
    // if hover image is a cover
      $imageHover && $imageHover.classList.add(c.cls.collection_image_cover_class);

    // replace color name
    if ($color) {
      $color.innerText = humanColor;
    }

    // replace color name
    if ($link) {
      $link.href = url;
    }

    // add selected class
    $swatches.forEach(($swatch) => {
      $swatch.classList.remove(c.cls.is_selected_class);
    })
    $target.classList.add(c.cls.is_selected_class);

    // replace price
    if ($price && price) {
      let formatPrice = SDG.formatMoney(price, 'amount_with_currency_without_trailing_zeros', theme.currency.symbol);
      if (theme.currency.iso_code != 'USD') {
        formatPrice = `${formatPrice} ${theme.currency.iso_code}`;
      }
      $price.innerText = formatPrice;
      $price.setAttribute('data-fp', globaleFp);
    }

    $compareAtPrice && $compareAtPrice.setAttribute('data-fp', globaleFpCompareAt);

    // updated sizes
    if ($sizes) {
      buildSizeHtml($sizes, variantsData);
    }

    const $quickAddButton = $product.querySelector('.js-mini-bag-quick-add');
    if ($quickAddButton) {
      $quickAddButton.dataset.variantId = variantId;
    }

    // show/hide low invetory copy
    if ($inventory) {
      if (inventory < 4 && inventory > 0) {
        $inventory.classList.add(c.cls.is_visible_class);
        $inventory.innerText = `Only ${inventory} left`;
        $flagLowStock.classList.add(c.cls.is_visible_class);
      } else {
        $inventory.classList.remove(c.cls.is_visible_class);
        $flagLowStock.classList.remove(c.cls.is_visible_class);
      }
    }

    // comapre at price
    if ($compareAtPrice) {
      if (compareAtPrice) {
        if (parseFloat(price) < parseFloat(compareAtPrice)) {
          let formatPrice = SDG.formatMoney(compareAtPrice, 'amount_with_currency_without_trailing_zeros', theme.currency.symbol);
          if (theme.currency.iso_code != 'USD') {
            formatPrice = `${formatPrice} ${theme.currency.iso_code}`;
          }

          $compareAtPrice.parentNode.classList.add(c.cls.with_price_class);
          $compareAtPrice.innerHTML = formatPrice;
          $compareAtPrice.setAttribute('data-fp', globaleFpCompareAt);
        } else {
          $compareAtPrice.parentNode.classList.remove(c.cls.with_price_class);
          $compareAtPrice.innerHTML = '';
          $compareAtPrice.setAttribute('data-fp', '');
        }
      } else {
        $compareAtPrice.parentNode.classList.remove(c.cls.with_price_class);
        $compareAtPrice.innerHTML = '';
        $compareAtPrice.setAttribute('data-fp', '');
      }
    }

    // update flags
    // remove additional flags
    $additionalFlags.forEach(($flag) => $flag.remove());

    // add new flags from the array
    if ($flagsWrap && flagsArray.length > 0) {
      flagsArray.forEach((flag) => {
        if (flag.length > 0) {
          const $flag = document.createElement('span');
          $flag.classList = `${c.cls.collection_flag_class} ${c.cls.collection_additional_flag} ${c.cls.is_visible_class}`;
          $flag.innerHTML = flag;
          $flagsWrap.append($flag);
        }
      });
    }

    // sold out and waitlist
    // if (soldout === 'true') {
    //   $flagSoldOut.classList.add(c.cls.is_visible_class);
    //   if (backInStock === 'true' || comingSoon === 'true') {
    //     $flagWaitlist && $flagWaitlist.classList.add(c.cls.is_visible_class);
    //     $flagSoldOut && $flagSoldOut.classList.remove(c.cls.is_visible_class);
    //   }
    // } else {
    //   $flagWaitlist && $flagWaitlist.classList.remove(c.cls.is_visible_class);
    //   $flagSoldOut && $flagSoldOut.classList.remove(c.cls.is_visible_class);
    // }

    // coming soon
    if (comingSoon === 'true') {
      $flagComingSoon && $flagComingSoon.classList.add(c.cls.is_visible_class);
    } else {
      $flagComingSoon && $flagComingSoon.classList.remove(c.cls.is_visible_class);
    }

    // sale
    if (finalSale === 'true') {
      $flagSale && $flagSale.classList.add(c.cls.is_visible_class);
    } else {
      $flagSale && $flagSale.classList.remove(c.cls.is_visible_class);
    }
  };

  /**
   * Handle size Select Event
   */
  function handleSizeSelectEvent(e, variantsData) {
    e.preventDefault();
    e.stopPropagation();
    const size = e.target.textContent;
    const currentVariant = variantsData?.find((variant) => {
      return variant.options[variant.options.length - 1] === size
    });

    const variantId = currentVariant.id;
    const $wrapper = e.target.closest('.js-collection-product');
    const $quickAddButton = $wrapper.querySelector('.js-show-size-button');
    $quickAddButton.dataset.variantId = variantId;
    SDG.Bag.quickAdd(variantId, $quickAddButton);
  }

  /**
   * Build size html
   */
  function buildSizeHtml(selector, variants) {
    let html = '';
    if (!selector || !variants || variants.length == 0) return;

    const featuredCollection = selector.closest('.featured-collection');
    const carouselElement = document.createElement('div');

    variants.forEach((variant) => {
      const sizeOption = variant.options[variant.options.length - 1];
      // Update: show available only.
      if (variant.available) {
        html += `
        <span class="size ${variant.available ? 'available' : 'sold-out'}">${sizeOption}</span>
        `;
      }
    })

    carouselElement.innerHTML = html;
    carouselElement.classList.add('product-swatch-carousel');
    selector.innerHTML = '';
    selector.append(carouselElement);
    const swatchCarousel = selector.querySelector('.product-swatch-carousel');

    if (featuredCollection) {
      if (variants.length > 6) {
        selector.classList.remove('list-view');
        initSizeCarouesl(swatchCarousel);
      } else {
        selector.classList.add('list-view');
      }
    } else {
      selector.classList.add('list-view');
    }

    if (featuredCollection) {
      const $sizesItem = [...selector.querySelectorAll('.size.available')];
      $sizesItem.forEach((item) => {
        item.addEventListener('click', (e) => {
          handleSizeSelectEvent(e, variants);
        })
      });
    }
  }

  /**
   * Init Size options carousel
   */
  function initSizeCarouesl(wrapper, destroyBeforeInit=false) {
    const settings = {
      cellAlign: 'center',
      wrapAround: false,
      pageDots: false,
      groupCells: 3,
      prevNextButtons: true,
      contain: true
    };

    if (destroyBeforeInit) {
      const flickityInstance = Flickity.data(wrapper);
      // flickityInstance && flickityInstance.destroy();
    }
    new Flickity(wrapper, settings);
  }

  function initSizeCarouesls() {
    const sizeCarousels = [...document.querySelectorAll(`.${c.cls.collection_product_sizes}.carousel-view .product-swatch-carousel`)];

    if (sizeCarousels.length === 0) return;

    sizeCarousels.forEach((wrapper) => {
      initSizeCarouesl(wrapper);
    });
  }

  function reInitAddToCartButtons() {
    const collection = document.querySelector('.js-collection-products');
    if (collection) {
      const $quickAdds = [...collection.querySelectorAll(`.js-mini-bag-quick-add`)];

      $quickAdds.forEach(($quickAdd) => $quickAdd.addEventListener('click', function quickAdd(e) {
        const $target = e.target;
        const variantId = Number($target.dataset.variantId);

        SDG.Bag.quickAdd(variantId, $target);
      }));

      const $products = [...collection.querySelectorAll(`.${c.cls.collection_product}`)];
      $products.forEach((product) => {
        let variantsData = null;
        const $variantsDataEl = product.querySelector(".is-selected [data-swatch-variant-data]");
        const $sizes = product.querySelector(`.${c.cls.collection_product_sizes}`);
        if ($variantsDataEl) {
          variantsData = JSON.parse($variantsDataEl.textContent);
        }
        buildSizeHtml($sizes, variantsData);
  
        product.addEventListener('click', e => {
          if (e.target.closest('.collection-product-swatches')) return;
          if (e.target.closest('.js-collection-product-title-link')) return;
          const $link = product.querySelector(`.${c.cls.collection_product_link}`);
          $link.click();
        });
      });
    }
  }

  /**
   * return
   */
  return init();
};

SDG.collectionSwatches();

// ==== CONTACT PAGE
$(document).ready(function() {

  var $sizeGuideSections = $('.size-guides .size-guide');
  var sizeGuidesIds = [];  
  $sizeGuideSections.each(function() {
      var id = '#' + $(this).attr('id');
     sizeGuidesIds.push(id);
  })
 
  $(".faqs .faq")
    .each(function() {
      $(this)
        .on("collapse", function() {
          var $content = $(this)?.find("> div").hide();
        })
        .on("expand", function() {
          var $siblings = $(this).siblings().trigger("collapse");
          var $content = $(this)?.find("> div").show();

          var id = $(this).attr("id");
          var hash = "#" + id;
          var header_height = $("header").height();

          var top = $(this).offset().top;
          var scroll_position = (top-header_height);

          $("html, body").animate({scrollTop: scroll_position});
          
        });

      $(this)?.find("h2")
        .addClass("clickable")
        .on("click", function(e) {
          e.preventDefault();
          var parentId = $(this).parent().attr("id");
          var hash = "#" + parentId;
          location.hash = $(this).parent().attr("id");
          $(this).trigger("expand");

          if (location.hash != hash)
            window.history.pushState("", $(this).text(), hash);
        });

      $(this).trigger("collapse");
    });

    if (jQuery.inArray(location.hash, sizeGuidesIds) != -1) {
      $(".faq"+ '#size-guide').trigger("expand");
      $([document.documentElement, document.body]).animate({
        scrollTop: $(location.hash).offset().top
      }, 0);
    } else {
      if (location.hash.length > 0) {
        $(".faq"+ location.hash).trigger("expand");
        $([document.documentElement, document.body]).animate({
          scrollTop: $(location.hash).offset().top
        }, 0);
      }
    }

});

function getTimeRemaining(endtime) {
  const total = endtime - Date.now();
  const seconds = Math.floor((total / 1000) % 60);
  const minutes = Math.floor((total / 1000 / 60) % 60);
  const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  const days = Math.floor(total / (1000 * 60 * 60 * 24));

  return {
    total,
    days,
    hours,
    minutes,
    seconds
  };
};

const plural = input => input === 1 ? '' : 's';

const countEl = ({ remaining, labelOne, labelOther }) => {
  const clampedRemaining = Math.max(remaining, 0);

  return `<div class="date-countdown__item">
    <div class="date-countdown__number">${clampedRemaining}</div>
    <div class="date-countdown__label">${clampedRemaining == 1 ? labelOne : labelOther}</div>
  </div>
`};

class DateCountdown extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const endTime = Date.parse(this.getAttribute('end-time'));
    const timeEl = this.querySelector('[data-time]');

    const interval = setInterval(() => {
      const { total, days, hours, minutes, seconds } = getTimeRemaining(endTime);

      const secondsEl = countEl({ remaining: ('0' + Math.max(seconds, 0)).slice(-2), labelOne: 'Sec', labelOther: 'Secs' });
      const minutesEl = countEl({ remaining: minutes, labelOne: 'Min', labelOther: 'Mins' });
      const hoursEl = countEl({ remaining: hours, labelOne: 'Hour', labelOther: 'Hours' });
      const daysEl = countEl({ remaining: days, labelOne: 'Day', labelOther: 'Days' });

      if (total < 0) {
        // this.style.display = 'none';
        clearInterval(interval);
      }

      // if (total < 60000) {
      //   timeEl.innerHTML = secondsEl;
      //   return;
      // }

      // if (total < 3600000) {
      //   timeEl.innerHTML = minutesEl + secondsEl;
      //   return;
      // }

      // if (total < 86400000) {
      //   timeEl.innerHTML = hoursEl + minutesEl + secondsEl;
      //   return;
      // }

      timeEl.innerHTML = daysEl + hoursEl + minutesEl + secondsEl;
    }, 1000);
  }

  disconnectedCallback() {

  }
}

if (!customElements.get("date-countdown")) {
  customElements.define("date-countdown", DateCountdown);
}

// ==== RECOVER FORM ON SIGN IN PAGE
$(document).ready(function() {
  $('#forgot_password_link')
    .each(function() {
      var $container = $(this).parents("#signin");
      var $target = $( $(this).attr("href") );

      $target.hide();

      $(this)
        .on("click", function() {
          $target.show();
          $container.hide();

          return false;
        });
    });
});

/**
 * Search State - closed or open
 * @type {Boolean}
 *
 */

SDG.SearchState = SDG.SearchState || false;

/**
 * Header Dropdown
 * @type {Function}
 * @return init()
 *
 */
SDG.headerDropdown = function () {

  const c = {
    cls: {
      notificationBanner: 'notification-banner',
      accountTrigger: 'js-account',
      cartTrigger: 'js-bag-trigger',
      childElement: 'js-child',
      childIsFadedClass: 'dropdown-nav__link--faded',
      childIsVisibleClass: 'child-is-visible',
      childTrigger: 'js-trigger-child',
      closeSearchTrigger: 'js-close-search',
      countrySwitcher: 'js-country-switcher',
      dropdown: 'js-dropdown',
      dropdownsWrap: 'js-dropdown-wrap',
      fadeMe: 'js-fade-me',
      header: 'js-header',
      logo: 'js-logo',
      mainNav: 'js-main-nav',
      navElement: 'js-dropdown-nav',
      hamburgerOpenClass: 'mobile-nav-trigger--open',
      parentElement: 'js-parent',
      search: 'js-search',
      searchDropdown: 'js-search-dropdown',
      searchInput: 'js-searchspring-input',
      searchIsOpenClass: 'search-is-open',
      isActiveClass: 'is-active',
      isExpandedClass: 'is-expanded',
      isFadedClass: 'is-faded',
      countryDropdown: 'country-current',
      countryDropdownSelector: 'locale-selectors__selector',
    },
    attributes: {
      titleHandle: 'data-title-handle'
    }
  };

  // cached globals
  const $accountTrigger = document.querySelector(`.${c.cls.accountTrigger}`);
  const $body = document.body;
  const $cartTrigger = document.querySelector(`.${c.cls.cartTrigger}`);
  const $notificationBanner = document.querySelector(`.${c.cls.notificationBanner}`);
  const $childs = document.querySelectorAll(`.${c.cls.childElement}`);
  const $navElements = document.querySelectorAll(`.${c.cls.navElement}`);
  const $closeSearch = document.querySelector(`.${c.cls.closeSearchTrigger}`);
  const $countrySwitcher = document.querySelector(`.${c.cls.countrySwitcher}`);
  const $elementsToFade = document.querySelectorAll(`.${c.cls.fadeMe}`);
  const $dropdowns = document.querySelectorAll(`.${c.cls.dropdown}`);
  const $dropdownsWrap = document.querySelector(`.${c.cls.dropdownsWrap}`);
  const $header = document.querySelector(`.${c.cls.header}`);
  const $logo = document.querySelector(`.${c.cls.logo}`);
  const $mainNavs = document.querySelectorAll(`.${c.cls.mainNav}`);
  const $mainNavToggles = document.querySelectorAll(`[data-mega-menu-button]`);
  const $parents = document.querySelectorAll(`.${c.cls.parentElement}`);
  const $search = document.querySelector(`.${c.cls.search}`);
  const $searchDropdown = document.querySelector(`.${c.cls.searchDropdown}`);
  const $searchInput = document.querySelector(`.${c.cls.searchInput}`);
  const $subNavTriggers = document.querySelectorAll(`.${c.cls.childTrigger}`);
  const $countryDropdowns = document.querySelectorAll(`.${c.cls.countryDropdown}`);
  const view = SDG.Viewport.currentState;

  SDG.closeSearch = closeSearch;

  /**
   * init
   */
  function init() {
    addEvents();
  };

  /**
   * Add Events
   */

  function addEvents() {

    $accountTrigger.addEventListener('mouseover', () => hideDropdown());
    $cartTrigger.addEventListener('mouseover', () => hideDropdown());
    $elementsToFade.forEach($element => $element.addEventListener('mouseover', e => fadeOutTheRest(e)));
    $closeSearch.addEventListener('click', () => closeSearch);
    $countrySwitcher?.addEventListener('mouseover', () => hideDropdown());
    $header.addEventListener('mouseleave', () => hideDropdown());
    $logo.addEventListener('mouseover', () => hideDropdown());
    $mainNavs.forEach(nav => nav.addEventListener('mouseover', (e) => toggleDropdown(e)));
    $mainNavToggles.forEach(nav => nav.addEventListener('click', (e) => showDropdownADA(e)));
    $parents.forEach(parent => parent.addEventListener('mouseout', e => resetFade()));
    $parents.forEach(parent => parent.addEventListener('mouseover', e => removeClassOnSiblings(e)));
    $subNavTriggers.forEach(trigger => trigger.addEventListener('mouseover', e => opendSubNav(e)));
    $countryDropdowns.forEach(dropdown => dropdown.addEventListener('keydown', e => onCountryDropdownKeyDown(e)));

    $dropdowns.forEach(dropdown => dropdown.addEventListener('keyup', e => closeDropdown(e)));

    if (view === 'mobile') {
      $search.addEventListener('click', e => openSearch(e));
    } else {
      $search.addEventListener('mouseover', e => openSearch(e));
      $search.addEventListener('click', e => openSearch(e));
    }
  };

  function onCountryDropdownKeyDown(e) {
    e.stopPropagation();
    if (e.key == ' ' || e.key == 'Enter') {
      e.currentTarget.parentElement.querySelector(`select.${c.cls.countryDropdownSelector}`).click();
    }
  };

  /**
   * Focus and open Keybord hack for iOS
   * https://stackoverflow.com/questions/54424729/ios-show-keyboard-on-input-focus
   */
  function focusAndOpenKeyboard(el, timeout) {
    if (!timeout) {
      timeout = 100;
    }
    if (el) {
      var __tempEl__ = document.createElement('input');
      __tempEl__.style.position = 'absolute';
      __tempEl__.style.top = (el.offsetTop + 7) + 'px';
      __tempEl__.style.left = el.offsetLeft + 'px';
      __tempEl__.style.height = 0;
      __tempEl__.style.opacity = 0;

      document.body.appendChild(__tempEl__);
      __tempEl__.focus();

      setTimeout(function () {
        el.focus();
        el.click();

        document.body.removeChild(__tempEl__);
      }, timeout); // timeout to remove temporary added fake input
    }
  }

  /**
   * Open Search Dropdown
   */
  function openSearch(event) {
    const dropdown = findMatchingDropdown(event);

    SDG.closeMobileNav();

    $dropdowns.forEach((dropdown) => {
      const dropDownTitleHandle = dropdown.getAttribute(`data-title-handle`);
      if (dropDownTitleHandle !== 'search') {
        dropdown.classList.remove(`${c.cls.isActiveClass}`);
      };
    });

    $body.classList.add(c.cls.searchIsOpenClass);

    // disable scroll
    if (SDG.Viewport.currentState === 'mobile') {
      bodyScrollLock.disableBodyScroll(dropdown);
      focusAndOpenKeyboard($searchInput, 1000);
    } else {
      setTimeout(() => $searchInput.focus(), 300); // wait until input is visibe
    }

    const bannerHeight = $notificationBanner?.offsetHeight || 0;
    const headerHeight = $header?.offsetHeight || 0;

    dropdown.style.top = `${bannerHeight + headerHeight}px`

    SDG.searchState = true;
    dropdown.classList.add(`${c.cls.isActiveClass}`);
  };

  /**
   * Find Matching Dropdown
   */
  function findMatchingDropdown(event) {
    $target = event.target;
    const navTitleHandle = $target.getAttribute('data-title-handle');
    let dropdown;

    $dropdowns.forEach((element) => {
      const dropDownTitleHandle = element.getAttribute('data-title-handle');

      if (navTitleHandle === dropDownTitleHandle) {
        dropdown = element;
      }
    });

    return dropdown;
  };

  function findMatchingNav(dropdown) {
    if (!dropdown) return null;
    const dropdownTitleHandle = dropdown.getAttribute('data-title-handle');
    let $nav;
    $mainNavs.forEach(element => {
      const navTitleHandle = element.getAttribute('data-title-handle');
      if (navTitleHandle === dropdownTitleHandle) {
        $nav = element;
      }
    });
    return $nav;
  }

  /**
   * Open Sub-Navigation
   */
  function opendSubNav(e) {
    const parent = e.target.parentNode;
    const siblings = getSiblings(parent);

    parent.classList.add(c.cls.childIsVisibleClass);
    siblings.forEach(sibling => sibling.classList.remove(c.cls.childIsVisibleClass));
  };

  /**
   * Reset Navigation State
   */
  function resetNavState() {
    $subNavTriggers.forEach(trigger => trigger.parentNode.classList.remove(c.cls.childIsVisibleClass));
    $elementsToFade.forEach($element => $element.classList.remove(c.cls.isFadedClass));
  };

  /**
   * Toggle Navigation Dropdown
   */
  function toggleDropdown(event) {
    const dropdown = findMatchingDropdown(event);

    resetNavState();

    if (dropdown !== undefined) {
      showDropdown(dropdown);
    } else {
      hideDropdown();
    };
  };

  /**
   * Hide Navigation Dropdown
   */
  function hideDropdown() {
    // $dropdownsWrap.style.height = '0px';
    $header.classList.remove(`${c.cls.isExpandedClass}`);

    $dropdowns.forEach(dropdown => dropdown.classList.remove(`${c.cls.isActiveClass}`));

    closeSearch();
  };

  function showDropdownADA(event) {
    const target = event.target;
    const item = target.previousElementSibling;
    const dropdown = findMatchingDropdown(event);

    if (item.classList.contains('is-active')) {
      target.setAttribute('aria-expanded', 'false');
      hideDropdown();
    } else {
      showDropdown(dropdown);
      target.setAttribute('aria-expanded', 'true');
      setTimeout(() => {
        dropdown.querySelector('a').focus();
      }, 250);
    }
  }

  function closeDropdown(event) {
    if (event.key == "Escape") {
      const $dropdown = event.currentTarget;
      const $nav = findMatchingNav($dropdown);
      hideDropdown();
      if ($nav) {
        $nav.nextElementSibling.setAttribute('aria-expanded', false);
        setTimeout(() => {
          $nav.nextElementSibling.focus();
        }, 250);
      }
    }
  }

  /**
   * Show Navigation Dropdown
   */
  function showDropdown(target) {
    if ($searchDropdown.classList.contains(`${c.cls.isActiveClass}`)) {
      closeSearch();
    }

    let dropdownHeight;
    $dropdowns.forEach((dropdown) => {
      dropdown.classList.remove(`${c.cls.isActiveClass}`);
    })

    dropdownHeight = target.offsetHeight;
    // $dropdownsWrap.style.height = `${dropdownHeight}px`
    target.classList.add(`${c.cls.isActiveClass}`);
    $header.classList.add(`${c.cls.isExpandedClass}`);
  };

  /**
   * Hide Search Dropdown
   */
  function closeSearch() {
    SDG.searchState = false;
    // $dropdownsWrap.style.height = '0px';
    $searchDropdown.classList.remove(`${c.cls.isActiveClass}`);
    $header.classList.remove(`${c.cls.isExpandedClass}`);
    $body.classList.remove(c.cls.searchIsOpenClass);

    // enable scroll
    // bodyScrollLock.enableBodyScroll($dropdownsWrap);
    bodyScrollLock.enableBodyScroll($searchDropdown);

    if ($searchDropdown.contains(document.activeElement)) {
      $searchInput.blur();
    }
  };

  /**
   * Remove Class Visible Class on Siblings
   */
  function removeClassOnSiblings(e) {
    const $parent = e.target.parentNode;
    const $siblings = getSiblings($parent);
    $siblings.forEach(sibling => sibling.classList.remove(c.cls.childIsVisibleClass));

  };

  /**
   * Fade out the rest
   */
  function fadeOutTheRest(e) {
    const $target = e.target;

    $elementsToFade.forEach($element => {
      if ($element !== $target) $element.classList.add(c.cls.isFadedClass);
    });
  };

  /**
   * Reset Fade
   */
  function resetFade() {
    $elementsToFade.forEach(element => element.classList.remove(c.cls.isFadedClass));
  };

  /**
   * Get Siblings
   */
  function getSiblings(element) {
    let siblings = [];
    let sibling = element.parentNode.firstChild;

    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== element) {
        siblings.push(sibling);
      };

      sibling = sibling.nextSibling;
    };

    return siblings;
  };

  /**
   * return
   */
  return init();
};

SDG.headerDropdown();

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector("select");

    this.form = this.querySelector("form");

    this.select.addEventListener("change", () => {
      this.form.submit();
    });
  }
}

if (!customElements.get("localization-form")) {
  customElements.define("localization-form", LocalizationForm);
}

/**
 * Mobile Navigation State - closed or open
 * @type {Boolean}
 * 
 */

SDG.MobileNavState = false;

/**
 * Mobile Navigation
 * @type {Function}
 * @return init()
 * 
 */

SDG.mobileNav = SDG.mobileNav || {};

SDG.mobileNav = function() {

  const c = {
    cls: {
      breadcrumbWithSubchildClass: 'mobile-nav-child__breadcrumbs--with-subchild',
      child: 'mobile-nav-child',
      childBreadcrumb: 'js-child-breadcrumb',
      dropdownWrap: 'js-dropdown-wrap',
      headerWrap: 'js-header-wrap',
      isActiveClass: 'is-active',
      isHiddenClass: 'is-hidden',
      mobielNavTriger: 'js-mobile-nav-trigger',
      mobileBackButton: 'js-mobile-back',
      mobileNav: 'js-mobile-nav',
      mobileNavOpen: 'mobile-nav-is-open',
      mobileNavTriggerOpen: 'mobile-nav-trigger--open',
      mobileNavWrap: 'js-mobile-nav-wrap',
      mobileNavList: 'js-mobile-nav-list',
      nestedElement: 'js-nested',
      nestedInViewClass: 'nested-is-in-view',
      searchIsOpenClass: 'search-is-open',
      subchildBreadcrumb: 'js-sub-child-breadcrumb'
    }
  };

  // cached globals
  const $body = document.body;
  const $mobileNavs = document.querySelectorAll(`.${c.cls.mobileNav}`);
  const $mobileNavsWrap = document.querySelector(`.${c.cls.mobileNavWrap}`);
  const $mobileNavTrigger = document.querySelector(`.${c.cls.mobielNavTriger}`);
  const $mobileBackButtons = document.querySelectorAll(`.${c.cls.mobileBackButton}`);
  const $childBreadcrumbs = document.querySelectorAll(`.${c.cls.childBreadcrumb}`);
  const $headerWrap = document.querySelector(`.${c.cls.headerWrap}`);

  SDG.closeMobileNav = closeMobileNav;

  /**
   * init
   */
  function init() {
    addEvents();
  };

  /**
   * Add Events
   */
  function addEvents() {
    $mobileNavTrigger.addEventListener('click', () => toggleMobileNav());
    $mobileNavs.forEach((nav) => nav.addEventListener('click', mobileNavigation));
    $mobileBackButtons.forEach((button) => button.addEventListener('click', mobileNavGoBack));
    window.addEventListener('resize', resetNavState);
  };

  /**
   * Mobile Navitation
   */
  function mobileNavigation(e) {
    const $parent = e.target.parentNode;
    const $parentSiblings = getSiblings($parent);
    let $childBreadcrumb;
    let $subchildBreadcrumb;
    let subchildWidth;

    $parent.classList.add(c.cls.isActiveClass);
    $parentSiblings.forEach(sibling => sibling.classList.add(c.cls.isHiddenClass));

    $mobileNavsWrap.classList.add(c.cls.nestedInViewClass);


    if ($parent.classList.contains(c.cls.child)) {
      $childBreadcrumb = $parent.parentNode.querySelector(`.${c.cls.childBreadcrumb}`);
      $subchildBreadcrumb = $parent.querySelector(`.${c.cls.subchildBreadcrumb}`);

      subchildWidth = $subchildBreadcrumb.offsetWidth;
      $childBreadcrumb.style.right = `${subchildWidth + 32}px`;
      $childBreadcrumb.classList.add(c.cls.breadcrumbWithSubchildClass);
    }
  };

  /**
   * Mobile Go Back Button
   */
  function mobileNavGoBack(e) {
    const $parent = e.target.parentNode.parentNode.parentNode;
    const $parentSiblings = getSiblings($parent);

    $parent.classList.toggle(c.cls.isActiveClass);
    $parent.classList.remove(c.cls.isHiddenClass);
    $parentSiblings.forEach(sibling => {
      sibling.classList.remove(c.cls.isActiveClass);
      sibling.classList.remove(c.cls.isHiddenClass);
    });

    if (document.querySelector(`.${c.cls.nestedElement}.${c.cls.isActiveClass}`) === null) {
      $mobileNavsWrap.classList.remove(c.cls.nestedInViewClass);
    };

    if ($parent.classList.contains(c.cls.child)) {
      $childBreadcrumb = $parent.parentNode.querySelector(`.${c.cls.childBreadcrumb}`);
      $subchildBreadcrumb = $parent.querySelector(`.${c.cls.subchildBreadcrumb}`);

      subchildWidth = $subchildBreadcrumb.offsetWidth;
      $childBreadcrumb.style.right = '';
      $childBreadcrumb.classList.remove(c.cls.breadcrumbWithSubchildClass);
    };
  };

  /**
   * Mobile Go Back Button
   */
  function toggleMobileNav() {
    const $elements = $mobileNavsWrap.querySelectorAll('li');

    if ($body.classList.contains(c.cls.searchIsOpenClass)) {
      
      SDG.closeSearch();
      // enable scroll
      bodyScrollLock.enableBodyScroll($mobileNavsWrap);
    } else {

      $mobileNavTrigger.classList.toggle(c.cls.mobileNavTriggerOpen);
      $body.classList.toggle(c.cls.mobileNavOpen);
  
      // reset mobile navigation state
      $mobileNavsWrap.classList.remove(c.cls.nestedInViewClass);
      $elements.forEach(element => {
        element.classList.remove(c.cls.isActiveClass);
        element.classList.remove(c.cls.isHiddenClass);
      });
  
      $childBreadcrumbs.forEach(child => {
        child.style.right = '';
        child.classList.remove(c.cls.breadcrumbWithSubchildClass);
      });
  
      if (SDG.MobileNavState === false) {
  
        // disable scroll
        bodyScrollLock.disableBodyScroll($mobileNavsWrap);
  
      } else {
  
        // enable scroll
        bodyScrollLock.enableBodyScroll($mobileNavsWrap);
      };
  
      SDG.MobileNavState = !SDG.MobileNavState;
    }
  };

  /**
   * Close Mobile Navigation
   */
  function closeMobileNav() {
    const $elements = $mobileNavsWrap.querySelectorAll('li');

    $mobileNavTrigger.classList.remove(c.cls.mobileNavTriggerOpen);
    $body.classList.remove(c.cls.mobileNavOpen);

    // reset mobile navigation state
    $mobileNavsWrap.classList.remove(c.cls.nestedInViewClass);
    $elements.forEach(element => {
      element.classList.remove(c.cls.isActiveClass);
      element.classList.remove(c.cls.isHiddenClass);
    });

    $childBreadcrumbs.forEach(child => {
      child.style.right = '';
      child.classList.remove(c.cls.breadcrumbWithSubchildClass);
    });

    bodyScrollLock.enableBodyScroll($mobileNavsWrap);

    SDG.mobileNavState = false;

  };

  function resetNavState() {
    if (SDG.Viewport.currentState === 'desktop') {
      closeMobileNav();
    }
  };

  /**
   * Get Siblings
   */
  function getSiblings(element) {
    let siblings = [];
    let sibling = element.parentNode.firstChild;

    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== element) {
        siblings.push(sibling);
      }
      sibling = sibling.nextSibling;
    }

    return siblings;
  };

  /**
   * return
   */
  return init();

};

SDG.mobileNav();
/**
 * Home Page Featured Collection
 * @type {Function}
 * @return init()
 *
 */

SDG.featuredCollection = function() {

  const featuredCarousels = document.querySelectorAll('.featured-collection');

  featuredCarousels.forEach((featured, index) => {

    const realIndex = index + 1;

    // console.log('carousel #', realIndex);

    const c = {
      cls: {
        cellSelector: `featured-collection-product-${realIndex}`,
        product: `js-product-${realIndex}`
      },

      ids: {
        carousel: `featuredCollectionCarousel-${realIndex}`
      }
    };


    // cached globals
    const $carousel = document.getElementById(`${c.ids.carousel}`);
    const $products = document.querySelectorAll(`.${c.cls.product}`);
    const view = SDG.Viewport.currentState;

    /**
     * init
     */
    function init() {
      if ($carousel) {
        addMargins();
        flickity();
      };
    };


    /**
     * flickity
     */
    function flickity() {
      const settings = {
        cellSelector: `.${c.cls.cellSelector}`,
        cellAlign: 'center',
        pageDots: false,
        prevNextButtons: false,
        setGallerySize: true,
        cellAlign: 'left',
        contain: true,
        wrapAround: true,
        groupCells: true
      }

      SDG.featuredCollectionFlickity = new Flickity($carousel, settings);

      SDG.carouselSelect(SDG.featuredCollectionFlickity);
      SDG.appendButtons(SDG.featuredCollectionFlickity);

      SDG.featuredCollectionFlickity.on('change', function () {
        SDG.carouselSelect(SDG.featuredCollectionFlickity);
        SDG.appendButtons(SDG.featuredCollectionFlickity);
      });
    };

    /**
     * Reinit Flickity
     */
    // function reinitFlickity() {
    //   console.log('destroy everything you touch');
    //   SDG.featuredCollectionFlickity.destroy();
    //   flickity();
    // }

    /**
     * Add Margins
     */
    function addMargins() {
      $products.forEach(($product) => {
        const { mobileMargin, desktopMargin } = $product.dataset;

        if (view === 'mobile') {
          $product.style.marginTop = `${mobileMargin}px`;
        } else {
          $product.style.marginTop = `${desktopMargin}px`;
        }
      })
    }
    /**
     * return
     */
    return init();
  });

  // for each carousel, destroy and reinit flickity on resize
  document.querySelectorAll('.featured-collection').forEach((carousel, index) => {
    var flkty = Flickity.data(`#featuredCollectionCarousel-${index + 1}`)
    window.addEventListener('resize', () => {
      flkty.reloadCells();
    });
  });


  //divs with class "featured-colllection__arrow" and class "prev" get an event listener on click to go to the previous slide
  document.querySelectorAll('.featured-collection__arrow.prev').forEach((arrow, index) => {
    var flkty = Flickity.data(`#featuredCollectionCarousel-${index + 1}`)
    arrow.addEventListener('click', () => {
      flkty.previous();
    });
  });

  document.querySelectorAll('.featured-collection__arrow.next').forEach((arrow, index) => {
    var flkty = Flickity.data(`#featuredCollectionCarousel-${index + 1}`)
    arrow.addEventListener('click', () => {
      flkty.next();
    });
  });
  

};

SDG.featuredCollection();


document.addEventListener('load', () => {
  window.dispatchEvent(new Event('resize'));
})

/**
 * HP UGC Carousel
 * @type {Function}
 * @return init()
 *
 */

 SDG.featuredugc = function() {

  const c = {
    cls: {
      cellSelector: 'featured-ugc-product',
      product: 'js-product-ugc'
    },

    ids: {
      carousel: 'featuredugcCarousel'
    }
  };

  // cached globals
  const $carousels = document.querySelectorAll(`#${c.ids.carousel}`);
  const $products = document.querySelectorAll(`.${c.cls.product}`);
  const view = SDG.Viewport.currentState;

  /**
   * init
   */
  function init() {
    if ($carousels.length > 0) {
      addMargins();
      flickity();
      addEvents();
    };
  };

  /**
   * Add Events
   */
  function addEvents() {
    window.addEventListener('resize', reinitFlickity);
  }


  /**
   * flickity
   */
  function flickity() {
    const settings = {
      cellSelector: `.${c.cls.cellSelector}`,
      cellAlign: 'left',
      arrowShape: {
        x0: 10,
        x1: 60, y1: 50,
        x2: 65, y2: 50,
        x3: 15
      },
      wrapAround: true,
      pageDots: false,
      prevNextButtons: true,
    }


    $carousels.forEach(($carousel, index) => {
      SDG[`featuredugcFlickity-${index}`] = new Flickity($carousel, settings);

      SDG.carouselSelect(SDG[`featuredugcFlickity-${index}`]);
      SDG.appendButtons(SDG[`featuredugcFlickity-${index}`]);

      SDG[`featuredugcFlickity-${index}`].on('change', function () {
        SDG.carouselSelect(SDG[`featuredugcFlickity-${index}`]);
        SDG.appendButtons(SDG[`featuredugcFlickity-${index}`]);
      });
    })

    
  };

  /**
   * Reinit Flickity
   */
  function reinitFlickity() {

    $carousels.forEach(($carousel, index) => {
      SDG[`featuredugcFlickity-${index}`].destroy();
    });
    flickity();
  }

  /**
   * Add Margins
   */
  function addMargins() {
    $products.forEach(($product) => {
      const { mobileMargin, desktopMargin } = $product.dataset;

      if (view === 'mobile') {
        $product.style.marginTop = `${mobileMargin}px`;
      } else {
        $product.style.marginTop = `${desktopMargin}px`;
      }
    })
  }

  /**
   * return
   */
  return init();
};

SDG.featuredugc();

/**
 * Home Page Hero
 * @type {Function}
 * @return init()
 *
 */

SDG.homepageHero = function () {
  const c = {
    cls: {
      bagIcon: "icon--bag",
      sliderDot: "dot",
      headerWrap: "header-wrap",
      heroSlide: "hero-slide",
      logo: "js-logo",
      mainNav: "main-nav",
      mobileNavTriggerChild: "js-mobile-nav-trigger-child",
      searchIcon: "icon--search",
      slide: "hero-slide",
      utilNav: "util-nav",
    },
    ids: {
      carousel: "heroCarousel",
      heroVideo: "hero-video",
    },
    attributes: {
      timing: "data-timing",
    },
  };

  // cached globals
  const $slides = document.querySelectorAll(`.${c.cls.slide}`);
  const $heroCarousel = document.querySelector(`#${c.ids.carousel}`);
  const $heroVideo = document.querySelector(`#${c.ids.heroVideo}`);
  const $header = document.querySelector(`.${c.cls.headerWrap}`);
  const $logo = $header.querySelector(`.${c.cls.logo}`);
  const $bagPath = $header.querySelector(`.${c.cls.bagIcon} path`);
  const $searchIconPath = $header.querySelector(`.${c.cls.searchIcon} path`);
  const $mainNav = $header.querySelector(`.${c.cls.mainNav}`);
  const $utilNav = $header.querySelector(`.${c.cls.utilNav}`);
  const $mobileNavTriggerChilds = document.querySelectorAll(
    `.${c.cls.mobileNavTriggerChild}`
  );
  let $dots;
  let heroTiming;

  if ($heroCarousel) {
    heroTiming = $heroCarousel.getAttribute(`${c.attributes.timing}`);
  }

  /**
   * init
   */
  function init() {
    if ($heroCarousel) {
      flickity();
      updateDotsAndNavigationColor();
    }

    if ($heroVideo) {
      updateNavColor();
    }
  }

  /**
   * Init Flicity
   */
  function flickity() {
    const settings = {
      cellSelector: `.${c.cls.heroSlide}`,
      pageDots: $slides.length > 1,
      prevNextButtons: true,
      wrapAround: true,
      autoPlay: heroTiming * 1000,
      pauseAutoPlayOnHover: false,
      adaptiveHeight: true,
      fade: true,
      setGallerySize: true,
      imagesLoaded: true,
      lazyLoad: true,
      on: {
        ready: function () {
          console.log('sdf', $heroCarousel);
          $dots = $heroCarousel.querySelectorAll(`.${c.cls.sliderDot}`);
          $heroCarousel.setAttribute('tabindex', '-1');
          const $btns = $heroCarousel.querySelectorAll(`.flickity-prev-next-button`);
          $btns.forEach((btn) => {
            btn.setAttribute('tabindex', '-1');
            btn.setAttribute('aria-hidden', 'true');
          });
          const slideText = $heroCarousel.querySelector(`.hero-slide__text-cta`);
          if (slideText) {
            slideText.setAttribute('tabindex', '-1');
            slideText.setAttribute('aria-hidden', 'true');
          }
        },
        change: function (index) {
          updateDotsAndNavigationColor(index);
        },
      },
    };

    const flkty = new Flickity(`#${c.ids.carousel}`, settings);

    SDG.carouselSelect(flkty);
    SDG.appendButtons(flkty);

    flkty.on("change", function () {
      SDG.carouselSelect(flkty);
      SDG.appendButtons(flkty);
    });
  }

  /**
   * Update Hero Elements Colors Per Active Slide
   */
  function updateDotsAndNavigationColor(index) {
    if (index === undefined) {
      index = 0;
    }

    console.log($heroCarousel)
    const $activeSlide = $slides[index];
    if ($activeSlide) {
      let slideStyleColor = $activeSlide.dataset.styleColor;
      let dotsColor = $activeSlide.dataset.dotsColor;

      // update flickity dots color
      $dots.forEach((dot) => (dot.style.color = dotsColor));

      if (document.querySelector('.main > .shopify-section-hero-carousel') != document.querySelector('.main').children[1]) {
        return;
      }

      SDG.updateNavigationColor(slideStyleColor);
    }
  }

  /**
   * Update Nav Colors if Hero Video
   */
  function updateNavColor() {
    const navColor = $heroVideo.dataset.getcolor;

    SDG.updateNavigationColor(navColor);
  }

  /**
   * return
   */
  return init();
};

SDG.homepageHero();

/**
 * Expanding touts
 * @type {Function}
 * return init()
 * 
 */

SDG.expandingTouts = function() {

  const c = {
    cls: {
      tout: 'js-tout',
      toutsWrap: 'js-expanding-touts',
      isActiveClass: 'tout--active'
    }
  }

  // cached globals
  const $touts = document.querySelectorAll(`.${c.cls.tout}`);
  const $toutsWrap = document.querySelector(`.${c.cls.toutsWrap}`);

  /**
   * init
   */
  function init() {
    if ($toutsWrap) addEvents();
  };

  /**
   * Add Events
   */
  function addEvents() {

    if ($touts) {
      $touts.forEach((tout) => {
        tout.addEventListener('mouseover', expandTout);
      });
    };
  };

  /**
   * Expand Tout
   */
  function expandTout(e) {
    const $target = e.target;
    const $parent = $target.closest(`.${c.cls.tout}`);
    const siblings = getSiblings($parent);
    siblings.forEach(sibling => sibling.classList.remove(c.cls.isActiveClass));
    $parent.classList.add(c.cls.isActiveClass);
  };

  /**
   * Get Siblings
   */
  function getSiblings(elem) {

    // Setup siblings array and get the first sibling
    let siblings = [];
    let sibling = elem.parentNode.firstChild;

    // Loop through each sibling and push to the array
    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== elem) {
        siblings.push(sibling);
      };
      sibling = sibling.nextSibling;
    };

    return siblings;
  };

  /**
   * return
   */
  return init();
};

SDG.expandingTouts();
// MOBILE MENU
$(document).ready(function () {
  // Do not generate 'View all or Featured'
  // Use object handles
  var direct_mobile_collections = [
    'stores'
  ]
  // Collections which should show 'Featured' instead of 'View All'
  // Use object handles
  var featured_mobile_collections = [
    'clutches',
    'crossbody-bags',
    'flats',
    'heels',
    'loafers',
    'shoulder-bags',
    'top-handles',
    'tote'
  ]

  $('body.with-mobile-menu .header').each(function () {

    var $user_menu    = $('#user-menu').clone()
    var $main_menu    = $('#main-menu').clone()

    var $mobile_menu  = $('<div id="mobile-menu" />')
    var $mobile_menu_scroller = $('<div class="scroller" />')
    var $mobile_menu_wrapper = $('<div class="wrapper" />')
      .append($user_menu)
      .append($main_menu)

    $mobile_menu_scroller
      .append($mobile_menu_wrapper)

    $mobile_menu
      .append($mobile_menu_scroller)

    $mobile_menu
      .on('mm:show', function () {
        $(this)
          .addClass('open')
      })
      .on('mm:hide', function () {
        $(this)
          .removeClass('open')
      })
      .on('mm:toggle', function () {
        $(this)
          .toggleClass('open')
      })
      .on('mm:back', 'a.back', function (e) {
        var level = $(this).parents('li').length - 1
        $mobile_menu_wrapper.css({transform: 'translate(' + (level*-100) + '%, 0)'})

        if ($(this).parents('ul').length === 1) {
          $mobile_menu.removeClass('is-navigating')
        }

        $(this).parents('li')
          .first()
          .removeClass('active current')

        $(this).parents('li')
          .filter('.active')
          .first()
          .addClass('current')
      })
      .on('mm:open', 'nav > a.main, nav > a.open', function (e) {
        var level = $(this).parents('li').length
        $mobile_menu_wrapper.css({transform: 'translate(' + level * -100 + '%, 0)'})
      })
      .on('mm:open', 'li > a.active, li > a.final', function (e) {
        var level = $(this).parents('li').length - 1
        $mobile_menu_wrapper.css({transform: 'translate(' + level * -100 + '%, 0)'})
      })
      .on('mm:open', 'a.main, a.open, a.final', function (e) {
        $mobile_menu.addClass('is-navigating')

        $main_menu
          .find('li')
          .removeClass('current')

        $(this)
          .parents('li')
          .addClass('active')
          .filter('.has-children')
          .first()
          .addClass('current')
      })
      .on('click', 'a.back', function (e) {
        e.preventDefault()
        $(this).trigger('mm:back')
      })
      .on('click', 'a.main:not(.is-direct), a.open, a.final, a[href^="#"]', function (e) {
        e.preventDefault()
        $(this).trigger('mm:open')
      })

    // Collection matching menues from collection menu
    $main_menu
      .find('a')
      .wrapAll('<ul />')
      .wrap('<li />')
      .each(function () {
        var $a = $(this)
        var handle = $a.data('title-handle')
        var $collection_menu_ul = $('li[data-title-handle="' + handle + '"] > ul').first().clone()
        $a.after($collection_menu_ul)
      })

    // Add some interaction to the menu entries
    $main_menu
      .find('a + ul')
      .each(function () {
        var $ul = $(this)
        var $first_li = $ul.find('li').first()
        var $a = $ul.prev('a')
        var a_title_handle = $a.data('title-handle')
        var a_object_handle = $a.data('object-handle')
        var $child_a_with_same_handle = $ul.find('a[data-title-handle="' + a_title_handle + '"], a[data-object-handle="' + a_object_handle + '"]')
        var level = $(this).parents('li').length

        $a.addClass('main is-proxy')
          .wrap('<nav class="breadcrumb" />')
          .wrapInner('<span />')
          .before($('<a href="#back" class="back">Back</a>'))
          .after($('<a href="#open" class="open">+</a>'))

        if (direct_mobile_collections.includes(a_title_handle)) {
          $a.addClass('is-direct')
            .removeClass('is-proxy')
        } else if ($child_a_with_same_handle.length === 0 &&
                   a_title_handle !== '') {
          var $main_link = $a.clone()
          var $view_link = $main_link.removeClass('main is-proxy')

          if (level === 1 || featured_mobile_collections.includes(a_object_handle)) {
            $view_link.text('Featured')
          } else {
            $view_link.text('View All')
          }

          // $first_li.before(
          //   $('<li />').append($view_link.clone())
          // )
        }

        $a.parents('li')
          .addClass('has-children')
      })

    $mobile_menu
      .find('a.final, a.active.main')
      .first()
      .trigger('mm:open')

    $(this).append($mobile_menu)

    // CART ICON

    var $cart_link = $user_menu.find('.customer_cart_link')
    $(this)
      .append($cart_link)

  })
})

$(document).ready(function () {
  let $previousEl;
  $('.modal, .notice, .new-modal')
    .on('modal:hide', function () {
      $(this).hide()
      $('body').removeClass('modal--active');
      if ($previousEl[0]) {
        $previousEl[0].focus();
      }
    })
    .on('modal:show', function () {
      $(this).show()
      $('body').addClass('modal--active')
      const $wrap = $(this).closest('.care__material');
      $previousEl = $wrap.find('[data-modal-trigger]');
      SDG.trapFocus(this)
    })
    .each(function () {
      var $notice = $(this)
      // var $dialog = $notice.find('.dialog, > div')
      var id = $(this).attr('id')

      $notice
        .hide()
        .on('click', function (ev) {
          if ($(ev.target).is('.notice, a.back, a.back *')) {
            $notice.trigger('modal:hide')

            return false
          }
        })

      $("a[href='#" + id + "']:not(.no-modal), input[data-rel='#" + id + "']")
        .on('click', function (e) {
          e.preventDefault();
          $notice.trigger('modal:show')
        })
    })
})

/**
 * Notification Banner State 
 * @type {Boolean}
 * 
 */
SDG.NotificationBannerState = SDG.NotificationBannerState || false

/**
 * Notification Banner
 * @type {Function}
 * @return init()
 * 
 */
SDG.notificationBanner = function() {
  const c = {
    cls: {
      notificationBannerEnabledClass: 'notification-banner-enabled',
      notificationBannerFlickity: 'notification-banner-flickity',
      headerWrap: 'js-header-wrap',
      flickitySlide: 'text',
    },
    ids: {
      notificationBanner: 'notificationBanner' 
    },
    attributes: {
      timing: 'data-timing'
    }
  }
  // cached globals
  const $headerWrap = document.querySelector(`.${c.cls.headerWrap}`);
  const $notificationBannerCarousel = document.querySelector(`.${c.cls.notificationBannerFlickity}`);
  const $notificationBanner = document.querySelector(`#${c.ids.notificationBanner}`);
  let flkty = null;
  let sliderTiming;

  if ($notificationBannerCarousel) {
    sliderTiming = $notificationBanner.getAttribute(`${c.attributes.timing}`);
  }

  /**
   * init
   */
  function init() {
    if ($notificationBannerCarousel) {

      // delay until global-e css will load
      setTimeout(() => {
        flickity($notificationBannerCarousel);
      }, 1000)
    }

    notificationBannerCheck();
  };

  function flickity(target) {

    const flickitySettings = {
      pageDots: false,
      prevNextButtons: false,
      wrapAround: true,
      autoPlay: sliderTiming * 1000,
      cellSelector: `.${c.cls.flickitySlide}`,
      on: {
        ready: function() {
        },
        change: function(index) {
          this.cells.forEach((cell, i) => {
            if (i == index) {
              cell.element.querySelectorAll('[href]').forEach(el => el.tabIndex = 0);
            } else {
              cell.element.querySelectorAll('[href]').forEach(el => el.tabIndex = -1);
            }
          });
        }
      }
    };

    flkty = new Flickity(target, flickitySettings);

    SDG.NotificationBannerState = true;
  };

  function notificationBannerCheck() {
    if (SDG.NotificationBannerState === true) {
      $headerWrap.classList.add(`${c.cls.notificationBannerEnabledClass}`)
    }
  };

  /**
   * return
   */
  return init();
};

SDG.notificationBanner();

class ProductATCSizer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setHeightVar = () => {
      document.documentElement.style.setProperty('--height-product-atc', `${this.getBoundingClientRect().height}px`);
    };

    this.setHeightVar();

    setTimeout(() => {
      this.setHeightVar();
    }, 2000);

    window.addEventListener('resize', this.setHeightVar);

    this.observer = new MutationObserver(this.setHeightVar);

    this.observer.observe(this, { childList: true, subtree: true, attributes: true, characterData: true });
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.setHeightVar);
    this.observer.disconnect();
  }
}

if (!customElements.get("product-atc-sizer")) {
  customElements.define("product-atc-sizer", ProductATCSizer);
}

/**
 * Product Tabs
 *
 * This was ported from legacy code and only
 * (barely) works for a single instance on the page.
 */

class ProductTabs extends HTMLElement {
  constructor() {
    super();

    this.c = {
      dom: {
        sizingContent: 'sizing-content',
        jsModal: 'js-modal',
        modal_overlay: 'js-modal-overlay',
      },
      cls: {
        tabs_wrap: 'js-product-tabs',
        tab_content: 'js-tab-content',
        mobile_tab_content: 'js-mobile-tab-content',
        tab: 'js-product-tab',
        is_active: 'is-active',
        scroll_down: 'js-product-scroll-down',
        scroll_down_short_device: 'js-product-scroll-down-short-device',
        scroll_here: 'js-scroll-here',
        is_ready: 'is-ready',
        size_guide_link: 'product-tabs__size_guide-link',
        js_trigger_size_guide: 'js-trigger-size-guide',
        modal_is_open_class: 'modal-is-open',
      }
    }

    // cached globals
    this.$productTabs = document.querySelectorAll(`.${this.c.cls.tab}`);
    this.$productTabsWrap = document.querySelectorAll(`.${this.c.cls.tab}`);
    this.$productTabContent = document.querySelectorAll(`.${this.c.cls.tab_content}`);
    this.$productMobileTabContent = document.querySelectorAll(`.${this.c.cls.mobile_tab_content}`);
    this.$productScrollDown = document.querySelector(`.${this.c.cls.scroll_down}`);
    this.$productScrollDownShortDevice = document.querySelector(`.${this.c.cls.scroll_down_short_device}`);
    this.$productScrollHere = document.querySelector(`.${this.c.cls.scroll_here}`);
    this.view = SDG.Viewport.currentState;
    this.$jsModals = document.querySelectorAll(`.${this.c.dom.jsModal}`);

    // This doesn't work and doesn't seem to be required
    // this.handleResize = () => this.resetTabsState(0);

    this.handleScrollDownClick = () => this.scrollDown();

    if (this.$productTabsWrap) {
      this.$productTabs.forEach((tab) => {
        tab.addEventListener('click', (e) => this.showTab(e.target));

        tab.addEventListener('keydown', (e) => {
          const arrowKeys = e.keyCode === 37 || e.keyCode === 38 || e.keyCode === 39 || e.keyCode === 40;
          if (arrowKeys) {
            SDG.tabArrow(e, this.$productTabs);
          }
        });
      })

      if (this.$productTabs.length > 0) {
        this.showTab(this.$productTabs[0]);
      }
    }
  }

  connectedCallback() {
    if (this.$productScrollDown) {
      this.$productScrollDown.addEventListener('click', this.handleScrollDownClick);
    }
    if (this.$productScrollDownShortDevice) this.$productScrollDownShortDevice.addEventListener('click', this.handleScrollDownClick);

    // window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    // window.removeEventListener('resize', this.handleResize);
    this.$productScrollDown?.removeEventListener('click', this.handleScrollDownClick);
    this.$productScrollDownShortDevice?.removeEventListener('click', this.handleScrollDownClick);
  }

  /**
   * Show Tab
   */
  showTab($target) {
    const tabName = $target.getAttribute('data-tab');
    let $content;
    let mobileTabContentName;
    let contentHeight;

    // adds size guide button if sizing is clicked on
    if (tabName === 'sizing') {
      // Add Size Guide Button function
      const product_id = $target.dataset.productId;

      let existing_size_guide = false;
      this.$jsModals.forEach(modal => {
        if (modal.dataset.productId == product_id) {
          existing_size_guide = true;
        }
      });
      if (existing_size_guide) {
        this.addSizeGuideBtn(product_id);
      }
    }

    if (this.view === 'mobile') {
      $content = $target.nextSibling.nextSibling;
      mobileTabContentName = $content.getAttribute('data-tab');

      if (tabName === mobileTabContentName && $content.classList.contains(this.c.cls.is_active)) {
        this.resetTabsState();
      } else {
        this.resetTabsState();
        $target.classList.add(this.c.cls.is_active);
        $content.classList.add(this.c.cls.is_active);
        $content.setAttribute('tabindex', 0);

        window.requestAnimationFrame(() => {
          const contentHeight = $content.offsetHeight;
          if (contentHeight === 0) {
            // Add 20px to allow for content padding
            $content.style.height = `${$content?.scrollHeight + 20}px`;
          } else {
            $content.style.height = `${$content.offsetHeight + 20}px`;
          }
        });
      }

    } else {
      this.resetTabsState();
      this.$productTabContent.forEach(($tabContent) => {
        const tabContentName = $tabContent.getAttribute('data-tab');

        if (tabName === tabContentName) {
          const contentHeight = $tabContent.offsetHeight;
          $tabContent.classList.add(this.c.cls.is_active);

          // set arrow posistion based on content height
          if (contentHeight !== 0 && this.$productScrollDown) {
            const position = 150 - contentHeight - 45;
            this.$productScrollDown.classList.add(this.c.cls.is_ready);
            this.$productScrollDown.style.bottom = `${position}px`;
            this.$productScrollDownShortDevice && this.$productScrollDownShortDevice.classList.add(this.c.cls.is_ready);
          }
        }
      });

      $target.classList.add(this.c.cls.is_active);
      $target.setAttribute('aria-selected', true);
      $target.removeAttribute('tabindex');
    }
  }

  /**
   * Add Size Guide Button
   */
  addSizeGuideBtn(product_id) {
    const $sizingContents = document.querySelectorAll(`.${this.c.dom.sizingContent}`);
    $sizingContents.forEach($sizingContent => {
      const existing_btn = $sizingContent.querySelector('button');
      if (existing_btn) {
        existing_btn.remove();
      }
      // add size guide button only once
      const sizeGuideBtn = document.createElement('button');
      sizeGuideBtn.setAttribute('type', 'button');
      // adds class, innerHTML and appends element
      sizeGuideBtn.classList.add(this.c.cls.size_guide_link, this.c.cls.js_trigger_size_guide);
      sizeGuideBtn.innerHTML = `
        <svg class="icon-ruler" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.9788 4.18066L12.1194 1.32129C12.0754 1.2769 12.0155 1.25195 11.953 1.25195C11.8905 1.25195 11.8306 1.2769 11.7866 1.32129L1.521 11.5869C1.47661 11.6309 1.45166 11.6908 1.45166 11.7533C1.45166 11.8158 1.47661 11.8757 1.521 11.9197L4.38037 14.7791C4.42461 14.8229 4.48447 14.8474 4.54677 14.8471C4.60883 14.8462 4.66826 14.8219 4.71317 14.7791L6.17805 13.3118L13.5117 5.97821L14.9789 4.51334C15.0233 4.46935 15.0483 4.40943 15.0483 4.34694C15.0483 4.28445 15.0233 4.22453 14.9789 4.18054L14.9788 4.18066ZM13.3382 5.48141L12.6796 4.81579C12.6357 4.77214 12.5763 4.74763 12.5143 4.74763C12.4524 4.74763 12.393 4.77214 12.3491 4.81579C12.3047 4.85978 12.2798 4.9197 12.2798 4.98219C12.2798 5.04468 12.3047 5.1046 12.3491 5.14859L13.0147 5.81421L11.8803 6.94859L10.8139 5.88453C10.7701 5.84087 10.7106 5.81636 10.6487 5.81636C10.5868 5.81636 10.5274 5.84087 10.4835 5.88453C10.4398 5.92842 10.4153 5.98785 10.4153 6.04976C10.4153 6.11168 10.4398 6.1711 10.4835 6.215L11.5475 7.27906L10.4132 8.41579L9.74753 7.75016C9.70354 7.70578 9.64363 7.68083 9.58113 7.68083C9.51864 7.68083 9.45872 7.70578 9.41473 7.75016C9.37108 7.79406 9.34657 7.85348 9.34657 7.9154C9.34657 7.97732 9.37108 8.03674 9.41473 8.08064L10.0804 8.75329L8.95301 9.88064L7.88895 8.81658C7.84495 8.77219 7.78504 8.74724 7.72255 8.74724C7.66005 8.74724 7.60013 8.77219 7.55615 8.81658C7.51249 8.86047 7.48798 8.9199 7.48798 8.98181C7.48798 9.04373 7.51249 9.10315 7.55615 9.14705L8.62255 10.2135L7.48582 11.3478L6.8202 10.6822C6.7763 10.6385 6.71688 10.614 6.65496 10.614C6.59304 10.614 6.53362 10.6385 6.48972 10.6822C6.44534 10.7262 6.42039 10.7861 6.42039 10.8486C6.42039 10.9111 6.44534 10.971 6.48972 11.015L7.15535 11.6806L6.02097 12.815L4.95457 11.7486C4.91068 11.7049 4.85125 11.6804 4.78933 11.6804C4.72742 11.6804 4.668 11.7049 4.6241 11.7486C4.57971 11.7926 4.55476 11.8525 4.55476 11.915C4.55476 11.9775 4.57971 12.0374 4.6241 12.0814L5.67175 13.1455L4.54675 14.2822L2.01787 11.7533L11.953 1.81819L14.4819 4.34706L13.3382 5.48141Z" fill="currentColor"/>
        </svg>
        Size Guide
      `;
      sizeGuideBtn.dataset.productId = product_id;
      $sizingContent.appendChild(sizeGuideBtn);
    });

  }

  /**
   * Scroll Down
   */
  scrollDown() {

    // Scroll to a certain element
    this.$productScrollHere.scrollIntoView({
      behavior: 'smooth'
    });
  }

  resetTabsState(activeTab) {
    this.$productTabs.forEach(($tab) => {
      $tab.classList.remove(this.c.cls.is_active);
      $tab.setAttribute('aria-selected', false);
      $tab.setAttribute('tabindex', -1);
    });

    this.$productTabContent.forEach(($tabContent) => {
      $tabContent.classList.remove(this.c.cls.is_active);
      $tabContent.setAttribute('tabindex', -1);
    });

    this.$productMobileTabContent.forEach(($tabContent) => {
      $tabContent.classList.remove(this.c.cls.is_active);
      $tabContent.style.height = '0px';
    });

    // This doesn't work if you want the first tab (index 0)
    if (activeTab) {
      this.$productTabs[activeTab].classList.add(this.c.cls.is_active);
      this.$productTabContent[activeTab].classList.add(this.c.cls.is_active);
    };
  }
}

if (!customElements.get("product-tabs")) {
  customElements.define("product-tabs", ProductTabs);
}

/**
 * Product Collections
 * @type {function}
 */

SDG.productCollections = function() {

  const c = {
    cls: {
      is_active: 'is-active',
      is_hidden: 'is-hidden',
      recently_viewed_carousel: 'js-recently-viewed-carousel',
      recently_vivewed_product: 'js-collection-product',
      related_carousel: 'js-related-carousel',
      related_product: 'js-related-product',
      tab_content: 'js-product-collection-content',
      tab: 'js-product-collection-tab',
      tabs_wrap: 'js-product-tabs',
      product_collections: 'js-product-collections',
    },
    attributes: {
      recently_viewed: 'data-tab="recently-viewed"'
    }
  }

  // cached globals
  const $productTabs = document.querySelectorAll(`.${c.cls.tab}`);
  const $productTabContent = document.querySelectorAll(`.${c.cls.tab_content}`);
  const $relatedCarousel = document.querySelector(`.${c.cls.related_carousel}`);
  const $relatedProducts = document.querySelectorAll(`.${c.cls.related_product}`);
  const $productCollections = document.querySelector(`.${c.cls.product_collections}`);
  let recentlyViewed = JSON.parse(localStorage.getItem('recently-viewed-products')) || [];
  let recentlyViewedIsEmpty = recentlyViewed.length === 0;
  let observers = [];
  let observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.85,
  };

  /**
   * init
   */
  function init() {
    addEvents();
    showHideCollections();

    if ($relatedCarousel) relatedCarousel();

    intersectionHandle();
    
    document.addEventListener('scroll', e => {
      intersectionHandle();
    })

    const collectionContent = document.querySelector('.js-product-collection-content');
    if (collectionContent) {
      collectionContent.addEventListener('scroll', e => {
        intersectionHandle();
      })
    }
  };

  function intersectionHandle() {
    for (let i = 0; i < $relatedProducts.length; i++) {
      // Set up the observer for this box
  
      // observerOptions.threshold = thresholdSets[i];
      observers[i] = new IntersectionObserver(
        intersectionCallback,
        observerOptions,
      );
      observers[i].observe($relatedProducts[i]);
    }
  }

  intersectionCallback = (entries) => {
    entries.forEach((entry) => {
      let box = entry.target;
      let visiblePct = Math.floor(entry.intersectionRatio * 100);
      
      if (visiblePct == 100 ) {
        box.removeAttribute('aria-hidden');
        // box.removeAttribute('tabindex');
      } else {
        box.setAttribute('aria-hidden', true);
        // box.setAttribute('tabindex', '-1');
      }
    });
  };
  /**
   * Add Events
   */
  function addEvents() {
    if ($productTabs) {
      $productTabs.forEach(($tab) => {
        $tab.addEventListener('click', showTab);
        $tab.addEventListener('keydown', onKeydownEvent);
      });
    }
  }

  /**
   * Add Events
   */
  function showHideCollections() {
    const $recentlyViewedElements = document.querySelectorAll(`[${c.attributes.recently_viewed}]`);
    let viewedElementsHidden;
    let relatedElementsHidden;

    if (recentlyViewedIsEmpty) {
      $recentlyViewedElements.forEach(($element) => $element.classList.add(c.cls.is_hidden));
      if ($productCollections) $productCollections.setAttribute('data-viewed', false);
    }

    if ($productCollections) {
      viewedElementsHidden = $productCollections.getAttribute('data-viewed');
      relatedElementsHidden = $productCollections.getAttribute('data-related');
    }

    // Now using Glood widget so these should always show.
    // if (viewedElementsHidden && relatedElementsHidden) $productCollections.classList.add(c.cls.is_hidden);
  }

  /**
   * Init Related Carousel
   */
  function relatedCarousel() {
    const triggerCarousel = $relatedProducts.length > 4;
    let carousel;
    const settings = {
      cellAlign: 'left',
      arrowShape: {
        x0: 10,
        x1: 60, y1: 50,
        x2: 65, y2: 50,
        x3: 15
      },
      wrapAround: true,
      pageDots: false,
      prevNextButtons: true,
      percentPosition: false,
      watchCSS: true
    }

    if ($relatedCarousel && triggerCarousel) carousel = new Flickity($relatedCarousel, settings);
  }

  /**
   * Show Tab
   */
  function showTab(e) {
    const $target = e.target;
    const tabName = $target.getAttribute('data-tab');

    $productTabs.forEach(($tab) => {
      $tab.classList.remove(c.cls.is_active);
      $tab.setAttribute('aria-selected', false);
      $tab.setAttribute('tabindex', '-1');
    });
    $target.classList.add(c.cls.is_active);
    $target.setAttribute('aria-selected', true);
    $target.removeAttribute('tabindex');

    $productTabContent.forEach(($content) => {
      const contentName = $content.getAttribute('data-tab');
      if (contentName === tabName) {
        $content.classList.add(c.cls.is_active);
        $content.setAttribute('tabindex', 0);
      } else {
        $content.classList.remove(c.cls.is_active);
        // $content.removeAttribute('tabindex');
      }
    });
  };


  function moveFocusToTab(currentTab) {
    currentTab.focus();
  }

  function moveFocusToPreviousTab(currentTab) {
    var index;

    if (currentTab === $productTabs[0]) {
      moveFocusToTab($productTabs[$productTabs.length-1]);
    } else {
      index = [...$productTabs].indexOf(currentTab);
      moveFocusToTab($productTabs[index - 1]);
    }
  }

  function moveFocusToNextTab(currentTab) {
    var index;

    if (currentTab === $productTabs[$productTabs.length-1]) {
      moveFocusToTab($productTabs[0]);
    } else {
      index = [...$productTabs].indexOf(currentTab);
      moveFocusToTab($productTabs[index + 1]);
    }
  }

  function onKeydownEvent(event) {
    var tgt = event.currentTarget,
      flag = false;

    switch (event.key) {
      case 'ArrowLeft':
        moveFocusToPreviousTab(tgt);
        flag = true;
        break;

      case 'ArrowRight':
        moveFocusToNextTab(tgt);
        flag = true;
        break;

      case 'Home':
        moveFocusToTab($productTabs[0]);
        flag = true;
        break;

      case 'End':
        moveFocusToTab($productTabs[$productTabs.length-1]);
        flag = true;
        break;

      default:
        break;
    }

    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }
  /**
   * return
   */
  return init();
};

SDG.productCollections();

/**
 * Product Monogramming
 * @type {function}
 */
SDG.MiniCart = SDG.MiniCart || {};

SDG.productMonogramming = function (reset) {

  const c = {
    cls: {
      add_to_cart_button: 'js-monogramming-add',
      add_to_cart_button_text: 'js-add-to-cart-text',
      added_class: 'added',
      additions: 'js-additions',
      back_button: 'js-back-button',
      button: 'js-monogramming-button',
      close_button: 'js-close-monogram-modal',
      color_headline: 'js-color-headline',
      color_swatch: 'js-monogramming-swatch',
      current_step: 'js-current-step',
      font_size: 'js-font-size',
      font_style_select: 'js-monogramming-font',
      position_select: 'js-monogramming-position',
      initials_preview_class: 'monogramming__preview-initials',
      is_active_class: 'is-active',
      has_value_class: 'has-value',
      is_expanded_class: 'is-expanded',
      hidden_class: 'hidden',
      is_visible_class: 'is-visible',
      letter_input: 'js-monogramming-letter-input',
      letter_left: 'js-letter-left',
      letter_center: 'js-letter-center',
      letter_right: 'js-letter-right',
      letter: 'js-letter',
      letters: 'js-letters',
      main_product_add_to_cart_button: 'js-add-to-cart',
      mobile_note: 'js-monogramming-note',
      monogram_open_class: 'monogram-modal-is-visible',
      monogramming_content: 'js-monogramming-content',
      monogramming_modal: 'js-monograming-modal',
      monogramming_step: 'js-monogramming-step',
      monogramming_sizeStep: '.js-monogramming-step.monogramming__font-size',
      next_button: 'js-next-button',
      overlay: 'js-overlay',
      open_button_main: 'js-open-monogramming-main',
      open_button: 'js-open-monogramming',
      product: 'js-product',
      scale_wrapper: 'scale-wrapper',
      select_input: 'js-selected-option',
      select_wrap: 'js-select-wrap',
      selected_class: 'selected',
      shadow_headline: 'js-shadow-headline',
      shadow_select: 'js-shadow-select',
      shadow_swatch: 'js-monogramming-shadow-swatch',
      sticky_config: 'js-sticky-configurables',
      with_shadow_class: 'with-shadow',
    },
    ids: {
      monogram_form: 'monogramProductForm',
    },
    select_size_text: 'Select a size',
    add_to_cart_text: 'Add to bag',
  }

  // cached globals
  const $monogramForm = document.querySelector(`#${c.ids.monogram_form}`);

  if (!$monogramForm) return;

  if (reset) {
    removeEvents();
    $monogramForm.innerHTML = SDG.initialMonogramFormContent;
  }

  const $addToCartButtonText = document.querySelector(`.${c.cls.add_to_cart_button_text}`)
  const $additions = document.querySelector(`.${c.cls.additions}`);
  const $backButton = document.querySelector(`.${c.cls.back_button}`);
  const $buttons = document.querySelectorAll(`.${c.cls.button}`);
  const $closeButton = document.querySelector(`.${c.cls.close_button}`);
  const $colorHeadline = document.querySelector(`.${c.cls.color_headline}`);
  const $colorSwatches = document.querySelectorAll(`.${c.cls.color_swatch}`);
  const $fontSizes = document.querySelectorAll(`.${c.cls.font_size}`);
  const $fontStyleSelects = document.querySelectorAll(`.${c.cls.font_style_select}`);
  const $positionSelects = document.querySelectorAll(`.${c.cls.position_select}`);
  const $letterInputs = document.querySelectorAll(`.${c.cls.letter_input}`);
  const $lettersPreview = document.querySelectorAll(`.${c.cls.letter}`);
  const $currentStep = document.querySelector(`.${c.cls.current_step}`);
  const $letters = document.querySelector(`.${c.cls.letters}`);
  const $mainProductAddToCartButton = document.querySelector(`.${c.cls.main_product_add_to_cart_button}`);
  const $monogramingAddToCart = document.querySelector(`.${c.cls.add_to_cart_button}`);
  const $monogrammingModal = document.querySelector(`.${c.cls.monogramming_modal}`);
  const $monogrammingSteps = document.querySelectorAll(`.${c.cls.monogramming_step}`);
  const $monogrammingSizeStep = document.querySelector(`${c.cls.monogramming_sizeStep}`);
  const $nextButton = document.querySelector(`.${c.cls.next_button}`);
  const $openMonogramming = document.querySelectorAll(`.${c.cls.open_button}`);
  const $overlay = document.querySelector(`.${c.cls.overlay}`);
  const $product = document.querySelector(`.${c.cls.product}`);
  const $scalewrapper = document.querySelector(`.${c.cls.scale_wrapper}`);
  const $shadowHeadline = document.querySelector(`.${c.cls.shadow_headline}`);
  const $shadowSelect = document.querySelector(`.${c.cls.shadow_select}`);
  const $shadowSwatches = document.querySelectorAll(`.${c.cls.shadow_swatch}`);
  const $body = document.body;
  const view = SDG.Viewport.currentState;
  window.blockMonogramFormSubmit = view === 'mobile';

  SDG.initialMonogramFormContent = SDG.initialMonogramFormContent || $monogramForm.innerHTML;

  let isShoe = false;
  if ($product && $product.classList.contains('shoe')) {
    isShoe = true;
  }

  SDG.openMonogramming = openModal;
  SDG.closeMonogramming = closeModal;
  SDG.updateMonogramModalContent = updateMonogramModal;

  let xDown = null;
  let yDown = null;
  let currentStep = 1;
  let colorHeadlineInitialText;
  let shadowHeadlineInitialText;
  let $previewLetterParent;
  let $previewImageParent;
  let fontStyle;
  let fontSize;
  let color;
  let position;
  let side;
  let shadowColor;
  let $monogrammingFirstTab

  if ($monogrammingModal) {
    $monogrammingFirstTab = $buttons[0];
    $previewLetterParent = $lettersPreview[0].closest('.monogramming__preview-initials');
    $previewImageParent = $lettersPreview[0].closest('.monogramming__preview');
    initialPreviewClass = $previewLetterParent.classList;
    colorHeadlineInitialText = $colorHeadline.innerHTML;
    shadowHeadlineInitialText = $shadowHeadline.innerHTML;
  }

  /**
   * init
   */
  function init() {
    if ($monogrammingModal) {
      addEvents();
      setInitialState();
      showCurrentStep();
    }
  };



  /**
   * Add Events
   */
  function addEvents() {
    $monogramForm.addEventListener('submit', () => {
      // Submit is prevented in minicart.js
      if (window.blockMonogramFormSubmit) {
        const activeInputIndex = [...$letterInputs].indexOf(document.activeElement);
        const nextInput = activeInputIndex > -1 ? $letterInputs[activeInputIndex + 1] : null;

        if (nextInput) {
          // Shift focus to next letter input
          nextInput.focus();
        } else {
          // Remove focus so mobile keyboard closes.
          document.activeElement.blur();
          nextStep();
        }
      }
    });

    $buttons.forEach(($button) => {
      $button.addEventListener('click', toggleContent);
    })

    $letterInputs.forEach(($input) => {
      $input.addEventListener('input', updateLetter);
    });

    $fontSizes.forEach(($fontSize) => {
      $fontSize.addEventListener('click', updateContent);
    });

    $colorSwatches.forEach(($colorSwatch) => {
      $colorSwatch.addEventListener('click', updateContent);
    });

    $shadowSwatches.forEach(($shadowSwatch) => {
      $shadowSwatch.addEventListener('click', updateContent);
    });

    $positionSelects.forEach(($positionSelect) => {
      $positionSelect.addEventListener('click', updateContent);
    });

    $fontStyleSelects.forEach(($fontStyleSelect) => {
      $fontStyleSelect.addEventListener('click', updateContent);
    });

    $closeButton.addEventListener('click', closeModal);

    $openMonogramming.forEach(($button) => {
      $button.addEventListener('click', openModal);
    })

    $nextButton.addEventListener('click', nextStep);
    $backButton.addEventListener('click', prevStep);

    document.addEventListener('touchstart', handleTouchStart, false);
    document.addEventListener('touchmove', handleTouchMove, false);
  }

  function removeEvents() {
    document.removeEventListener('touchstart', handleTouchStart, false);
    document.removeEventListener('touchmove', handleTouchMove, false);
  }

  function getTouches(evt) {
    return evt.touches ||             // browser API
      evt.originalEvent.touches; // jQuery
  }

  function handleTouchStart(evt) {
    const firstTouch = getTouches(evt)[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
  };

  function handleTouchMove(evt) {
    if (!xDown || !yDown) {
      return;
    }

    var xUp = evt.touches[0].clientX;
    var yUp = evt.touches[0].clientY;

    var yDiff = yDown - yUp;

    if (yDiff < 0) {
      $monogrammingSteps.forEach(($step) => {
        if ($step.classList.contains(c.cls.is_active_class)) {
          $step.style.height = '60px';
        }
      })
    } else {
      $monogrammingSteps.forEach(($step) => {
        if ($step.classList.contains(c.cls.is_active_class)) {
          const $button = $step.querySelector(`.${c.cls.button}`);
          $button.click();
        }
      })

    }
    /* reset values */
    xDown = null;
    yDown = null;
  };

  /**
   * Toggle Content
   */
  function toggleContent(e) {
    const $target = e.target;
    const $content = $target.nextElementSibling;
    const contentHeight = $content?.scrollHeight;
    const isOpen = $content.classList.contains(c.cls.is_expanded_class);
    const $parent = $target.parentNode;

    $buttons.forEach(($button) => {
      if ($button !== $target) {
        const $content = $button.nextElementSibling;
        $content.style.height = `0px`;
        $content.classList.remove(c.cls.is_expanded_class);
        $button.classList.remove(c.cls.is_expanded_class);
      }
    });

    if (isOpen === true) {
      $content.style.height = `0px`;
      $content.classList.remove(c.cls.is_expanded_class);
      $target.classList.remove(c.cls.is_expanded_class);
    } else {
      $content.style.height = `${contentHeight}px`;
      $content.classList.add(c.cls.is_expanded_class);
      $target.classList.add(c.cls.is_expanded_class);
    }

    if (view === 'mobile') {
      if (isOpen === true) {
        $parent.style.height = `${$target.offsetHeight}px`;
      } else {
        $parent.style.height = `${$target.offsetHeight + contentHeight}px`;
      }
    }
  };

  /**
   * Update Monogram Content
   */
  function updateMonogramModal(blockHandle) {
    const monogramLetterOption = SDG.Product.monogrammingOptions.filter((el) => el.name === blockHandle)[0];
    if (monogramLetterOption) {

      const previewEl = document.querySelector('.monogramming__preview');

      if (previewEl) {
        previewEl.style.setProperty('--letter_top', monogramLetterOption.letter_top);
        previewEl.style.setProperty('--letter_left', monogramLetterOption.letter_left);
        previewEl.style.setProperty('--letter_spacing', monogramLetterOption.letter_spacing);
        previewEl.style.setProperty('--letter_top_alt', monogramLetterOption.letter_top_alt);
        previewEl.style.setProperty('--letter_left_alt', monogramLetterOption.letter_left_alt);
        previewEl.style.setProperty('--letter_spacing_alt', monogramLetterOption.letter_spacing_alt);
      }

      // Write size styles to the document.
      const style = document.createElement('style');
      style.innerHTML = `

      .monogramming-text-size-s .scale-wrapper {
        font-size: ${(monogramLetterOption.font_scale_small / 100) * 20}px;
      }
      .monogramming-text-size-m .scale-wrapper {
        font-size: ${(monogramLetterOption.font_scale_medium / 100) * 30}px;
      }
      .monogramming-text-size-l .scale-wrapper {
        font-size: ${(monogramLetterOption.font_scale_large / 100) * 45}px;
      }

      @media (min-width: 375px) and (max-width: 599px) {
        .monogramming-text-size-s .scale-wrapper {
          font-size: 3.75vw;
        }
        .monogramming-text-size-m .scale-wrapper {
          font-size: 5.75vw;
        }
        .monogramming-text-size-l .scale-wrapper {
          font-size: 7.25vw;
        }
      }

      @media (min-width: 600px) {
        .monogramming-text-size-s .scale-wrapper {
          font-size: ${(monogramLetterOption.font_scale_small / 100) * 50}px;
        }
        .monogramming-text-size-m .scale-wrapper {
          font-size: ${(monogramLetterOption.font_scale_medium / 100) * 65}px;
        }
        .monogramming-text-size-l .scale-wrapper {
          font-size: ${(monogramLetterOption.font_scale_large / 100) * 75}px;
        }
      }

      @media (min-width: 1024px) and (max-width: 1350px) {
        .monogramming-text-size-s .scale-wrapper {
          font-size: ${(monogramLetterOption.font_scale_small / 100) * 40}px;
        }
        .monogramming-text-size-m .scale-wrapper {
          font-size: ${(monogramLetterOption.font_scale_medium / 100) * 50}px;
        }
        .monogramming-text-size-l .scale-wrapper {
          font-size: ${(monogramLetterOption.font_scale_large / 100) * 60}px;
        }
      }
      `
      document.head.appendChild(style);

      // Set default Font-size & hide it
      if (monogramLetterOption.skip_font_size_step) {
        // Remove font-size steps
        if ($monogrammingSizeStep) {
          $monogrammingSizeStep.remove();
        }
        const fontSizeInput = $monogramForm.querySelector('.font-size-property');
        fontSizeInput && fontSizeInput.remove();

        // Set hidden properties for default font size
        const newInput = document.createElement("input");
        newInput.type = 'hidden';
        newInput.name = 'properties[Font Size]';
        newInput.className = 'font-size-property';
        newInput.value = monogramLetterOption.default_font_size;
        $monogramForm.append(newInput);
        fontSize = true;

        // Set font-size class to preview initials
        $letters.classList.remove('monogramming-text-size-s', 'monogramming-text-size-m', 'monogramming-text-size-l');
        $letters.classList.add(`monogramming-text-size-${monogramLetterOption.default_font_size.toLocaleLowerCase()}`);
      } else {
        // Set font-size class to preview initials
        fontSize = true
        $letters.classList.remove('monogramming-text-size-s', 'monogramming-text-size-m', 'monogramming-text-size-l');
        $letters.classList.add(`monogramming-text-size-${monogramLetterOption.default_font_size.toLocaleLowerCase()}`);

        // Select Default Size on Load
        $fontSizes.forEach(($fontSize) => {
          const input = $fontSize.querySelector('input');
          if (input.value == monogramLetterOption.default_font_size) {
            $fontSize.classList.add(c.cls.selected_class);
            input.checked = true
          } else {
            $fontSize.classList.remove(c.cls.selected_class);
            input.checked = false
          }
        });
      }
    }
  }

  /**
   * Set Initial State
   */
  function setInitialState() {
    const randomKeyInput = document.createElement("input");
    const loopInput = document.createElement("input");

    randomKeyInput.type = 'hidden';
    randomKeyInput.name = 'properties[_randomMatchingKey]';
    randomKeyInput.value = SDG.randomString(32);

    loopInput.type = 'hidden';
    loopInput.name = 'properties[_LPROP]';
    loopInput.value = 'salefinal';

    // append inputs to DOM
    $monogramForm.append(randomKeyInput);
    $monogramForm.append(loopInput);

    $positionSelects.forEach(($positionSelect) => {
      if ($positionSelect.classList.contains(c.cls.selected_class)) {
        const previewClass = $positionSelect.querySelector('input').dataset.previewClass;
        $previewLetterParent.classList.add(previewClass);
        $positionSelect.classList.remove(c.cls.selected_class);
        position = true;
      }
    });

    $fontSizes.forEach(($fontSize) => {
      if ($fontSize.classList.contains(c.cls.selected_class)) {
        const previewClass = $fontSize.querySelector('input').dataset.previewClass;
        $previewLetterParent.classList.add(previewClass);
      }
    });

    $colorSwatches.forEach(($colorSwatch) => {
      if ($colorSwatch.classList.contains(c.cls.selected_class)) {
        const previewClass = $colorSwatch.querySelector('input').dataset.previewClass;
        $previewLetterParent.classList.add(previewClass);
        color = true
      }
    });

    $fontStyleSelects.forEach(($fontStyleSelect) => {
      if ($fontStyleSelect.classList.contains(c.cls.selected_class)) {
        const previewClass = $fontStyleSelect.querySelector('input').dataset.previewClass;
        $previewLetterParent.classList.add(previewClass);
        shadowColor = false;
        fontStyle = 'no-shadow';
      }
    });

    side = document.querySelector('[name="properties[Position]"]:checked')?.dataset.previewClass;
  }

  /**
   * Next Step
   */
  function nextStep() {
    const leftInputLength = $letterInputs[0]?.value.length;
    const centerInputLength = $letterInputs[1]?.value.length;
    const rightInputLength = $letterInputs[2]?.value.length;

    switch (currentStep) {
      case 1:
        if (isShoe) {
          if (position) {
            currentStep++;
            showCurrentStep();
          }
        } else {
          if (leftInputLength > 0 || centerInputLength > 0 || rightInputLength > 0) {
            currentStep++;
            showCurrentStep();
          }
        }
        break;

      case 2:
        if (isShoe) {
          if (leftInputLength > 0 || centerInputLength > 0) {
            currentStep++;
            showCurrentStep();
          }
        } else {
          if (fontStyle) {
            currentStep++;
            showCurrentStep();
          }
        }
        break;

      case 3:
        if (isShoe) {
          if (fontStyle) {
            currentStep++;
            console.log(side)
            if (side != 'position-standard') {
              currentStep++;
            }
            showCurrentStep();
          }
        } else {
          if (fontSize) {
            currentStep++;
            showCurrentStep();
          }
        }
        break;

      case 4:
        if (isShoe) {
          if (fontSize) {
            currentStep++;
            showCurrentStep();
          }
        } else {
          if (color) {
            currentStep++;
            showCurrentStep();
          }
        }
        break;

      case 5:
        if (isShoe) {
          if (color) {
            currentStep++;
            showCurrentStep();
          }
        }
        break;

      default:
        return;
    }
  }


  /**
   * Prev Step
   */
  function prevStep() {
    currentStep--;
    showCurrentStep();
  }

  /**
   * Prev Step
   */
  function resetCurrentStep() {
    currentStep = 1;

    // reset all inputs
    $letterInputs.forEach(($input) => {
      $input.value = '';
    });

    document.querySelectorAll(`.${c.cls.letter_left}, .${c.cls.letter_center}, .${c.cls.letter_right}`)?.forEach((item) => {
      item.innerHTML = '';
    })

    $fontSizes.forEach(($fontSize) => {
      $fontSize.classList.remove(c.cls.selected_class);
    });

    $colorSwatches.forEach(($colorSwatch) => {
      $colorSwatch.classList.remove(c.cls.selected_class);
    });

    $shadowSwatches.forEach(($shadowSwatch) => {
      $shadowSwatch.classList.remove(c.cls.selected_class);
    });

    if ($positionSelects.length) {
      $positionSelects[0].click();
    }

    showCurrentStep();
  }

  /**
   * Show Current Step
   */
  function showCurrentStep() {
    let monogramLetterOption = null;
    const selectedColorSwatch = document.querySelector('.product__colors-swatch.is-selected');
    if (selectedColorSwatch) {
      const { monogramLettersBlock } = selectedColorSwatch.dataset;
      monogramLetterOption = SDG.Product.monogrammingOptions.filter((el) => el.name === monogramLettersBlock)[0];
    }

    let lastStep = 5;
    let maxStep = 4;

    if (monogramLetterOption && monogramLetterOption.skip_font_size_step) {
      maxStep = 3;
      lastStep = 4;
    }

    if (isShoe) {
      lastStep = 5;
      maxStep = 5;
    }

    $currentStep.innerHTML = `${currentStep} of ${maxStep}`;

    if (currentStep === 1 && view === 'mobile') {
      $backButton.style.visibility = 'hidden';
    }

    if (currentStep === 2 && view === 'mobile') {
      $backButton.style.visibility = 'visible';
    }
    if (currentStep === lastStep && view === 'mobile') {
      $nextButton.style.visibility = 'hidden';
      $additions.style.display = 'block';
      window.blockMonogramFormSubmit = false;
    }

    if (currentStep < lastStep && view === 'mobile') {
      $nextButton.style.visibility = 'visible';
      $additions.style.display = 'none';
      $monogramingAddToCart.disabled = true;
    } else if (view === 'mobile') {
      if ($mainProductAddToCartButton.disabled === true) {
        $monogramingAddToCart.disabled = true;
      } else {
        $monogramingAddToCart.disabled = false;
      }
    }

    $monogrammingSteps.forEach(($step) => {
      const $content = $step.querySelector(`.${c.cls.monogramming_content}`);
      let step = $step.dataset.step * 1;
      let button;
      let buttonHeight;
      let contentHeight;
      let height;

      if (monogramLetterOption && monogramLetterOption.skip_font_size_step) {
        if (step == 4) {
          step = 3;
        }

        if (step == 5) {
          step = 4;
        }
      }

      if (step === currentStep) {
        setTimeout(() => {
          button = $step.querySelector(`.${c.cls.button}`);
          buttonHeight = button.offsetHeight;
          contentHeight = $content?.scrollHeight;
          height = buttonHeight + contentHeight;

          $step.classList.add(c.cls.is_active_class);
          if (view === 'mobile') {
            $content.style.height = `${contentHeight}px`;
            $content.classList.add(c.cls.is_expanded_class);
            $step.style.height = `${height}px`;
          }
          validateForm();
        }, 1000);
      } else {
        $step.classList.remove(c.cls.is_active_class);
        if (view === 'mobile') {
          $content.style.height = `0px`;
          $content.classList.remove(c.cls.is_expanded_class);
          $step.style.height = `0px`;
        }
      }
    });
  }

  /**
   * Update Letter Preview
   */
  function updateLetter(e) {
    const value = e.target.value;
    const valueUppercase = value.toUpperCase();
    const $target = e.target;
    const side = $target.dataset.side;

    e.target.value = valueUppercase;

    $lettersPreview.forEach(($letter) => {
      const previewSide = $letter.dataset.side;

      if (side === previewSide) {
        $letter.innerHTML = value;
        // if value is empty, remove has-value class, else add has-value class
        if (value.length === 0) {
          $letter.classList.remove(c.cls.has_value_class);
        } else {
          $letter.classList.add(c.cls.has_value_class);
        }
      }
    });

    validateForm();
  };

  /**
   * Update Content
   */
  function updateContent(e) {
    let $target = e.target;
    let previewClass;
    let shadowClass;
    let classCheck = false;
    let positionClasses = [];
    let colorSwatchesClasses = [];
    let fontSizesClasses = [];
    let shadowSwatchesClasses = [];
    let fontStyleClasses = [];

    const checkedPosition = document.querySelector('[name="properties[Position]"]:checked');
    const isSidePosition = checkedPosition?.value === 'Side';
    side = checkedPosition?.dataset.previewClass;

    if ($target.nodeName === 'INPUT' || $target.nodeName === 'SPAN') {
      $target = $target.parentNode;
    }

    // if click is on position selector
    if ($target.classList.contains(c.cls.position_select)) {
      // reset font size state & get current font size class
      $positionSelects.forEach(($positionSelect) => {
        $positionSelect.classList.remove(c.cls.selected_class);
        positionClasses.push($positionSelect.querySelector('input').dataset.previewClass);
      });

      classCheck = hasClass($previewImageParent, positionClasses);
      position = true;

      let fontSelection = document.querySelectorAll('[name="properties[Font Size]"]');

      fontSelection.forEach(fontOption => {
        fontOption.checked = false;
        fontOption.parentNode.classList.remove('selected');
      });

      if (fontSelection[0]) {
        fontSelection[0].click();
      }

      // if click is on font size selector
    } else if ($target.classList.contains(c.cls.font_size)) {
      if (isSidePosition) return;

      // reset font size state & get current font size class
      $fontSizes.forEach(($fontSize) => {
        $fontSize.classList.remove(c.cls.selected_class);
        fontSizesClasses.push($fontSize.querySelector('input').dataset.previewClass);
      });

      classCheck = hasClass($previewLetterParent, fontSizesClasses);
      fontSize = true;

      // else if click is on color swatch
    } else if ($target.classList.contains(c.cls.color_swatch)) {

      // reset swatch state & get current swatch class
      $colorSwatches.forEach(($colorSwatch) => {
        $colorSwatch.classList.remove(c.cls.selected_class);
        colorSwatchesClasses.push($colorSwatch.querySelector('input').dataset.previewClass);
      });

      classCheck = hasClass($previewLetterParent, colorSwatchesClasses);

      $colorHeadline.innerHTML = `${colorHeadlineInitialText} <span class="color-name">${$target.querySelector('input').value}</span>`

      color = true;

      // else if click is on shadow swatch
    } else if ($target.classList.contains(c.cls.shadow_swatch)) {

      // reset swatch state & get current swatch class
      $shadowSwatches.forEach(($shadowSwatch) => {
        $shadowSwatch.classList.remove(c.cls.selected_class);
        shadowSwatchesClasses.push($shadowSwatch.querySelector('input').dataset.previewClass);
      });

      classCheck = hasClass($previewLetterParent, shadowSwatchesClasses);

      $shadowHeadline.innerHTML = `${shadowHeadlineInitialText} <span class="color-name">${$target.querySelector('input').value}</span>`

      shadowColor = true;

      // else if click is on font style selector
    } else if ($target.classList.contains(c.cls.font_style_select)) {

      // reset font state & get current font class
      $fontStyleSelects.forEach(($fontStyleSelect) => {
        $fontStyleSelect.classList.remove(c.cls.selected_class);
        fontStyleClasses.push($fontStyleSelect.querySelector('input').dataset.previewClass);
      });

      classCheck = hasClass($previewLetterParent, fontStyleClasses);

      if ($target.classList.contains(c.cls.with_shadow_class)) {
        $shadowSelect.style.display = 'flex';
        shadowClass = $shadowSwatches[0].querySelector('input').dataset.previewClass;
        $colorSwatches[1].click();
        $shadowSwatches[0].click();
        shadowColor = true;
        fontStyle = 'with-shadow';
        $shadowSwatches[0].querySelector('input').required = true;
      } else {
        $shadowSelect.style.display = 'none';
        $shadowSwatches.forEach(($shadowSwatch) => {
          const $input = $shadowSwatch.querySelector('input');
          $input.checked = false;
          shadowClass = $input.dataset.previewClass;
          $previewLetterParent.classList.remove(shadowClass);
        });
        shadowColor = false;
        fontStyle = 'no-shadow';
        $shadowSwatches[0].querySelector('input').required = false;
      }

    }

    if (classCheck !== false) {
      $previewLetterParent.classList.remove(classCheck);
      $previewImageParent.classList.remove(classCheck);
    }

    previewClass = $target.querySelector('input').dataset.previewClass;
    $target.classList.add(c.cls.selected_class);

    $previewImageParent.classList.add(previewClass);
    $previewLetterParent.classList.add(previewClass);

    validateForm();
  }

  /**
   * Validate Form
   */
  function validateForm() {
    let result = false;
    let inputCount = 0;
    const leftInputLength = $letterInputs[0]?.value.length;
    const centerInputLength = $letterInputs[1]?.value.length;
    const rightInputLength = $letterInputs[2]?.value.length;

    // go through all inputs and add up the length of the values
    if (leftInputLength) {
      inputCount++;
    }

    if (centerInputLength) {
      inputCount++;
    }

    if (rightInputLength) {
      inputCount++;
    }

    if (fontStyle === 'with-shadow' && inputCount > 0) {
      if (shadowColor && color && (fontSize || position)) {
        result = true;
      }
    } else if (fontStyle === 'no-shadow' && inputCount > 0) {

      if (color && (fontSize || position)) {
        result = true;
      }
    }

    if (result === true) {
      // update the input in the form #monogramProductForm with the name "quantity" to the value of inputCount
      const quantityInput = $monogramForm.querySelector('#monogramProductForm input[name="quantity"]');
      const quantityProperty = $monogramForm.querySelector('#monogramProductForm input[name="properties[_quantity]"]');
      if (quantityInput) {
        quantityInput.value = inputCount;
      }

      if (quantityProperty) {
        quantityProperty.value = inputCount;
      }

      if ($mainProductAddToCartButton.disabled === true) {
        $monogramingAddToCart.disabled = true;
      } else {
        $monogramingAddToCart.disabled = false;
      }
    } else {
      $monogramingAddToCart.disabled = true;
    }

    return result;
  }

  /**
   * Close Modal
   */
  function closeModal() {
    SDG.Product.monogrammingModalTrigger = false;
    $monogrammingModal.classList.remove(c.cls.is_visible_class);
    $overlay.classList.remove(c.cls.is_visible_class);
    $body.classList.remove(c.cls.monogram_open_class);
    bodyScrollLock.clearAllBodyScrollLocks();
    SDG.MiniCart.addToBagClickCount = 0;
    resetCurrentStep();
  }

  /**
   * Open Modal
   */
  function openModal(e) {
    const $selectsWrap = document.querySelectorAll(`.${c.cls.select_wrap}`);
    let sizeSelected = false;

    SDG.MiniCart.addToBagClickCount = 2;

    // update random key value
    const $randomKeyInput = document.querySelector('[name="properties[_randomMatchingKey]"]');
    $randomKeyInput.value = SDG.randomString(32);

    if ($selectsWrap.length > 0) {
      // show select size copy, if size has not been selected
      $selectsWrap.forEach(($wrap) => {
        if (!$wrap.classList.contains(c.cls.hidden_class) &&
          !$wrap.parentNode.classList.contains(c.cls.sticky_config)) {

          const $selectedSize = $wrap.querySelector(`.${c.cls.select_input}`);

          if (!$selectedSize.classList.contains(c.cls.has_value_class)) {

            if (view === 'desktop') {
              window.scrollBy({
                top: -window.scrollY,
                left: 0,
                behavior: 'smooth'
              });

              showSelectSizeText();
            } else {
              SDG.Product.monogrammingModalTrigger = true;
              $mainProductAddToCartButton.click();
            }

          } else {
            sizeSelected = true;
          }
        }
      });
    } else {
      sizeSelected = true;
    }

    if (sizeSelected) {
      showCurrentStep();
      $monogrammingModal.classList.add(c.cls.is_visible_class);
      $body.classList.add(c.cls.monogram_open_class);
      bodyScrollLock.disableBodyScroll($monogrammingModal);
      if (view === 'desktop') $buttons[0].click();
    }
  }

  /**
   * Show 'Select Size' Text
   */
  function showSelectSizeText() {
    const $openMonogrammingMain = document.querySelector(`.${c.cls.open_button_main}`);
    const initialInnerHtml = $openMonogrammingMain.innerHTML;

    $openMonogrammingMain.innerHTML = c.select_size_text;
    $openMonogrammingMain.disabled = true;
    $openMonogrammingMain.classList.add(`${c.cls.added_class}`);

    //  remove classes and text after 3s, return to initial state of the button
    setTimeout(() => {
      $openMonogrammingMain.innerHTML = initialInnerHtml;
      $openMonogrammingMain.disabled = false;
      $openMonogrammingMain.classList.remove(`${c.cls.added_class}`);
    }, 3000);
  }

  /**
   * Has Class
   */
  function hasClass(element, classes) {
    let result = false;

    classes.forEach((classFromArray) => {
      if (element.classList.contains(classFromArray)) {
        result = classFromArray
      }
    })

    return result;
  }

  /**
   * return
   */
  return init();
};

SDG.productMonogramming();

SDG.resetProductMonogramming = () => {
  SDG.productMonogramming(true);
};

/**
 * Product Gallery
 * @type {function}
 */
SDG.Product = SDG.Product || {};
SDG.Product.gallery = SDG.Product.gallery || {};

SDG.productGallery = function () {

  const c = {
    cls: {
      carousel_status: 'carousel-status',
      is_selected_class: 'is-selected',
      product_details: 'js-product-details',
      product_image: 'js-product-image',
      sticky_class: 'product__gallery--sticky',
      zoom_class: 'zoom',
      zoom_in_button: 'js-product-zoom-in',
      zoom_in_close_button: 'js-product-zoom-in-close',
      video: 'js-is-video',
      externalVideo: 'js-is-external_video'
    },
    ids: {
      carousel: 'productGallery'
    },
    dom: {
      cell: '.product-gallery__picture--active'
    }
  }

  // cached globals
  const $galleryCarousel = document.querySelector(`#${c.ids.carousel}`);
  const $carouselStatus = document.querySelector(`.${c.cls.carousel_status}`);
  const $productDetails = document.querySelector(`.${c.cls.product_details}`);
  const $productImages = document.querySelectorAll(`.${c.cls.product_image}`);
  const $imagesToZoom = document.querySelectorAll(`.${c.cls.zoom_class}`);
  const $zoomInButton = document.querySelector(`.${c.cls.zoom_in_button}`);
  const $zoomInCloseButton = document.querySelector(`.${c.cls.zoom_in_close_button}`);
  const view = SDG.Viewport.currentState;

  /**
   * init
   */
  function init() {

    if ($galleryCarousel) {
      flickity();
      if (view === 'desktop') {
        stickyGallery();
      }

      if (view === 'desktop') {
        window.addEventListener('scroll', stickyGallery);
      }

      addEvents();
    }

  };

  /**
   * Add Events
   */
  function addEvents() {
    if ($zoomInButton) $zoomInButton.addEventListener('click', triggerZoom);
    if ($zoomInCloseButton) $zoomInCloseButton.addEventListener('click', SDG.Product.zoomClose);
  }

  /**
   * Sticky Gallery
   */
  function stickyGallery() {
    if (window.scrollY > ($productDetails?.scrollHeight - $galleryCarousel?.scrollHeight)) {
      $galleryCarousel.classList.remove(c.cls.sticky_class);
    } else {
      $galleryCarousel.classList.add(c.cls.sticky_class);
    }
  }

  /**
   * Trigger Zoom
   */
  function triggerZoom() {
    $productImages.forEach(($image) => {
      if ($image.classList.contains(c.cls.is_selected_class)) {
        if ($image.classList.contains(c.cls.externalVideo)) {
          $image.click();
        } else {
          const image = $image.querySelector('img');
          image && image.click();
        }
      }
    });
  }

  /**
   * Init Flicity
   */
  function flickity() {
    const settings = {
      cellSelector: c.dom.cell,
      arrowShape: {
        x0: 10,
        x1: 60, y1: 50,
        x2: 65, y2: 50,
        x3: 15
      },
      pageDots: false,
      prevNextButtons: true,
      adaptiveHeight: false,
      wrapAround: true,
      autoPlay: false,
      on: {
        change: function () {
          updateStatus()
        }
      }
    };

    // update flickity status
    function updateStatus(skipChangeEvent) {
      const selectedElement = SDG.Product.gallery.flkty.selectedElement
      if (!skipChangeEvent) {
        document.dispatchEvent(new CustomEvent('product-gallery-change', { detail: { index: SDG.Product.gallery.flkty.selectedIndex } }));
      }
      if (selectedElement.classList.contains(c.cls.video)) {
        const $video = selectedElement.getElementsByTagName('video');
        $video[0].play();
        $video[0].currentTime = 0;
      }

      var slideNumber = SDG.Product.gallery.flkty.selectedIndex + 1;
      $carouselStatus.textContent = slideNumber + ' of ' + SDG.Product.gallery.flkty.slides.length;

      if (selectedElement) {
        selectedElement.removeAttribute('aria-hidden')
      }

      const elements = SDG.Product.gallery.flkty.getCellElements()
      elements.forEach((element) => {
        if (element != selectedElement) {
          element.setAttribute('aria-hidden', true);
        }
      })
    }

    SDG.Product.gallery.updateStatus = updateStatus;
    SDG.Product.gallery.settings = settings;
    SDG.Product.gallery.domElement = `#${c.ids.carousel}`;

    // Flickity is initialized in product-swatches.js

  };


  /**
   * return
   */
  return init();
};

SDG.productGallery();

/**
 * Product Configurables
 * @type {Function}
 * @return init()
 *
 */

SDG.MiniCart = SDG.MiniCart || {};
SDG.MiniCart.addToBagClickCount = SDG.MiniCart.addToBagClickCount || 0;
SDG.Product = SDG.Product || {};

SDG.productConfigurables = function () {

  const c = {
    ids: {
      form: 'productForm',
    },
    cls: {
      add_to_cart_button_text: 'js-add-to-cart-text',
      add_to_cart_button: 'js-add-to-cart',
      back_in_stock_button: 'js-back-in-stock',
      back_in_stock_class: 'back-in-stock',
      back_in_stock_form: 'js-back-in-stock-form',
      button_price: 'js-button-price',
      close_notify: 'js-close-notify',
      close_size_select: 'js-close-size-select',
      has_value_class: 'has-value',
      hidden_class: 'hidden',
      is_expanded_class: 'is-expanded',
      is_gift_card_class: 'is_gift_card',
      is_hideen_class: 'is-hidden',
      is_monogrammable_class: 'is-monogrammable',
      is_sold_out_class: 'is-sold-out',
      is_visible_class: 'is-visible',
      leather_list: 'js-leather-list',
      leather_select: 'new-select--leather',
      leather: 'js-leather',
      monogramming_button: 'js-open-monogramming',
      monogram_form: '#monogramProductForm',
      new_select_wrap: 'new-select-wrap',
      option_flag: 'js-option-flag',
      overlay: 'js-overlay',
      preorder_class: 'preorder',
      product_price: 'js-price',
      product: 'js-product',
      productSizes: 'js-product-sizes',
      select_heading: 'js-select-heading',
      select_is_open_class: 'select-is-open',
      select_option_list: 'js-select-option-list',
      select_wrap: 'js-select-wrap',
      select: 'js-select',
      selected_class: 'selected',
      selectedOption: 'js-selected-option',
      selectOption: 'js-select-option',
      sold_out_class: 'soldout',
      sticky_add_to_cart_button: 'js-sticky-add-to-cart',
      sticky_back_in_stock_button: 'js-sticky-back-in-stock',
      sticky_configurables: 'js-sticky-configurables',
      sticky_title: 'js-sticky-title',
      swatch: 'js-swatch',
    },
    add_to_cart_text: 'Add to bag',
    add_monogram_text: 'Add a monogram',
    preorder_text: 'Preorder',
    select_size_text: 'Select a size',
    select_value_text: 'Select a value',
  }

  // cached globals
  const $product = document.querySelector(`.${c.cls.product}`);
  const $productPrice = document.querySelector(`.${c.cls.product_price}`);
  const $productSizesSelects = document.querySelectorAll(`.${c.cls.productSizes}`);
  const $addToCartButton = document.querySelector(`.${c.cls.add_to_cart_button}`);
  const $addToCartButtonText = document.querySelector(`.${c.cls.add_to_cart_button_text}`);
  const $backInStockButton = document.querySelector(`.${c.cls.back_in_stock_button}`);
  const $backInStockForm = document.querySelector(`.${c.cls.back_in_stock_form}`);
  const $monogrammingButtons = document.querySelectorAll(`.${c.cls.monogramming_button}`);
  const $overlay = document.querySelector(`.${c.cls.overlay}`);
  const $closeNotify = document.querySelector(`.${c.cls.close_notify}`);
  const $buttonPrice = document.querySelector(`.${c.cls.button_price}`);
  const $leatherSelect = document.querySelector(`.${c.cls.leather}`);
  const $leatherSelectList = document.querySelector(`.${c.cls.leather_list}`);
  const $swatches = document.querySelectorAll(`.${c.cls.swatch}`);
  const $selectOptionList = document.querySelector(`.${c.cls.select_option_list}`);
  const $leatherSelectWrap = document.querySelector(`.${c.cls.leather_select}`);
  const $stickyConfigurables = document.querySelector(`.${c.cls.sticky_configurables}`);
  const $stickyTitle = document.querySelector(`.${c.cls.sticky_title}`);
  const $stickyAddToCart = document.querySelector(`.${c.cls.sticky_add_to_cart_button}`);
  const $stickyBackInStockButton = document.querySelector(`.${c.cls.sticky_back_in_stock_button}`);
  const $monogramForm = document.querySelector(`${c.cls.monogram_form}`);
  const view = SDG.Viewport.currentState;
  let selectIsOpen = false;

  /**
   * init
   */
  function init() {

    if ($product) {
      saveCurrentProduct();
      addEvents();

      if ($productSizesSelects.length > 0) {
        disableSelects();
        $productSizesSelects.forEach(($select) => {
          renderNewSelect($select);
        })
      }

      if ($leatherSelect) renderLeatherSelect();

      if ($stickyConfigurables) copySelectsToStickyConfigurables();
    }
  };

  /**
   * Add Events
   */
  function addEvents() {
    if ($backInStockButton) $backInStockButton.addEventListener('click', showNotifyMeForm);
    if ($closeNotify) $closeNotify.addEventListener('click', closeNotifyForm);

    if (view === 'mobile') {
      window.addEventListener('scroll', showButtonPrice);
    }
  }


  /**
   * Copy Selects To Sticky Configurables
   */
  function copySelectsToStickyConfigurables() {
    const $selectWraps = document.querySelectorAll(`.${c.cls.select_wrap}`);

    // copy select wraps to sticky
    $selectWraps.forEach(($select) => {
      const clone = $select.cloneNode(true);
      $stickyTitle.after(clone);
    });
    addEventsToStickyConfigurables()
  }

  /**
   * Add Events To Sticky Configurables
   */
  function addEventsToStickyConfigurables() {
    const $selects = $stickyConfigurables.querySelectorAll(`.${c.cls.select_wrap}`);
    if ($selects.length > 0) {
      $selects.forEach(($select) => {
        addEventsToSelect($select);
      });
    }
  }

  /**
   * Show Button Price
   */
  function showButtonPrice() {
    const fromTop = window.pageYOffset;

    if ($buttonPrice && !SDG.Product.currentProduct.isGiftCard) {
      if (fromTop > 10) {
        $buttonPrice.classList.remove(c.cls.is_hideen_class);
      } else {
        $buttonPrice.classList.add(c.cls.is_hideen_class);
      }
    }
  }

  /**
   * Save Current Product Id
   */
  function saveCurrentProduct() {
    SDG.Product.currentProduct = SDG.currentProduct || {};
    SDG.Product.currentProduct.id = $product.dataset.id;
    SDG.Product.currentProduct.handle = $product.dataset.handle;
    SDG.Product.currentProduct.isGiftCard = false;

    if (SDG.Product.currentProduct.handle === 'gift-card') SDG.Product.currentProduct.isGiftCard = true;
  }

  /**
   * Disable Selects
   */
  function disableSelects() {
    $productSizesSelects.forEach(($select) => {
      const productId = $select.dataset.productId;
      if (productId !== SDG.Product.currentProduct.id) {
        $select.disabled = true;
      } else {
        $select.disabled = false;
      }
    })
  }

  /**
   * Render Leather Select
   */
  function renderLeatherSelect() {
    const $newSelectWrap = document.querySelector(`.${c.cls.new_select_wrap}`);
    let str = '';

    Object.values(SDG.Product.fabricDropdowns).forEach((product) => {
      str += `
        <li class="new-select-element js-select-option" data-outside-color="${product.color_outside}" data-material="${product.material}" data-product-id="${product.id}">
          ${product.select_text === '' ? product.material : product.select_text}
          <svg class="icon icon--tick" width="14px" height="12px" viewBox="0 0 14 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="02-Mobile---PLP-Sort" transform="translate(-24.000000, -548.000000)" fill="#FFFFFF">
                    <g id="Slider">
                        <g id="Options" transform="translate(19.000000, 535.000000)">
                            <polygon id="Fill-1" points="17.7283363 13 8.8185909 21.9106454 6.27256364 19.3637182 5 20.6362818 8.8185909 24.4557727 19 14.2734636 19 14.2716637"></polygon>
                        </g>
                    </g>
                </g>
            </g>
          </svg>
        </li>
      `;
    });

    $leatherSelectList.innerHTML = str;
    addEventsToLeatherSelect($newSelectWrap);
  }

  /**
   * Render New Select
   */
  function renderNewSelect($target) {
    const $newSelect = document.createElement("div");
    const firstOptionText = $target.querySelector('option').innerHTML;
    const optionsArray = Array.apply(null, $target.options);

    $newSelect.classList.add(c.cls.new_select_wrap);
    $newSelect.classList.add(c.cls.select_wrap);
    $newSelect.setAttribute('data-product-id', $target.dataset.productId);

    if ($target.disabled === true) {
      $newSelect.classList.add('hidden');
    }

    var str = `
      <div class="new-select ${c.cls.select}" data-product-id="${$target.dataset.productId}">
        <div class="new-select__heading js-select-heading">
          <h3 class="new-select__heading-headline">${firstOptionText}</h3>
          ${SDG.Product.currentProduct.isGiftCard ? '' :
        `<p class="new-select__heading-body">
              Unsure about your size?
              <button type="button" class="new-select__heading-button new-select__heading-button--size-guide js-trigger-size-guide" data-product-id="${$target.dataset.productId}">
                <svg class="icon-ruler" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.9788 4.18066L12.1194 1.32129C12.0754 1.2769 12.0155 1.25195 11.953 1.25195C11.8905 1.25195 11.8306 1.2769 11.7866 1.32129L1.521 11.5869C1.47661 11.6309 1.45166 11.6908 1.45166 11.7533C1.45166 11.8158 1.47661 11.8757 1.521 11.9197L4.38037 14.7791C4.42461 14.8229 4.48447 14.8474 4.54677 14.8471C4.60883 14.8462 4.66826 14.8219 4.71317 14.7791L6.17805 13.3118L13.5117 5.97821L14.9789 4.51334C15.0233 4.46935 15.0483 4.40943 15.0483 4.34694C15.0483 4.28445 15.0233 4.22453 14.9789 4.18054L14.9788 4.18066ZM13.3382 5.48141L12.6796 4.81579C12.6357 4.77214 12.5763 4.74763 12.5143 4.74763C12.4524 4.74763 12.393 4.77214 12.3491 4.81579C12.3047 4.85978 12.2798 4.9197 12.2798 4.98219C12.2798 5.04468 12.3047 5.1046 12.3491 5.14859L13.0147 5.81421L11.8803 6.94859L10.8139 5.88453C10.7701 5.84087 10.7106 5.81636 10.6487 5.81636C10.5868 5.81636 10.5274 5.84087 10.4835 5.88453C10.4398 5.92842 10.4153 5.98785 10.4153 6.04976C10.4153 6.11168 10.4398 6.1711 10.4835 6.215L11.5475 7.27906L10.4132 8.41579L9.74753 7.75016C9.70354 7.70578 9.64363 7.68083 9.58113 7.68083C9.51864 7.68083 9.45872 7.70578 9.41473 7.75016C9.37108 7.79406 9.34657 7.85348 9.34657 7.9154C9.34657 7.97732 9.37108 8.03674 9.41473 8.08064L10.0804 8.75329L8.95301 9.88064L7.88895 8.81658C7.84495 8.77219 7.78504 8.74724 7.72255 8.74724C7.66005 8.74724 7.60013 8.77219 7.55615 8.81658C7.51249 8.86047 7.48798 8.9199 7.48798 8.98181C7.48798 9.04373 7.51249 9.10315 7.55615 9.14705L8.62255 10.2135L7.48582 11.3478L6.8202 10.6822C6.7763 10.6385 6.71688 10.614 6.65496 10.614C6.59304 10.614 6.53362 10.6385 6.48972 10.6822C6.44534 10.7262 6.42039 10.7861 6.42039 10.8486C6.42039 10.9111 6.44534 10.971 6.48972 11.015L7.15535 11.6806L6.02097 12.815L4.95457 11.7486C4.91068 11.7049 4.85125 11.6804 4.78933 11.6804C4.72742 11.6804 4.668 11.7049 4.6241 11.7486C4.57971 11.7926 4.55476 11.8525 4.55476 11.915C4.55476 11.9775 4.57971 12.0374 4.6241 12.0814L5.67175 13.1455L4.54675 14.2822L2.01787 11.7533L11.953 1.81819L14.4819 4.34706L13.3382 5.48141Z" fill="currentColor"/>
                </svg>
                <span>View size guide</span>
              </button>
            </p>`
      }
          <svg class="icon--close js-close-size-select" width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="03-Size-guide" transform="translate(-1130.000000, -133.000000)" fill="#FFFFFF">
                <g id="Popup">
                  <g id="X-Close" transform="translate(1129.866667, 132.466667)">
                    <polygon id="Rectangle" transform="translate(8.133333, 8.533333) rotate(-315.000000) translate(-8.133333, -8.533333) " points="-2 8 18.2666667 8 18.2666667 9.06666667 -2 9.06666667"></polygon>
                    <polygon id="Rectangle" transform="translate(8.133333, 8.533333) rotate(-45.000000) translate(-8.133333, -8.533333) " points="-2 8 18.2666667 8 18.2666667 9.06666667 -2 9.06666667"></polygon>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </div>
        <div class="new-select__selected ${c.cls.selectedOption}">
          ${firstOptionText}
        </div>
        <ul class="new-select__list ${c.cls.select_option_list}">
    `
    optionsArray.forEach((option) => {
      let { soldout, backInStock, size, inventory, giftCard, url, vendor, type, price, title, firstImage, humanColor } = option.dataset;

      if (giftCard === undefined) {
        giftCard = false;
      }

      str += `
        <li
          class="new-select-element ${option.classList.value} ${c.cls.selectOption}"
          data-value="${option.value}"
          data-size="${size}"
          data-gift-card="${giftCard}"
          data-url="${url}"
          data-vendor="${vendor}"
          data-type="${type}"
          data-price="${price}"
          data-title="${title}"
          data-first-image="${firstImage}"
          data-human-color="${humanColor}"
        >
          ${option.text}
          ${soldout === 'true' && backInStock === undefined ? '<span class="flag">Sold out</span>' : ''}
          ${soldout === 'true' && backInStock === 'true' ? '<span class="flag flag--sold-out-notify">Sold out. Notify me</span>' : ''}
          ${Number(inventory) < 4 && Number(inventory) > 0 ? '<span class="flag flag--red js-option-flag">Only ' + inventory + ' left</span>' : ''}
          <svg class="icon icon--tick" width="14px" height="12px" viewBox="0 0 14 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="02-Mobile---PLP-Sort" transform="translate(-24.000000, -548.000000)" fill="#FFFFFF">
                    <g id="Slider">
                        <g id="Options" transform="translate(19.000000, 535.000000)">
                            <polygon id="Fill-1" points="17.7283363 13 8.8185909 21.9106454 6.27256364 19.3637182 5 20.6362818 8.8185909 24.4557727 19 14.2734636 19 14.2716637"></polygon>
                        </g>
                    </g>
                </g>
            </g>
          </svg>
        </li>
      `;
    });

    str += '</ul>';
    str += '</div>';

    $newSelect.innerHTML = str;

    insertAfter($target, $newSelect)
    addEventsToSelect($newSelect);
  }

  /**
   * Add Events To Select
   */
  function addEventsToSelect($target) {
    const $selected = $target.querySelector(`.${c.cls.selectedOption}`);
    const $selectOptions = $target.querySelectorAll(`:not(.hidden) .${c.cls.selectOption}`);
    const $options = document.querySelectorAll(`.${c.cls.leather} .${c.cls.selectOption}`);
    const $closeSizeSelect = $target.querySelector(`.${c.cls.close_size_select}`);

    if (view === 'desktop') {
      window.addEventListener('click', (e) => {
        if (!$target.contains(e.target)) {
          closeSelectOptionList($target);
        }
      });
    }

    $closeSizeSelect.addEventListener('click', () => closeSelectOptionList($target));
    $selected.addEventListener('click', toggleSelectOptionList);

    $selectOptions.forEach(($option) => {
      $option.addEventListener('click', applySelection);
    });
  };

  /**
   * Add Events To Leather Select
   */
  function addEventsToLeatherSelect($target) {
    const $selected = $target.querySelector(`.${c.cls.selectedOption}`);
    const $selectOptions = $target.querySelectorAll(`.${c.cls.selectOption}`);
    const $closeSizeSelect = $target.querySelector(`.${c.cls.close_size_select}`);

    $closeSizeSelect.addEventListener('click', () => closeSelectOptionList($target));
    $selected.addEventListener('click', toggleSelectOptionList);

    $selectOptions.forEach(($option) => {
      $option.addEventListener('click', applyLeatherSelection);
    });
  };

  /**
   * Toggle Select Option List
   */
  function toggleSelectOptionList(e) {
    let $target = e.target;
    if ($target.nodeName === 'SPAN') $target = $target.parentNode;

    const $parent = $target.parentNode;
    const $selectOptionList = $parent.querySelector(`.${c.cls.select_option_list}`);

    const listHeight = $selectOptionList.offsetHeight;
    const targetHeight = $target.offsetHeight;
    const newHeight = listHeight + targetHeight;
    const headingHeight = $parent.querySelector(`.${c.cls.select_heading}`).offsetHeight;

    $parent.classList.toggle(c.cls.is_expanded_class);

    if (selectIsOpen === false) {
      if (view === 'mobile') {
        $overlay.classList.add(c.cls.is_visible_class);
        $parent.style.height = `${headingHeight + listHeight}px`;
        document.body.classList.add(`${c.cls.select_is_open_class}`);

        // disable scroll
        bodyScrollLock.disableBodyScroll($selectOptionList);
      } else {
        $parent.style.height = `${newHeight}px`;
      }
    } else {
      $parent.style.height = `${targetHeight}px`;
      document.body.classList.remove(`${c.cls.select_is_open_class}`);

      // enable scroll
      bodyScrollLock.clearAllBodyScrollLocks();
    }
    selectIsOpen = !selectIsOpen;
  }

  /**
   * Close Select Option List
   */
  function closeSelectOptionList($target) {
    const $select = $target.querySelector(`.${c.cls.select}`);
    const $selected = $target.querySelector(`.${c.cls.selectedOption}`);
    const selectedHeight = $selected.offsetHeight;

    SDG.MiniCart.addToBagClickCount = 0;

    selectIsOpen = false;

    if ($select) {
      $select.classList.remove(c.cls.is_expanded_class);
      $select.style.height = `${selectedHeight}px`;
    }

    if ($selectOptionList && view === 'mobile') {
      $selectOptionList.classList.remove(c.cls.is_expanded_class);
      $leatherSelectWrap.style.height = `0px`;
    }

    if (view === 'mobile') {
      $overlay.classList.remove(c.cls.is_visible_class);

      if (SDG.Product.currentProduct.isGiftCard) {
        $addToCartButtonText.innerHTML = `${c.select_value_text}`;
      } else {
        // check to see if a size has been selected
        if ($target.querySelector(`.${c.cls.selectOption}.${c.cls.selected_class}`) != null) {
          $addToCartButtonText.innerHTML = c.add_to_cart_text;
        }
      }

      SDG.Product.monogrammingModalTrigger = false;
    }

    // enable scroll
    bodyScrollLock.clearAllBodyScrollLocks();

    // resert Add To Bag Click Counter
    SDG.MiniCart.addToBagClickCount = 0;
  }

  /**
   * Apply Selection
   */
  function applySelection(e) {
    let $target = e.target;
    if ($target.nodeName === 'SPAN') $target = $target.parentNode;

    const { availableText, soldoutText } = $addToCartButton.dataset;
    const backInStockText = $backInStockButton.dataset.text;
    const $parent = $target.parentNode;
    const $wrap = $parent.parentNode;
    const $selectedOption = $wrap.querySelector(`.${c.cls.selectedOption}`);
    const selectedOptionHeight = $selectedOption.offsetHeight;
    const $selectOptions = document.querySelectorAll(`.${c.cls.selectOption}`);
    const { value, firstImage, type, vendor, price, url, title, size, humanColor, productId } = $target.dataset;
    const $flag = $target.querySelector(`.${c.cls.option_flag}`);
    const isMonogrammable = $product.classList.contains(c.cls.is_monogrammable_class);
    const addMonogramButtonClickCheck = isMonogrammable === true && SDG.Product.monogrammingModalTrigger === true;

    let soldOut = false;
    let backInStock = false;
    let preOrder = false;
    selectIsOpen = false;

    SDG.MiniCart.addToBagClickCount = 1;

    $selectOptions.forEach(($option) => {
      if ($option.dataset.value === value && $option !== $target) {
        $option.click();
      }
    });

    if ($target.classList.contains(c.cls.sold_out_class)) {
      soldOut = true;
    }

    if ($target.classList.contains(c.cls.preorder_class)) {
      preOrder = true;
    }

    // Update properties for `variant ID` of monogram
    if ($monogramForm && value) {
      if ($monogramForm.querySelector('[name="properties[Product]"]')) {
        $monogramForm.querySelector('[name="properties[Product]"]').value = value
      }
    }

    if ($target.classList.contains(c.cls.back_in_stock_class)) {
      backInStock = true;
    }

    // reset wrap height
    if (view === 'desktop') {
      $wrap.style.height = `${selectedOptionHeight}px`;
      $wrap.classList.remove(c.cls.is_expanded_class);
    }

    if (view === 'mobile') {
      $selectOptions.forEach(($option) => {
        $option.classList.remove(c.cls.selected_class)
      });
      $target.classList.add(c.cls.selected_class);
    }

    // select the orginal select
    document.querySelector('[value="' + value + '"]').selected = true;

    // add selected style to selected div
    $selectedOption.classList.add(c.cls.has_value_class);
    $selectedOption.innerHTML = $target.dataset.size.replace('IT ', '');

    // if gift card add gift card class
    if ($target.dataset.giftCard === 'true') {
      $selectedOption.classList.add(c.cls.is_gift_card_class);
      $productPrice.innerHTML = $target.dataset.size;
    }

    // add sold out text to select options
    if ($target.classList.contains('soldout')) {
      $selectedOption.innerHTML = `${$target.dataset.size.replace('IT ', '')} <span class="sold-out">Sold Out</span>`;
      $selectedOption.classList.add(c.cls.is_sold_out_class);
    } else {
      $selectedOption.classList.remove(c.cls.is_sold_out_class);
    }

    // if low stock
    if ($flag) {
      const flagText = $flag.innerHTML;
      $selectedOption.innerHTML = `${$target.dataset.size.replace('IT ', '')} <span class="flag flag--red">${flagText}</span>`;
    }

    // update BackInStock form
    if ($backInStockForm) {
      $backInStockForm.setAttribute('data-variant-id', value)
    }

    // if Sold Out - update Add To Cart button
    if (backInStock && soldOut) {
      $backInStockButton.innerHTML = backInStockText;
      $addToCartButton.disabled = true;
      $addToCartButton.style.display = 'none';
      $stickyAddToCart.disabled = true;
      $stickyAddToCart.style.display = 'none';
      $backInStockButton.style.display = 'block';
      if ($stickyBackInStockButton) {
        $stickyBackInStockButton.style.display = 'block';
      }

      if ($monogrammingButtons.length > 0) {
        $monogrammingButtons.forEach(($button) => $button.style.display = 'none')
      }
    } else if (soldOut) {
      $addToCartButtonText.innerHTML = soldoutText;
      $addToCartButton.disabled = true;
      $stickyAddToCart.disabled = true;
      $stickyAddToCart.innerHTML = soldoutText;

      if ($monogrammingButtons.length > 0) {
        $monogrammingButtons.forEach(($button) => $button.style.display = 'none')
      }
    } else {

      if ($monogrammingButtons.length > 0) {
        $monogrammingButtons.forEach(($button) => $button.removeAttribute('style'));
      }

      if (addMonogramButtonClickCheck) {
        $addToCartButtonText.innerHTML = c.add_monogram_text;
      } else {
        $addToCartButtonText.innerHTML = c.add_to_cart_text;
      }

      $addToCartButton.disabled = false;
      $addToCartButton.style.display = 'flex';

      $stickyAddToCart.disabled = false;
      $stickyAddToCart.style.display = 'block';

      if ($backInStockButton) {
        $backInStockButton.innerHTML = backInStockText;
        $backInStockButton.style.display = 'none';
        if ($stickyBackInStockButton) {
          $stickyBackInStockButton.style.display = 'none';
        }
        $stickyBackInStockButton.innerHTML = backInStockText;
      }

      if ($backInStockForm) {
        $backInStockForm.style.display = 'none';
      }
    }
  }

  /**
   * Apply Leather Selection
   */
  function applyLeatherSelection(e) {
    let $target = e.target;
    const material = $target.dataset.material;
    const $selectOptions = document.querySelectorAll(`.${c.cls.selectOption}`);

    const $parent = $target.parentNode;
    const $wrap = $parent.parentNode;
    const $selectedOption = $wrap.querySelector(`.${c.cls.selectedOption}`);
    const selectedOptionHeight = $selectedOption.offsetHeight;
    const targetProductId = $target.dataset.productId;
    const source = 'leather-selector';

    selectIsOpen = false;

    // reset wrap height
    if (view === 'desktop') {
      $wrap.style.height = `${selectedOptionHeight}px`;
      $wrap.classList.remove(c.cls.is_expanded_class);
    }

    SDG.MiniCart.addToBagClickCount = 1;

    $selectedOption.innerHTML = material;
    $selectedOption.classList.add(c.cls.has_value_class);

    if (view === 'mobile') {
      $selectOptions.forEach(($option) => {
        $option.classList.remove(c.cls.selected_class)
      });
      $target.classList.add(c.cls.selected_class);
    }

    $swatches.forEach(($swatch) => {
      const swatchProductId = $swatch.dataset.productId;

      if (targetProductId === swatchProductId) {
        SDG.Product.updateContent($swatch, source);
      }
    });
  }

  /**
   * Show Notify Form
   */
  function showNotifyMeForm() {
    const $currentSelect = document.querySelector(`.${c.cls.select}.${c.cls.is_expanded_class}`);

    if ($currentSelect !== null) $currentSelect.style.height = '0px';

    $backInStockButton.style.display = 'none';
    $backInStockForm.style.display = 'block';
  }

  /**
   * Show Notify Form
   */
  function closeNotifyForm() {
    const $currentSelect = document.querySelector(`.${c.cls.select}.${c.cls.is_expanded_class}`);
    const $form = document.querySelector(`#${c.ids.form}`);
    const $select = $form.querySelector('select:not([disabled])');

    $backInStockButton.style.display = 'block';
    $backInStockForm.style.display = 'none';
    $currentSelect.classList.remove(c.cls.is_expanded_class);
    $overlay.classList.remove(c.cls.is_visible_class);
    $select.options[$select.selectedIndex].selected = false;
    bodyScrollLock.clearAllBodyScrollLocks();

    SDG.MiniCart.addToBagClickCount = 0;
  }

  /**
   * Insert After
   */
  function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
  }

  /**
   * return
   */
  return init();
};

SDG.productConfigurables();

/**
 * Product Sticky Configurables
 * @type {Function}
 * @return init()
 *
 */

SDG.sizeGudide = function() {

  const c = {
    cls: {
      add_to_cart_button: 'js-add-to-cart',
      added_class: 'added',
      back_in_stock_button: 'js-back-in-stock',
      is_visible_class: 'is-visible',
      product_form: 'product-form',
      sticky_add_to_cart_button: 'js-sticky-add-to-cart',
      sticky_back_in_stock_button: 'js-sticky-back-in-stock',
      sticky_configurables: 'js-sticky-configurables',
      zoom_is_open: 'zoom-is-open',
    },
    ids: {
      back_in_stock_position: 'backInStockPosition'
    },
    select_size_text: 'Select a size',
    select_value_text: 'Select a value',
  }

  // cached globals
  const $addToCartButton = document.querySelector(`.${c.cls.add_to_cart_button}`);
  const $backInStockPosition = document.querySelector(`#${c.ids.back_in_stock_position}`);
  const $backInStockButton = document.querySelector(`.${c.cls.back_in_stock_button}`);
  const $stickyAddToCart = document.querySelector(`.${c.cls.sticky_add_to_cart_button}`);
  const $stickyBackInStockButton = document.querySelector(`.${c.cls.sticky_back_in_stock_button}`);
  const $stickyConfigurables = document.querySelector(`.${c.cls.sticky_configurables}`);
  const $form = document.querySelector(`.${c.cls.product_form}`);
  let $select;
  let selectedOptionValue;

  if ($form) $select = $form.querySelector('select:not([disabled])');

  /**
   * init
   */
  function init() {

    if ($stickyConfigurables) {
      addEvents();
      showHideStickyConfigurables();
    }
  };

  /**
   * Add Events
   */
  function addEvents() {
    window.addEventListener('scroll', showHideStickyConfigurables);
    $stickyAddToCart.addEventListener('click', addToCart);
    $stickyBackInStockButton.addEventListener('click', openBackInStockForm);
  };

  /**
   * Show/HideSticky Configurables
   */
  function showHideStickyConfigurables() {
    if (SDG.Viewport.scrollPosition > 300) {
      $stickyConfigurables.classList.add(c.cls.is_visible_class);
    } else {
      $stickyConfigurables.classList.remove(c.cls.is_visible_class);
    }
  };

  /**
   * Add To Cart
   */
  function addToCart() {
    if ($select) selectedOptionValue = $select.options[$select.selectedIndex].value;

    if ($select && selectedOptionValue === '') {
      showSelectSizeText();
    } else {
      if (document.body.classList.contains(c.cls.zoom_is_open)) {
        SDG.Product.zoomClose();
      }
      $addToCartButton.click();
    }
  }

  /**
   * Show 'Select Size' Text
   */
  function showSelectSizeText() {
    const initialInnerHtml = $stickyAddToCart.innerHTML;

    if (SDG.Product.currentProduct.handle === 'gift-card') {
      $stickyAddToCart.innerHTML = c.select_value_text;
    } else {
      $stickyAddToCart.innerHTML = c.select_size_text;
    }

    $stickyAddToCart.classList.add(`${c.cls.added_class}`);

    setTimeout(() => {
      $stickyAddToCart.innerHTML = initialInnerHtml
      $stickyAddToCart.classList.remove(`${c.cls.added_class}`);
    }, 3000);
  }

  /**
   * Open Back In Stock Form
   */
  function openBackInStockForm() {
    const offsetTop = $backInStockPosition.offsetTop;
    if (document.body.classList.contains(c.cls.zoom_is_open)) {
      SDG.Product.zoomClose();
    }
    scroll({
      top: offsetTop,
      behavior: "smooth"
    });

    $backInStockButton.click();
  }

  /**
   * return
   */
  return init();
};

SDG.sizeGudide();

/**
 * Recently Viewed
 * @type {Function}
 * @return init()
 *
 */

SDG.recentlyViewed = function (action) {

  const c = {
    cls: {
      recently_viewed_wrapper: 'js-recently-viewed',
      recently_viewed_product_class: 'collection-product',
      js_recently_viewed_product_class: 'js-collection-product',
      recently_viewed_product_class_quick_add: 'collection-product--with-quick-add',
      recently_viewed_product_rtw_class: 'collection-product--rtw',
      mini_bag_qucik_add: 'js-mini-bag-quick-add',
      empty_bag_collection: 'js-collection-empty-bag',
    },
    howManyToShow: 4,
    howManyToStoreInMemory: 4
  }

  const $recentlyViewedWrapper = document.querySelectorAll(`.${c.cls.recently_viewed_wrapper}`);
  let recentlyViewed = JSON.parse(localStorage.getItem('recently-viewed-products')) || [];

  const getSymbol = (code) => ({ AED: 'د.إ', AFN: '؋', ALL: 'L', AMD: '֏', ANG: 'ƒ', AOA: 'Kz', ARS: '$', AUD: '$', AWG: 'Afl', AZN: '₼', BAM: 'KM', BBD: '$', BDT: '৳', BGN: 'лв.', BHD: '.د.ب', BIF: 'FBu', BMD: '$', BND: '$', BOB: '$b', BRL: 'R$', BSD: '$', BTC: '₿', BTN: 'Nu.', BWP: 'P', BYR: 'Br', BYN: 'Br', BZD: 'BZ$', CAD: '$', CDF: 'FC', CHF: 'Fr.', CLP: '$', CNY: '¥', COP: '$', CRC: '₡', CUC: '$', CUP: '₱', CVE: '$', CZK: 'Kč', DJF: 'Fdj', DKK: 'kr', DOP: 'RD$', DZD: 'دج', EGP: '£', ERN: 'Nfk', ETB: 'Br', ETH: 'Ξ', EUR: '€', FJD: '$', FKP: '£', GBP: '£', GEL: '₾', GGP: '£', GHS: 'GH₵', GIP: '£', GMD: 'D', GNF: 'FG', GTQ: 'Q', GYD: '$', HKD: '$', HNL: 'L', HRK: 'kn', HTG: 'G', HUF: 'Ft', IDR: 'Rp', ILS: '₪', IMP: '£', INR: '₹', IQD: 'ع.د', IRR: '﷼', ISK: 'kr', JEP: '£', JMD: 'J$', JOD: 'JD', JPY: '¥', KES: 'KSh', KGS: 'лв', KHR: '៛', KMF: 'CF', KPW: '₩', KRW: '₩', KWD: 'KD', KYD: '$', KZT: '₸', LAK: '₭', LBP: '£', LKR: '₨', LRD: '$', LSL: 'M', LTC: 'Ł', LYD: 'LD', MAD: 'MAD', MDL: 'lei', MGA: 'Ar', MKD: 'ден', MMK: 'K', MNT: '₮', MOP: 'MOP$', MRO: 'UM', MRU: 'UM', MUR: '₨', MVR: 'Rf', MWK: 'MK', MXN: '$', MYR: 'RM', MZN: 'MT', NAD: '$', NGN: '₦', NIO: 'C$', NOK: 'kr', NPR: '₨', NZD: '$', OMR: '﷼', PAB: 'B/.', PEN: 'S/', PGK: 'K', PHP: '₱', PKR: '₨', PLN: 'zł', PYG: 'Gs', QAR: '﷼', RMB: '￥', RON: 'L', RSD: 'Дин.', RUB: '₽', RWF: 'R₣', SAR: '﷼', SBD: '$', SCR: '₨', SDG: 'ج.س.', SEK: 'kr', SGD: '$', SHP: '£', SLL: 'Le', SOS: 'S', SRD: '$', SSP: '£', STD: 'Db', STN: 'Db', SVC: '$', SYP: '£', SZL: 'E', THB: '฿', TJS: 'SM', TMT: 'T', TND: 'د.ت', TOP: 'T$', TRL: '₤', TRY: '₺', TTD: 'TT$', TVD: '$', TWD: 'NT$', TZS: 'TSh', UAH: '₴', UGX: 'USh', USD: '$', UYU: '$', UZS: 'soʻm', VEF: 'Bs', VND: '₫', VUV: 'VT', WST: 'WS$', XAF: 'FCFA', XBT: '₿', XCD: '$', XOF: 'CFA', XPF: '₣', YER: '﷼', ZAR: 'R', ZMW: 'ZK', ZMK: 'ZK', ZWL: 'Z$' }[code]);

  let currency = getSymbol(window.Shopify.currency.active)


  /**
   * Init
   */
  function init() {

    if (action === 'store') {
      storeRecentlyViewed();
    }

    if (action === 'render' && $recentlyViewedWrapper.length > 0) {
      getRecentlyViewedData();
    }
  }

  /**
   * Store Recently Viewed
   */
  function storeRecentlyViewed() {
    if (window.location.pathname.indexOf('/products/') !== -1) {
      const productHandle = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1];
      const positionInArray = recentlyViewed.indexOf(productHandle);
      if (positionInArray === -1) {
        recentlyViewed.unshift(productHandle);
        recentlyViewed = recentlyViewed.splice(0, c.howManyToStoreInMemory);
      } else {
        recentlyViewed.splice(positionInArray, 1);
        recentlyViewed.unshift(productHandle);
      }

      localStorage.setItem('recently-viewed-products', JSON.stringify(recentlyViewed));
    }
  }

  /**
   * Get Recently Viewed Data
   */
  function getRecentlyViewedData() {
    SDG.RecentlyViewedProducts = SDG.RecentlyViewedProducts || {};
    recentlyViewed.forEach((productHandle, index) => {

      if (index < c.howManyToShow) {
        fetch(`/products/${productHandle}.js`, {
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then(res => res.json())
          .then(productData => {
            SDG.RecentlyViewedProducts[productData.id] = productData;
            // get metafields
            fetch(`/products/${productHandle}?view=metafields`, {
              headers: {
                "Content-Type": "application/json",
              },
            })
              .then(res => res.json())
              .then((response) => {
                SDG.RecentlyViewedProducts[productData.id].metafields = response;
                renderProduct(SDG.RecentlyViewedProducts[productData.id]);
              });
          });
      }
    });
  }

  /**
   * Render Product
   */
  function renderProduct(productData) {
    const $product = document.createElement('div');
    const productType = _.handleize(productData.type);
    const productDataTileIsUndefined = productData.title.split('-')[1] === undefined;
    const isShoe = productData.tags?.includes('shoes');
    const showWhenSoldOutTag = productData.tags?.includes('show-when-soldout')
      || productData.tags?.includes('!back-in-stock')
      || productData.tags?.includes('!coming-soon');
    let productInventory = 0;
    let additionalFlagsStr = '';
    let productSoldOut = false;
    let productComingSoon = false;
    let productWaitlist = false;
    let productLowStock = false;
    let productSale = false;
    let coverMainImage = false;
    let coverHoverImage = false;
    let productColor = true;
    let hasHoverImage = false;
    let buttonHtml = '';
    let hoverImage = '';

    $product.classList.add(c.cls.recently_viewed_product_class);
    $product.classList.add(c.cls.js_recently_viewed_product_class);
    $product.classList.add(c.cls.recently_viewed_product_class_quick_add);
    $product.setAttribute('data-product-type-handle', productType);

    productData.variants.forEach((variant) => {
      productInventory += variant.inventory_quantity;
    });

    if (productData.tags.length > 0) {
      productData.tags.forEach((tag) => {
        const newTag = tag.replace('!', '').replace('monogramming', '').replace(':', '').replace(/\s/g, '');
        if ($product && newTag.length > 0) $product.classList.add(newTag);
      })

      if (productInventory === 0) {
        productSoldOut = true;

        if (productData.tags?.includes('!coming-soon')) {
          productComingSoon = true;
          productSoldOut = false;
        } else if (productData.tags?.includes('!back-in-stock')) {
          productWaitlist = true;
          productSoldOut = false;
        }
      }

      if (productData.tags?.includes('rtw')) {
        if ($product) $product.classList.add(c.cls.recently_viewed_product_rtw_class);
      }
    }

    if (productInventory < 4 && productInventory > 0) {
      productLowStock = true;
    }

    if (productData.tags.length > 0) {
      productData.tags.forEach((tag) => {
        if (tag?.includes('flag:')) {
          tag = tag.split(':');
          tag = tag[1];
          additionalFlagsStr += `<span class="${c.cls.recently_viewed_product_class}__flags-flag is-visible">${tag}</span>`
        }

        if (tag === 'salefinal' && !productData.tags.includes('used')) {
          productSale = true;
        }
      })
    }

    if (productData.media[0]?.alt === 'cover') {
      coverMainImage = true
    }

    if (productData.media[1]?.alt === 'cover') {
      coverHoverImage = true
    }

    if (productDataTileIsUndefined) {
      productColor = false
    }

    if (isShoe) {
      buttonHtml = `
        <a href="${productData.url}"
          class="collection-product__select-size"
        >
          Select a size
        </a>`;

    } else {
      buttonHtml = `
        <button
          type="button"
          class="collection-product__quick-add js-mini-bag-quick-add"
          data-fp="${productData.metafields.data_fp}"
          data-cafp="${productData.metafields.data_cafp}"
          data-variant-id="${productData.variants[0].id}"
          data-handle="${productData.handle}"
          ${productSale ? 'data-final-sale="true"' : ''}
        >
          Add to bag
        </button>`;
    }

    if (productData.media[1]) {
      hoverImage = `
        <img
          class="lazyload collection-image--hover image-scale${coverHoverImage ? ` collection-image--hover-cover` : ''}"
          data-src="${getSizedImageUrl(productData.media[1].src, '{width}x')}"
          data-widths="[180,360,540,720,900]"
          data-sizes="auto"
          tabindex="-1"
          alt="${productData.media[1].alt}"
        >`;
      hasHoverImage = true;
    }

    var str = `
      <div class="${c.cls.recently_viewed_product_class}__flags">
        ${productSoldOut ? `<span class="${c.cls.recently_viewed_product_class}__flags-flag is-visible">Sold out</span>` : ''}
        ${productComingSoon ? `<span class="${c.cls.recently_viewed_product_class}__flags-flag is-visible">Coming Soon</span>` : ''}
        ${productWaitlist ? `<span class="${c.cls.recently_viewed_product_class}__flags-flag is-visible">Waitlist</span>` : ''}
        ${productLowStock ? `<span class="${c.cls.recently_viewed_product_class}__flags-flag is-visible">Low Stock</span>` : ''}
        ${productSale ? `<span class="${c.cls.recently_viewed_product_class}__flags-flag is-visible">Sale</span>` : ''}
        ${additionalFlagsStr}
      </div>

      <a href="${productData.url}" class="collection-image-wrap${hasHoverImage ? `` : ` collection-image-wrap--no-hover-image`}">
        <img
          class="lazyload collection-image image-scale${coverMainImage ? ` collection-image--cover` : ''}"
          data-src="${getSizedImageUrl(productData.media[0].src, '{width}x')}"
          data-widths="[180,360,540,720,900]"
          data-sizes="auto"
          tabindex="-1"
          alt="${productData.media[0].alt}"
        >
        ${hoverImage}
      </a>

      <a href="${productData.url}" class="${c.cls.recently_viewed_product_class}__details">
        <div class="collection-product__details-block">
          <h4 class="${c.cls.recently_viewed_product_class}__details-title">
            ${productData.title.split('-')[0]}
          </h4>
          <div class="${c.cls.recently_viewed_product_class}__details-prices">
          ${productData.tags?.includes('on-sale') ? `<s class="compare-at-price with-price">
            <span class="screenreader">Original: ${currency}${(productData.compare_at_price / 100).toFixed()}</span>
          </s>` : ''}
          ${productData.tags?.includes('on-sale') ? `<s class="compare-at-price with-price">
            <span class="price js-collection-product-compare-at-price">${currency}${(productData.compare_at_price / 100).toFixed()}</span>
          </s>` : ''}
            <span class="product__price">
              <span class="screenreader">Current Price: ${currency}${(productData.price / 100).toFixed()} ${Shopify.currency.active === 'USD' ? '' : Shopify.currency.active}</span>
              <span class="price" data-fp="${productData.metafields.data_fp}">
                ${currency}${(productData.price / 100).toFixed()} ${Shopify.currency.active === 'USD' ? '' : Shopify.currency.active}
              </span>
            </span>
          </div>
        </div>
        <div class="${c.cls.recently_viewed_product_class}__details-color">
          ${productColor ? productData.title.split('-')[1] : ''}
        </div>
        ${productInventory < 4 && productInventory > 0 ? `<p class="${c.cls.recently_viewed_product_class}__details-low-inventory">Only ${productInventory} left</p>` : ``}
      </a>
      ${buttonHtml}
    `;

    $product.innerHTML = str;

    $recentlyViewedWrapper.forEach(($wrapper) => {
      if ($wrapper.classList.contains(c.cls.empty_bag_collection)) {
        $wrapper.append($product);
      } else {
        $wrapper.append($product.cloneNode(true));
      }
    });

    // add qucik add click event
    const $productQuickAdd = $product.querySelector(`.${c.cls.mini_bag_qucik_add}`);

    if ($productQuickAdd) {
      const variantId = Number($productQuickAdd.dataset.variantId);
      $productQuickAdd.addEventListener('click', (e) => SDG.Bag.quickAdd(variantId, e.target));
    }
  };

  /**
   * Resize Shopify Image URL
   * @param {*} src
   * @param {*} size
   */
  function getSizedImageUrl(src, size) {
    // remove any current image size then add the new image size
    if (typeof src !== 'undefined') {
      return src
        .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
        .replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
          return `_${size}${match}`;
        })
    } else {
      return '';
    }
  }


  return init();

};

SDG.recentlyViewed(action = 'render');

/**
 * Product Swatches
 * @type {Function}
 * @return init()
 *
 */
SDG.MiniCart = SDG.MiniCart || {};
SDG.Product.gallery = SDG.Product.gallery || {};
SDG.Product.updateContent = SDG.Product.updateContent || '';
SDG.MiniCart.addToBagClickCount = SDG.MiniCart.addToBagClickCount || 0;

SDG.productSwatches = function () {

  const getSymbol = (code) => ({ AED: 'د.إ', AFN: '؋', ALL: 'L', AMD: '֏', ANG: 'ƒ', AOA: 'Kz', ARS: '$', AUD: '$', AWG: 'ƒ', AZN: '₼', BAM: 'KM', BBD: '$', BDT: '৳', BGN: 'лв.', BHD: '.د.ب', BIF: 'FBu', BMD: '$', BND: '$', BOB: '$b', BRL: 'R$', BSD: '$', BTC: '₿', BTN: 'Nu.', BWP: 'P', BYR: 'Br', BYN: 'Br', BZD: 'BZ$', CAD: '$', CDF: 'FC', CHF: 'Fr.', CLP: '$', CNY: '¥', COP: '$', CRC: '₡', CUC: '$', CUP: '₱', CVE: '$', CZK: 'Kč', DJF: 'Fdj', DKK: 'kr', DOP: 'RD$', DZD: 'دج', EGP: '£', ERN: 'Nfk', ETB: 'Br', ETH: 'Ξ', EUR: '€', FJD: '$', FKP: '£', GBP: '£', GEL: '₾', GGP: '£', GHS: 'GH₵', GIP: '£', GMD: 'D', GNF: 'FG', GTQ: 'Q', GYD: '$', HKD: '$', HNL: 'L', HRK: 'kn', HTG: 'G', HUF: 'Ft', IDR: 'Rp', ILS: '₪', IMP: '£', INR: '₹', IQD: 'ع.د', IRR: '﷼', ISK: 'kr', JEP: '£', JMD: 'J$', JOD: 'JD', JPY: '¥', KES: 'KSh', KGS: 'лв', KHR: '៛', KMF: 'CF', KPW: '₩', KRW: '₩', KWD: 'KD', KYD: '$', KZT: '₸', LAK: '₭', LBP: '£', LKR: '₨', LRD: '$', LSL: 'M', LTC: 'Ł', LYD: 'LD', MAD: 'MAD', MDL: 'lei', MGA: 'Ar', MKD: 'ден', MMK: 'K', MNT: '₮', MOP: 'MOP$', MRO: 'UM', MRU: 'UM', MUR: '₨', MVR: 'Rf', MWK: 'MK', MXN: '$', MYR: 'RM', MZN: 'MT', NAD: '$', NGN: '₦', NIO: 'C$', NOK: 'kr', NPR: '₨', NZD: '$', OMR: '﷼', PAB: 'B/.', PEN: 'S/', PGK: 'K', PHP: '₱', PKR: '₨', PLN: 'zł', PYG: 'Gs', QAR: '﷼', RMB: '￥', RON: 'L', RSD: 'Дин.', RUB: '₽', RWF: 'R₣', SAR: '﷼', SBD: '$', SCR: '₨', SDG: 'ج.س.', SEK: 'kr', SGD: '$', SHP: '£', SLL: 'Le', SOS: 'S', SRD: '$', SSP: '£', STD: 'Db', STN: 'Db', SVC: '$', SYP: '£', SZL: 'E', THB: '฿', TJS: 'SM', TMT: 'T', TND: 'د.ت', TOP: 'T$', TRL: '₤', TRY: '₺', TTD: 'TT$', TVD: '$', TWD: 'NT$', TZS: 'TSh', UAH: '₴', UGX: 'USh', USD: '$', UYU: '$', UZS: 'soʻm', VEF: 'Bs', VND: '₫', VUV: 'VT', WST: 'WS$', XAF: 'FCFA', XBT: '₿', XCD: '$', XOF: 'CFA', XPF: '₣', YER: '﷼', ZAR: 'R', ZMW: 'ZK', ZMK: 'ZK', ZWL: 'Z$' }[code]);

  currency = getSymbol(window.Shopify.currency.active)

  const c = {
    cls: {
      active_cell_class: 'product-gallery__picture--active',
      add_monogramming_button: 'js-monogramming-add',
      add_to_cart_button_text: 'js-add-to-cart-text',
      added_class: 'added',
      additional_flag: 'js-additional-flag',
      addToCartButton: 'js-add-to-cart',
      back_in_stock_form_submit: 'js-back-in-stock-button',
      back_in_stock_form: 'js-back-in-stock-form',
      backInStockButton: 'js-back-in-stock',
      button_price: 'js-button-price',
      color_label: 'js-color-label',
      coming_soon_flag: 'js-coming-soon-flag',
      compare_at_price_wrap: 'js-compare-at-price-wrap',
      compare_at_price: 'js-compare-at-price',
      description: 'product__description-us',
      description_mobile: 'tab-description--mobile',
      empty_class: 'is-empty',
      flag_class: 'product__tags-tag',
      flags_wrap: 'js-flags-wrap',
      final_sale: 'js-final-sale',
      final_sale_hidden_input: 'js-final-sale-hidden-input',
      preorder: 'js-preorder',
      has_value_class: 'has-value',
      hidden_class: 'hidden',
      hidden_fp_input: 'js-hidden-fp-input',
      hidden_cafp_input: 'js-hidden-cafp-input',
      is_monogrammable_class: 'is-monogrammable',
      is_active_class: 'is-active',
      leather_selects: 'js-leather',
      low_stock_flag: 'js-low-stock-flag',
      monogram_product_image: 'js-monogram-product-image',
      monogramming_open_button: 'js-open-monogramming',
      fit_information: 'js-fit-infromation',
      oldSelects: 'js-product-sizes',
      price: 'js-price',
      product_block: 'js-product-block',
      product_blocks_wrap: 'js-product-blocks',
      product_thumb: 'js-product-thumb',
      product_zoom_image: 'js-product-zoom-image',
      product_form: 'js-product-form',
      monogram_form: '#monogramProductForm',
      preorder_input: 'js-preorder-input',
      product: 'js-product',
      productImage: 'js-product-image',
      sale_flag: 'js-sale-flag',
      select_option: 'js-select-option',
      selected_option: 'js-selected-option',
      selectedClass: 'is-selected',
      selectWrap: 'js-select-wrap',
      sold_out_flag: 'js-soldout-flag',
      sticky_add_to_bag_button: 'js-sticky-add-to-cart',
      sticky_back_in_stock_button: 'js-sticky-back-in-stock',
      sticky_color: 'js-sticky-color',
      sticky_configurables: 'js-sticky-configurables',
      sticky_price: 'js-sticky-price',
      swatch_wrap: 'js-swatch-wrap',
      swatch: 'js-swatch',
      tab: 'js-product-tab',
      tabContent: 'js-tab-content',
      visible_class: 'is-visible',
      waitlist_flag: 'js-waitlist-flag',
      with_price_class: 'with-price',
      product_services: 'js-product-services',
      product_services_international: 'js-product-services-international',
    },
    monogram_add_text: 'Add a monogram',
    coming_soon_text: 'Coming Soon',
    waitlist_text: 'Waitlist',
    init_leather_text: 'Select a leather',
    select_size_text: 'Select a size',
    add_to_cart_text: 'Add to bag',
  }

  // These elements get replaced when monogramming resets, so just grab them every time
  // to ensure we aren't referencing removed elements.
  const $addMonogrammingButton = () => document.querySelector(`.${c.cls.add_monogramming_button}`);
  const $monogramProductImages = () => document.querySelectorAll(`.${c.cls.monogram_product_image}`);
  // cached globals
  const $addToCartButton = document.querySelector(`.${c.cls.addToCartButton}`);
  const $addToCartButtonText = document.querySelector(`.${c.cls.add_to_cart_button_text}`);
  const $backInStockButton = document.querySelector(`.${c.cls.backInStockButton}`);
  const $backInStockForm = document.querySelector(`.${c.cls.back_in_stock_form}`);
  const $backInStockFormSubmit = document.querySelector(`.${c.cls.back_in_stock_form_submit}`);
  const $buttonPrice = document.querySelector(`.${c.cls.button_price}`);
  const $colorLabel = document.querySelector(`.${c.cls.color_label}`);
  const $comingSoonFlags = document.querySelectorAll(`.${c.cls.coming_soon_flag}`);
  const $compareAtPrice = document.querySelector(`.${c.cls.compare_at_price}`);
  const $compareAtPriceWrap = document.querySelector(`.${c.cls.compare_at_price_wrap}`);
  const $description = document.querySelector(`.${c.cls.description}`);
  const $descriptionMobile = document.querySelector(`.${c.cls.description_mobile}`);
  const $finalSale = document.querySelector(`.${c.cls.final_sale}`);
  const $finalSaleHiddenInput = document.querySelector(`.${c.cls.final_sale_hidden_input}`);
  const $preorder = document.querySelector(`.${c.cls.preorder}`);
  const $fitInformation = document.querySelector(`.${c.cls.fit_information}`);
  const $flagsWrap = document.querySelectorAll(`.${c.cls.flags_wrap}`);
  const $hiddenCafpInput = document.querySelector(`.${c.cls.hidden_cafp_input}`);
  const $hiddenFpInput = document.querySelector(`.${c.cls.hidden_fp_input}`);
  const $leatherSelectsWrap = document.querySelector(`.${c.cls.leather_selects}`);
  const $lowStockFlags = document.querySelectorAll(`.${c.cls.low_stock_flag}`);
  const $oldSelects = document.querySelectorAll(`.${c.cls.oldSelects}`);
  const $product = document.querySelector(`.${c.cls.product}`);
  const $productBlocksWrap = document.querySelector(`.${c.cls.product_blocks_wrap}`);
  const $productImages = document.querySelectorAll(`.${c.cls.productImage}`);
  const $productServices = document.querySelector(`.${c.cls.product_services}`);
  const $productServicesInternational = document.querySelector(`.${c.cls.product_services_international}`);
  const $productThumbs = document.querySelectorAll(`.${c.cls.product_thumb}`);
  const $productZoomImages = document.querySelectorAll(`.${c.cls.product_zoom_image}`);
  const $saleFlags = document.querySelectorAll(`.${c.cls.sale_flag}`);
  const $selectedOption = document.querySelector(`.${c.cls.selected_option}`);
  const $selectOptions = document.querySelectorAll(`.${c.cls.select_option}`);
  const $selectWraps = document.querySelectorAll(`.${c.cls.selectWrap}`);
  const $soldOutFlags = document.querySelectorAll(`.${c.cls.sold_out_flag}`);
  const $stickyAddToCartButton = document.querySelector(`.${c.cls.sticky_add_to_bag_button}`);
  const $stickyBackInStockButton = document.querySelector(`.${c.cls.sticky_back_in_stock_button}`);
  const $stickyColor = document.querySelector(`.${c.cls.sticky_color}`);
  const $stickyPrice = document.querySelector(`.${c.cls.sticky_price}`);
  const $swatches = document.querySelectorAll(`.${c.cls.swatch}`);
  const $swatchWraps = document.querySelectorAll(`.${c.cls.swatch_wrap}`);
  const $waitlistFlags = document.querySelectorAll(`.${c.cls.waitlist_flag}`);
  const $productForm = document.querySelector(`.${c.cls.product_form}`);
  const $monogramForm = document.querySelector(`${c.cls.monogram_form}`);
  const view = SDG.Viewport.currentState;

  let productTemplateRequestId = 0;
  let initialLoad = true;

  SDG.Product.updateContent = updateContent;

  /**
   * init
   */
  function init() {

    if ($swatches.length > 0) {
      addEvents();
      setCurrentProduct();
      showWaitlistButton();

      if ($leatherSelectsWrap) {
        hideMergedSwatches();
      }
    }
  };

  /**
   * Add Events
   */
  function addEvents() {
    $swatches.forEach(($swatch) => {
      $swatch.addEventListener('click', updateContent)
    });
  };

  /**
   * Set Current Product
   */

  function setCurrentProduct() {
    let $currentSwatch;
    let url = window.top.location.pathname.replace(/\/+$/, "");

    $swatches.forEach(($swatch) => {
      if ($swatch.dataset.url === url) {
        $currentSwatch = $swatch;
      }
    })

    if ($currentSwatch === undefined) {
      $currentSwatch = $swatches[0];
    }

    SDG.Product.currentProduct = $currentSwatch.dataset;

    $currentSwatch.click();
  }

  /**
   * Hide Merged Swatches
   */
  function hideMergedSwatches() {
    let colorsArray = [];
    let groupedColorsArray = [];


    $swatchWraps.forEach(($swatchWrap) => {
      const $button = $swatchWrap.querySelector(`.${c.cls.swatch}`);
      const outsideColor = $button.dataset.outsideColor;

      if (outsideColor !== '') {
        colorsArray.push($swatchWrap);
      }
    });

    // group swatches by outside color
    colorsArray.forEach((item) => {
      let groupedColors = [];
      let includes;
      const $button = item.querySelector(`.${c.cls.swatch}`);
      const outsideColor = $button.dataset.outsideColor;

      colorsArray.forEach((i) => {
        const $button = i.querySelector(`.${c.cls.swatch}`);
        const color = $button.dataset.outsideColor;

        if (outsideColor === color) {
          groupedColors.push(i);
        }
      });

      includes = groupedColorsArray.some(a => groupedColors.every((v, i) => v === a[i]));
      if (includes === false) {
        groupedColorsArray.push(groupedColors);
      }
    })

    // show only first swatch from grouped swatches and hide the rest
    groupedColorsArray.forEach((array) => {
      array.forEach(($swatch, index) => {
        if (index !== 0) {
          $swatch.style.display = 'none';
        }
      })
    })
  }

  /**
   * Update Content
   */
  function updateContent(eventOrTarget, source) {
    let $target;

    if (eventOrTarget.target === undefined) {
      $target = eventOrTarget;
    } else {
      $target = eventOrTarget.target;
    }

    if ($target.nodeName === 'IMG') $target = eventOrTarget.target.parentNode;

    const { colorHandle, humanColor, description, productId, contentBlocks, productTitle, firstImage, comingSoon, monogram,
      monogramLettersBlock, url, soldout, backInStock, backInStockButtonText, type, vendor, flags, sizing,
      variantId, finalSale, lowStock, globaleFp, globaleFpCompareAt, fabricDropdown, outsideColor, productServices, preorder, hasSizeGuide } = $target.dataset;

    const price = parseInt($target.dataset.price, 10);
    const compareAtPrice = parseInt($target.dataset.compareAtPrice, 10);

    const $price = document.querySelector(`.${c.cls.price}`);
    const $radio = document.querySelector(`input[value="${variantId}"]`);
    const $radios = document.querySelectorAll(`input[type="radio"]`);
    const allContentBlocks = SDG.Product.contentBlocks;
    const stickyAddToCartHtml = `
      Add to bag
      <span class="sticky-configurables__button-dot"></span>
      <span class="js-sticky-price"></span>
    `;
    const flagsArray = flags.split(',');
    const $additionalFlags = document.querySelectorAll(`.${c.cls.additional_flag}`);

    const priceFormatted = `${SDG.formatMoney(price, 'amount_with_currency_without_trailing_zeros', theme.currency.symbol)} ${theme.currency.iso_code == "USD" ? "" : theme.currency.iso_code}`;
    const compareFormatted = `${SDG.formatMoney(compareAtPrice, 'amount_with_currency_without_trailing_zeros', theme.currency.symbol)} ${theme.currency.iso_code == "USD" ? "" : theme.currency.iso_code}`;

    const showCompareAtPrice = $compareAtPrice
      && compareAtPrice !== ''
      && price < compareAtPrice;

    let contentBlocksHandlesArray = contentBlocks.split(',');

    // update Size guide
    const view_size_guide_btn_all = document.querySelectorAll('.js-trigger-size-guide');
    const view_size_guide_btn_mobile = document.querySelector('.product-tabs__size_guide-link');

    $addToCartButton.dataset.productId = productId;

    view_size_guide_btn_all && view_size_guide_btn_all.forEach(btn => {
      if (btn) {
        btn.dataset.productId = productId;
        const parent = btn.closest('.new-select__heading-body');
        if (hasSizeGuide == "true") {
          btn.classList.remove('hidden');
          parent && parent.classList.remove('hidden');
        } else {
          btn.classList.add('hidden');
          parent && parent.classList.add('hidden');
        }
      }
    });

    if (!initialLoad) {
      productTemplateRequestId++;
      const currentRequestId = productTemplateRequestId;

      document.querySelector('.js-product-tabs').style.opacity = 0;

      fetch(url)
        .then(res => res.text())
        .then(res => {
          if (currentRequestId !== productTemplateRequestId) return;

          html = new DOMParser().parseFromString(res, "text/html");

          const newTabs = html.querySelector('.js-product-tabs');

          document.querySelector('.js-product-tabs').outerHTML = newTabs.outerHTML;
        });
    }

    if (view_size_guide_btn_mobile) {
      view_size_guide_btn_mobile.dataset.productId = productId;
      if (hasSizeGuide == "true") {
        view_size_guide_btn_mobile.classList.remove('hidden');
      } else {
        view_size_guide_btn_mobile.classList.add('hidden');
      }
    }


    // remove empty strings
    contentBlocksHandlesArray = contentBlocksHandlesArray.filter(Boolean);

    // update SDG Product
    SDG.Product.currentProduct.id = productId;
    SDG.Product.currentProduct.color = colorHandle;

    if ($productForm && variantId) {
      $productForm.dataset.variantId = variantId;
    }

    if ($monogramForm && variantId) {
      if ($monogramForm.querySelector('[name="properties[Product]"]')) {
        $monogramForm.querySelector('[name="properties[Product]"]').value = variantId
      }
    }

    // add active class to clicked swatch
    if (source !== 'leather-selector') {
      // remove active class from swatches
      $swatches.forEach(($swatch) => {
        $swatch.classList.remove(c.cls.selectedClass);
      });
      $target.classList.add(c.cls.selectedClass);

      if ($selectedOption && fabricDropdown === 'true') {
        $selectedOption.innerHTML = c.init_leather_text;
        $selectedOption.classList.remove(c.cls.has_value_class);
        $radios.forEach(($radio) => $radio.checked = false)
      } else {
        // if product has only colors find radio and select
        if ($radio) $radio.checked = true;
      }
    } else {
      // if product has only colors find radio and select
      if ($radio) $radio.checked = true;
    }

    // show corect size select
    $selectWraps.forEach(($select) => {
      if ($select.dataset.productId === productId) {
        $select.classList.remove(c.cls.hidden_class);
      } else {
        $select.classList.add(c.cls.hidden_class);
      }
    });

    // enable select
    $oldSelects.forEach(($select) => {
      if ($select.dataset.productId === productId) {
        $select.disabled = false;
      } else {
        $select.disabled = true;
      }
    });

    // update flags
    // add new flags from the array
    $additionalFlags.forEach(($flag) => $flag.remove());

    if (flagsArray.length > 0) {
      flagsArray.forEach((flag) => {
        if (flag.length > 0) {
          const $flag = document.createElement('div');
          const $flagFobile = document.createElement('div');
          $flag.classList = `${c.cls.flag_class} ${c.cls.additional_flag}`;
          $flagFobile.classList = `${c.cls.flag_class} ${c.cls.additional_flag}`;
          $flag.innerHTML = flag;
          $flagFobile.innerHTML = flag;
          $flagsWrap[0].append($flag);
          $flagsWrap[1].append($flagFobile);
        }
      });
    }

    // sale flag
    if (finalSale === 'true') {
      $saleFlags.forEach(($flag) => $flag.classList.remove(c.cls.hidden_class));
      $finalSale.classList.remove(c.cls.hidden_class);
      $finalSaleHiddenInput.setAttribute('name', 'properties[_finalSale]');
    } else {
      $saleFlags.forEach(($flag) => $flag.classList.add(c.cls.hidden_class));
      $finalSale.classList.add(c.cls.hidden_class);
      $finalSaleHiddenInput.removeAttribute('name');
    }

    const compareWrap = document.querySelector('.js-compare-at-price-wrap');
    const compareTarget = document.querySelector('.price.js-compare-at-price');
    const priceTarget = document.querySelector('.price.product__price.js-price');

    if (showCompareAtPrice) {
      priceTarget.innerHTML = `<span class="screenreader">Current Price: </span>${priceFormatted}`;
      compareTarget.innerHTML = `<span class="screenreader">Original Price: </span>${compareFormatted}`;
      compareWrap.classList.add('with-price');
    } else {
      priceTarget.innerHTML = `<span class="screenreader">Current Price: </span>${priceFormatted}`;
      compareTarget.innerHTML = ``;
      compareWrap.classList.remove('with-price');
    }

    let atcbut = document.querySelector('.product__add-submit.js-add-to-cart');
    // preorder text
    if (preorder !== 'false') {
      $preorder.innerHTML = preorder;
      $preorder.classList.remove(c.cls.hidden_class);

      const preorderHiddenInput = document.createElement("input");
      if(atcbut) {
        atcbut.classList.add('preorder');
      }
      preorderHiddenInput.type = 'hidden';
      preorderHiddenInput.name = 'properties[_preorder]';
      preorderHiddenInput.value = preorder;
      preorderHiddenInput.classList = c.cls.preorder_input;

      // append input to DOM
      $productForm.append(preorderHiddenInput);
    } else {
      $preorder.classList.add(c.cls.hidden_class);
      $preorder.innerHTML = '';

      if(atcbut) {
        atcbut.classList.remove('preorder');
      }
      const preorderHiddenInput = document.querySelector(`.${c.cls.preorder_input}`);
      if (preorderHiddenInput) preorderHiddenInput.remove();
    }

    // low stock flag
    if (lowStock === 'true') {
      $lowStockFlags.forEach(($flag) => $flag.classList.remove(c.cls.hidden_class));
    } else {
      $lowStockFlags.forEach(($flag) => $flag.classList.add(c.cls.hidden_class));
    }

    // sold out flag
    if (soldout === 'true') {
      $soldOutFlags.forEach(($flag) => $flag.classList.remove(c.cls.hidden_class));
    } else {
      $soldOutFlags.forEach(($flag) => $flag.classList.add(c.cls.hidden_class));
    }

    // waitlist, coming soon and sold out flag
    if (soldout === 'true' && backInStock === 'true' && comingSoon === 'false') {
      $waitlistFlags.forEach(($flag) => $flag.classList.remove(c.cls.hidden_class));
      $comingSoonFlags.forEach(($flag) => $flag.classList.add(c.cls.hidden_class));
      $soldOutFlags.forEach(($flag) => $flag.classList.add(c.cls.hidden_class));
    } else if (soldout === 'true' && backInStock === 'false' && comingSoon === 'false') {
      $waitlistFlags.forEach(($flag) => $flag.classList.add(c.cls.hidden_class));
      $soldOutFlags.forEach(($flag) => $flag.classList.remove(c.cls.hidden_class));
      $comingSoonFlags.forEach(($flag) => $flag.classList.add(c.cls.hidden_class));
    } else if (comingSoon === 'true' && backInStock === 'false' && soldout === 'true') {
      $comingSoonFlags.forEach(($flag) => $flag.classList.remove(c.cls.hidden_class));
      $waitlistFlags.forEach(($flag) => $flag.classList.remove(c.cls.hidden_class));
      $soldOutFlags.forEach(($flag) => $flag.classList.add(c.cls.hidden_class));
    } else {
      $waitlistFlags.forEach(($flag) => $flag.classList.add(c.cls.hidden_class));
      $soldOutFlags.forEach(($flag) => $flag.classList.add(c.cls.hidden_class));
      $comingSoonFlags.forEach(($flag) => $flag.classList.add(c.cls.hidden_class));
    }

    // set active class on current product images
    $productImages.forEach(($image) => {
      if ($image.classList.contains(`js-${SDG.Product.currentProduct.color}`)) {
        $image.classList.add(c.cls.active_cell_class);
      } else {
        $image.classList.remove(c.cls.active_cell_class);
      }
    });

    // set active class on current product thumbs
    $productThumbs.forEach(($image) => {
      if ($image.classList.contains(`js-${SDG.Product.currentProduct.color}`)) {
        $image.classList.remove(c.cls.hidden_class);
        $image.classList.add(c.cls.visible_class);
      } else {
        $image.classList.add(c.cls.hidden_class);
        $image.classList.remove(c.cls.visible_class);
      }
    });

    // set active class on current product zoom images
    $productZoomImages.forEach(($image) => {
      if ($image.classList.contains(`js-${SDG.Product.currentProduct.color}`)) {
        $image.classList.remove(c.cls.hidden_class);
        $image.classList.add(c.cls.visible_class);
      } else {
        $image.classList.add(c.cls.hidden_class);
        $image.classList.remove(c.cls.visible_class);
      }
    });

    if ($monogramProductImages().length > 0) {
      $monogramProductImages().forEach(($monogramImage) => {
        if ($monogramImage.classList.contains(`js-${SDG.Product.currentProduct.color}`)) {
          $monogramImage.classList.add(c.cls.is_active_class);
        } else {
          $monogramImage.classList.remove(c.cls.is_active_class);
        }
      });
    }

    // show fabric/leather dropdown
    if (fabricDropdown === 'true') {
      SDG.Data.hasFabricDropdown = true;
      $leatherSelectsWrap.style.display = 'block';
      $selectOptions.forEach(($select) => {
        if ($select.dataset.outsideColor === outsideColor) {
          $select.style.display = 'block';
        } else {
          $select.style.display = 'none';
        }
      });

      const activeSelects = $leatherSelectsWrap.querySelectorAll(`[style*="display: block"]`);

      // if there is only one leather type, select this leather
      if (activeSelects.length === 1) {
        activeSelects[0].click();
      }

    } else if (fabricDropdown === 'false') {
      SDG.Data.hasFabricDropdown = false;
      $leatherSelectsWrap.style.display = 'none';
    }

    // reload Flickity
    if (SDG.Product.gallery.flkty) {
      SDG.Product.gallery.flkty.destroy();
    }

    SDG.Product.gallery.flkty = new Flickity(SDG.Product.gallery.domElement, SDG.Product.gallery.settings);
    SDG.Product.gallery.updateStatus(true);

    // update BackInStock form
    if ($backInStockForm) {
      $backInStockForm.setAttribute('data-product-id', productId);
      $backInStockForm.setAttribute('data-variant-id', variantId);
    }

    // hide back in stock form
    $backInStockForm.style.display = 'none';

    // reset add monogram button
    if ($addMonogrammingButton()) {
      $addMonogrammingButton().classList.remove(c.cls.added_class);
      $addMonogrammingButton().innerHTML = c.monogram_add_text;
    }

    // if sold out / coming soon or waitlist
    if (soldout === 'true') {
      $addToCartButton.disabled = true;
      $addToCartButtonText.innerHTML = $addToCartButton.dataset.soldoutText;
      if ($stickyAddToCartButton) {
        $stickyAddToCartButton.disabled = true;
        $stickyAddToCartButton.innerHTML = $addToCartButton.dataset.soldoutText;
        $stickyAddToCartButton.style.display = 'flex';
      }
      $backInStockButton.style.display = 'none';
      if ($stickyBackInStockButton) {
        $stickyBackInStockButton.style.display = 'none';
      }
      $addToCartButton.style.display = 'flex';

      if ($addMonogrammingButton()) {
        $addMonogrammingButton().disabled = true;
        $addMonogrammingButton().innerHTML = $addToCartButton.dataset.soldoutText;
      }

      if (backInStock === 'true' || comingSoon === 'true') {
        $addToCartButton.style.display = 'none';
        if ($stickyAddToCartButton) {
          $stickyAddToCartButton.style.display = 'none';
        }
        $backInStockButton.style.display = 'block';
        if ($stickyBackInStockButton) {
          $stickyBackInStockButton.style.display = 'block';
          $stickyBackInStockButton.innerHTML = backInStockButtonText;
        }
        $backInStockButton.innerHTML = backInStockButtonText;
        $backInStockFormSubmit.innerHTML = backInStockButtonText;

        if ($addMonogrammingButton()) {
          $addMonogrammingButton().innerHTML = $addToCartButton.dataset.soldoutText;

          if (backInStock === 'true') {
            $addMonogrammingButton().innerHTML = c.waitlist_text;
          } else if (comingSoon === 'true') {
            $addMonogrammingButton().innerHTML = c.coming_soon_text;
          }
        }
      }

    } else {
      $backInStockButton.style.display = 'none';
      if ($stickyBackInStockButton) {
        $stickyBackInStockButton.style.display = 'none';
      }
      if ($stickyAddToCartButton) {
        $stickyAddToCartButton.style.display = 'flex';
        $stickyAddToCartButton.disabled = false;
      }
      $addToCartButton.style.display = 'flex';
      $addToCartButton.disabled = false;
      $backInStockForm.style.display = 'none';

      if ($addMonogrammingButton()) {
        $addMonogrammingButton().innerHTML = c.monogram_add_text;
      }

      if (view === 'mobile') {
        if ($product.classList.contains('shoes') || $product.classList.contains('rtw')) {
          $addToCartButtonText.innerHTML = c.select_size_text;
        } else {
          $addToCartButtonText.innerHTML = c.add_to_cart_text;
        }
      } else {
        $addToCartButtonText.innerHTML = c.add_to_cart_text;
        if ($stickyAddToCartButton) {
          $stickyAddToCartButton.innerHTML = stickyAddToCartHtml;
        }

        const $newStickyPrice = document.querySelector(`.${c.cls.sticky_price}`);
        if ($newStickyPrice) {
          $newStickyPrice.innerHTML = priceFormatted;
          $newStickyPrice.setAttribute('data-fp', globaleFp);
        }
      }
    }

    // show hide product services section
    if (productServices === 'true') {
      if ($productServices) $productServices.classList.remove(c.cls.hidden_class);
      if ($productServicesInternational) $productServicesInternational.classList.remove(c.cls.hidden_class);
    } else {
      if ($productServices) $productServices.classList.add(c.cls.hidden_class);
      if ($productServicesInternational) $productServicesInternational.classList.add(c.cls.hidden_class);
    }

    // update content blocks
    if ($productBlocksWrap) {
      $productBlocksWrap.innerHTML = allContentBlocks;
      const $productBlocks = document.querySelectorAll(`.${c.cls.product_block}`);
      let blockCount = 0;
      $productBlocks.forEach(($block) => {
        const blockHandle = $block.dataset.handle;

        if (contentBlocksHandlesArray?.includes(blockHandle)) {
          $block.style.display = 'flex';
          blockCount++;
        } else {
          $block.style.display = 'none';
        }
      });

      if (blockCount === 0) {
        $productBlocksWrap.classList.add(c.cls.empty_class);
      } else {
        $productBlocksWrap.classList.remove(c.cls.empty_class);
      }

      // add monograming button event
      const $monogramOpen = $productBlocksWrap.querySelectorAll(`.${c.cls.monogramming_open_button}`);
      if ($monogramOpen.length > 0) {
        $monogramOpen.forEach(($button) => {
          $button.addEventListener('click', SDG.openMonogramming);
        });
      }
    }

    //update product description
    let descriptionText = description.split('!!!')[1];
    //remove: 'Description---' from description
    descriptionText = descriptionText.replace('Description---', '');
    // find the sentence with "We recommend" in it and wrap it in <strong> tags
    descriptionText = descriptionText.replace(/(We recommend.*?\.)\s/, '<br><strong>$1</strong> ');
    if ($description) $description.innerHTML = `<p>${descriptionText}</p>`;
    if ($descriptionMobile) $descriptionMobile.innerHTML = `<p>${descriptionText}</p>`;

    // show/hide monogramming options
    if (monogram === 'true') {
      $product.classList.add(c.cls.is_monogrammable_class);
    } else {
      $product.classList.remove(c.cls.is_monogrammable_class);
    }

    // update monogramming letters position
    if (monogram === 'true' && monogramLettersBlock) {
      SDG.updateMonogramModalContent(monogramLettersBlock);
    }

    // update color label (mobile)
    if ($colorLabel) $colorLabel.innerHTML = humanColor;
    if ($stickyColor) $stickyColor.innerHTML = humanColor;

    // update mobile add to cart button product price
    if ($buttonPrice) {
      $buttonPrice.innerHTML = `
      <span
        class="button-price__price"
        data-fp="${globaleFp}"
      >
        <span class="button-price__dot"></span>
        ${priceFormatted}
      </span>
     `;
    }

    // store visited product
    SDG.recentlyViewed(action = 'store');

    // only if url has changed
    if (window.location.pathname !== url) {
      // update window URL - keep this after Hero Track Event
      window.history.replaceState(null, null, url);
    }

    initialLoad = false;
  };

  function showWaitlistButton() {
    const { soldout, backInStock, backInStockButtonText } = SDG.Product.currentProduct;

    if (soldout === 'true') {
      $addToCartButton.disabled = true;
      $addToCartButtonText.innerHTML = $addToCartButton.dataset.soldoutText;

      if (backInStock === 'true') {
        $addToCartButton.style.display = 'none';
        $backInStockButton.style.display = 'block';
        $backInStockButton.innerHTML = backInStockButtonText;
      }
    } else {
      $backInStockButton.style.display = 'none';
      $addToCartButton.style.display = 'flex';
      $addToCartButton.disabled = false;

      $addToCartButtonText.innerHTML = $addToCartButton.dataset.availableText;

      if (view === 'mobile') {
        if ($product.classList.contains('shoes') || $product.classList.contains('rtw')) {
          $addToCartButtonText.innerHTML = c.select_size_text;
        }
      }
    }
  }

  /**
   * return
   */
  return init();
};

SDG.productSwatches();

/**
 * Product Size Guide
 * @type {Function}
 * @return init()
 *
 */

SDG.sizeGudide = function () {

  const c = {
    cls: {
      button_is_active_class: 'size-guide-modal__nav-element--is-active',
      close_button: 'size-guide-modal__close',
      content_is_visible_class: 'size-guide-modal__content--is-visible',
      is_highlighted_class: 'is-highlighted',
      modal_content: 'js-modal-content',
      modal_is_open_class: 'modal-is-open',
      modal_overlay: 'js-modal-overlay',
      modal: 'js-modal',
      size_guide_nav: 'js-size-guide-nav',
      size_guide_trigger: 'js-trigger-size-guide',
      table_cell: 'js-table-cell',
      table_sizes: 'js-table-sizes',
      table: 'js-table',
    },
  }

  // cached globals
  const $modalOverlay = document.querySelector(`.${c.cls.modal_overlay}`);

  /**
   * init
   */
  function init() {
    addEvents();
  };

  /**
   * Add Events
   */
  function addEvents() {
    document.addEventListener('click', (e) => {
      const button = e.target.closest(`.${c.cls.size_guide_trigger}`);
      if (!button) return;

      let product_id = button.dataset.productId;
      openModal(product_id);
    });

    if ($modalOverlay) {
      $modalOverlay.addEventListener('click', closeModal);
    }
  };

  /**
   * Close Modal
   */
  function closeModal() {
    document.dispatchEvent(new CustomEvent('size-guide:close'));
  }

  /**
   * Open Modal
   */
  function openModal(product_id) {
    document.dispatchEvent(new CustomEvent('size-guide:open', { detail: { productId: product_id } }))
  }

  /**
   * return
   */
  return init();
};

SDG.sizeGudide();

class SizeGuideModal extends HTMLElement {
  static c = {
    cls: {
      button_is_active_class: 'size-guide-modal__nav-element--is-active',
      close_button: 'size-guide-modal__close',
      content_is_visible_class: 'size-guide-modal__content--is-visible',
      is_highlighted_class: 'is-highlighted',
      modal_content: 'js-modal-content',
      modal_is_open_class: 'modal-is-open',
      modal_overlay: 'js-modal-overlay',
      modal: 'js-modal',
      size_guide_nav: 'js-size-guide-nav',
      size_guide_trigger: 'js-trigger-size-guide',
      table_cell: 'js-table-cell',
      table_sizes: 'js-table-sizes',
      table: 'js-table',
    },
  }

  constructor() {
    super();
  }

  connectedCallback() {
    this._removeEvents = [];

    this.handleOpen = (e) => {
      if (e.detail.productId !== this.productId) return;

      this.open();
    };

    this.handleClose = () => this.close();

    document.addEventListener('size-guide:open', this.handleOpen);
    document.addEventListener('size-guide:close', this.handleClose);

    this.addEventListener('click', (e) => {
      if (!e.target.closest(`.${SizeGuideModal.c.cls.close_button}`)) return;

      this.close();
    });
  }

  disconnectedCallback() {
    this.unloadContent();
    document.removeEventListener('size-guide:open', this.handleOpen);
    document.removeEventListener('size-guide:close', this.handleClose);
  }

  get productId() {
    return this.dataset.productId;
  }

  get modalOverlay() {
    return document.querySelector(`.${SizeGuideModal.c.cls.modal_overlay}`);
  }

  get tables() {
    return this.querySelectorAll(`.${SizeGuideModal.c.cls.table}`);
  }

  get cells() {
    return this.querySelectorAll(`.${SizeGuideModal.c.cls.table_cell}`);
  }

  get isMobile() {
    return SDG.Viewport.currentState === 'mobile';
  }

  get content() {
    return this.querySelector('[data-content]');
  }

  addEvents() {
    this.tables.forEach(table => {
      const handler = () => this.removeHighlight();
      table.addEventListener('mouseleave', handler)
      this._removeEvents.push(() => table.removeEventListener('mouseleave', handler));
    });

    this.cells.forEach(cell => {
      const handler = (e) => this.highlightCells(e);
      cell.addEventListener('mouseover', handler)
      this._removeEvents.push(() => cell.removeEventListener('mouseover', handler));
    });
  }

  removeEvents() {
    this._removeEvents.forEach(removeEvent => removeEvent());
    this._removeEvents = [];
  }

  injectContent() {
    const template = this.querySelector('template');

    this.content.innerHTML = '';
    template.content.childNodes.forEach(node => this.content.appendChild(node.cloneNode(true)));

    this.headerCta = this.querySelector('[data-size-guide-header-cta]')
    this.howTo = this.querySelector('[data-size-guide-how-to]');
    this.jumpArrow = this.querySelector('[data-size-guide-jump-arrow]');
    this.inner = this.querySelector('.size-guide-modal__inner');

    this.endTarget = this.inner.appendChild(document.createElement('div'));
    this.endTarget.dataset.sizeGuideModalTarget = 'end';

    if (this.howTo) {
      const scrollToHowTo = (e) => {
        e.preventDefault();
        this.howTo.scrollIntoView({ behavior: 'smooth' });
      }

      this.headerCta.addEventListener('click', scrollToHowTo);
      this.jumpArrow.addEventListener('click', scrollToHowTo);
    }

    this.observer = new IntersectionObserver((entries) => {
      this.jumpArrow.classList.toggle('scrolled-to-end', entries[0].isIntersecting);
    },
      {
        root: this.inner,
        rootMargin: '1px 1px 1px 1px',
        threshold: 0,
      });

    this.observer.observe(this.endTarget);

    this.addEvents();
  }

  unloadContent() {
    this.observer.disconnect();
    this.endTarget.remove();
    this.removeEvents();
    this.content.innerHTML = '';
  }

  open() {
    this.injectContent();
    this.classList.add(SizeGuideModal.c.cls.modal_is_open_class);
    this.modalOverlay.classList.add(SizeGuideModal.c.cls.modal_is_open_class);
    // In Safari 17.3, sometimes modals aren't responding to scroll but adding this
    // as an inline style randomly fixes it.
    this.style.zIndex = 5000;
    document.querySelector('body').classList.add('overflow-hidden');
    if (this.isMobile) {
      bodyScrollLock.clearAllBodyScrollLocks();
    }
    document.querySelector('.main-wrapper').style.zIndex = 1000;
  }

  close() {
    if (!this.classList.contains(SizeGuideModal.c.cls.modal_is_open_class)) return;

    this.classList.remove(SizeGuideModal.c.cls.modal_is_open_class);
    this.style.zIndex = null;
    this.modalOverlay.classList.remove(SizeGuideModal.c.cls.modal_is_open_class);
    document.querySelector('body').classList.remove('overflow-hidden');
    document.querySelector('.main-wrapper').style.zIndex = null;
    if (this.isMobile) {
      bodyScrollLock.clearAllBodyScrollLocks();
    }
    this.unloadContent();
  }

  highlightCells(e) {
    const $target = e.target;
    const $wrap = $target.closest(`.${SizeGuideModal.c.cls.table}`);

    const $cells = $wrap.querySelectorAll(`.${SizeGuideModal.c.cls.table_cell}`);

    const cellNumber = Number($target.dataset.cell);
    const rowNumber = Number($target.dataset.row);

    $cells.forEach(($cell) => {
      const cellData = Number($cell.dataset.cell);
      const rowData = Number($cell.dataset.row);

      if (cellData < cellNumber && rowNumber === rowData || rowData < rowNumber && cellData === cellNumber) {
        $cell.classList.add(SizeGuideModal.c.cls.is_highlighted_class);
      } else {
        $cell.classList.remove(SizeGuideModal.c.cls.is_highlighted_class);
      }
    });
  };

  removeHighlight() {
    this.cells.forEach((cell) => {
      cell.classList.remove(SizeGuideModal.c.cls.is_highlighted_class);
    });
  }
}

if (!customElements.get("size-guide-modal")) {
  customElements.define("size-guide-modal", SizeGuideModal);
}

/**
 * Product Zoom
 * @type {Function}
 * @return init()
 *
 */

SDG.productZoom = function() {

  const c = {
    cls: {
      is_active_class: 'is-active',
      is_open_class: 'is-open',
      is_visible_class: 'is-visible',
      lazyload_class: 'lazyload',
      lazyloaded_class: 'lazyloaded',
      product_image: 'js-product-image',
      product_thumbs: 'js-thumbs',
      thumb_button: 'js-thumb-button',
      pdp_zoom_wrapper: 'js-pdp-zoom-container',
      zoom_container: 'js-product-zoom',
      zoom_image: 'js-zoom-image',
      zoom_close: 'js-zoom-close',
      zoom_is_open_class: 'zoom-is-open',
      video: 'video'
    },
    meta: {
      viewport: '[name=viewport]'
    },
    attr: {
      meta_initial_content: 'width=device-width, user-scalable=no',
      meta_content_mobile_zoom_open: 'width=device-width, initial-scale=1.0'
    },
  }

  // cached globals
  const $productImages = document.querySelectorAll(`.${c.cls.product_image}`);
  const $productThumbs = document.querySelector(`.${c.cls.product_thumbs}`);
  const $thumbButtons = document.querySelectorAll(`.${c.cls.thumb_button}`);
  const $zoomWrapper = document.querySelector(`.${c.cls.pdp_zoom_wrapper}`);
  const $zoomContainer = document.querySelector(`.${c.cls.zoom_container}`);
  const $zoomedImages = document.querySelectorAll(`.${c.cls.zoom_image}`);
  const $zoomeClose = document.querySelectorAll(`.${c.cls.zoom_close}`);
  const $viewportMeta = document.querySelector(`${c.meta.viewport}`);
  const view = SDG.Viewport.currentState;
  let previousEl;

  /**
   * init
   */
  function init() {
    if ($zoomWrapper) {
      addEvents();
    }
  };

  /**
   * Add Events
   */
  function addEvents() {
    $productImages.forEach(($image) => {
      $image.addEventListener('click', openZoom);
    });
    $thumbButtons.forEach(($thumb) => {
      $thumb.addEventListener('click', showImage);
    });
    $zoomeClose.forEach(($elem) => $elem.addEventListener('click', closeZoom));
  }

  /**
   * Show Image
   */
  function showImage(e) {
    let $target = e.target;
    if ($target.nodeName === 'IMG') $target = e.target.parentNode;
    const activeImageIndex = $target.dataset.index;
    setActiveImage(activeImageIndex)
  }

  /**
   * Open Zoom
   */
  function openZoom(e) {

    const $target = e.target;
    let activeImageIndex = $target.dataset.index;
    if (!activeImageIndex) {
      activeImageIndex = e.target.parentNode.dataset.index;
    }

    previousEl = e.currentTarget;
    
    $zoomWrapper.classList.add(c.cls.is_open_class);
    $zoomContainer.classList.add(c.cls.is_open_class);

    document.body.classList.add(c.cls.zoom_is_open_class);

    $zoomWrapper.setAttribute('aria-hidden', false);

    if (view === 'desktop') {
      // disable scroll
      bodyScrollLock.disableBodyScroll($zoomContainer);
    }

    // show thumbs
    // $productThumbs.classList.add(c.cls.is_visible_class);

    setActiveImage(activeImageIndex);

    if (view === 'mobile') {
      $viewportMeta.setAttribute('content', c.attr.meta_content_mobile_zoom_open);
    }

    
    $zoomeClose[0].focus();

    SDG.trapFocus($zoomWrapper)
  }

  /**
   * Center Zoomed Image
   */
  function centerZoomedImage() {
    const containerHeight = window.innerHeight;
    let activeImageHeight;
    let moveScrollBy;

    $zoomedImages.forEach(($image) => {
      if ($image.parentNode.classList.contains(c.cls.is_active_class)) {

        // set interval to check if image has been loaded
        const interval = setInterval(checkClass, 200);

        function checkClass() {

          if (($image.querySelector('img') && $image.querySelector('img').classList.contains(c.cls.lazyloaded_class)) || $image.querySelector('video') ) {
            clearInterval(interval);
            activeImageHeight = $image.parentNode.offsetHeight;
            moveScrollBy = (activeImageHeight - containerHeight) / 2;

            // center zoomed image
            if (view === 'desktop') {
              $zoomContainer.scrollBy({
                top: moveScrollBy,
                left: 0,
                behavior: 'smooth'
              });
            }
          }
        }
      }
    });
  }

  /**
   * Close Zoom
   */
  function closeZoom(e) {
    const targetLocalName = e.target.localName;

    // Mobile: do not close zoom on image click
    if (view === 'mobile' && targetLocalName === 'img') {
      return;
    }

    $zoomWrapper.classList.remove(c.cls.is_open_class);
    $zoomContainer.classList.remove(c.cls.is_open_class);
    document.body.classList.remove(c.cls.zoom_is_open_class);

    $zoomWrapper.setAttribute('aria-hidden', true);

    // clear scroll locks
    bodyScrollLock.clearAllBodyScrollLocks();

    // hide thumbs
    // $productThumbs.classList.remove(c.cls.is_visible_class);

    $viewportMeta.setAttribute('content', c.attr.meta_initial_content);

    previousEl.focus();
  }

  /**
   * Set Active Image
   */
  function setActiveImage(activeImageIndex) {
    $zoomedImages.forEach(($image) => {
      const $figure = $image.parentNode;
      const zoomImageIndex = $image.dataset.index;
      const isCurrentColor = $figure.classList.contains(c.cls.is_visible_class);
      let $img;
      if (activeImageIndex === zoomImageIndex && isCurrentColor) {
        $img = $image.querySelector('img');

        if ($figure.classList.contains(c.cls.video)){
          const $video = $figure.getElementsByTagName('video');
          $video[0].play();
          $video[0].currentTime = 0;
          $figure.classList.add(c.cls.is_active_class);
        }

        $figure && $figure.classList.add(c.cls.is_active_class);
        $img && $img.classList.remove(c.cls.lazyloaded_class);
        $img && $img.classList.add(c.cls.lazyload_class);
      } else {
        $figure && $figure.classList.remove(c.cls.is_active_class);
      }
    });

    // center image on desktop
    if (view === 'desktop') {
      setTimeout(centerZoomedImage, 200);
    }

    $thumbButtons.forEach(($thumb) => {
      const thumbIndex = $thumb.dataset.index;
      const isCurrentColor = $thumb.classList.contains(c.cls.is_visible_class);
      if (activeImageIndex === thumbIndex && isCurrentColor) {
        $thumb.classList.add(c.cls.is_active_class);
        $thumb.setAttribute("aria-current", true);
        // $thumb.focus();
      } else {
        $thumb.classList.remove(c.cls.is_active_class);
        $thumb.removeAttribute("aria-current");
      }
    });
  }

  /**
   * return
   */
  return init();
};

SDG.productZoom();

$(document).ready(function () {
  $('.block-menu_button.with-image').each(function () {
    var $this = $(this)
    var $button = $(this).find('a')
    var $image = $(this).find('div[id]').hide()
    var $other_sections = $(this).siblings()

    $button
      .on('click', function (e) {
        e.preventDefault()
        $this.trigger('menu_button:toggle')
      })

    $this
      .on('menu_button:show', function () {
        $(this).addClass('active')

        $other_sections.hide()
        $image.show()
        $button.text('Close')
      })
      .on('menu_button:hide', function () {
        $(this).removeClass('active')

        $other_sections.show()
        $image.hide()
        $button.text('Menu')
      })
      .on('menu_button:toggle', function () {
        $this.hasClass('active')
          ? $this.trigger('menu_button:hide')
          : $this.trigger('menu_button:show')
      })
  })
})

/**
 * South Korean Landing
 * @type {Function}
 * @return init()
 * 
 */

SDG.southKoreanLanding = function() {

  const c = {
    cls: {
      inViewCheck: 'js-in-view-check',
      isInView: 'is-in-view'
    }
  }

  const $elementsToCheck = document.querySelectorAll(`.${c.cls.inViewCheck}`);

  /**
   * init
   */
  function init() {
    if ($elementsToCheck.length > 0) {
      inView('.js-in-view-check').on('enter', el => el.classList.add(`${c.cls.isInView}`));
    }
  };

  /**
   * return
   */
  return init();
};

SDG.southKoreanLanding();
$(document).ready(function() {
  $('.store a[href]')
    .each(function() {
      href = $(this).attr('href')

      if ( href.match(/^http/i) )
        $(this).attr('target', '_blank');
    })

  $('.shopify-section.store:not(:has(.blocks))')
    .hide()

  $('.shopify-section.store_la-laduree')
    .parents('.stores')
    .addClass('with-aligned-headlines')
})

/**
 * Tab Arrow
 * For ADA - Changes focus on set of items with the arrow keys
 */

SDG.tabArrow = function (e, $buttons) {
  /**
   * Init
   */
  function init() {
    tab();
  }

  function tab() {
    e.preventDefault();
    const back = e.keyCode === 37 || e.keyCode === 38; // Left and Down arrow keys
    const next = e.keyCode === 40 || e.keyCode === 39; // Up and Right arrow keys
    let isFirst = false;

    if (next) {
      for (let i = 0; i < $buttons.length; i += 1) {
        if ($buttons[i] === document.activeElement) {
          if ($buttons[i] === $buttons[$buttons.length - 1]) {
            $buttons[0].focus();
          } else {
            $buttons[i + 1].focus();
            break;
          }
        }
      }
    } else if (back) {
      for (let i = 0; i < $buttons.length; i += 1) {
        if ($buttons[i] === document.activeElement && !isFirst) {
          if ($buttons[i] === $buttons[0]) {
            $buttons[$buttons.length - 1].focus();
            isFirst = true;
          } else {
            $buttons[i - 1].focus();
          }
        }
      }
    }
  }

  return init();
}

class TabComponent extends HTMLElement {
  constructor() {
    super();

    this.tabs = [];
    this.firstTab = null;
    this.lastTab = null;

    this.tabs = [...this.querySelectorAll("[role=tab]")];
    this.tabpanels = new Map();

    this.init();
  }

  init() {
    this.tabs.forEach((tab) => {
      const tabpanel = document.getElementById(
        tab.getAttribute("aria-controls"),
      );
      tab.tabIndex = -1;
      tab.setAttribute("aria-selected", "false");
      this.tabpanels.set(tab, tabpanel);

      tab.addEventListener("keydown", this.onKeydown.bind(this));
      tab.addEventListener("click", this.onClick.bind(this));
      if (!this.firstTab) {
        this.firstTab = tab;
      }
      this.lastTab = tab;
    });

    this.currentTab = null;
    this.setSelectedTab(this.firstTab, false);
  }

  setSelectedTab(newTab, setFocus) {
    if (typeof setFocus !== "boolean") {
      setFocus = true;
    }

    for (var i = 0; i < this.tabs.length; i += 1) {
      var tab = this.tabs[i];
      if (newTab === tab) {
        // new tab
        tab.setAttribute("aria-selected", "true");
        tab.removeAttribute("tabindex");
        this.tabpanels.get(tab).classList.add("tab--active");
        if (setFocus) {
          tab.focus();
        }
      } else {
        tab.setAttribute("aria-selected", "false");
        tab.tabIndex = -1;
        this.tabpanels.get(tab).classList.remove("tab--active");
      }
    }

    this.currentTab = newTab;
    this.dispatchEvent(
      new CustomEvent("tab-component:tab-selected", {
        bubbles: true,
        detail: { tab: newTab, panel: this.tabpanels.get(newTab) },
      }),
    );
  }

  setSelectedToPreviousTab(currentTab) {
    var index;
    if (currentTab === this.firstTab) {
      this.setSelectedTab(this.lastTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index - 1]);
    }
  }

  setSelectedToNextTab(currentTab) {
    var index;
    if (currentTab === this.lastTab) {
      this.setSelectedTab(this.firstTab);
    } else {
      index = this.tabs.indexOf(currentTab);
      this.setSelectedTab(this.tabs[index + 1]);
    }
  }
  /* EVENT HANDLERS */
  onKeydown(event) {
    let target = event.currentTarget,
      flag = false;
    switch (event.key) {
      case "ArrowLeft":
        this.setSelectedToPreviousTab(target);
        flag = true;
        break;
      case "ArrowRight":
        this.setSelectedToNextTab(target);
        flag = true;
        break;
      case "Home":
        this.setSelectedTab(this.firstTab);
        flag = true;
        break;
      case "End":
        this.setSelectedTab(this.lastTab);
        flag = true;
        break;
      default:
        break;
    }
    if (flag) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  onClick(event) {
    this.setSelectedTab(event.currentTarget);
  }
}

if (!customElements.get("tab-component")) {
  customElements.define("tab-component", TabComponent);
}

/**
 * Mini Cart
 */
SDG.MiniCart = SDG.MiniCart || {};
SDG.MiniCart.config = SDG.MiniCart.config || {};
SDG.MiniCart.addToBagClickCount = SDG.MiniCart.addToBagClickCount || 0;
SDG.Product.currentSelect = SDG.Product.currentSelect || null;

SDG.MiniCart.config = {
  close_btn: '#btnCloseCart',
  form: '#productForm',
  header: '#header-menues',
  minicart_btn: '#btnMiniCart',
  minicart_list: '#miniCartList',
  minicart: '#miniCart',
  monogram_form: '#monogramProductForm',
  ids: {
    monogram_form: 'monogramProductForm',
    product_form: 'productForm',
  },
  cls: {
    active: 'is-active',
    add_to_cart_button_text: 'js-add-to-cart-text',
    add_to_cart_button: 'js-add-to-cart',
    added_class: 'added',
    cart_count: 'js-bag-count',
    close_monogram_question: 'js-close-monogram-question',
    close_size_select: 'js-close-size-select',
    close_minicart: 'js-close-minicart',
    hidden_class: 'hidden',
    is_expanded_class: 'is-expanded',
    is_monogrammable_class: 'is-monogrammable',
    is_visible_class: 'is-visible',
    leather_select_wrap: 'js-leather',
    leather_select: 'new-select--leather',
    monogram_no: 'js-button-no',
    monogram_question: 'js-monogram-question',
    monogram_yes: 'js-button-yes',
    monogramming_button: 'js-open-monogramming',
    monogramming_modal: 'js-monograming-modal',
    monogramming_tabs: 'js-monogramming-button',
    monogramming_form: 'monogramming-form',
    overlay: 'js-overlay',
    product: 'js-product',
    response_class: 'response',
    select_wrap: 'js-select-wrap',
    select: 'js-select',
    selected_option: 'js-selected-option',
    select_is_open_class: 'select-is-open',
    sticky_config: 'js-sticky-configurables',
    shoe_class: 'shoe',
    reversed_letters_class: 'reversed-letters',
    select_option: 'js-select-option',
  },
  add_to_cart_text: 'Add to bag',
  added_text: 'Added!',
  monogram_added_text: 'Monogram added!',
  monogram_add_text: 'Add Monogram',
  preorder_text: 'Preorder',
  select_size_text: 'Select a size',
  select_value_text: 'Select a value',
  select_leather_text: 'Select a leather',
};

/**
 * Init
 */
SDG.MiniCart.init = function (opts) {

  SDG.MiniCart.config = { ...SDG.MiniCart.config, ...opts };

  const c = SDG.MiniCart.config;
  const $product = document.querySelector(`.${c.cls.product}`);
  const $monogramButtonYes = document.querySelector(`.${c.cls.monogram_yes}`);
  const $monogramButtonNo = document.querySelector(`.${c.cls.monogram_no}`);
  const $closeMonogramQuestion = document.querySelector(`.${c.cls.close_monogram_question}`);
  const $monogramQuestion = document.querySelector(`.${c.cls.monogram_question}`);
  const $overlay = document.querySelector(`.${c.cls.overlay}`);
  const $monogramButtons = document.querySelectorAll(`.${c.cls.monogramming_button}`);
  const $productForm = document.querySelector(c.form);

  SDG.Product.monogrammingModalTrigger = false

  if ($product) {
    isMonogrammable = $product.classList.contains(c.cls.is_monogrammable_class);
  }

  function init() {
    bindEvents();
  };

  function bindEvents() {
    // on form submit
    $(document).on('submit', c.form, function (e) {
      e.preventDefault();
      SDG.MiniCart.ajaxAdd(this);
    });

    $(document).on('click', c.cls.add_to_cart_button, function (e) {
      e.preventDefault();
    });

    // on monogram form submit
    $(document).on('submit', c.monogram_form, function (e) {
      e.preventDefault();

      if (!window.blockMonogramFormSubmit) {
        SDG.MiniCart.ajaxAdd(this);
      }
    });


    if ($product) {
      const addItemToBag = true;

      if ($monogramButtonYes) $monogramButtonYes.addEventListener('click', openMonogram);
      if ($monogramButtonNo) $monogramButtonNo.addEventListener('click', () => closeMonogramQuestion(addItemToBag));
      if ($closeMonogramQuestion) $closeMonogramQuestion.addEventListener('click', closeMonogramQuestion);
    }
  }

  /**
   * Close Monogram Question
   */
  function closeMonogramQuestion(addItemToBag) {
    $monogramQuestion.style.height = `0px`;
    $overlay.classList.remove(c.cls.is_visible_class);

    if (addItemToBag === true) {
      SDG.MiniCart.addToBagClickCount = 3;
      SDG.MiniCart.ajaxAdd($productForm);
    }

    SDG.MiniCart.addToBagClickCount = 0;
    // enable scroll
    bodyScrollLock.clearAllBodyScrollLocks();
  }

  /**
   * Open Monogram Modal
   */
  function openMonogram() {
    const addItemToBag = false;

    closeMonogramQuestion(addItemToBag);
    $monogramButtons[0].click();
  }

  return init();
}

/**
 * Add item
 */
SDG.MiniCart.ajaxAdd = function (form) {
  const c = SDG.MiniCart.config;
  const $miniCart = $(c.minicart);
  const $body = document.body;
  const $product = document.querySelector(`.${c.cls.product}`);
  const endpoint = '/cart/add.js';
  const $addToCartButton = document.querySelector(`.${c.cls.add_to_cart_button}`);
  const $addToCartButtonText = document.querySelector(`.${c.cls.add_to_cart_button_text}`);
  const $select = form.querySelector('select:not([disabled])');
  const $letherSelectWrap = document.querySelector(`.${c.cls.leather_select_wrap}`);
  const $letherSelect = document.querySelector(`.${c.cls.leather_select}`);
  const $monogrammingModal = document.querySelector(`.${c.cls.monogramming_modal}`);
  const $monogramButtons = document.querySelectorAll(`.${c.cls.monogramming_button}`);
  const $monogramQuestion = document.querySelector(`.${c.cls.monogram_question}`);
  const $selectWraps = document.querySelectorAll(`.${c.cls.select_wrap}`);
  const $overlay = document.querySelector(`.${c.cls.overlay}`);
  const $productForm = document.querySelector(`#${c.ids.product_form}`);
  const view = SDG.Viewport.currentState;
  const $selectedRadio = document.querySelector('input[type="radio"]:checked');
  const hasSizeSelect = $selectWraps.length > 0;
  const hasLeatherSelect = SDG.Data.hasFabricDropdown === true;
  const isMonogrammingForm = form.classList.contains(c.cls.monogramming_form);
  let isMonogrammable = false;

  if ($product) {
    isMonogrammable = $product.classList.contains(c.cls.is_monogrammable_class);
  }
  let $selectedOption
  let selectedOptionValue;
  let monogram = false;
  let $currentSelect = SDG.Product.currentSelect;

  SDG.Product.addToCart = addToCart;

  /**
   * Init
   */
  function init() {

    if ($select) selectedOptionValue = $select.options[$select.selectedIndex].value;

    if ($product) {
      if (isMonogrammable) monogram = true;
    }

    if (isMonogrammingForm === true) {
      SDG.MiniCart.addToBagClickCount = 3;
    }

    // Mobile View
    if (view === 'mobile') {
      $body.classList.add(c.cls.select_is_open_class);

      // *
      // MONOGRAM
      // *
      if (monogram === true && isMonogrammingForm === false) {

        // if product is monogram and has size select
        if (hasSizeSelect) {

          // 1st add to bag click
          if (SDG.MiniCart.addToBagClickCount === 0 && SDG.Product.monogrammingModalTrigger === false) {
            $selectWraps.forEach(($wrap) => {
              if ($wrap.classList.contains(c.cls.hidden_class) === false && !$wrap.parentNode.classList.contains(c.cls.sticky_config)) {
                SDG.Product.currentSelect = $wrap.querySelector(`.${c.cls.select}`);
                $selectedOption = $wrap.querySelector(`.${c.cls.selected_option}`);
                $selectedOption.click();
              }
            });

            SDG.MiniCart.addToBagClickCount++;
            return;
          }

          if (SDG.MiniCart.addToBagClickCount === 2 && SDG.Product.monogrammingModalTrigger === true) {
            $selectWraps.forEach(($wrap) => {
              if ($wrap.classList.contains(c.cls.hidden_class) === false && !$wrap.parentNode.classList.contains(c.cls.sticky_config)) {
                SDG.Product.currentSelect = $wrap.querySelector(`.${c.cls.select}`);
                $selectedOption = $wrap.querySelector(`.${c.cls.selected_option}`);
                $selectedOption.click();
              }
            });

            SDG.MiniCart.addToBagClickCount = 1;
            return;
          }

          // 2nd add to bag click - no size selected
          if (SDG.MiniCart.addToBagClickCount === 1 && selectedOptionValue === '') {
            showSelectSizeText();
            return;
          }

          // 2nd add to bag click - size selected
          if (SDG.MiniCart.addToBagClickCount === 1 && selectedOptionValue !== '') {

            if (SDG.Product.monogrammingModalTrigger === false) {

              // show monogram recomendation
              if ($monogramQuestion) $monogramQuestion.style.height = `${$monogramQuestion?.scrollHeight}px`;

              // hide size select
              if ($currentSelect) $currentSelect.style.height = '0px';
              SDG.MiniCart.addToBagClickCount++

            } else {
              SDG.openMonogramming();

              // hide size select
              if ($currentSelect) $currentSelect.style.height = '0px';
              SDG.MiniCart.addToBagClickCount++

              return;
            }
          }

        } else if (hasLeatherSelect) {

          // 1st add to bag click
          if (SDG.MiniCart.addToBagClickCount === 0 && SDG.Product.monogrammingModalTrigger === false) {
            $selectedOption = $letherSelect.querySelector(`.${c.cls.selected_option}`);
            $selectedOption.click();
            SDG.MiniCart.addToBagClickCount++;
            return;
          }

          // if leather selected show monogramming option
          if (SDG.MiniCart.addToBagClickCount === 1 && $selectedRadio == null) {
            showSelectLeatherText();
            return;
          }

          if (SDG.Product.monogrammingModalTrigger === false &&
            SDG.MiniCart.addToBagClickCount === 1
            && $selectedRadio
            && $monogramQuestion) {
            $monogramQuestion.style.height = `${$monogramQuestion?.scrollHeight}px`;
            return;
          }


        } else { // if product is monogram and does not have size select
          // 1st click add to bag

          /*
          // Disable Monogram question popup
          // Date: 10/25/2022
          if (SDG.MiniCart.addToBagClickCount === 0) {
            if ($monogramQuestion) $monogramQuestion.style.height = `${$monogramQuestion?.scrollHeight}px`;

            SDG.MiniCart.addToBagClickCount++;
            return;
          }
          */
        }
      }

      // *
      // NOT MONOGRAM
      // *
      if (monogram !== true) {

        // 1st click
        if (SDG.MiniCart.addToBagClickCount === 0) {

          if ($letherSelectWrap && $selectedRadio == null) {
            if (SDG.MiniCart.addToBagClickCount === 0) {
              $selectedOption = document.querySelector(`.${c.cls.selected_option}`);
              $selectedOption.click();

              return;
            }
          }

          SDG.MiniCart.addToBagClickCount += 1;

          if ($selectWraps.length > 0) {
            $selectWraps.forEach(($wrap) => {
              if ($wrap.classList.contains(c.cls.hidden_class) === false && !$wrap.parentNode.classList.contains(c.cls.sticky_config)) {
                SDG.Product.currentSelect = $wrap.querySelector(`.${c.cls.select}`);
                $selectedOption = $wrap.querySelector(`.${c.cls.selected_option}`);
                $selectedOption.click();
              }
            })
            return;
          }
        }
      }
    }

    // Desktop View
    if (view === 'desktop') {

      if ($letherSelectWrap && $selectedRadio == null) {
        showSelectLeatherText();
        return;
      }

      if (selectedOptionValue === '') {
        showSelectSizeText();
        return;
      }
    }

    if ($overlay) $overlay.classList.remove(c.cls.is_visible_class);
    if (hasLeatherSelect && view === 'mobile') {
      $selectedOption = $letherSelect.querySelector(`.${c.cls.selected_option}`);
      $selectedOption.click();
    }
    addToCart();
  }

  /**
   * Add To Cart
   */
  function addToCart() {
    const formData = new FormData(form);

    fetch(endpoint, {
      method: 'POST',
      body: formData
    })
      .then(res => res.json())
      .then(response => {
        const $product = document.querySelector(`.${c.cls.product}`);
        const isMonogrammable = $product.classList.contains(c.cls.is_monogrammable_class);
        const isMonogram = form.getAttribute('id') === c.ids.monogram_form;
        const $selectedRadio = document.querySelector('input[type="radio"]:checked');
        const $selectedElement = document.querySelector(`.${c.cls.select_option}.selected`);
        document.body.classList.remove(`${c.cls.select_is_open_class}`);

        if ($selectedElement) $selectedElement.classList.remove('selected');
        SDG.Product.monogrammingModalTrigger = false;

        // if product is monogram
        if (isMonogram) {
          $monogramButtons.forEach(($button) => {
            $button.innerHTML = c.monogram_added_text;
            $button.disabled = true;
            $button.classList.add(`${c.cls.added_class}`);

            // setTimeout removes 'Monogram Added' copy after 3s
            setTimeout(() => {
              $button.innerHTML = c.monogram_add_text;
              $button.disabled = false;
              $button.classList.remove(`${c.cls.added_class}`);
            }, 3000);
          });

          // add random marching key field to the main product
          const randomKeyValue = form.querySelector('[name="properties[_randomMatchingKey]"]').value;
          const randomKeyInput = document.createElement("input");
          const loopInput = document.createElement("input");
          const initialRight = document.createElement("input");
          const initialCenter = document.createElement("input");
          const initialLeft = document.createElement("input");
          const font = document.createElement("input");
          const fontSize = document.createElement("input");
          const letterPosition = document.createElement("input");
          const textColor = document.createElement("input");
          const shadowColor = document.createElement("input");

          randomKeyInput.type = 'hidden';
          randomKeyInput.name = 'properties[_randomMatchingKey]';
          randomKeyInput.value = randomKeyValue;

          // does not allow any return in Loop App
          loopInput.type = 'hidden';
          loopInput.name = 'properties[_LPROP]';
          loopInput.value = 'salefinal';

          initialLeft.type = 'hidden';
          initialCenter.type = 'hidden';
          initialRight.type = 'hidden';
          if ($product.classList.contains('shoes')) {
            initialLeft.name = 'properties[Initial Left]';
            initialLeft.value = form.querySelector('[name="properties[Initial Left]"]').value;
            initialRight.name = 'properties[Initial Right]';
            initialRight.value = form.querySelector('[name="properties[Initial Right]"]').value;
          } else {
            initialLeft.name = 'properties[Initial One]';
            initialLeft.value = form.querySelector('[name="properties[Initial One]"]').value;
            initialCenter.name = 'properties[Initial Two]';
            initialCenter.value = form.querySelector('[name="properties[Initial Two]"]').value;
            initialRight.name = 'properties[Initial Three]';
            initialRight.value = form.querySelector('[name="properties[Initial Three]"]').value;
          }
          font.type = 'hidden';
          font.name = 'properties[Font]';
          font.value = form.querySelector('[name="properties[Font]"]:checked').value;
          fontSize.type = 'hidden';
          fontSize.name = 'properties[Font Size]';
          if (form.querySelector('[name="properties[Font Size]"]:checked')) {
            fontSize.value = form.querySelector('[name="properties[Font Size]"]:checked').value;
          } else {
            fontSize.value = form.querySelector('.font-size-property').value;
          }

          letterPosition.type = 'hidden';
          letterPosition.name = 'properties[Position]';
          letterPosition.value = form.querySelector('[name="properties[Position]"]:checked')?.value;

          textColor.type = 'hidden';
          textColor.name = 'properties[Text Color]'
          textColor.value = form.querySelector('[name="properties[Text Color]"]:checked').value;

          if ($product.classList.contains(c.cls.reversed_letters_class)) {
            initialRight.value ? $addToCartButton.parentNode.append(initialRight) : null;
            initialCenter.value ? $addToCartButton.parentNode.append(initialCenter) : null;
            initialLeft.value ? $addToCartButton.parentNode.append(initialLeft) : null;
          } else {
            initialLeft.value ? $addToCartButton.parentNode.append(initialLeft) : null;
            initialCenter.value ? $addToCartButton.parentNode.append(initialCenter) : null;
            initialRight.value ? $addToCartButton.parentNode.append(initialRight) : null;
          }

          $addToCartButton.parentNode.append(font);
          $addToCartButton.parentNode.append(fontSize);
          if (form.querySelector('[name="properties[Position]"]')) {
            $addToCartButton.parentNode.append(letterPosition);
          }
          $addToCartButton.parentNode.append(textColor);

          if (form.querySelector('[name="properties[Shadow Color]"]:checked') !== null) {
            shadowColor.type = 'hidden';
            shadowColor.name = 'properties[Shadow Color]'
            shadowColor.value = form.querySelector('[name="properties[Shadow Color]"]:checked').value
            $addToCartButton.parentNode.append(shadowColor);
          }

          $addToCartButton.parentNode.append(randomKeyInput);
          $addToCartButton.parentNode.append(loopInput);

          $addToCartButton.click();
          showAddedText();

          loopInput.remove();
          initialRight.remove();
          initialCenter.remove();
          initialLeft.remove();
          font.remove();
          fontSize.remove();
          letterPosition.remove();
          textColor.remove();

          if (form.querySelector('[name="properties[Shadow Color]"]:checked') !== null) {
            shadowColor.remove();
          }

          // Not sure why needed???
          // Date: 10/25/2022
          // if ($selectedRadio) $selectedRadio.checked = false;

        } else { // update add to cart button text
          showAddedText();
        }
        if (view === 'mobile') {
          if ($currentSelect) $currentSelect.style.height = '0px';
          if ($overlay) $overlay.classList.remove(c.cls.is_visible_class);

          if ($letherSelect) {
            $letherSelect.style.height = '0px';
            $selectedOption = $letherSelect.querySelector(`.${c.cls.selected_option}`);
            $selectedOption.click();
          }
        }

        if (!isMonogram) {
          SDG.Bag.open(refresh = true);
        }

        if ($monogrammingModal) {

          // close monogram modal
          SDG.closeMonogramming();
          $miniCart.addClass(c.cls.active)
        } else {
          SDG.MiniCart.toggleMiniCart();
        }

        document.body.classList.remove(`${c.cls.select_is_open_class}`);

        // enable scroll
        bodyScrollLock.clearAllBodyScrollLocks();

        // reset Add To Bag Click Count
        SDG.MiniCart.addToBagClickCount = 0;


        // run gift with purchase
        if (window.SDG.GiftWithPurchase.enabled) {
          const comesFromMiniCart = true;
          // update global cart data
          SDG.Bag.getCartData(comesFromMiniCart);
        }

        // remove input with random key
        const randomKey = $productForm.querySelector('[name="properties[_randomMatchingKey]"]');
        if (form.getAttribute('id') !== c.ids.monogram_form && isMonogrammable === true) {
          if (randomKey) randomKey.parentNode.removeChild(randomKey);
        }

        if (isMonogram) {
          // For some reason this needs to be delayed or else the monogramming font
          // size doesn't get reset to default. Must be some async stuff somewhere
          // but I can't find it so just delay a bit, which follows the pattern of existing code.
          setTimeout(() => {
            SDG.resetProductMonogramming();
            // Selecting the swatch triggers a bunch of random things that
            // collectively help reset the monogram form to the default state
            $productForm.querySelector('.js-swatch.is-selected')?.click();
          }, 1000);
        }

        const message = response.description;
        if (message) {
          if (message == "Required parameter missing or invalid: id") {
            textStatus = 'Select a size'
          } else {
            textStatus = 'No Stock'
          }

          $addToCartButtonText.innerHTML = textStatus;
        }

        // enable scroll
        bodyScrollLock.clearAllBodyScrollLocks();
        document.body.classList.remove(`${c.cls.select_is_open_class}`);

        resetAddToCartText();
      });
  }


  /**
   * Show Added Text
   */
  function showAddedText() {
    if (Object.values($product.classList).includes('preorder')) {
      let atcbut = document.querySelector('.product__add-submit.js-add-to-cart');
      if(atcbut.classList.contains('preorder'))
        $addToCartButtonText.innerHTML = c.preorder_text;
    } else {
      $addToCartButtonText.innerHTML = c.added_text;
      console.log(`c.added_text`, c.added_text);
    }
    $addToCartButton.classList.add(`${c.cls.added_class}`);

    resetAddToCartText();
    setTimeout(() => $addToCartButton.classList.remove(`${c.cls.added_class}`), 3000);
  }

  /**
   * Reset Add To Cart Button text
   */
  function resetAddToCartText() {
    setTimeout(() => {
      if (view === 'mobile') {
        if ($product.classList.contains('shoes') || $product.classList.contains('rtw')) {
          if ($product.classList.contains('preorder')) {
            $addToCartButtonText.innerHTML = c.preorder_text;
          } else {
            $addToCartButtonText.innerHTML = c.select_size_text;
          }
        } else {
          if ($product.classList.contains('preorder')) {
            $addToCartButtonText.innerHTML = c.preorder_text;
          } else {
            $addToCartButtonText.innerHTML = c.add_to_cart_text;
          }
        }
      } else {
        if ($product.classList.contains('preorder')) {
          $addToCartButtonText.innerHTML = c.preorder_text;
        } else {
          $addToCartButtonText.innerHTML = c.add_to_cart_text;
        }
      }
    }, 3000);
  }

  /**
   * Show 'Select Size' Text
   */
  function showSelectSizeText() {

    if (SDG.Product.currentProduct.handle === 'gift-card') {
      $addToCartButtonText.innerHTML = c.select_value_text;
    } else {
      $addToCartButtonText.innerHTML = c.select_size_text;
    }
  }

  /**
   * Show 'Select Leather' Text
   */
  function showSelectLeatherText() {
    $addToCartButtonText.innerHTML = c.select_leather_text;
    $addToCartButton.classList.add(`${c.cls.added_class}`);

    setTimeout(() => {
      if ($product.classList.contains('preorder')) {
        $addToCartButtonText.innerHTML = c.preorder_text;
      } else {
        $addToCartButtonText.innerHTML = c.add_to_cart_text;
      }
      $addToCartButton.classList.remove(`${c.cls.added_class}`);
    }, 3000);
  }

  init();
};

/**
 * Update Cart Count
 */
SDG.MiniCart.updateCartCount = function () {
  const c = SDG.MiniCart.config;
  const $cartCount = document.querySelector(`.${c.cls.cart_count}`);
  const currentCount = parseInt($cartCount.innerHTML);

  $cartCount.innerHTML = currentCount + 1;
};

/**
 * Build Mini cart
 */
SDG.MiniCart.buildCart = function (data, form) {
  const c = SDG.MiniCart.config;
  const $closeMiniCart = document.querySelector(`.${c.cls.close_minicart}`);

  let productPrice;
  let rtw;
  let html;
  let dataPcAttribiute;
  let dataFpAttribiute;

  if (form) {
    productPrice = form.querySelector('.js-price');
    rtw = form.getAttribute('data-rtw');
  }

  if (productPrice) {
    dataPcAttribiute = productPrice.getAttribute('data-pc');
    dataFpAttribiute = productPrice.getAttribute('data-fp');
  }

  // regular product template
  if (data.product_title !== undefined) {
    html = `<div class="minicart__item">
              <div class="minicart__image ${rtw === 'true' ? 'minicart__image--rtw' : ''} item__image">
                <a class="minicart__image-link" href="${data.url}">
                  <img
                    data-src="${SDG.getSizedImageUrl(data.image, '120x')}"
                    data-srcset="${SDG.getSizedImageUrl(data.image, '120x')} 1x, ${SDG.getSizedImageUrl(data.image, '240x')}} 2x"
                    alt="${data.product_title}"
                    class="lazyload"
                  />
                </a>
              </div>
              <div class="minicart__details">
                <div class="minicart__product item__product">
                  <h3 class="minicart__product-title">
                    <a href="${data.url}">
                      ${data.product_title.replace(' - ', '').replace(data.variant_options[0], '')}
                    </a>
                  </h3>

                  ${typeof data.options_with_values !== 'undefined' ? '<h4 class="minicart__product-option"><span class="minicart__product-option-name">' + data.options_with_values[0].name + '</span>' + data.options_with_values[0].value + '</h4>' : ''}
                  ${typeof data.options_with_values[1] !== 'undefined' ? '<h4 class="minicart__product-option"><span class="minicart__product-option-name">' + data.options_with_values[1].name + '</span>' + data.options_with_values[1].value + '</h4>' : ''}

                </div>
                <div class="minicart__price item__price">
                  <span class="minicart__price product-price" data-pc="${dataPcAttribiute}" data-fp="${dataFpAttribiute}">
                  $${(data.price / 100).toFixed()}
                  </span>
                </div>
              </div>
            </div>`;
  } else {
    // free gift template
    html = `<div class="minicart__item">
              <div class="minicart__image item__image">
                  <img
                    data-src="${SDG.getSizedImageUrl(data.image, '120x')}"
                    data-srcset="${SDG.getSizedImageUrl(data.image, '120x')} 1x, ${SDG.getSizedImageUrl(data.image, '240x')}} 2x"
                    alt="${data.title}"
                    class="lazyload"
                  />
              </div>
              <div class="minicart__details">
                <div class="minicart__product item__product">
                  <h3>
                      ${data.title}
                  </h3>
                </div>
              </div>
            </div>`;
  }

  $(c.minicart_list).html(html);

  setTimeout(() => {
    $closeMiniCart?.dispatchEvent(new Event('click'));
  }, 3000);
};


/**
 * Show/hide mini cart
 */
SDG.MiniCart.toggleMiniCart = function (e) {
  const c = SDG.MiniCart.config;
  const $miniCart = $(c.minicart);
  let $target;

  if (e) { // if there is an click event
    $target = e.target;

    // if click is outside the minicart - close cart
    if (!$miniCart.contains($target)) {
      $miniCart.removeClass(c.cls.active);
    }
  } else {
    if ($miniCart.hasClass(c.cls.active)) {
      $miniCart.removeClass(c.cls.active);
    } else {
      $miniCart.addClass(c.cls.active);
    }
  }
};



/**
 * Fire functions
 */
SDG.MiniCart.init()

/**
 * Footer
 * @type {Function}
 * @return init()
 *
 */

SDG.footer = function() {

  const c = {
    cls: {
      isOpenClass: 'is-open',
      title: 'js-footer-link-title',
    }
  };

  // cached globals
  const $titles = document.querySelectorAll(`.${c.cls.title}`);

  /**
   * init
   */
  function init() {
    addEvents();
  };

  /**
   * Add Events
   */
  function addEvents() {
    if ($titles) {
      $titles.forEach(title => title.addEventListener('click', toggleOpenClass));
    };
  };

  /**
   * Toogle Open Class
   */
  function toggleOpenClass(e) {
    const $target = e.target.parentNode;
    const siblings = getSiblings($target);

    $target.classList.toggle(c.cls.isOpenClass);
    siblings.forEach(sibling => sibling.classList.remove(c.cls.isOpenClass));
  };

  /**
   * Get Siblings
   */
  function getSiblings(element) {
    let siblings = [];
    let sibling = element.parentNode.firstChild;

    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== element) {
        siblings.push(sibling);
      };
      sibling = sibling.nextSibling;
    }

    return siblings;
  };

  /**
   * return
   */
  return init();
};

SDG.footer();

class KlaviyoForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    if (typeof KlaviyoSubscribe === "undefined") return;

    this.initFunction();
  }

  initFunction() {
    this.initKlaviyoForm();
    this.form.email.addEventListener("keypress", this.removeError.bind(this));
    this.form.addEventListener("submit", this.handleFormSubmit.bind(this));
  }

  initKlaviyoForm() {
    KlaviyoSubscribe.attachToForms(this.form, {
      hide_form_on_success: true,
      success: function ($form) {
        // `$form` is a jQuery wrapper
        $form.addClass("success");
      },
      extra_properties: {
        $source: "Shopify Form",
        $method_type: "Custom Klaviyo Form",
        $consent_version: "",
      },
    });
  }

  handleFormSubmit(event) {
    const email = this.form.email.value;
    const emailWrapper = this.form.email.closest(".inputs");
    if (this.validateEmail(email)) {
      emailWrapper.classList.remove("error");
    } else {
      event.preventDefault();
      emailWrapper.classList.add("error");
    }
  }

  removeError() {
    const emailWrapper = this.form.email.closest(".inputs");
    emailWrapper.classList.remove("error");
  }

  validateEmail(email) {
    if (new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,3}").test(email)) {
      return true;
    }

    return false;
  }
}

if (!customElements.get("klaviyo-form")) {
  customElements.define("klaviyo-form", KlaviyoForm);
}

/**
 * Utility Page
 * @type {Function}
 * @return init()
 *
 */
SDG.utilityPages = function () {
  const c = {
    cls: {
      utility_nav_triggers: 'js-mobile-utility-nav-trigger',
      utility_nav: 'js-utility-nav',
      is_visible_class: 'is-visible',
      summary: 'js-faq-summary',
      overlay: 'js-overlay',
      close_button: 'js-utility-nav-close',
      open_class: 'is-open'
    }
  }

  // cached globals
  const $utilityNavTriggers = document.querySelectorAll(`.${c.cls.utility_nav_triggers}`);
  console.log("$utilityNavTriggers", $utilityNavTriggers);
  const $utilityNav = document.querySelector(`.${c.cls.utility_nav}`);
  console.log("$utilityNav", $utilityNav);
  const $overlay = document.querySelector(`.${c.cls.overlay}`);
  const $utilityNavClose = document.querySelector(`.${c.cls.close_button}`);
  const $faqSummary = document.querySelectorAll(`.${c.cls.summary}`);

  /**
   * init
   */
  function init() {
    addEvents();
  };

  /**
   * Add Events
   */
  function addEvents() {
    if ($utilityNavTriggers.length > 0 && $utilityNav) {
      $utilityNavTriggers.forEach(($trigger) => {
        $trigger.addEventListener('click', showMobileUtilityNav);
      });
    }

    if ($faqSummary.length > 0) {
      $faqSummary.forEach(($summary) => $summary.addEventListener('click', toggleOpenClass));
    }

    if ($utilityNavClose) $utilityNavClose.addEventListener('click', hideMobileUtilityNav);
  };

  /**
   * Show Mobile Utility Nav
   */
  function showMobileUtilityNav() {
    console.log("Clicked");
    $utilityNav.classList.add(c.cls.is_visible_class);
    $overlay.classList.add(c.cls.is_visible_class);
  };

  /**
   * Toggle Open Class ( fix for safari )
   */
  function toggleOpenClass(e) {
    const $parent = e.target.parentNode;
    $parent.classList.toggle(c.cls.open_class);
  };

  /**
   * Hide Mobile Utility Nav
   */
  function hideMobileUtilityNav() {
    $utilityNav.classList.remove(c.cls.is_visible_class);
    $overlay.classList.remove(c.cls.is_visible_class);
  };

  /**
   * return
   */
  return init();
};

SDG.utilityPages();

/**
 * Account Errors
 * For A360, links form errors to their associated inputs
 */

SDG.accountErrors = function () {
  const c = {
    dom: {
      errors: 'errors',
    },
  };

  const $errors = document.querySelector(`.${c.dom.errors}`);

  /**
   * Init
   */
  function init() {
    if (!$errors) return;
    detectErrors();
  }

  /**
   * Login errors (For WCAG)
   */
  function detectErrors() {
    const $errorsList = $errors.querySelectorAll('li');

    $errorsList.forEach((error) => {
      const isEmailError = error.innerHTML.toLowerCase().includes('email');
      const isPasswordError = error.innerHTML.toLowerCase().includes('password');
      let $errorInput;
      if (isEmailError) {
        $errorInput = $errors.parentElement.querySelector('[data-email]');
      } else if (isPasswordError) {
        $errorInput = $errors.parentElement.querySelector('[data-password]');
      }
      updateErrorLink(error, $errorInput);
    });
  }

  /**
   * Update Errors
   */
  function updateErrorLink(error, $input) {
    const errorId = `${$input.id}_error`;
    $input.setAttribute('aria-describedby', errorId);
    error.id = errorId;
    $input.focus();
  }

  return init();
}

SDG.accountErrors();

// Application
